var SVP =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonpSVP"];
/******/ 	window["webpackJsonpSVP"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		3: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "js/svtvideoplayer." + ({"0":"dash","1":"hls","2":"immersive"}[chunkId]||chunkId) + "." + {"0":"074b543b27817906f7d4","1":"ed4f7e0c12d815da60dd","2":"c48541a2357af1ca78f1"}[chunkId] + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ({

/***/ "+3SP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _sessionStorageWrapper = __webpack_require__("6flW");

var _errorType = __webpack_require__("0PB5");

var _errorType2 = _interopRequireDefault(_errorType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Sizzle = __webpack_require__("zZaF");
var VideoConfig = __webpack_require__("Pqsl");
var Device = __webpack_require__("xOtj");
var Debug = __webpack_require__("BF+C")('android-fallback');
var VideoAttributes = __webpack_require__("tpcr");
var VideoDataBuilder = __webpack_require__("0t/H");

var _sessionStorageKey = 'currentChromecastStatus';

/**
 * Chromecast status enum
 */
var CHROMECAST_STATUS = {
	Disconnected: 'Disconnected',
	Connecting: 'Connecting',
	Connected: 'Connected'
};

var NAMESPACE = 'ios-native';
var videoData;

//chromecast bridge
window.IOSDeviceBridge = window.IOSDeviceBridge || {
	CHROMECAST_STATUS: CHROMECAST_STATUS,

	setChromecastStatus: function setChromecastStatus(status) {
		(0, _sessionStorageWrapper.setInSessionStorage)(_sessionStorageKey, status);
	},

	getChromecastStatus: function getChromecastStatus() {
		return (0, _sessionStorageWrapper.getFromSessionStorage)(_sessionStorageKey, CHROMECAST_STATUS.Disconnected);
	},

	isChromecastConnected: function isChromecastConnected() {
		return (0, _sessionStorageWrapper.getFromSessionStorage)(_sessionStorageKey) === CHROMECAST_STATUS.Connected;
	}
};

//chromecast player plugin
module.exports = {
	create: function create(api) {
		if (!Device.isIOSApp()) {
			return;
		}

		var storedPosition = 0,
		    isPlaying = false;

		window.IOSDeviceBridge.getVideoPosition = function () {
			var pos = storedPosition;
			Debug('getting video position: %s', pos);

			return pos;
		};

		var oldSetStatus = window.IOSDeviceBridge.setChromecastStatus;
		window.IOSDeviceBridge.setChromecastStatus = function (status) {
			var currStatus = (0, _sessionStorageWrapper.getFromSessionStorage)(_sessionStorageKey);
			Debug('setting cc status to %s (old status = %s)', status, currStatus);
			oldSetStatus(status);
			if (status !== currStatus) {
				if (status === CHROMECAST_STATUS.Connected && isPlaying) {
					api.pause();
					_play(videoData);
				} else if (status === CHROMECAST_STATUS.Disconnected) {
					api.load();
				}
			}
		};

		function _getMetadataForIOSNativePlayer(videoId, onSuccess) {
			VideoConfig.metadataFetchFunction(videoId, function (metadata) {
				api.fire('metadata', metadata);
				if (api.data().inSweden !== undefined && !api.data().inSweden && metadata.rights && metadata.rights.geoBlockedSweden) {
					api.fire('error', {
						name: _errorType2.default.GEO_BLOCK_ERROR
					});

					return;
				}

				var videoData = VideoDataBuilder.build(videoId, metadata, api);

				videoData.video.position = VideoAttributes.getStartPosition(Sizzle('video', api.element())[0]);
				videoData.videoId = Number(videoData.videoId);
				_sendEvent('ready', {
					videoId: videoData.videoId,
					externalUi: true
				});
				api.state().loading = false;
				api.state().ready = true;
				onSuccess(videoData);
			}, function (error, data) {
				if (data) {
					api.fire('metadata', data);
				}
				api.fire('error', error);
			});
		}

		function _isConnected() {
			return (0, _sessionStorageWrapper.getFromSessionStorage)(_sessionStorageKey) === CHROMECAST_STATUS.Connected;
		}

		function _play(videoData) {
			var jsonURL = 'svtplay://api.svt.se/videoplayer-embed/android/videodata/?json=' + encodeURIComponent((0, _stringify2.default)(videoData));
			storedPosition = api.getCurrentTime();
			window.location = jsonURL;
		}

		function _sendEvent(eventType, data) {
			if (api.fire) {
				api.fire(eventType, data);
			}
		}

		api.on(NAMESPACE + '.playing', function () {
			isPlaying = true;
		});

		api.on(NAMESPACE + '.pause', function () {
			isPlaying = false;
		});

		api.on(NAMESPACE + '.error', function () {
			isPlaying = false;
		});

		api.filters.push({
			load: function load(videoId) {
				videoId = videoId || Sizzle('video', api.element())[0].getAttribute('data-video-id');
				if (_isConnected()) {
					api.element().on('click', function () {
						api.play();
					});

					_getMetadataForIOSNativePlayer(videoId, function (metadata) {
						videoData = metadata;
						api.state().ready = true;

						_sendEvent('ready', {
							videoId: videoId,
							externalUi: true
						});
					});

					return true;
				} else {
					api.once(NAMESPACE + '.metadata', function (metadata) {
						videoData = VideoDataBuilder.build(videoId, metadata.detail, api);
						videoData.video.position = VideoAttributes.getStartPosition(Sizzle('video', api.element())[0]);
						videoData.videoId = Number(videoData.videoId);
					});
				}

				return false;
			},
			play: function play() {
				if (_isConnected()) {
					videoData.video.position = videoData.video.position || api.getCurrentTime();
					_play(videoData);
					api.reset();
					_sendEvent('ready', {
						videoId: videoData.videoId,
						externalUi: true
					});

					return true;
				}
			},
			pause: function pause() {
				return _isConnected();
			},
			seek: function seek() {
				return _isConnected();
			},
			getVolume: function getVolume() {
				return _isConnected();
			},
			isMuted: function isMuted() {
				if (_isConnected()) {
					return false;
				}

				return null;
			},
			mute: function mute() {
				return _isConnected();
			},
			showCaptions: function showCaptions() {
				return _isConnected();
			},
			setVolume: function setVolume() {
				return _isConnected();
			}
		});
	},

	destroy: function destroy(api) {
		api.off(NAMESPACE + '.playing');
		api.off(NAMESPACE + '.pause');
		api.off(NAMESPACE + '.error');
	}
};

/***/ }),

/***/ "+3lO":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("abPz");
var global = __webpack_require__("YjQv");
var hide = __webpack_require__("aLzV");
var Iterators = __webpack_require__("yYxz");
var TO_STRING_TAG = __webpack_require__("hgbu")('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),

/***/ "+GuK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__("Wdy1");
var core = __webpack_require__("iANj");
var global = __webpack_require__("YjQv");
var speciesConstructor = __webpack_require__("BfX3");
var promiseResolve = __webpack_require__("qC2Z");

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),

/***/ "+JT+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var timeoutID = void 0;
var isListening = false;
var queries = [];
var regex = /\((min|max)-(width|height)[\s\t]*[~$^]?:[\s\t]*(\d+)px\)+/gi;
var breakpointSupport = 'getComputedStyle' in window;

function getBreakpoints(css) {
    var match = void 0;
    var breakpoints = [];

    while (null !== (match = regex.exec(css))) {
        breakpoints.push({
            'condition': match[1],
            'dimension': match[2],
            'value': match[3]
        });
    }

    return breakpoints;
}

function _matches(query) {
    var isMatch = true;
    var containerWidth = getContainerWidth(query.element);

    for (var i = 0; i < query.breakpoints.length; i++) {
        var breakpoint = query.breakpoints[i];
        if (breakpoint.condition === 'min' && breakpoint.dimension === 'width' && containerWidth >= breakpoint.value) {
            isMatch = true;
        } else if (breakpoint.condition === 'max' && breakpoint.dimension === 'width' && containerWidth <= breakpoint.value) {
            isMatch = true;
        } else {
            isMatch = false;
            break;
        }
    }

    return isMatch;
}

function match(query) {
    var cb = query.cb;
    var matches = _matches(query);

    if (query.isMatched !== matches) {
        query.isMatched = matches;

        if (cb && typeof cb === 'function') {
            cb.call(window, query.name, matches);
        }
    }
}

function isDefault(q) {
    return q.indexOf('!default') > -1;
}

function stripDefault(q) {
    var i = q.indexOf('!default');
    if (i > -1) {
        return q.substr(0, i);
    }

    return q;
}

function getContainerWidth(element) {
    return parseInt(getComputedStyle(element, null).width, 10);
}

function throttle(fn) {
    clearTimeout(timeoutID);
    timeoutID = setTimeout(fn, 50);
}

var handleChange = function handleChange() {
    throttle(function () {
        queries.forEach(function (query) {
            match(query);
        });
    });
};

module.exports = {
    forceCheck: function forceCheck() {
        queries.forEach(function (query) {
            match(query);
        });
    },

    destroy: function destroy(element) {
        // Find queries to remove
        var queriesToRemove = [];
        queries.forEach(function (query) {
            if (query.element === element) {
                queriesToRemove.push(query);
            }
        });

        // Remove queries found above
        queriesToRemove.forEach(function (query) {
            var index = queries.indexOf(query);
            if (index !== -1) {
                queries.splice(index, 1);
            }
        });

        // Stop listening if there are no active queries left
        if (queries.length === 0) {
            window.removeEventListener('resize', handleChange, true);
            isListening = false;
            clearTimeout(timeoutID);
        }
    },

    addListener: function addListener(element, name, mediaQuery, cb) {
        if (!breakpointSupport) {
            //if we have a default mediaQuery, make the callback
            if (isDefault(mediaQuery) && cb && typeof cb === 'function') {
                cb.call(window, name, true);
            }

            return;
        }

        queries.push({
            element: element,
            name: name,
            breakpoints: getBreakpoints(stripDefault(mediaQuery)),
            cb: cb,
            isMatched: false
        });

        match(queries[queries.length - 1]);

        if (!isListening) {
            isListening = true;
            window.addEventListener('resize', handleChange, true);
        }
    }
};

/***/ }),

/***/ "+MZ2":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ "+Mt+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__("Ds5P");
var core = __webpack_require__("7gX0");
var global = __webpack_require__("OzIq");
var speciesConstructor = __webpack_require__("7O1s");
var promiseResolve = __webpack_require__("nphH");

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),

/***/ "+SdG":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("a/OS")('keys');
var uid = __webpack_require__("GmwO");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ "+VX5":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("W6Rd");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ "+iDZ":
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__("YjQv").document;
module.exports = document && document.documentElement;


/***/ }),

/***/ "+zJ9":
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__("GmwO")('meta');
var isObject = __webpack_require__("8ANE");
var has = __webpack_require__("x//u");
var setDesc = __webpack_require__("GCs6").f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__("zyKz")(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ "//Fk":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("x/31"), __esModule: true };

/***/ }),

/***/ "/Hyb":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Enforces a single instance of the Raven client, and the
 * main entry point for Raven. If you are a consumer of the
 * Raven library, you SHOULD load this file (vs raven.js).
 **/

var RavenConstructor = __webpack_require__("JIHV");

// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
var _window =
  typeof window !== 'undefined'
    ? window
    : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
var _Raven = _window.Raven;

var Raven = new RavenConstructor();

/*
 * Allow multiple versions of Raven to be installed.
 * Strip Raven from the global context and returns the instance.
 *
 * @return {Raven}
 */
Raven.noConflict = function() {
  _window.Raven = _Raven;
  return Raven;
};

Raven.afterLoad();

module.exports = Raven;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "/JIA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _dom = __webpack_require__("TdxG");

var domUtils = _interopRequireWildcard(_dom);

var _uiConstants = __webpack_require__("W1Zj");

var UIConstants = _interopRequireWildcard(_uiConstants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var device = __webpack_require__("xOtj");
var Sizzle = __webpack_require__("zZaF");

var EVENT_NAMESPACE = 'pip';

var CLASSNAMES = {
	pipButton: 'svp_js-pip--btn',
	pipButtonLabel: 'svp_js-pip--btn-label',
	placeholderContainer: 'svp_js-pip--placeholder-container'
};

var BUTTON_ICONS = {
	pipButton: 'svp_pictureinpicture-button',
	pipButtonEnd: 'svp_pictureinpicture-button-end'
};

module.exports = {
	create: function create(api) {

		function _getElement(className) {
			return api && Sizzle('.' + className, api.element())[0];
		}

		api.once(EVENT_NAMESPACE + '.canplay', function () {

			if (device.isPictureInPictureCapable(api.video())) {
				var pipButton = _getButton();
				domUtils.addEvents(api.video(), 'webkitpresentationmodechanged', function () {
					var pipButtonLabel = _getElement(CLASSNAMES.pipButtonLabel),
					    placeholderElement = _getVideoPlaceholder(),
					    labelText;

					if (api.video().webkitPresentationMode === 'picture-in-picture') {
						domUtils.addClass(api.element(), UIConstants.STATE_CLASS.pipMode);
						api.data().allowNoUi = false;
						api.fire('showControls', { shouldShow: true });
						labelText = 'Avsluta Bild-i-bild';
						domUtils.removeClass(pipButton, BUTTON_ICONS.pipButton);
						domUtils.addClass(pipButton, BUTTON_ICONS.pipButtonEnd);
						api.element().insertBefore(placeholderElement, api.video());
					} else {
						placeholderElement.parentElement.removeChild(placeholderElement);
						domUtils.removeClass(api.element(), UIConstants.STATE_CLASS.pipMode);
						api.data().allowNoUi = true;
						labelText = 'Aktivera Bild-i-bild';
						domUtils.removeClass(pipButton, BUTTON_ICONS.pipButtonEnd);
						domUtils.addClass(pipButton, BUTTON_ICONS.pipButton);
					}

					pipButton.setAttribute('title', labelText);
					pipButtonLabel.innerHTML = labelText;
				}, EVENT_NAMESPACE);

				api.on(EVENT_NAMESPACE + '.playing', domUtils.show.bind(this, pipButton));
				api.on(EVENT_NAMESPACE + '.ended', domUtils.hide.bind(this, pipButton));
			}
		});

		function _togglePictureInPicture(e) {
			e.stopPropagation();
			e.preventDefault();
			var newMode = api.video().webkitPresentationMode === 'picture-in-picture' ? 'inline' : 'picture-in-picture';
			api.video().webkitSetPresentationMode(newMode);
		}

		function _getButton() {
			var button = Sizzle('.' + CLASSNAMES.pipButton, api.element())[0];

			if (!button) {
				button = domUtils.fromString('<button class="svp_pictureinpicture-button ' + CLASSNAMES.pipButton + '"\
							aria-live="assertive"\
							title="Aktivera Bild-i-bild"\
							tabindex="0">\
								<span class="svp_ui-controls__hidden ' + CLASSNAMES.pipButtonLabel + '">Aktivera Bild-i-bild</span>\
							</button>');
				domUtils.addEvents(button, 'click, touchend', _togglePictureInPicture, EVENT_NAMESPACE);

				domUtils.hide(button);
				api.insertButton(button);
			}

			return button;
		}

		function _getVideoPlaceholder() {
			var placeholder = _getElement(CLASSNAMES.placeholderContainer);
			if (placeholder) {
				return placeholder;
			}

			return domUtils.fromString('<div class="svp_pictureinpicture-placeholder ' + CLASSNAMES.placeholderContainer + '">\
						<div class="svp_pictureinpicture-placeholder__image"></div>\
						<div class="svp_pictureinpicture-placeholder__text">\
							<p>Bild-i-bild aktiverat</p>\
						</div>\
					</div>');
		}
	},
	destroy: function destroy(api) {
		var button = Sizzle('.svp_pictureinpicture-button', api.element())[0];
		if (button) {
			button.parentElement.removeChild(button);
			domUtils.removeEvents(api.video(), 'webkitpresentationmodechanged', EVENT_NAMESPACE);
			api.off(EVENT_NAMESPACE + '.playing');
			api.off(EVENT_NAMESPACE + '.ended');
		}

		api.off(EVENT_NAMESPACE + '.ready');
	}
};

/***/ }),

/***/ "/W6e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var VIDEO_FORMAT = {
    Mono: 0,
    Stereo_TB: 1,
    Stereo_LR: 2
};

var EYE = {
    Left: 1,
    Right: 2
};

module.exports = { VIDEO_FORMAT: VIDEO_FORMAT, EYE: EYE };

/***/ }),

/***/ "/whu":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("3BFI");


/***/ }),

/***/ "0/jl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__("YjQv");
var has = __webpack_require__("x//u");
var DESCRIPTORS = __webpack_require__("qs+f");
var $export = __webpack_require__("Wdy1");
var redefine = __webpack_require__("1RnF");
var META = __webpack_require__("+zJ9").KEY;
var $fails = __webpack_require__("zyKz");
var shared = __webpack_require__("a/OS");
var setToStringTag = __webpack_require__("LhDF");
var uid = __webpack_require__("GmwO");
var wks = __webpack_require__("hgbu");
var wksExt = __webpack_require__("4DQ7");
var wksDefine = __webpack_require__("Ntt2");
var enumKeys = __webpack_require__("6rdy");
var isArray = __webpack_require__("NU0k");
var anObject = __webpack_require__("FKWp");
var toIObject = __webpack_require__("ksFB");
var toPrimitive = __webpack_require__("9MbE");
var createDesc = __webpack_require__("YTz9");
var _create = __webpack_require__("NZ8V");
var gOPNExt = __webpack_require__("6tLb");
var $GOPD = __webpack_require__("rjjF");
var $DP = __webpack_require__("GCs6");
var $keys = __webpack_require__("pEGt");
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__("2m2c").f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__("bSeU").f = $propertyIsEnumerable;
  __webpack_require__("THEY").f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__("c8Kh")) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    if (it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    replacer = args[1];
    if (typeof replacer == 'function') $replacer = replacer;
    if ($replacer || !isArray(replacer)) replacer = function (key, value) {
      if ($replacer) value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__("aLzV")($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ "0Gsn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    DEFAULT_AUDIO: 'sv',
    SPOKEN_TEXT: 'sv-tal'
};
module.exports = exports['default'];

/***/ }),

/***/ "0Lvz":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("W6Rd");
var defined = __webpack_require__("+MZ2");
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),

/***/ "0PB5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * TODO
 *  -   Specify errors thrown by dashjs?
 *  -   Specify errors thrown by hls.js
 *  -   The error thrown by HTML5 media elements is mapped to internal error names in the ErrorHandler plugin, should be a core functionality?
 */

exports.default = {
    DEFAULT_ERROR: 'defaultError',
    DRM_PROTECTION_ERROR: 'drmProtectionError',
    FLASH_NOT_SUPPORTED: 'flashNotSupported',
    GEO_BLOCK_ERROR: 'geoblockError',
    IMMERSIVE_NOT_SUPPORTED_ERROR: 'immersiveNotSupported',
    IMMERSIVE_FAILED_TO_LOAD: 'immersiveFailedToLoad',
    LIVE_NOT_STARTED_ERROR: 'liveNotStartedError',
    LOAD_ERROR: 'loadError',
    LOAD_PLAYER_ERROR: 'loadPlayerError',
    RIGHTS_EXPIRED_ERROR: 'rightsExpiredError',
    PROGRAM_NOT_STARTED_ERROR: 'programNotStartedError',
    UNKNOW_VIDEO_TYPE_ERROR: 'unknownVideoTypeError',

    // Originates from HTML5 MediaError
    MEDIA_ERROR_ABORTED: 'mediaErrorAborted',
    MEDIA_ERROR_NETWORK: 'mediaErrorNetwork',
    MEDIA_ERROR_DECODE: 'mediaErrorDecode',
    MEDIA_ERROR_SRC_NOT_SUPPORTED: 'mediaErrorSrcNotSupported'
};
module.exports = exports['default'];

/***/ }),

/***/ "0fkz":
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}


/***/ }),

/***/ "0t/H":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Sizzle = __webpack_require__("zZaF");
var statsUtil = __webpack_require__("ahyN");

module.exports = function () {

	function _getHLSVideoReference(videoReferences) {
		videoReferences = videoReferences || [];
		var hlsUrl = null,
		    hlsWebVTTUrl = null;

		videoReferences.forEach(function (ref) {
			if (ref.format === 'hls') {
				hlsUrl = ref.url;
			} else if (ref.format === 'hlswebvtt') {
				hlsWebVTTUrl = ref.url;
			}
		});

		return {
			videos: [{ playerType: 'ios', url: hlsWebVTTUrl || hlsUrl || '', bitrate: 0 }]
		};
	}

	function _getVideoSettings(videoId, metadata, api) {
		var client = statsUtil.getClient(),
		    programTitle = metadata.mmsStatistics.ns_st_pr || 'unknown_program',
		    episodeTitle = metadata.mmsStatistics.ns_st_ep || 'unknown_episode',
		    videoReference = _getHLSVideoReference(metadata.videoReferences),
		    thumbnailImage = Sizzle('video', api.element())[0].getAttribute('poster') || 'http://www.svtplay.se/public/images/default/play_default_998x561.jpg';

		// Transform to a string that can be parsed as a 32-bit integer
		videoId = String(videoId).replace(/[^0-9]/g, '').substring(0, 10);

		if (thumbnailImage.indexOf('http') === -1) {
			thumbnailImage = 'http:' + thumbnailImage;
		} else {
			// The wrapper-apps don't like https-URLs for images, so ensure we use http
			thumbnailImage = thumbnailImage.replace(/^https/, 'http');
		}

		return {
			videoId: videoId,
			programVersionId: metadata.programVersionId,
			video: {
				videoReferences: videoReference.videos,
				materialLength: metadata.contentDuration,
				live: metadata.live || metadata.simulcast || false,
				livestartUTC: metadata.liveStartTimeUTC || 0, // default to 0 to avoid NPE in Java
				livestart: 0,
				dvr: metadata.timeshiftEnabled || false,
				blockedForChildren: metadata.blockedForChildren || false
			},
			statistics: {
				client: client,
				mmsClientNr: statsUtil.getMmsClientNr(),
				programId: metadata.programVersionId,
				statisticsUrl: statsUtil.getComscoreBaseUrl() + client + '.' + programTitle + '.' + episodeTitle,
				title: episodeTitle,
				category: metadata.mmsStatistics.ns_st_pl,
				folderStructure: programTitle,
				mmsCategory: metadata.live || metadata.simulcast ? 8 : 1 //hack for the old android lib to send the correct live flag
			},
			context: {
				title: metadata.episodeTitle,
				programTitle: metadata.programTitle,
				thumbnailImage: thumbnailImage
			}
		};
	}

	return {
		build: _getVideoSettings
	};
}();

/***/ }),

/***/ "1A13":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__("49qz")(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__("uc2A")(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "1I8z":
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__("c5AH")('WeakMap');


/***/ }),

/***/ "1RnF":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("aLzV");


/***/ }),

/***/ "1jZ2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("YjQv");
var $export = __webpack_require__("Wdy1");
var meta = __webpack_require__("+zJ9");
var fails = __webpack_require__("zyKz");
var hide = __webpack_require__("aLzV");
var redefineAll = __webpack_require__("nJ75");
var forOf = __webpack_require__("dudK");
var anInstance = __webpack_require__("4S0F");
var isObject = __webpack_require__("8ANE");
var setToStringTag = __webpack_require__("LhDF");
var dP = __webpack_require__("GCs6").f;
var each = __webpack_require__("eAa1")(0);
var DESCRIPTORS = __webpack_require__("qs+f");

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    C = wrapper(function (target, iterable) {
      anInstance(target, C, NAME, '_c');
      target._c = new Base();
      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
        anInstance(this, C, KEY);
        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    IS_WEAK || dP(C.prototype, 'size', {
      get: function () {
        return this._c.size;
      }
    });
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F, O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),

/***/ "1yV6":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("FHqv");
var ITERATOR = __webpack_require__("hgbu")('iterator');
var Iterators = __webpack_require__("yYxz");
module.exports = __webpack_require__("iANj").getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ "2KM4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _dom = __webpack_require__("TdxG");

var domUtils = _interopRequireWildcard(_dom);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var Debug = __webpack_require__("BF+C")('embed');

var NAMESPACE = 'embed';

module.exports = {
	create: function create(api) {

		api.on(NAMESPACE + '.metadata', function (metadata) {

			domUtils.addEvents(api.element(), 'keyup', function (event) {
				var keyName = domUtils.getKeyFromKeyEvent(event);
				if (keyName === 'keye') {
					Debug('e pressed');

					var embedElement = domUtils.fromString('<textarea style="z-index:-1; position:absolute; top=0;">' + '<div style="position:relative; padding-bottom:56.25%;">' + '<iframe style="position:absolute; top:0; left:0; width: 100%; height: 100%;" ' + 'frameborder="0" allowfullscreen="true" scrolling="no" ' + 'src="https://api.svt.se/videoplayer-embed/' + metadata.detail.programVersionId + '">' + '</iframe>' + '</div>' + '</textarea>');
					api.element().appendChild(embedElement);
					embedElement.select();
					try {
						var successful = document.execCommand('copy');
						var msg = successful ? 'successful' : 'unsuccessful';
						Debug('Copying text command was ' + msg);
					} catch (err) {
						Debug('Oops, unable to copy');
					}
					api.element().removeChild(embedElement);
				}
			}, NAMESPACE);
		});
	},
	destroy: function destroy(api) {
		api.off(NAMESPACE + '.metadata');
	}
};

/***/ }),

/***/ "2ghV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* global SVP */


var _dom = __webpack_require__("TdxG");

var domUtils = _interopRequireWildcard(_dom);

var _uiConstants = __webpack_require__("W1Zj");

var UIConstants = _interopRequireWildcard(_uiConstants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var Sizzle = __webpack_require__("zZaF");

var device = __webpack_require__("xOtj");
var VideoConfig = __webpack_require__("Pqsl");

var UIPlayButton = __webpack_require__("l+LE");
var UILanguageButton = __webpack_require__("4kuM");
var UIFullscreenButton = __webpack_require__("hEWt");
var UIVolumeControls = __webpack_require__("n4Q7");
var UITimelineControls = __webpack_require__("AtL8");

var CLASSNAMES = {
	buttonContainer: 'svp_js-buttons',
	buttonContainerButton: 'svp_ui-buttons__button',
	controlsContainer: 'svp_js-controls',
	play: 'svp_js-controls-btn--play',
	uiContainer: 'svp_js-ui',
	toggleTabIndex: 'svp_js-togg-tab-index',
	loader: 'svp_js-loader'
};

var STATE_CLASS = UIConstants.STATE_CLASS;

var PLAYING_STATE = UIConstants.PLAYING_STATE;

var NAMESPACE = 'svtUI';

module.exports = {
	namespace: NAMESPACE,
	create: function create(api) {

		if (!api.config.controls) {
			return;
		}

		var uiPlayButton = UIPlayButton.create(api);
		var uiTimelineControls = UITimelineControls.create(api);
		var uiFullscreenButton = UIFullscreenButton.create(api);
		var uiVolumeControls = UIVolumeControls.create(api);
		var uiLanguageButton = UILanguageButton.create(api);

		domUtils.addClass(uiPlayButton, CLASSNAMES.toggleTabIndex);
		domUtils.addClass(uiTimelineControls, CLASSNAMES.toggleTabIndex);
		domUtils.addClass(uiFullscreenButton, CLASSNAMES.toggleTabIndex);
		domUtils.addClass(uiVolumeControls, CLASSNAMES.toggleTabIndex);

		var _uiFadeTimeout = void 0;

		var FADE_INTERVAL_SHORT = 10,
		    FADE_INTERVAL_MEDIUM = 3000,
		    FADE_INTERVAL_LONG = 10000,
		    _isEventsBound = false,
		    _isVideoStarted = false,
		    _isVideoPlaying = false,
		    _isVideoPaused = false,
		    _isVideoBuffering = false,
		    _isControlsVisible = false,
		    _isTouchClick = false,
		    _isTouchDown = false,
		    _isTouchMove = false,
		    _isManualFocus = false,
		    _isInFocus = false,
		    _isMouseOver = false,
		    _useExternalUi = false,
		    _prevState = PLAYING_STATE.paused;

		function _getElement(className) {
			return Sizzle('.' + className, api.element())[0];
		}

		function _createVideoControls() {

			var controls = domUtils.fromString('<div class="svp_ui svp_js-ui">\n\t\t\t\t\t<div class="svp_ui-buttons svp_js-buttons svp_is--initial-ui"></div>\n\t\t\t\t\t<div class="svp_ui-controls-container">\n\t\t\t\t\t\t<div class="svp_ui-controls svp_js-controls svp_is--initial-ui"></div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="svp_ui-loader svp_js-loader">\n\t\t\t\t\t    <span class="svp_ui-loader__spinner"></span>\n                    </div>\n\t\t\t\t</div>');

			if (SVP._cssNotLoadedClass) {
				domUtils.addClass(controls, SVP._cssNotLoadedClass);
				controls.style.visibility = 'hidden';
			}

			var controlsNode = Sizzle('.svp_js-controls', controls)[0],
			    playButton = uiPlayButton.createElement(),
			    timelineControls = uiTimelineControls.createElement(),
			    languageButton = uiLanguageButton.createElement(),
			    fullscreenButton = uiFullscreenButton.createElement();

			controlsNode.appendChild(playButton);
			controlsNode.appendChild(timelineControls);

			if (_includeVolumeControls()) {
				controlsNode.appendChild(uiVolumeControls.createElement());
			}

			controlsNode.appendChild(languageButton);
			controlsNode.appendChild(fullscreenButton);

			domUtils.addClass(fullscreenButton, UIConstants.PROPERTY_CLASS.isLast);

			return controls;
		}

		function _includeVolumeControls() {
			return !device.isIOS();
		}

		function _buildVideoUI() {
			var tabFocusElement = domUtils.fromString('<div class="svp_ui-tabfocus ' + UIConstants.FOCUS_ELEMENT_CLASS + '" tabindex="-1" aria-label="Videospelare">Videospelare</div>');
			var controlsElement = _createVideoControls();

			api.element().appendChild(tabFocusElement);
			api.element().appendChild(controlsElement);

			_setTabIndex(false);
			var uiContainer = _getElement(CLASSNAMES.uiContainer);

			if (!VideoConfig.splash) {
				domUtils.removeClass(Sizzle('.' + STATE_CLASS.initialUi, uiContainer), STATE_CLASS.initialUi);
				domUtils.addClass(uiContainer, STATE_CLASS.visible);
			}
		}

		function _setTabIndex(shouldSet) {
			var controlsContainer = _getElement(CLASSNAMES.controlsContainer),
			    index = shouldSet ? '0' : '-1',
			    items;
			if (controlsContainer) {
				items = Sizzle('.' + CLASSNAMES.toggleTabIndex, controlsContainer);
				for (var i = 0; i < items.length; i++) {
					items[i].setAttribute('tabindex', index);
				}
			}
		}

		function _fadeOutFn(force) {
			var uiContainer = _getElement(CLASSNAMES.uiContainer);
			if (!(uiContainer && api.data())) {
				return;
			}

			if (api.data().allowNoUi && (force || !(_isVideoPaused || _isVideoBuffering || _isTouchDown || _isInFocus))) {
				_setTabIndex(false);
				domUtils.removeClass(uiContainer, STATE_CLASS.visible);
				uiLanguageButton.destroyDialog();
				setTimeout(function () {
					_isControlsVisible = false;
					if (api.fire) {
						api.fire('controls', { visible: false });
					}
					domUtils.addClass(uiContainer, UIConstants.PROPERTY_CLASS.hideCursor);
				}, 200);
			}
		}

		function _fadeInFn(fadeOutInterval) {
			fadeOutInterval = fadeOutInterval || FADE_INTERVAL_MEDIUM;
			clearTimeout(_uiFadeTimeout);
			var uiContainer = _getElement(CLASSNAMES.uiContainer);
			if (!uiContainer) {
				return;
			}

			_setTabIndex(true);
			domUtils.removeClass(uiContainer, UIConstants.PROPERTY_CLASS.hideCursor);
			domUtils.addClass(uiContainer, STATE_CLASS.visible);
			setTimeout(function () {
				_isControlsVisible = true;
				if (api.fire) {
					api.fire('controls', { visible: true });
				}
			}, 200);
			_uiFadeTimeout = setTimeout(_fadeOutFn, fadeOutInterval);
		}

		function _setPlayingState(state, what) {
			if (state === PLAYING_STATE.error) {
				uiPlayButton.setState('error', what);
			} else {
				if (!_isVideoStarted && state === PLAYING_STATE.playing) {
					domUtils.removeClass(Sizzle('.' + STATE_CLASS.initialUi, Sizzle('.' + CLASSNAMES.uiContainer, api.element())[0]), STATE_CLASS.initialUi);
					_isVideoStarted = true;
					_fadeInFn();
				}

				_isVideoPlaying = state === PLAYING_STATE.playing;
				_isVideoPaused = state === PLAYING_STATE.paused;
				_isVideoBuffering = state === PLAYING_STATE.loading;

				var loader = Sizzle('.' + CLASSNAMES.loader, api.element())[0];
				if (_isVideoStarted && _isVideoBuffering) {
					domUtils.addClass(loader, 'svp_ui-loader--loading');
				} else {
					domUtils.removeClass(loader, 'svp_ui-loader--loading');

					//hide ui if we've been in buffer state but no longer is in mouse over mode
					if (!_isMouseOver && _isVideoStarted) {
						clearTimeout(_uiFadeTimeout);
						_uiFadeTimeout = setTimeout(_fadeOutFn, FADE_INTERVAL_MEDIUM);
					}
				}

				if (!_isVideoBuffering) {
					_prevState = state;
				}
			}
		}

		function _resetUi(clearAll) {
			_isVideoStarted = false;
			_isVideoBuffering = false;
			clearTimeout(_uiFadeTimeout);
			_uiFadeTimeout = null;

			var controlsContainer = _getElement(CLASSNAMES.controlsContainer);
			domUtils.removeClass(controlsContainer, STATE_CLASS.error);

			if (VideoConfig.splash) {
				domUtils.addClass(controlsContainer, STATE_CLASS.hidden);
			}

			uiTimelineControls.reset();
			uiPlayButton.reset();

			if (clearAll) {
				uiLanguageButton.reset();
			}

			domUtils.addClass(controlsContainer, STATE_CLASS.initialUi);
		}

		/*function _focusVideo() {
      var tabFocusElement = Sizzle('.' + CLASSNAMES.tabFocus, api.element())[0];
       tabFocusElement.setAttribute('tabindex', 0);
      _isManualFocus = true;
      tabFocusElement.focus();
      _isManualFocus = false;
  }*/

		function _addVideoEventListeners() {
			var setLoading = _setPlayingState.bind(this, PLAYING_STATE.loading);
			api.on(NAMESPACE + '.play', setLoading);
			api.on(NAMESPACE + '.buffering', setLoading);
			api.on(NAMESPACE + '.seeking', setLoading);

			api.on(NAMESPACE + '.seeked', function () {
				_setPlayingState(_prevState);
			});

			api.on(NAMESPACE + '.canplay', function () {
				_setPlayingState(PLAYING_STATE.paused);
			});

			api.on(NAMESPACE + '.playing', function () {
				_setPlayingState(PLAYING_STATE.playing);

				// fade timeout is cleared on reset, meaning we need to re-set it if we're playing multiple videos in a row
				if (!_uiFadeTimeout) {
					_uiFadeTimeout = setTimeout(_fadeOutFn, FADE_INTERVAL_SHORT);
				}
			});

			api.on(NAMESPACE + '.pause', function () {
				_setPlayingState(PLAYING_STATE.paused);
				_fadeInFn();
			});
		}

		function _setupControlEvents() {
			var controlsMouseOverFn = function controlsMouseOverFn() {
				_isMouseOver = true;
				if (_isVideoStarted) {
					_fadeInFn();
				}
			},
			    controlsMouseOutFn = function controlsMouseOutFn() {
				_isMouseOver = false;
				if (_isVideoStarted) {
					clearTimeout(_uiFadeTimeout);
					_uiFadeTimeout = setTimeout(_fadeOutFn, FADE_INTERVAL_SHORT);
				}
			};
			domUtils.addEvents(_getElement(CLASSNAMES.controlsContainer), 'mouseover', controlsMouseOverFn, NAMESPACE);
			domUtils.addEvents(_getElement(CLASSNAMES.buttonContainer), 'mouseover', controlsMouseOverFn, NAMESPACE);
			domUtils.addEvents(_getElement(CLASSNAMES.controlsContainer), 'mousemove', _fadeInFn.bind(this, FADE_INTERVAL_LONG), NAMESPACE);

			domUtils.addEvents(_getElement(CLASSNAMES.controlsContainer), 'mouseout', controlsMouseOutFn, NAMESPACE);
			domUtils.addEvents(_getElement(CLASSNAMES.buttonContainer), 'mouseout', controlsMouseOutFn, NAMESPACE);

			var togglePlayFn = function togglePlayFn(e) {
				e.preventDefault();

				uiPlayButton.togglePlay();

				return false;
			};

			var toggleUiFn = function toggleUiFn() {
				if (_isControlsVisible) {
					_fadeOutFn();
				} else {
					_fadeInFn();
				}
			};

			domUtils.addEvents(_getElement(CLASSNAMES.uiContainer), 'click', togglePlayFn, NAMESPACE);
			domUtils.addEvents(_getElement(CLASSNAMES.uiContainer), 'touchend', function (e) {
				_isTouchDown = false;
				if (e.cancelable) {
					e.preventDefault();
				}
				if (_isTouchMove) {
					_isTouchMove = false;

					return;
				}
				_isInFocus = false;
				toggleUiFn();
			}, NAMESPACE);
			domUtils.addEvents(_getElement(CLASSNAMES.uiContainer), 'touchmove', function () {
				_isTouchMove = true;
			}, NAMESPACE);

			domUtils.addEvents(_getElement(CLASSNAMES.controlsContainer), 'touchstart', function () {
				_isTouchClick = true;
				_isTouchDown = true;
			}, NAMESPACE);

			domUtils.addEvents(_getElement(CLASSNAMES.controlsContainer), 'touchend', function () {
				_isTouchDown = false;
			}, NAMESPACE);

			domUtils.addEvents(_getElement(CLASSNAMES.controlsContainer), 'click', function (e) {
				if (_isTouchClick) {
					toggleUiFn(e);
				} else {
					togglePlayFn(e);
				}
				_isTouchClick = false;
			}, NAMESPACE);

			domUtils.addEvents(api.element(), 'mousedown', function () {
				api.element().setAttribute('tabindex', '0');
				_getElement(UIConstants.FOCUS_ELEMENT_CLASS).removeAttribute('tabindex');
			}, NAMESPACE);

			domUtils.addEvents(api.element(), 'blur', function () {
				api.element().removeAttribute('tabindex');
				_getElement(UIConstants.FOCUS_ELEMENT_CLASS).setAttribute('tabindex', '0');
			}, NAMESPACE);

			domUtils.addEvents(_getElement(UIConstants.FOCUS_ELEMENT_CLASS), 'focusin', function () {
				if (!_isManualFocus) {
					_fadeInFn();
					_isInFocus = true;
				}
			}, NAMESPACE);

			domUtils.addEvents(_getElement(UIConstants.FOCUS_ELEMENT_CLASS), 'focusout', function () {
				_isInFocus = false;
				setTimeout(function () {
					if (!_isInFocus) {
						_fadeOutFn();
					}
				}, 250);
			}, NAMESPACE);

			domUtils.addEvents(_getElement(CLASSNAMES.controlsContainer), 'focusin', function () {
				_isInFocus = true;
			}, NAMESPACE);

			domUtils.addEvents(_getElement(CLASSNAMES.controlsContainer), 'focusout', function (e) {
				_isInFocus = false;
				if (!e.dialogFocusOut) {
					setTimeout(function () {
						if (!_isInFocus) {
							_fadeOutFn();
						}
					}, 250);
				}
			}, NAMESPACE);
		}

		function _bindUiInteractionEvents() {
			if (!device.isTouch()) {
				var controlsMouseOverFn = function controlsMouseOverFn() {
					_isMouseOver = true;
					if (_isVideoStarted) {
						_fadeInFn(FADE_INTERVAL_MEDIUM);
					}
				};

				var controlsMouseOutFn = function controlsMouseOutFn() {
					_isMouseOver = false;
					if (_isVideoStarted) {
						clearTimeout(_uiFadeTimeout);
						_uiFadeTimeout = setTimeout(_fadeOutFn, FADE_INTERVAL_SHORT);
					}
				};

				api.element().addEventSVP('mousemove', controlsMouseOverFn);
				api.element().addEventSVP('mouseout', controlsMouseOutFn);
			}

			_setupControlEvents();

			uiPlayButton.bindEvents(api);
			uiFullscreenButton.bindEvents(api);
			uiTimelineControls.bindEvents(api);
			uiLanguageButton.bindEvents(api);

			if (_includeVolumeControls()) {
				uiVolumeControls.bindEvents(api);
			}

			api.on('showControls', function (e) {
				if (_isVideoStarted) {
					if (e.detail.shouldShow) {
						_fadeInFn();
					} else {
						_fadeOutFn();
					}
				}
			});

			api.on('languageDialog', function (event) {
				var uiContainer = _getElement(CLASSNAMES.uiContainer);
				if (event.detail.visible) {
					domUtils.addClass(uiContainer, 'svp_ui--language-dialog-visible');
				} else {
					domUtils.removeClass(uiContainer, 'svp_ui--language-dialog-visible');
				}
			});
		}

		function _bindEvents() {
			if (!_isEventsBound) {
				_addVideoEventListeners();
				_bindUiInteractionEvents();

				api.on(NAMESPACE + '.ready', function (data) {
					_useExternalUi = data.detail.externalUi;
				});

				_isEventsBound = true;
			}

			api.once(NAMESPACE + '-bind.playing', function () {
				var controlsContainer = _getElement(CLASSNAMES.controlsContainer);
				domUtils.removeClass(controlsContainer, STATE_CLASS.hidden);
				var uiContainer = Sizzle('.' + CLASSNAMES.uiContainer, api.element())[0];

				if (_useExternalUi) {
					// TODO this 'else'-clause is for chromecast-with-HDS-video, and should be removed once the flash player isn't used any more.
					if (api.data().allowNoUi) {
						domUtils.addClass(uiContainer, STATE_CLASS.externalUi);
					} else {
						domUtils.addClass(Sizzle('.' + CLASSNAMES.controlsContainer, api.element())[0], STATE_CLASS.animatable);
						_fadeInFn();
					}
				} else {
					domUtils.removeClass(uiContainer, STATE_CLASS.externalUi);
					domUtils.addClass(controlsContainer, STATE_CLASS.animatable);
				}
			});
		}

		_buildVideoUI();

		api.filters.push({
			load: function load(videoId, autoplay) {
				_resetUi(true);
				_bindEvents();

				if (VideoConfig.splash) {
					_fadeOutFn(true);
				}

				return false;
			},
			insertButton: function insertButton(domElement) {
				var buttonRow = Sizzle('.' + CLASSNAMES.buttonContainer, api.element())[0];

				if (buttonRow) {
					domUtils.addClass(domElement, CLASSNAMES.buttonContainerButton);
					if (buttonRow.firstChild) {
						buttonRow.insertBefore(domElement, buttonRow.firstChild);
					} else {
						buttonRow.appendChild(domElement);
					}
				}
			},
			reset: function reset() {
				_resetUi(false);
				if (VideoConfig.splash) {
					_fadeOutFn(true);
					api.once(NAMESPACE + '-bind.playing', function () {
						var controlsContainer = _getElement(CLASSNAMES.controlsContainer);
						domUtils.removeClass(controlsContainer, STATE_CLASS.hidden);
					});
				}
			}
		});
	},
	destroy: function destroy(api) {
		var element = Sizzle('.' + CLASSNAMES.uiContainer, api.element())[0],
		    tabFocusElement = Sizzle('.' + UIConstants.FOCUS_ELEMENT_CLASS, api.element())[0];

		if (element) {
			UIPlayButton.destroy(api);
			UITimelineControls.destroy(api);
			UILanguageButton.destroy(api);
			UIFullscreenButton.destroy(api);
			UIVolumeControls.destroy(api);

			element.parentElement.removeChild(element);
			tabFocusElement.parentElement.removeChild(tabFocusElement);
		}
	}
};

/***/ }),

/***/ "2kY9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__("eaCm");
var validate = __webpack_require__("fTPD");
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__("1jZ2")(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),

/***/ "2m2c":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__("DvwR");
var hiddenKeys = __webpack_require__("B5V0").concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),

/***/ "2p1q":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("lDLk");
var createDesc = __webpack_require__("fU25");
module.exports = __webpack_require__("bUqO") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "30vf":
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__("Wdy1");
var core = __webpack_require__("iANj");
var fails = __webpack_require__("zyKz");
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ "3BFI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("6/yx");

__webpack_require__("gOoy");

__webpack_require__("N/Vz");

__webpack_require__("SCKt");

var _sizzle = __webpack_require__("zZaF");

var _sizzle2 = _interopRequireDefault(_sizzle);

var _ravenJs = __webpack_require__("/Hyb");

var _ravenJs2 = _interopRequireDefault(_ravenJs);

var _url = __webpack_require__("QKfw");

var url = _interopRequireWildcard(_url);

var _device = __webpack_require__("xOtj");

var device = _interopRequireWildcard(_device);

var _extend = __webpack_require__("5E+y");

var _extend2 = _interopRequireDefault(_extend);

var _request = __webpack_require__("ft8J");

var _request2 = _interopRequireDefault(_request);

var _video = __webpack_require__("c2wH");

var _video2 = _interopRequireDefault(_video);

var _errorType = __webpack_require__("0PB5");

var _errorType2 = _interopRequireDefault(_errorType);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Debug = __webpack_require__("BF+C")('svt-video');

var oldDefine = window.define;
window.define = false;

if (oldDefine !== undefined) {
    window.define = oldDefine;
} else {
    window.define = undefined;
}

Debug.log('Version ' + "2.1.0");

var Config = __webpack_require__("Pqsl");

var isRavenConfigured = false;

/*
 * Configure Raven, which is the official SDK for Sentry. It is used to report
 * errors.
 */
var configureRaven = function configureRaven() {
    // Sentry/Raven can be disabled in the config.
    if (!Config.sentry || typeof Config.sentry.dsn !== 'string') {
        return;
    }

    /*
     * We call Raven.config but never Raven.install, because we do not want to
     * pollute the global scope. Instead, we just configure the Sentry DSN and
     * rely on manually reporting errors via Raven.captureException calls.
     *
     * Some uncaught exceptions are reported by wrapping event handlers in
     * our custom event handler api. We also report errors in the error handler
     * plugin.
     */
    _ravenJs2.default.config(Config.sentry.dsn, {
        release: "2.1.0",
        environment: "production", // eslint-disable-line no-process-env
        autoBreadcrumbs: false,
        instrument: false,
        sampleRate: Config.sentry.sampleRate,
        ignoreErrors: Config.sentry.ignoreErrors
    });
};

var SVTVideoPlayer = function SVTVideoPlayer(elements) {
    if (!elements) {
        return;
    }

    if (!isRavenConfigured && "production" !== 'development') {
        // eslint-disable-line no-process-env
        configureRaven();
        isRavenConfigured = true;
    }

    //NB: For memory testing - remove sizzle cache
    //Sizzle.selectors.cacheLength = 1;

    var videoContainerElements = Array.isArray(elements) ? elements : [elements];

    for (var i = 0; i < videoContainerElements.length; i++) {
        _video2.default.initialize(videoContainerElements[i]);
    }
};

SVTVideoPlayer.version = "2.1.0";

SVTVideoPlayer.config = function (config) {
    if (config) {
        (0, _extend2.default)(Config, config);
    }

    return Config;
};

SVTVideoPlayer.extend = _video2.default.addPlugin;
SVTVideoPlayer.destroy = _video2.default.destroy;
SVTVideoPlayer.ErrorType = _errorType2.default;

SVTVideoPlayer.debug = function (isDebug, expression) {
    if (isDebug) {
        Debug.enable(expression);
    } else {
        Debug.disable();
    }
};

function loadCss() {
    var styleNode = document.createElement('link');
    styleNode.setAttribute('rel', 'stylesheet');
    styleNode.setAttribute('type', 'text/css');
    styleNode.setAttribute('href', url.absolutePath('svtvideoplayer.css'));

    var _styleNodeLoadFn = void 0;

    if (styleNode.addEventListener) {
        SVTVideoPlayer._cssNotLoadedClass = 'svp_js--req-css';
        _styleNodeLoadFn = function styleNodeLoadFn() {
            Debug('css loaded');
            styleNode.removeEventListener('load', _styleNodeLoadFn);

            var nodes = (0, _sizzle2.default)('.' + SVTVideoPlayer._cssNotLoadedClass);

            nodes.forEach(function (node) {
                node.style.visibility = '';
            });

            SVTVideoPlayer._cssNotLoadedClass = undefined;
        };

        styleNode.addEventListener('load', _styleNodeLoadFn);
        //Hack for old Androids and iOS 5 that don't get the load event
        setTimeout(function () {
            if (SVTVideoPlayer._cssNotLoadedClass) {
                _styleNodeLoadFn();
            }
        }, 2000);
    }

    (0, _sizzle2.default)('head')[0].appendChild(styleNode);
}

function loadLibs() {
    if (device.supportsDash()) {
        __webpack_require__.e/* require.ensure */(0).then((function () {
            Debug('dashjs loaded');
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }

    if (!device.supportsHls() && device.supportsHlsJs()) {
        __webpack_require__.e/* require.ensure */(1).then((function () {
            Debug('hls.js loaded');
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }

    _request2.default.getText('//www.svtstatic.se/video/geocheck/', function () {
        SVTVideoPlayer._inSweden = true;
    }, function () {
        SVTVideoPlayer._inSweden = false;
    });
}

function modifyConfigFromScriptSource() {
    var scriptNode = (0, _sizzle2.default)('script[src*="/svtvideoplayer"]')[0];
    var stageOverride = url.getQueryParameter('svtIsStage') === 'true';
    var scriptSource = scriptNode && scriptNode.getAttribute('src') || '';

    var basePath = '';

    //if url don't starts with http or just // then add current browser location
    if (!/(^http(s)?:)|(^\/\/)/.test(scriptSource)) {
        var _window$location = window.location,
            host = _window$location.host,
            protocol = _window$location.protocol;

        basePath = protocol + '//' + host;
    }

    basePath += scriptSource.split(/\/js\/svtvideoplayer.+\.js$/)[0] + '/';

    Config.basePath = basePath;
    Config.isStage = Boolean(stageOverride);

    if (stageOverride && Config.nojsPlayerBaseUrl) {
        Config.embedPlayerBaseUrl = Config.nojsPlayerBaseUrl.replace('api.svt', 'api.stage.svt');
    }

    // Dynamically set the webpack public path to the url that serves the
    // static player files. The public path is used by webpack when additional
    // chunks are loaded.
    __webpack_require__.p = url.absolutePath('');
}

/**
 * Initialization starts here
 */
modifyConfigFromScriptSource();
loadCss();
loadLibs();

function onDOMContentLoaded() {
    SVTVideoPlayer((0, _sizzle2.default)('.svtvideoplayer'));
}

if (document.addEventListener) {
    document.addEventListener('DOMContentLoaded', onDOMContentLoaded);
} else {
    window.attachEvent('onload', onDOMContentLoaded);
}

module.exports = SVTVideoPlayer;

/***/ }),

/***/ "3HN9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__("SWGL");

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),

/***/ "3fMt":
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__("SWGL");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "3ggi":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("Ntt2")('asyncIterator');


/***/ }),

/***/ "49qz":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("oeih");
var defined = __webpack_require__("/whu");
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),

/***/ "4DQ7":
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__("hgbu");


/***/ }),

/***/ "4S0F":
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),

/***/ "4ajQ":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("Wdy1");
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__("qs+f"), 'Object', { defineProperty: __webpack_require__("GCs6").f });


/***/ }),

/***/ "4dmN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("c8Kh");
var $export = __webpack_require__("Wdy1");
var redefine = __webpack_require__("1RnF");
var hide = __webpack_require__("aLzV");
var has = __webpack_require__("x//u");
var Iterators = __webpack_require__("yYxz");
var $iterCreate = __webpack_require__("I7B8");
var setToStringTag = __webpack_require__("LhDF");
var getPrototypeOf = __webpack_require__("VD8v");
var ITERATOR = __webpack_require__("hgbu")('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ "4kuM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _map = __webpack_require__("ifoU");

var _map2 = _interopRequireDefault(_map);

var _dom = __webpack_require__("TdxG");

var domUtils = _interopRequireWildcard(_dom);

var _sizzle = __webpack_require__("zZaF");

var _sizzle2 = _interopRequireDefault(_sizzle);

var _uiConstants = __webpack_require__("W1Zj");

var _languageDialog = __webpack_require__("Y00i");

var _languageDialog2 = _interopRequireDefault(_languageDialog);

var _config = __webpack_require__("Pqsl");

var _config2 = _interopRequireDefault(_config);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NAMESPACE = 'ui-language-button';

var CLASSNAMES = {
    captionsText: 'svp_js-controls-captions--text',
    languageButton: 'svp_js-controls-btn--language',
    captionsLabel: 'svp_ui-controls__captions-label'
};
var CAPTIONS_STORAGE_KEY = "captionsOn";

var instances = new _map2.default();

var LanguageButton = function () {
    function LanguageButton(api) {
        (0, _classCallCheck3.default)(this, LanguageButton);

        this.api = api;
        this.languageDialog = new _languageDialog2.default(api, this);
        this.dialogVisible = false;
    }

    (0, _createClass3.default)(LanguageButton, [{
        key: '_getContainer',
        value: function _getContainer() {
            return this._getElement('svp_ui-controls__button-captions-container');
        }
    }, {
        key: '_getElement',
        value: function _getElement(className) {
            return this.api && (0, _sizzle2.default)('.' + className, this.api.element())[0];
        }
    }, {
        key: '_getLanguageButton',
        value: function _getLanguageButton() {
            return this._getElement(CLASSNAMES.languageButton);
        }
    }, {
        key: '_toggleButtonState',
        value: function _toggleButtonState() {
            if (!this.dialogVisible) {
                this._createDialog();
            } else {
                this.destroyDialog();
            }
        }
    }, {
        key: '_createDialog',
        value: function _createDialog() {
            var _this = this;

            this.dialogElement = this.languageDialog.create();
            this._getContainer().appendChild(this.dialogElement);
            this.dialogVisible = true;
            this._getLanguageButton().setAttribute('aria-expanded', true);
            this.api.fire('languageDialog', { visible: true });

            domUtils.addEvents(this._getContainer(), 'focusout', function (e) {
                e.dialogFocusOut = true; //to delay closing of video controls in ui.js
                var focusStillOnDialog = _this._getContainer().contains(e.relatedTarget);

                if (!focusStillOnDialog && e.relatedTarget !== null) {
                    _this.destroyDialog();
                }
            }, NAMESPACE);

            domUtils.addEvents(this.dialogElement, 'keyup', function (e) {
                if (domUtils.getKeyFromKeyEvent(e) === 'escape') {
                    _this.destroyDialog();
                }
            }, NAMESPACE);
        }
    }, {
        key: '_isSmallScreen',
        value: function _isSmallScreen() {
            return domUtils.hasClass(this.api.element(), 'svp_container--small');
        }
    }, {
        key: 'destroyDialog',
        value: function destroyDialog() {
            if (this.dialogVisible) {
                domUtils.removeEvents(this._getContainer(), 'focusout', NAMESPACE);
                domUtils.removeEvents(this.dialogElement, 'keyup', NAMESPACE);

                this.dialogVisible = false;
                this._getContainer().removeChild(this.dialogElement);
                this.dialogElement = undefined;
                this._getLanguageButton().setAttribute('aria-expanded', false);
                this.api.fire('languageDialog', { visible: false });
            }
        }
    }, {
        key: 'createElement',
        value: function createElement() {
            return domUtils.fromString('<div class="' + _uiConstants.PROPERTY_CLASS.controlsHideInitially + ' svp_ui-controls__button-captions-container svp_ui-controls--hide-on-error">\n\t\t\t\t\t<button class="' + CLASSNAMES.languageButton + ' svp_ui-controls__button-captions"\n                        aria-expanded="false"\n\t\t\t\t\t\ttitle="Inst\xE4llningar"\n\t\t\t\t\t\ttabindex="0">\n\t\t\t\t\t\t<span class="svp_ui-controls__hidden ' + CLASSNAMES.captionsLabel + '">Inst\xE4llningar</span>\n\t\t\t\t\t</button>\n\t\t\t\t</div>');
        }
    }, {
        key: 'reset',
        value: function reset() {
            this.dialogVisible = false;
            var languageButton = this._getLanguageButton();

            if (languageButton) {
                domUtils.removeClass(languageButton, [_uiConstants.STATE_CLASS.visible]);
            }
        }
    }, {
        key: 'bindEvents',
        value: function bindEvents(api) {
            var _this2 = this;

            api.on(NAMESPACE + '.captionsloaded', function () {
                domUtils.addClass(_this2._getLanguageButton(), _uiConstants.STATE_CLASS.visible);
            });

            api.on(NAMESPACE + '.audiotracksloaded', function () {
                domUtils.addClass(_this2._getLanguageButton(), _uiConstants.STATE_CLASS.visible);
            });

            api.on(NAMESPACE + '.ready', function () {
                if (api.getTextTracks() && api.getTextTracks().length > 0) {
                    var shouldShow = domUtils.getStoredData(CAPTIONS_STORAGE_KEY) === 'true';
                    api.showCaptions(shouldShow);
                }
            });

            domUtils.addEvents(this._getLanguageButton(), 'touchstart, mousedown', function (e) {
                e.stopPropagation();
                e.preventDefault();
            }, NAMESPACE);

            domUtils.addEvents(this._getLanguageButton(), 'click', function (e) {
                e.stopPropagation();
                e.preventDefault();

                // Yes, this closes the dialog on big screens since it's already opened on hover but that is probably ok
                _this2._toggleButtonState();
            }, NAMESPACE);

            domUtils.addEvents(this._getLanguageButton(), 'touchend', function (e) {
                e.stopPropagation();
                e.preventDefault();
                _this2._toggleButtonState();
            }, NAMESPACE);

            domUtils.addEvents(this._getContainer(), 'mouseenter', function (e) {
                if (_this2._isSmallScreen()) {
                    return;
                }
                if (!_this2.dialogVisible) {
                    _this2._createDialog();
                }
            }, NAMESPACE);

            domUtils.addEvents(this._getContainer(), 'mouseleave', function (e) {
                if (_this2._isSmallScreen()) {
                    return;
                }
                _this2.destroyDialog();
            }, NAMESPACE);

            domUtils.addEvents(this._getLanguageButton(), 'keyup', function (e) {
                var keyName = domUtils.getKeyFromKeyEvent(e);

                // Prevent to pause video if pressing enter on the language button
                if (keyName === 'enter') {
                    e.stopPropagation();
                    e.preventDefault();

                    return true;
                }

                return false;
            }, NAMESPACE);
        }
    }, {
        key: 'destroy',
        value: function destroy() {
            var languageButton = (0, _sizzle2.default)('.' + CLASSNAMES.languageButton, this.api.element())[0];
            if (languageButton) {
                domUtils.removeEvents(languageButton, 'mousedown, touchstart, click, touchend, keyup, mouseenter, mouseleave', NAMESPACE);
                languageButton.parentElement.removeChild(languageButton);
            }
            this.destroyDialog();

            this.api.off(NAMESPACE + '.audiotracksloaded');
            this.api.off(NAMESPACE + '.captionsloaded');
            this.api.off(NAMESPACE + '.ready');
        }
    }]);
    return LanguageButton;
}();

module.exports = {
    create: function create(api) {
        var languageButton = new LanguageButton(api);
        instances.set(api, languageButton);

        return languageButton;
    },
    destroy: function destroy(api) {
        var languageButton = instances.get(api);
        if (languageButton) {
            instances.delete(api);
            languageButton.destroy();
        }
    }
};

/***/ }),

/***/ "4uUc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _sessionStorageWrapper = __webpack_require__("6flW");

var _dom = __webpack_require__("TdxG");

var domUtils = _interopRequireWildcard(_dom);

var _errorType = __webpack_require__("0PB5");

var _errorType2 = _interopRequireDefault(_errorType);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Sizzle = __webpack_require__("zZaF");
var VideoConfig = __webpack_require__("Pqsl");
var Device = __webpack_require__("xOtj");
var Debug = __webpack_require__("BF+C")('ios-native-cc');

var VideoAttributes = __webpack_require__("tpcr");

var _sessionStorageKey = 'currentIOSChromecastStatus';
var _sessionStoragePlayerStateKey = 'currentIOSChromecastPlayerState';
var _sessionStorageDeviceName = 'currentIOSChromecastDeviceName';

/**
 * UI Classes
 */
var CLASSNAMES = {
	chromecast: 'svp_js-chromecast',
	preloadCountdown: 'svp_js-chromecast__preload__countdown',
	message: 'svp_js-chromecast__message',
	icon: 'svp_js-chromecast__icon',
	splash: 'svp_js-splash',
	svpUi: 'svp_js-ui'
};

var STATE_CLASS = {
	visible: 'svp_is--visible',
	loading: 'svp_is--loading',
	hidden: 'svp_is--hidden',
	forceHide: 'svp_is--force-hide',
	error: 'svp_is--error'
};

var MESSAGES = {
	Connecting: 'Ansluter till %s',
	Connected: 'Visas på %s',
	Loading: 'Laddar video på %s',
	Playing: 'Visas på %s'
};

/**
 * Chromecast status enum
 */
var CHROMECAST_STATUS = {
	Disconnected: 'Disconnected',
	Disconnecting: 'Disconnecting',
	Connecting: 'Connecting',
	Connected: 'Connected'
};

var CHROMECAST_PLAYER_STATE = {
	IDLE: 'idle',
	BUFFERING: 'buffering',
	LOADING: 'loading',
	PLAYING: 'playing',
	PAUSED: 'paused',
	UNKNOWN: 'unknown'
};

var STATUS_EVENT_METHOD = {
	SUSPEND: "didSuspendCast",
	ENDED: "didEndCast"
};

// var DEFAULT_VIDEO_PLAYLIST_ITEM = {
// 	videoId: '', /** @type {string} programVersionId */
// 	poster: '', /** @type {image} */
// 	startPosition: 0  /** @type {number} */
// };
//
// var DEFAULT_VIDEO_PLAYLIST = {
// 	autoplay: true,
// 	repeatMode: 'all', // titleModel.series ? 'off' : 'all',
// 	items: [/** @type {!DEFAULT_VIDEO_PLAYLIST_ITEM} */]
// };

var NAMESPACE = 'ios-native-cc';
function initialVideoData() {
	return {
		videoId: '',
		thumbnailImage: '',
		posterImage: '',
		position: 0,
		metadata: {}
	};
}

//chromecast bridge
window.IOSDeviceChromecastBridgeInitialChromecastDeviceName = window.IOSDeviceChromecastBridgeInitialChromecastDeviceName || null;
window.IOSDeviceChromecastBridgeInitialChromecastStatus = window.IOSDeviceChromecastBridgeInitialChromecastStatus || CHROMECAST_STATUS.Disconnected;
window.IOSDeviceChromecastBridge = window.IOSDeviceChromecastBridge || {
	CHROMECAST_STATUS: CHROMECAST_STATUS,

	setChromecastStatus: function setChromecastStatus(status) {
		(0, _sessionStorageWrapper.setInSessionStorage)(_sessionStorageKey, status);
	},

	setChromecastDeviceName: function setChromecastDeviceName(deviceName) {
		(0, _sessionStorageWrapper.setInSessionStorage)(_sessionStorageDeviceName, deviceName);
	},

	setChromecastPlayerState: function setChromecastPlayerState(playerState) {
		(0, _sessionStorageWrapper.setInSessionStorage)(_sessionStoragePlayerStateKey, playerState);
	},

	onChromecastPreload: function onChromecastPreload() {
		// empty
	},

	onChromecastTimeUpdate: function onChromecastTimeUpdate(currentTime) {
		// empty
	},

	getChromecastStatus: function getChromecastStatus() {
		return (0, _sessionStorageWrapper.getFromSessionStorage)(_sessionStorageKey, CHROMECAST_STATUS.Disconnected);
	},

	isChromecastConnected: function isChromecastConnected() {
		return (0, _sessionStorageWrapper.getFromSessionStorage)(_sessionStorageKey) === CHROMECAST_STATUS.Connected;
	}
};
// Use IOSDeviceChromecastBridgeInitialCastStatus as initial value for ChromecastStatus
window.IOSDeviceChromecastBridge.setChromecastDeviceName(window.IOSDeviceChromecastBridgeInitialChromecastDeviceName);
window.IOSDeviceChromecastBridge.setChromecastStatus(window.IOSDeviceChromecastBridgeInitialChromecastStatus);
window.IOSDeviceChromecastBridge.setChromecastPlayerState(CHROMECAST_PLAYER_STATE.IDLE);

//chromecast player plugin
module.exports = {
	create: function create(api) {
		if ((Device.isIOS() && VideoConfig.isInNativeApp) === false) {
			//Debug('Device is not an iOS app');
			return;
		}

		var videoData = initialVideoData();
		var videoPlaylist;
		var storedPosition = 0;
		var _isPlaying = false;
		var _isLoading = false;
		var _isExternalUi = false;
		var _isPaused = false;
		var _internalLoadAndPlayEvent = false;

		function currentSessionStatus() {
			return (0, _sessionStorageWrapper.getFromSessionStorage)(_sessionStorageKey);
		}

		function currentSessionDeviceName() {
			return (0, _sessionStorageWrapper.getFromSessionStorage)(_sessionStorageDeviceName);
		}

		function currentSessionPlayState() {
			return (0, _sessionStorageWrapper.getFromSessionStorage)(_sessionStoragePlayerStateKey);
		}

		var nativeBuffer = {
			eventList: [],
			purging: false,
			exec: function exec(event) {
				nativeBuffer.eventList.push(event);
				nativeBuffer.purgeEventList();
			},
			purgeEventList: function purgeEventList() {
				if (nativeBuffer.purging || nativeBuffer.eventList.length === 0) {
					return;
				}
				var nextEvent = nativeBuffer.eventList.shift();

				if (webkit && webkit.messageHandlers && webkit.messageHandlers.svpCallbackHandler && webkit.messageHandlers.svpCallbackHandler.postMessage) {
					try {
						webkit.messageHandlers.svpCallbackHandler.postMessage(nextEvent);

						return;
					} catch (err) {
						Debug.error('Failed during postMessage', err);
					}
				}

				nativeBuffer.purging = true;
				setTimeout(function () {
					if (nextEvent) {
						window.location = nextEvent;
					}
					nativeBuffer.purging = false;
					nativeBuffer.purgeEventList();
				}, 100);
			}
		};

		var NativeDispatcher = {
			send: function send(eventName, data) {
				if (eventName.indexOf('chromecast-') === -1) {
					eventName = 'chromecast-' + eventName;
				}

				var jsonURL = ['svtplay', eventName, encodeURIComponent((0, _stringify2.default)(data))].join(':');
				nativeBuffer.exec(jsonURL);
			},
			load: function load() {
				if (videoPlaylist) {
					Debug.log('Native.load withPlaylist', videoPlaylist);
					NativeDispatcher.send('loadplaylist', videoPlaylist);
				} else if (videoData.videoId !== '') {
					Debug.log('Native.load withVideodata', videoData);
					NativeDispatcher.send('load', videoData);
				} else {
					Debug.log('WARNING! Native.load with invalid data. Could happen if data changes occur during idle app mode');
				}
			},
			queueNextItem: function queueNextItem() {
				NativeDispatcher.send('queue-next-item');
			},
			controlsToggled: function controlsToggled(visible) {
				visible = visible || false;
				NativeDispatcher.send('controls', { visible: visible });
			}
		};

		var ccUi = {
			getElement: function getElement(className) {
				return Sizzle('.' + (className ? className : CLASSNAMES.chromecast), api.element())[0];
			},
			build: function build() {
				var chromecastElement = domUtils.fromString('<div class="svp_ui-chromecast ' + CLASSNAMES.chromecast + ' ' + STATE_CLASS.hidden + '">\
						<div class="svp_ui-chromecast__dimmer">\
							<div class="svp_ui-chromecast__inner">\
								<div class="svp_ui-chromecast__icon ' + CLASSNAMES.icon + '"></div>\
								<div class="svp_ui-chromecast__message ' + CLASSNAMES.message + '">Ready to cast</div>\
								<div class="svp_ui-chromecast__preload ' + CLASSNAMES.preloadCountdown + '">\
									<div class="svp_ui-chromecast__preload__info">\
										<span class="svp_ui-chromecast__preload__text">Nästa avsnitt börjar om </span>\
										<span class="svp_ui-chromecast__preload__countdown">15 sekunder</span>\
									</div>\
									<button class="svp_ui-chromecast__preload__next-button">Spela nästa nu</button>\
								</div>\
							</div>\
						</div>\
					</div>');

				api.element().appendChild(chromecastElement);

				var preloadButtonElement = this.getElement(CLASSNAMES.preloadCountdown);
				if (preloadButtonElement) {
					domUtils.addEvents(preloadButtonElement, 'click, touchend', function (e) {
						Debug('preload queue next item clicked');
						e.stopPropagation();
						ccUi.hidePreload();
						NativeDispatcher.queueNextItem();
					}, NAMESPACE);
				}
			},
			reset: function reset() {
				var preloadButtonElement = this.getElement(CLASSNAMES.preloadCountdown);
				if (preloadButtonElement) {
					domUtils.removeEvents(preloadButtonElement, 'click, touchend', NAMESPACE);
				}

				var chromecastElement = ccUi.getElement();
				if (chromecastElement) {
					api.element().removeChild(chromecastElement);
				}
				domUtils.removeClass(api.element(), STATE_CLASS.forceHide);
			},
			text: function text(status) {
				var result = '';
				if (status === CHROMECAST_STATUS.Connected) {
					if (_isLoading) {
						// Show loading text
						result = MESSAGES.Loading;
					} else if (_isPlaying) {
						// Show playing text
						result = MESSAGES.Playing;
					} else {
						result = MESSAGES.Connected;
					}
				} else if (status === CHROMECAST_STATUS.Connecting) {
					result = MESSAGES.Connecting;
				}

				return result.replace('%s', currentSessionDeviceName() || 'din cast-enhet');
			},
			showIcon: function showIcon(status) {
				var ccIconElement = ccUi.getElement(CLASSNAMES.icon);
				if (!ccIconElement) {
					return;
				}
				if (status === CHROMECAST_STATUS.Connected && _isLoading) {
					domUtils.addClass(ccIconElement, STATE_CLASS.loading);
				} else if (status === CHROMECAST_STATUS.Connecting) {
					domUtils.addClass(ccIconElement, STATE_CLASS.loading);
				} else {
					domUtils.removeClass(ccIconElement, STATE_CLASS.loading);
				}
			},
			showPreload: function showPreload(secondsLeft) {
				var preloadElement = ccUi.getElement(CLASSNAMES.preload);
				if (preloadElement) {
					domUtils.addClass(preloadElement, STATE_CLASS.visible);
					var preloadCountdownElement = ccUi.getElement(CLASSNAMES.preloadCountdown);
					if (preloadCountdownElement) {
						preloadCountdownElement.innerHTML = secondsLeft + (secondsLeft === 1 ? ' sekund' : ' sekunder');
					}
				}
			},
			hidePreload: function hidePreload() {
				var preloadElement = ccUi.getElement(CLASSNAMES.preload);
				if (preloadElement) {
					domUtils.removeClass(preloadElement, STATE_CLASS.visible);
				}
			},
			show: function show(status) {
				var ccElement = ccUi.getElement();

				if (!ccElement) {
					ccUi.build();
					ccElement = ccUi.getElement();
				}
				var ccTextElement = ccUi.getElement(CLASSNAMES.message),
				    splash = ccUi.getElement(CLASSNAMES.splash);

				// Set poster as background-cover-image
				ccElement.setAttribute('style', 'background-image: url(' + getPosterImage() + ');');

				// Force hide all UI elements when in Chromecast state
				domUtils.addClass(api.element(), STATE_CLASS.forceHide);
				if (splash) {
					domUtils.addClass(splash, STATE_CLASS.hidden);
				}

				this.showIcon(status);

				ccTextElement.innerHTML = this.text(status);
				domUtils.removeClass(ccElement, STATE_CLASS.hidden);
			},
			hide: function hide() {
				var ccElement = ccUi.getElement(),
				    ccTextElement = ccUi.getElement(CLASSNAMES.message);

				if (!ccElement) {
					return;
				}

				ccElement.removeAttribute('style');

				Debug.log('hideUi');
				if (domUtils.hasClass(ccElement, STATE_CLASS.hidden) === false) {
					domUtils.addClass(ccElement, STATE_CLASS.hidden);
					ccTextElement.innerHTML = '';
				}
				domUtils.removeClass(api.element(), STATE_CLASS.forceHide);
			}
		};

		window.IOSDeviceChromecastBridge.getVideoPosition = function () {
			var pos = storedPosition;
			Debug.log('getting video position: %s', pos);

			return pos;
		};

		var oldSetStatus = window.IOSDeviceChromecastBridge.setChromecastStatus;
		window.IOSDeviceChromecastBridge.setChromecastStatus = function (status, customData) {
			var currStatus = currentSessionStatus();
			if (typeof customData === 'string') {
				try {
					customData = JSON.parse(customData);
					customData.videoId = customData.videoId || null;
					customData.position = customData.position || "";
					customData.eventMethod = customData.eventMethod || null; /** {@type STATUS_EVENT_METHOD } */
				} catch (e) {
					Debug.warn('setChromecastStatus: Could not parse customData: ' + customData);
					customData = {};
				}
			}
			_updateActivePlaylistVideoData(customData.videoId, customData.position);

			oldSetStatus(status);
			Debug.log('setting cc status to %s (old status = %s) isPlaying = %s, customData=', status, currStatus, _isPlaying, customData);
			if (status !== currStatus) {
				_handleStateUpdate(status, currStatus, customData);
			}
		};

		var oldSetDeviceName = window.IOSDeviceChromecastBridge.setChromecastDeviceName;
		window.IOSDeviceChromecastBridge.setChromecastDeviceName = function (deviceName) {
			if (deviceName !== currentSessionDeviceName()) {
				Debug.log('setting device name: ' + deviceName);
				oldSetDeviceName(deviceName);
				ccUi.show(currentSessionStatus());
			}
		};

		window.IOSDeviceChromecastBridge.onChromecastTimeUpdate = function (currentTime) {
			if (typeof currentTime === 'string') {
				try {
					currentTime = parseInt(currentTime, 10);
				} catch (e) {
					currentTime = null;
					Debug.log('Could not parse currentTime: ' + currentTime);
				}
			}

			if (currentTime) {
				storedPosition = currentTime;
				_sendEvent('timeupdate', currentTime);
			}
		};

		window.IOSDeviceChromecastBridge.onChromecastPreload = function (preloadData) {
			if (typeof preloadData === 'string') {
				try {
					preloadData = JSON.parse(preloadData);
					preloadData.videoId = preloadData.videoId || null;
					preloadData.secondsLeft = parseInt(preloadData.secondsLeft, 10);
				} catch (e) {
					Debug.warn('onSetPreloadState: Could not parse preloadData: ' + preloadData);
					preloadData = {};
				}
			}
			Debug.log('onSetPreloadState videoId=%s secondsLeft=%s', preloadData.videoId, preloadData.secondsLeft);
			//ccUi.showPreload();
			_sendEvent('preload', preloadData);
		};

		function _sendEvent(eventType, data) {
			if (api.fire) {
				api.fire(eventType, data);
			}
		}

		function _handleStateUpdate(currentStatus, previousStatus, customData) {
			customData = customData || {};
			//CC Status -> Connecting. Loading = false. Ready = true. Playing = true.

			Debug.log('Status Update (%s) -> %s Loading = %s. Ready = %s. Playing = %s.', customData.eventMethod, currentStatus, _isLoading, api.state().ready, _isPlaying);
			if (currentStatus === CHROMECAST_STATUS.Connected && _isLoading) {
				Debug.log('Connected and loading');
				api.pause();
				ccUi.show(CHROMECAST_STATUS.Connected);
			} else if (currentStatus === CHROMECAST_STATUS.Connected && _isPlaying && previousStatus === CHROMECAST_STATUS.Connecting) {
				_internalLoadAndPlayEvent = false;
				Debug.log('Connected and playing');
				api.pause();

				if (api.state().ready && api.video && api.video().getCurrentTime) {
					_updateVideoStartPosition(api.video().getCurrentTime() || storedPosition);
				}
				NativeDispatcher.load();
				ccUi.show(CHROMECAST_STATUS.Connected);

				_sendEvent('ready', {
					externalUi: true
				});
			} else if (currentStatus === CHROMECAST_STATUS.Connected && _internalLoadAndPlayEvent && !_isPaused) {
				_internalLoadAndPlayEvent = false;
				Debug.log('Connected and ready, sending native load event');
				NativeDispatcher.load();

				_sendEvent('ready', {
					externalUi: true
				});
			} else if (currentStatus === CHROMECAST_STATUS.Connected && api.state().ready && !_isPaused) {
				_internalLoadAndPlayEvent = false;
				Debug.log('Connected and api-ready, show correct ui state');
				//NativeDispatcher.load();
				api.pause();
				ccUi.show(CHROMECAST_STATUS.Connected);

				_sendEvent('ready', {
					externalUi: true
				});
			} else if (currentStatus === CHROMECAST_STATUS.Connecting) {
				if (_isPlaying && !_isPaused) {
					Debug.log('Connecting and playing, pausing...');
					api.pause();
				}
				ccUi.show(CHROMECAST_STATUS.Connecting);
			} else if (currentStatus === CHROMECAST_STATUS.Disconnected && customData.eventMethod === STATUS_EVENT_METHOD.ENDED) {
				_internalLoadAndPlayEvent = false;
				var videoId = videoData.videoId;

				api.reset();
				_sendEvent('ready', {
					externalUi: false
				});

				Debug.log('Disconnected and ended cast at position: ' + customData.position);
				VideoAttributes.setStartPosition(Sizzle('video', api.element())[0], customData.position);
				api.load(videoId);
				// And then show controls
				api.fire('showControls', { shouldShow: true });
			} else if (currentStatus === CHROMECAST_STATUS.Disconnected && customData.eventMethod !== STATUS_EVENT_METHOD.ENDED) {
				_internalLoadAndPlayEvent = false;
			} else {
				Debug.log('Changed CC Status but not handled %s -> %s', customData.eventMethod, currentStatus);
			}
		}

		var oldSetPlayerState = window.IOSDeviceChromecastBridge.setChromecastPlayerState;
		window.IOSDeviceChromecastBridge.setChromecastPlayerState = function (playerState, customData) {
			if (typeof customData === 'string') {
				try {
					customData = JSON.parse(customData);
					customData.position = parseInt(customData.position, 10);
					customData.videoId = customData.videoId || null;
				} catch (e) {
					Debug.warn('Could not parse customData: ' + customData);
					customData = {};
				}
			}

			var currPlayerState = currentSessionPlayState();
			oldSetPlayerState(playerState);
			switch (playerState) {
				case CHROMECAST_PLAYER_STATE.PLAYING:
					if (currPlayerState !== playerState) {
						_sendEvent('playing');
					}
					ccUi.show(CHROMECAST_STATUS.Connected);
					break;
				case CHROMECAST_PLAYER_STATE.BUFFERING:
					if (currPlayerState !== playerState) {
						_sendEvent('buffering');
					}
					break;
				case CHROMECAST_PLAYER_STATE.LOADING:
					if (currPlayerState !== playerState) {
						_sendEvent('loading');
					}
					break;
				case CHROMECAST_PLAYER_STATE.PAUSED:
					if (currPlayerState !== playerState) {
						Debug.log('Player sent pause event');
						_sendEvent('pause');
					}
					break;
				case CHROMECAST_PLAYER_STATE.IDLE:
					// For some reason, idle gets called when switching video -- it should be handled by the app but fallback handled here!
					if (!_isLoading) {
						if (!customData.videoId || customData.videoId === videoData.videoId) {
							_sendEvent('pause');
							_sendEvent('ended', { videoId: customData.videoId });
						} else if (customData.videoId) {
							_sendEvent('ended', { videoId: videoData.videoId });
						} else if (!videoPlaylist || !videoPlaylist.items) {
							_sendEvent('ended', { videoId: videoData.videoId });
						}
					}
					break;
				case CHROMECAST_PLAYER_STATE.UNKNOWN:
					// Probably an error?
					Debug.log('unknownPlayerState State=%s isLoading=%s isPlaying=%s isPaused=%s', currentSessionStatus(), _isLoading, _isPlaying, _isPaused);
					break;
			}

			// Update this last
			_updateActivePlaylistVideoData(customData.videoId, customData.position);
		};

		function _updateActivePlaylistVideoData(videoId, position) {
			if (!videoPlaylist || videoPlaylist.items === 0) {
				Debug.log('_updateActivePlaylistVideoData: incorrect videoPlaylist', videoPlaylist);

				return;
			}

			if (!videoId || videoId === '' || videoId === videoData.videoId) {
				//Debug.log('_updateActivePlaylistVideoData: incorrect videoId (%s) or same as videoData %s', videoId, videoData.videoId);
				return;
			}

			videoData = initialVideoData();
			for (var i = 0; i < videoPlaylist.items.length; i++) {
				var playlistItem = videoPlaylist.items[i];
				if (playlistItem.videoId === videoId) {
					videoData.videoId = playlistItem.videoId;
					videoData.posterImage = playlistItem.poster;
					videoData.thumbnailImage = playlistItem.poster;
					videoData.position = position;
					// Updated videoData, send event
					_sendEvent('ready', {
						videoId: videoData.videoId,
						externalUi: true
					});
				}
			}

			if (videoData.videoId === '') {
				Debug.log('_updateActivePlaylistVideoData: Did not find videoPlaylistItem for ' + videoId);
			} else {
				Debug.log('_updateActivePlaylistVideoData: Found videoData for videoId = ' + videoData.videoId);
			}
		}

		function _updateVideoStartPosition(startPosition) {
			videoData.position = startPosition;

			if (videoPlaylist && videoPlaylist.items) {
				videoPlaylist.items[0].startPosition = videoData.position;
			}
		}

		function getPosterImage() {
			return videoData.posterImage || Sizzle('video', api.element())[0].getAttribute('poster') || api.config.defaultThumbnail;
		}

		function _buildVideodata(videoId, metadata) {
			// Reset first!
			videoData = initialVideoData();

			var posterImage = getPosterImage();

			videoData.videoId = videoId;
			videoData.thumbnailImage = posterImage;
			videoData.posterImage = posterImage;
			videoData.position = VideoAttributes.getStartPosition(Sizzle('video', api.element())[0]) || 0;
			videoData.metadata = metadata || {};

			Debug.log('videoData', videoData);
			_buildVideoPlaylist(videoId);
		}

		function _buildVideoPlaylist(videoId) {
			/**
    See DEFAULT_VIDEO_PLAYLIST for required format
    using getVideoPlaylistFunction
    */
			if (typeof VideoConfig.getVideoPlaylistFunction === 'function') {
				var position = VideoAttributes.getStartPosition(Sizzle('video', api.element())[0]) || 0;
				videoPlaylist = VideoConfig.getVideoPlaylistFunction(videoId, position);
				Debug.log('videoPlaylist', videoPlaylist);
			}
		}

		function _getMetadataForIOSNativePlayer(videoId, onSuccess) {
			VideoConfig.metadataFetchFunction(videoId, function (metadata) {
				api.fire('metadata', metadata);
				if (api.data().inSweden !== undefined && !api.data().inSweden && metadata.rights && metadata.rights.geoBlockedSweden) {
					api.fire('error', {
						name: _errorType2.default.GEO_BLOCK_ERROR
					});

					return;
				}

				_buildVideodata(videoId, metadata);

				_sendEvent('ready', {
					videoId: videoData.videoId,
					externalUi: true
				});
				api.state().loading = false;
				api.state().ready = true;
				onSuccess(videoData);
			}, function (error, data) {
				if (data) {
					api.fire('metadata', data);
				}
				api.fire('error', error);
			});
		}

		function _reset() {
			videoData = initialVideoData();
			videoPlaylist = null;
			_isLoading = false;
			_isPlaying = false;
			_isExternalUi = false;
			_isPaused = false;
			_internalLoadAndPlayEvent = false;

			ccUi.reset();
		}

		function _isConnected() {
			return (0, _sessionStorageWrapper.getFromSessionStorage)(_sessionStorageKey) === CHROMECAST_STATUS.Connected;
		}

		function _isConnecting() {
			return (0, _sessionStorageWrapper.getFromSessionStorage)(_sessionStorageKey) === CHROMECAST_STATUS.Connecting;
		}

		api.on(NAMESPACE + '.playing', function () {
			_isLoading = false;
			_isPlaying = true;
			_isPaused = false;
		});

		api.on(NAMESPACE + '.ready', function (event) {
			_isExternalUi = event.detail.externalUi;
			_isLoading = false;
			_isPaused = false;
		});

		api.on(NAMESPACE + '.pause', function () {
			_isPaused = true;
		});

		api.on(NAMESPACE + '.ended', function () {
			ccUi.hide();
			_isPlaying = false;
			_isPaused = false;
		});

		api.on(NAMESPACE + '.error', function () {
			if (_isConnected() || _isConnecting()) {
				domUtils.removeClass(api.element(), STATE_CLASS.error);
			} else {
				_isPlaying = false;
				_isPaused = false;
			}
		});

		api.on(NAMESPACE + '.controls', function (event) {
			if (event && event.detail && event.detail.visible !== undefined) {
				NativeDispatcher.controlsToggled(event.detail.visible);
			}
		});

		ccUi.build();

		api.filters.push({
			load: function load(videoId) {
				Debug.log('Loading ios-chromecast, connected = ' + _isConnected());
				videoId = videoId || Sizzle('video', api.element())[0].getAttribute('data-video-id');
				if (_isConnected() || _isConnecting()) {

					if (videoData.videoId === videoId) {
						Debug.log('Already loading or will automatically load video with id = ' + videoId);
						ccUi.show(currentSessionStatus());

						return true;
					}

					_isLoading = true;
					_handleStateUpdate(currentSessionStatus());
					_buildVideoPlaylist(videoId);

					if (videoPlaylist) {
						api.state().ready = true;
						_internalLoadAndPlayEvent = true;
						_sendEvent('ready', {
							videoId: videoId,
							externalUi: true
						});

						api.play(videoId);

						return;
					}

					_getMetadataForIOSNativePlayer(videoId, function () {
						api.state().ready = true;

						_sendEvent('ready', {
							videoId: videoId,
							externalUi: true
						});

						if (api.config.autoplay) {
							api.play(videoId);
						}
					});

					return true;
				} else {
					_reset();
					api.once(NAMESPACE + '.metadata', function (metadata) {
						_buildVideodata(videoId, metadata.detail);
					});
				}

				return false;
			},
			play: function play(videoId) {
				if (_isConnected()) {
					api.reset();

					NativeDispatcher.load();

					_sendEvent('ready', {
						videoId: videoId,
						externalUi: true
					});

					return true;
				} else if (_isConnecting()) {
					_sendEvent('ready', {
						videoId: videoId,
						externalUi: true
					});

					return true;
				}
			},
			reset: function reset() {
				if (_isConnected() || _isConnecting()) {
					if (_isPlaying || _isLoading) {
						Debug.log('reset() - Ignored since were connected to chromecast and loading/playing video');

						return true;
					}
				} else {
					_reset();
				}
			},
			pause: function pause() {
				_isPaused = true;

				return _isConnected();
			},
			seek: function seek() {
				return _isConnected();
			},
			getVolume: function getVolume() {
				return _isConnected();
			},
			isMuted: function isMuted() {
				if (_isConnected()) {
					return false;
				}

				return null;
			},
			mute: function mute() {
				return _isConnected();
			},
			showCaptions: function showCaptions() {
				return _isConnected();
			},
			setVolume: function setVolume() {
				return _isConnected();
			}
		});
	},

	destroy: function destroy(api) {
		api.off(NAMESPACE + '.playing');
		api.off(NAMESPACE + '.pause');
		api.off(NAMESPACE + '.ready');
		api.off(NAMESPACE + '.ended');
		api.off(NAMESPACE + '.error');
		api.off(NAMESPACE + '.controls');

		var chromecastElement = Sizzle('.' + CLASSNAMES.chromecast, api.element())[0];
		if (chromecastElement) {
			api.element().removeChild(chromecastElement);
		}
	}
};

/***/ }),

/***/ "59mL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*global SVP */


/**
 * The splash plugin shows an overlay with a play button or loading indicator,
 * depending on the current state of the video player. In addition, the plugin
 * will show an indication on whether the current media is a live stream.
 */

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.namespace = undefined;

var _map = __webpack_require__("ifoU");

var _map2 = _interopRequireDefault(_map);

var _assign = __webpack_require__("woOf");

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

exports.create = create;
exports.destroy = destroy;

var _sizzle = __webpack_require__("zZaF");

var _sizzle2 = _interopRequireDefault(_sizzle);

var _dom = __webpack_require__("TdxG");

var domUtils = _interopRequireWildcard(_dom);

var _videoAttributes = __webpack_require__("tpcr");

var _videoAttributes2 = _interopRequireDefault(_videoAttributes);

var _debug = __webpack_require__("BF+C");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var config = __webpack_require__("Pqsl");


var NAMESPACE = 'splash';
var Debug = (0, _debug2.default)(NAMESPACE);

var BUTTON_ICONS = {
    play: 'svp_splash__btn-play',
    loading: 'svp_splash__btn-loading'
};

var ATTRIBUTES = {
    videoIsLive: 'svp_is--video-live',
    splashTextVisible: 'svp_is--splash-text-visible'
};

var CLASSNAMES = {
    playButton: 'svp_js-splash--btn-play',
    liveIcon: 'svp_js-splash--live-icon',
    splash: 'svp_js-splash',
    splashText: 'svp_js-splash--text'
};

var OVERRIDE_CLASSNAMES = {
    playButton: 'svp_css-splash--btn-play'
};

var STATE_CLASS = {
    hidden: 'svp_is--hidden'
};

/**
 * Status enum for the splash plugin state.
 *
 * @readonly
 * @enum {string}
 */
var STATUS = {
    /**
     * Indicates that the splash should show the play button.
     */
    idle: 'idle',

    /** Indicates that the video is currently loading or buffering. */
    loading: 'loading',

    /** Indicates that the splash is hidden. */
    hidden: 'hidden'
};

function createSplashElement() {
    var splashElement = domUtils.fromString('<div class="svp_splash ' + CLASSNAMES.splash + '">\
            <div class="svp_splash__video-live ' + CLASSNAMES.liveIcon + '">\
                <span class="svp_splash__video-live__icon"></span>\
                <span class="svp_splash__video-live__text">Direkt</span>\
            </div>\
            <div class="svp_splash__inner">\
                <button class="' + BUTTON_ICONS.loading + ' ' + CLASSNAMES.playButton + ' ' + OVERRIDE_CLASSNAMES.playButton + '" \
                    aria-live="assertive" \
                    tabindex="0"\
                    data-rt="video-player-splash-play">\
                    <span class="svt_splash__video-icon--play"></span>\
                    <span class="svp_ui-controls__hidden">Spela video</span>\
                    <span class="svp_splash__text ' + CLASSNAMES.splashText + '"></span>\
                </button>\
            </div> \
        </div>');

    if (SVP._cssNotLoadedClass) {
        domUtils.addClass(splashElement, SVP._cssNotLoadedClass);
        splashElement.style.visibility = 'hidden';
    }

    return splashElement;
}

function getVideoElement(api) {
    return (0, _sizzle2.default)('video', api.element())[0];
}

function getSplashTextFromVideoElement(videoElement) {
    var splashText = _videoAttributes2.default.getSplashText(videoElement);

    return splashText ? String(splashText) : '';
}

var SplashPlugin = function () {
    function SplashPlugin(api) {
        (0, _classCallCheck3.default)(this, SplashPlugin);

        this.api = api;

        this.state = {
            isLive: false,
            status: STATUS.idle,
            wasPlayed: false
        };

        // Create DOM elements
        this.splashRootElement = createSplashElement();
        this.splashButtonElement = (0, _sizzle2.default)('.' + CLASSNAMES.playButton, this.splashRootElement)[0];
        this.splashTextElement = (0, _sizzle2.default)('.' + CLASSNAMES.splashText, this.splashRootElement)[0];

        this._addOwnEventListeners();
        this._addAPIEventListeners();
        this._addAPIFilters();

        this.updateElements();
        this.api.element().appendChild(this.splashRootElement);
    }

    (0, _createClass3.default)(SplashPlugin, [{
        key: 'setState',
        value: function setState(newState) {
            Debug.log('New splash state: ', newState);
            this.state = newState;
            this.updateElements();
        }
    }, {
        key: 'mergeState',
        value: function mergeState(newState) {
            this.setState((0, _assign2.default)({}, this.state, newState));
        }

        /**
         * Update the DOM with the current state.
         */

    }, {
        key: 'updateElements',
        value: function updateElements() {
            var _state = this.state,
                status = _state.status,
                isLive = _state.isLive;

            var splashText = getSplashTextFromVideoElement(getVideoElement(this.api));
            var buttonIcon = status === STATUS.loading ? BUTTON_ICONS.loading : BUTTON_ICONS.play;

            // Update button
            domUtils.removeClass(this.splashButtonElement, BUTTON_ICONS.play);
            domUtils.removeClass(this.splashButtonElement, BUTTON_ICONS.loading);
            domUtils.addClass(this.splashButtonElement, buttonIcon);

            // Update text
            this.splashTextElement.innerHTML = splashText;
            domUtils.toggleClass(this.splashButtonElement, ATTRIBUTES.splashTextVisible, Boolean(splashText));

            // Update root
            domUtils.toggleClass(this.splashRootElement, STATE_CLASS.hidden, status === STATUS.hidden);
            domUtils.toggleClass(this.splashRootElement, ATTRIBUTES.videoIsLive, isLive);
        }

        /**
         * Attempt to play the video if it is ready, or load the video if it
         * is not yet loaded.
         */

    }, {
        key: 'loadOrPlay',
        value: function loadOrPlay() {
            var _this = this;

            var apiState = this.api.state();
            if (!apiState.ready && !apiState.loading) {
                // Load video if not yet loaded.
                this.api.load(this.api.data().videoId, true);
            } else {
                this.api.play().catch(function () {
                    // If the play fails we are no longer loading.
                    _this.mergeState({ status: STATUS.idle });
                });
            }
        }
    }, {
        key: 'destroy',
        value: function destroy() {
            this.api.off(NAMESPACE + '.ready');
            this.api.off(NAMESPACE + '.playing');
            this.api.off(NAMESPACE + '.metadata');
            this.api.off(NAMESPACE + '.click');

            if (this.splashRootElement && this.splashRootElement.parentElement) {
                this.splashRootElement.parentElement.removeChild(this.splashRootElement);
            }
        }

        /**
         * @private
         */

    }, {
        key: '_addOwnEventListeners',
        value: function _addOwnEventListeners() {
            var _this2 = this;

            this.splashRootElement.addEventListener('keyup', function (ev) {
                if (_this2.state.status === STATUS.idle) {
                    var key = domUtils.getKeyFromKeyEvent(ev);
                    if (key === 'enter' || key === 'space') {
                        _this2.loadOrPlay();
                    }
                }
            });
        }

        /**
         * @private
         */

    }, {
        key: '_addAPIEventListeners',
        value: function _addAPIEventListeners() {
            var _this3 = this;

            this.api.on(NAMESPACE + '.click', function () {
                if (_this3.state.status === STATUS.idle) {
                    _this3.loadOrPlay();
                }
            });

            this.api.on(NAMESPACE + '.playing', function () {
                _this3.mergeState({
                    status: STATUS.hidden,
                    wasPlayed: true
                });
            });

            this.api.on(NAMESPACE + '.canplay', function () {
                if (!_this3.state.wasPlayed) {
                    _this3.mergeState({
                        status: STATUS.idle
                    });
                }
            });

            this.api.on(NAMESPACE + '.ready', function () {
                if (_this3.api.isAutoplay() && !_this3.state.wasPlayed) {
                    _this3.mergeState({ status: STATUS.loading });
                } else {
                    _this3.mergeState({ status: STATUS.idle });
                }
            });

            this.api.on(NAMESPACE + '.metadata', function (ev) {
                var isLive = Boolean(ev && ev.detail && ev.detail.live);

                _this3.mergeState({ isLive: isLive });
            });

            this.api.on(NAMESPACE + '.autoplaynotallowed', function () {
                _this3.mergeState({ status: STATUS.idle });
            });

            this.api.once(NAMESPACE + '.suspend', function () {
                if (!_this3.state.wasPlayed) {
                    _this3.mergeState({ status: STATUS.idle });
                }
            });
        }

        /**
         * @private
         */

    }, {
        key: '_addAPIFilters',
        value: function _addAPIFilters() {
            var _this4 = this;

            this.api.filters.push({
                load: function load(videoId, autoplay) {
                    if (_this4.api.isAutoplay()) {
                        _this4.mergeState({ status: STATUS.loading, wasPlayed: false });
                    } else {
                        _this4.mergeState({ status: STATUS.idle, wasPlayed: false });
                    }
                },
                play: function play() {
                    if (!_this4.state.wasPlayed) {
                        _this4.mergeState({ status: STATUS.loading });
                    }
                }
            });
        }
    }]);
    return SplashPlugin;
}();

var instances = new _map2.default();

exports.namespace = NAMESPACE;
function create(api) {
    if (api.config.autostart || !config.splash) {
        return;
    }

    if (instances.has(api)) {
        Debug.warn('SplashPlugin was already created for this api instance and has' + ' not been destroyed. The previous instance may leak memory and' + ' listeners.');
    }

    var instance = new SplashPlugin(api);
    instances.set(api, instance);

    return instance;
}

function destroy(api) {
    if (instances.has(api)) {
        instances.get(api).destroy();
        instances.delete(api);
    }
}

/***/ }),

/***/ "5E+y":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _createDestroy(extendDestroy, extensionDestroy) {
	return function () {
		extendDestroy();
		extensionDestroy();
	};
}

module.exports = function () {
	if (!arguments.length) {
		return;
	}

	var extended = arguments[0]; // eslint-disable-line prefer-rest-params

	for (var i = 1; i < arguments.length; i++) {
		var extension = arguments[i]; // eslint-disable-line prefer-rest-params

		if (!extension) {
			continue;
		}

		for (var name in extension) {
			if (Object.prototype.hasOwnProperty.call(extension, name)) {
				var extendedProperty = extended[name];
				var extensionProperty = extension[name];

				if (name === 'destroy' && typeof extendedProperty === 'function' && typeof extensionProperty === 'function') {
					extended.destroy = _createDestroy(extensionProperty.bind(extension), extendedProperty.bind(extended));
				} else if (extensionProperty !== undefined && extendedProperty !== extensionProperty) {
					extended[name] = extensionProperty;
				}
			}
		}
	}

	return extended;
};

/***/ }),

/***/ "5Fj8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var each = __webpack_require__("eAa1")(0);
var redefine = __webpack_require__("1RnF");
var meta = __webpack_require__("+zJ9");
var assign = __webpack_require__("xVc6");
var weak = __webpack_require__("74xK");
var isObject = __webpack_require__("8ANE");
var fails = __webpack_require__("zyKz");
var validate = __webpack_require__("fTPD");
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var tmp = {};
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__("1jZ2")(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),

/***/ "5QVw":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("tYO1"), __esModule: true };

/***/ }),

/***/ "6/yx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (!Function.prototype.bind) {
	Function.prototype.bind = function bind(that) {
		// .length is 1
		var target = this;
		if (typeof target != "function") {
			throw new TypeError("Function.prototype.bind called on incompatible " + target);
		}
		var slice = [].slice;
		var Empty = function Empty() {};
		var args = slice.call(arguments, 1); // for normal call
		var bound = function bound() {

			if (this instanceof bound) {

				var result = target.apply(this, args.concat(slice.call(arguments)));
				if (Object(result) === result) {
					return result;
				}
				return this;
			} else {
				return target.apply(that, args.concat(slice.call(arguments)));
			}
		};
		if (target.prototype) {
			Empty.prototype = target.prototype;
			bound.prototype = new Empty();
			Empty.prototype = null;
		}
		return bound;
	};
}

/***/ }),

/***/ "6flW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setInSessionStorage = setInSessionStorage;
exports.getFromSessionStorage = getFromSessionStorage;
exports.removeFromSessionStorage = removeFromSessionStorage;
var Debug = __webpack_require__("BF+C")('session-storage-wrapper');

/**
 * If you´re browsing in private mode in Safari, the session storage will throw an error.
 * This wrapper function takes care of that kind of errors.
 * @param {string} key
 * @param {*} value
 */
function setInSessionStorage(key, value) {
    if (window.sessionStorage) {
        try {
            sessionStorage[key] = value;
        } catch (e) {
            Debug('Could not save to session storage', e);
        }
    }
}

/**
 * If you´re browsing in private mode in Safari, the session storage will throw an error.
 * This wrapper function takes care of that kind of errors.
 * @param {string} key
 * @param defaultValue {*} If unset
 * @returns {*}
 */
function getFromSessionStorage(key) {
    var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    if (window.sessionStorage) {
        try {
            return sessionStorage[key] || defaultValue;
        } catch (e) {
            Debug('Could not fetch from session storage', e);

            return defaultValue;
        }
    }
}

/**
 * If you´re browsing in private mode in Safari, the session storage will throw an error.
 * This wrapper function takes care of that kind of errors.
 * @param {string} key
 */
function removeFromSessionStorage(key) {
    if (window.sessionStorage) {
        try {
            sessionStorage.removeItem(key);
        } catch (e) {
            Debug('Could not fetch from session storage', e);
        }
    }
}

/***/ }),

/***/ "6n1X":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* global chrome */


var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _sessionStorageWrapper = __webpack_require__("6flW");

var _errorType = __webpack_require__("0PB5");

var _errorType2 = _interopRequireDefault(_errorType);

var _dom = __webpack_require__("TdxG");

var domUtils = _interopRequireWildcard(_dom);

var _audioTrack = __webpack_require__("0Gsn");

var _audioTrack2 = _interopRequireDefault(_audioTrack);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var statsUtil = __webpack_require__("ahyN");
var VideoConfig = __webpack_require__("Pqsl");
var Sizzle = __webpack_require__("zZaF");
var Debug = __webpack_require__("BF+C")('chromecast');


var EVENT_NAMESPACE = 'chromecast';
var CAPTIONS_STORAGE_KEY = "captionsOn";
var AUDIO_STORAGE_KEY = 'audioTrack';

module.exports = {
	create: function create(api) {

		if (!window.chrome) {
			return;
		}

		var APPLICATION_ID = VideoConfig.chromecastReceiverId,
		    START_BITRATE = 3000,
		    MAX_BITRATE = 9000,
		    SESSION_KEY = "chromecastEnabled";

		var NAMESPACE = {
			ERROR: 'urn:x-cast:svt.chromecast.error',
			SEND_COMMAND: 'urn:x-cast:svt.chromecast.command'
		};

		var COMMANDS = {
			SUBS_ON: "SUBS_ON",
			SUBS_OFF: "SUBS_OFF",
			SUBS_STATUS: "SUBS_STATUS",
			NO_SUBS: "NO_SUBS",
			WAN_CONNECTION_LOST: "WAN_CONNECTION_LOST",
			WAN_CONNECTION_RESTORED: "WAN_CONNECTION_RESTORED",
			AUDIO_DEFAULT: "AUDIO_DEFAULT",
			AUDIO_SPOKEN: "AUDIO_SPOKEN"
		};

		var STATUS = {
			INACTIVE: 0,
			ACTIVE: 1,
			LOADING: 2,
			PLAYING: 3,
			PAUSED: 4,
			SEEKING: 5,
			BUFFERING: 6,
			IDLE: 7,
			OTHER_VIDEO_PLAYING: 8,
			ERROR: 9,
			CONNECTING: 10
		};

		var ICON = {
			CC_OFF: 'svp_chromecast__button-not-connected',
			CC_ON: 'svp_chromecast__button-connected',
			CC_CONNECTING_0: 'svp_chromecast__button-connecting-1',
			CC_CONNECTING_1: 'svp_chromecast__button-connecting-2',
			CC_CONNECTING_2: 'svp_chromecast__button-connecting-3',
			CC_CONNECTING_3: 'svp_chromecast__button-connecting-2',
			PAUSE: 'svt_icon--pause',
			STOP: 'svt_icon--stop'
		};

		function _sendEvent(eventType, data) {
			if (api.fire) {
				api.fire(eventType, data);
			}
		}

		this.chromecastController = {
			_startPosition: null,
			_autostart: false,
			_sessionStorageTimeout: null,
			_videoData: null,
			_buttonIconLoadingTimer: null,
			_subAvailableSent: false,
			error: false,
			disallowed: false,
			session: null,

			setMetadata: function setMetadata(metadata) {
				this._videoData = metadata.detail;
			},

			loadChromeCast: function loadChromeCast() {
				var _this = this;

				this._sessionStorageTimeout = setTimeout(function () {
					if (window.sessionStorage) {
						sessionStorage.removeItem(SESSION_KEY);
					}
					// TODO: this should be some sort of reset
				}, 5000);

				if (this.hasLocalSession()) {
					api.data().allowNoUi = false;
					api.data().isRemote = true;
				}

				this._loadChromeCastSDK(function () {
					if (!chrome.cast || !chrome.cast.isAvailable) {
						var _intervalTimer = setInterval(function () {
							if (chrome.cast && chrome.cast.isAvailable) {
								clearInterval(_intervalTimer);
								_this._initChromeCast();
							}
						}, 1000);
					} else {
						_this._initChromeCast();
					}
				});

				api.on(EVENT_NAMESPACE + '.error', function () {
					_this.error = true;
				});
			},

			_initChromeCast: function _initChromeCast() {
				if (!chrome.cast.SessionRequest) {
					return;
				}

				var sessionRequest = new chrome.cast.SessionRequest(APPLICATION_ID);
				var apiConfig = new chrome.cast.ApiConfig(sessionRequest, this._sessionFoundListener.bind(this), this._receiverListener.bind(this), chrome.cast.AutoJoinPolicy.TAB_AND_ORIGIN_SCOPED);

				chrome.cast.initialize(apiConfig, this._onInitSuccess.bind(this), this._onInitError.bind(this));
			},

			_loadChromeCastSDK: function _loadChromeCastSDK(callback) {
				if (!chrome.cast) {
					domUtils.getScript('https://www.gstatic.com/cv/js/sender/v1/cast_sender.js').then(function () {
						callback();
					});
				} else {
					callback();
				}
			},

			_sessionFoundListener: function _sessionFoundListener(session) {
				// Exit early if we've already been destroyed
				if (!api.state()) {
					return;
				}
				this.session = session;
				api.data().allowNoUi = false;
				api.data().isRemote = true;

				this.session.addMessageListener(NAMESPACE.SEND_COMMAND, this._sessionCommandListener.bind(this));
				this._setChromecastButtonState(STATUS.ACTIVE);
				clearTimeout(this._sessionStorageTimeout);

				(0, _sessionStorageWrapper.setInSessionStorage)(SESSION_KEY, true);

				var media = this.getMedia(session);
				if (media) {
					var currVideoId = media.media.customData.videoId,
					    state = media.playerState;

					if (api.data().videoId === currVideoId) {
						this._isCurrentCastVideo = true;
						this._initMediaListeners();
						this._sendCommand(COMMANDS.SUBS_STATUS);

						_sendEvent('play');
						if (state === chrome.cast.media.PlayerState.PLAYING || state === chrome.cast.media.PlayerState.BUFFERING) {
							_sendEvent('playing');
							this.startProgressTimer();
						} else {
							_sendEvent('pause');
							this.stopProgressTimer();
						}

						this.duration = media.media.duration;

						this.currentTime = media.currentTime;
						this.updateProgress();
						_sendEvent('volumechange');
					} /*else {
       //MessageChannel.publish('/player/chromecast/othervideo/' + this.video.playerID);
       }*/
				} else if (this._autostart) {
					this._loadMediaOnChromecast();
					this._autostart = false;
				} /*else {
      //MessageChannel.publish('/player/chromecast/idle/' + this.video.playerID, this.session.receiver.friendlyName);
      }*/

				this.session.addUpdateListener(this._sessionUpdateListener.bind(this));
			},

			_getChromecastButton: function _getChromecastButton() {
				var button = Sizzle('.svp_chromecast-button', api.element());

				if (!button.length && !this.buttonInserted) {
					button = domUtils.fromString('<div class="svp_chromecast-button"></div>');
					var _this = this;
					domUtils.addEvents(button, 'click, touchend', function (e) {
						Debug('CC clicked');
						e.stopPropagation();
						_this._requestSession();
					});

					api.insertButton(button);
					this.buttonInserted = true;
				}

				return button;
			},

			_receiverListener: function _receiverListener(receiverState) {

				if (api.state() && !this.disallowed) {
					if (receiverState === chrome.cast.ReceiverAvailability.AVAILABLE) {
						domUtils.show(this._getChromecastButton());
						this._setChromecastButtonState(STATUS.INACTIVE);
					} else if (this._getChromecastButton()) {
						domUtils.hide(this._getChromecastButton());
					}
				}
			},

			_sessionUpdateListener: function _sessionUpdateListener(session) {
				if (!session) {
					//MessageChannel.publish('/player/chromecast/inactive/' + this.video.playerID);
					this.session = null;
					this._stopSession();
				} else {
					_sendEvent('volumechange');
				}
			},

			_sessionCommandListener: function _sessionCommandListener(namespace, commandStr) {
				if (namespace === NAMESPACE.SEND_COMMAND) {
					var command = void 0;
					var sendSubStatus = void 0;
					var sendAudioStatus = void 0;

					try {
						command = JSON.parse(commandStr).command;
					} catch (e) {}

					switch (command) {
						case COMMANDS.SUBS_OFF:
							_sendEvent('captionsvisible', { shouldShow: false });
							sendSubStatus = true;
							break;
						case COMMANDS.SUBS_ON:
							_sendEvent('captionsvisible', { shouldShow: true });
							sendSubStatus = true;
							break;
						case COMMANDS.AUDIO_DEFAULT:
						case COMMANDS.AUDIO_SPOKEN:
							sendAudioStatus = true;
							break;
						case COMMANDS.WAN_CONNECTION_LOST:
							_sendEvent('error', { error: 'connectionLost' });
							break;
						case COMMANDS.WAN_CONNECTION_RESTORED:
							// restore state
							break;
					}

					if (!this._subAvailableSent && sendSubStatus) {
						var shouldShow = domUtils.getStoredData(CAPTIONS_STORAGE_KEY) === 'true';

						if (api.state() && api.state().ready) {
							api.showCaptions(shouldShow);
						}

						_sendEvent('captionsloaded');
						this._subAvailableSent = true;
					}

					if (!this._audioAvailableSent && sendAudioStatus) {
						var preferredAudioTrack = domUtils.getStoredData(AUDIO_STORAGE_KEY) || 'sv';
						api.setAudioTrack(preferredAudioTrack);
						this._audioAvailableSent = true;
					}
				}
			},

			_onInitSuccess: function _onInitSuccess() {
				chrome.cast.addReceiverActionListener(this._receiverActionListener.bind(this));
			},

			_onInitError: function _onInitError(err) {
				// empty
			},

			_onLaunchError: function _onLaunchError(err) {
				// empty
			},

			_onMediaDiscovered: function _onMediaDiscovered(how) {
				this._initMediaListeners();

				if (how === 'loadMedia') {
					this._isCurrentCastVideo = true;
				}

				var mediaObj = this.getMedia();
				if (mediaObj) {
					if (how === 'activeSession') {
						this.currentTime = mediaObj.currentTime;
					}

					this.duration = mediaObj.media.duration;
				}

				this._loading = false;
				_sendEvent('playing');
			},

			_onLoadMediaError: function _onLoadMediaError(err) {
				if (!(err && err.description === 'LOAD_CANCELLED')) {
					_sendEvent('error', { error: _errorType2.default.LOAD_ERROR });
				}
			},

			loadAndPlay: function loadAndPlay() {
				if (this.session) {
					this._autostart = true;
					this._loadMediaOnChromecast();
				}
			},

			_requestSession: function _requestSession() {
				chrome.cast.requestSession(this._sessionFoundListener.bind(this), this._onLaunchError.bind(this));
			},

			_loadMediaOnChromecast: function _loadMediaOnChromecast() {
				api.data().allowNoUi = false;
				api.data().isRemote = true;
				_sendEvent('play');
				// Capture any canplay-events, in case we're not loaded
				if (!api.state().loaded) {
					api.on(EVENT_NAMESPACE + '.canplay', function () {
						_sendEvent('buffering');
						api.off(EVENT_NAMESPACE + '.canplay');

						return false;
					});
				}
				var mediaUrl = this._getVideoUrl();
				var data = this._videoData;

				if (!mediaUrl) {
					_sendEvent('error', { 'type': 'device' });

					return;
				}
				Debug('loading', mediaUrl);

				var mediaInfo = new chrome.cast.media.MediaInfo(mediaUrl, 'application/vnd.apple.mpegurl');
				var client = statsUtil.getClient();
				var statsProgramTitle = data.mmsStatistics.ns_st_pr || 'unknown-program';
				var statsEpisodeTitle = data.mmsStatistics.ns_st_ep || 'unknown-episode';
				var thumbnailImage = Sizzle('video', api.element())[0].getAttribute('poster') || api.config.defaultThumbnail;
				if (thumbnailImage.indexOf('http') === -1) {
					thumbnailImage = 'http:' + thumbnailImage;
				}

				var statisticsData = {
					client: client,
					mmsClientNr: statsUtil.getMmsClientNr(),
					programId: data.programVersionId,
					statisticsUrl: statsUtil.getComscoreBaseUrl() + client + '.' + statsProgramTitle + '.' + statsEpisodeTitle,
					title: statsEpisodeTitle,
					category: data.mmsStatistics.ns_st_pl,
					folderStructure: statsProgramTitle
				};

				statisticsData.subSite = statisticsData.subSite || '.desktop';

				mediaInfo.customData = {
					videoId: data.programVersionId,
					statisticsData: (0, _stringify2.default)(statisticsData),
					showSubtitles: false,
					source: window.location.href
				};
				var metadataObject = new chrome.cast.media.GenericMediaMetadata();
				metadataObject.images = [new chrome.cast.Image(thumbnailImage), new chrome.cast.Image(thumbnailImage)];

				if (data.mmsStatistics.svt_content_type === 'klipp') {
					metadataObject.title = data.episodeTitle;
					metadataObject.subtitle = '';
				} else {
					metadataObject.title = data.programTitle;
					metadataObject.subtitle = data.episodeTitle;
				}

				mediaInfo.metadata = metadataObject;

				mediaInfo.streamType = data.live ? chrome.cast.media.StreamType.LIVE : chrome.cast.media.StreamType.BUFFERED;
				mediaInfo.duration = data.live && !data.dvr ? 0 : api.video().getDuration() || 0;
				mediaInfo.tracks = [];

				var request = new chrome.cast.media.LoadRequest(mediaInfo);
				request.autoplay = true;

				if (!this._startPosition) {
					if (data.live) {
						request.currentTime = data.dvr ? data.liveStartTimeUTC : 0;
					} else {
						request.currentTime = Number(api.video().getAttribute('data-position') || 0);
					}
				} else {
					request.currentTime = this._startPosition;
				}

				this.currentTime = request.currentTime;
				this.duration = mediaInfo.duration;

				this.session.loadMedia(request, this._onMediaDiscovered.bind(this, 'loadMedia'), this._onLoadMediaError.bind(this));
			},

			_initMediaListeners: function _initMediaListeners() {
				var mediaObject = this.getMedia(),
				    _this = this;

				if (!mediaObject) {
					return;
				}

				mediaObject.addUpdateListener(function () {
					var playerState = mediaObject.playerState,
					    media = _this.getMedia();

					if (media) {
						_this.duration = media.media.duration;
						_this.currentTime = media.currentTime;
						_this.updateProgress();
					}

					if (!_this._settingVolume) {
						_sendEvent('volumechange');
					}

					if (_this.seeked && (playerState === chrome.cast.media.PlayerState.PLAYING || playerState === chrome.cast.media.PlayerState.PAUSED)) {
						_sendEvent('seeked');
						_this.seeked = false;
					}

					switch (playerState) {
						case chrome.cast.media.PlayerState.PLAYING:
							_sendEvent('playing');
							_this.startProgressTimer();
							_this._loading = false;
							break;
						case chrome.cast.media.PlayerState.BUFFERING:
							_sendEvent('buffering');
							_this.stopProgressTimer();
							break;
						case chrome.cast.media.PlayerState.PAUSED:
							_this.stopProgressTimer();
							_sendEvent('pause');
							break;
						case chrome.cast.media.PlayerState.IDLE:
							// For some reason, idle gets called when switching video -- disable it during load.
							if (!_this._loading) {
								_this.stopProgressTimer();
								_sendEvent('pause');
								_sendEvent('ended');
								break;
							}
					}
				});
			},

			_receiverActionListener: function _receiverActionListener(receiver, action) {
				if (action === chrome.cast.ReceiverAction.CAST) {
					api.data().allowNoUi = false;
					api.data().isRemote = true;

					if (api.state().ready) {
						api.pause();
						this._startPosition = api.video().getCurrentTime();
						this._autostart = !!this._startPosition;
					} else {
						this._startPosition = 0;
						this._autostart = false;
					}
					this._setChromecastButtonState(STATUS.CONNECTING);
				} else if (action === chrome.cast.ReceiverAction.STOP) {
					this._stopSession();
				}
			},

			_stopSession: function _stopSession(isDestroy) {
				if (this.hasLocalSession()) {
					this.session = null;
					this._setChromecastButtonState(STATUS.INACTIVE);
					(0, _sessionStorageWrapper.removeFromSessionStorage)(SESSION_KEY);

					if (!isDestroy) {
						this._resetVideo();
					}
				}
			},

			_resetVideo: function _resetVideo() {
				if (this._isCurrentCastVideo) {
					api.data().isRemote = false;
					if (this.currentTime && this.duration - this.currentTime > 15) {
						api.seek(this.currentTime);
						api.play(); //TODO figure out the correct state here, should we match the latest state from remote device?
					}
					api.on(EVENT_NAMESPACE + '.playing', function () {
						api.off(EVENT_NAMESPACE + '.playing');
						api.data().allowNoUi = true;
					});
				}
			},

			startProgressTimer: function startProgressTimer() {
				var _this = this;

				if (!this.timer) {
					this.timer = setInterval(function () {
						if (!_this.session) {
							return;
						}

						_this.currentTime += 1;
						_this.updateProgress();
					}, 1000);
				}
			},

			stopProgressTimer: function stopProgressTimer() {
				clearInterval(this.timer);
				this.timer = null;
			},

			updateProgress: function updateProgress() {
				var media = this.getMedia();

				if (!media) {
					this.stopProgressTimer();

					return;
				}

				_sendEvent('timeupdate', this.currentTime);
			},

			pause: function pause() {
				var media = this.getMedia();
				if (media) {
					var _this = this;
					media.pause(null, function () {
						_this.stopProgressTimer();
						_sendEvent('pause');
					}, function () {
						_sendEvent('error');
					});
				}
			},

			play: function play() {
				var media = this.getMedia();
				if (media) {
					var _this = this;
					media.play(null, function () {
						_sendEvent('playing');
						_this.startProgressTimer();
					}, function () {
						_sendEvent('error');
					});
				} else {
					this.loadAndPlay();
				}
			},

			seek: function seek(position) {
				var media = this.getMedia();
				var _this = this;

				if (!media) {
					return;
				}

				_sendEvent('seeking');
				this.stopProgressTimer();
				var request = new chrome.cast.media.SeekRequest();
				request.currentTime = position;

				media.seek(request, function () {
					_this.seeked = true;
				}, function (e) {
					Debug.error(e);
					_sendEvent('error');
				});
			},

			setVolume: function setVolume(level) {
				if (!this.session) {
					return;
				}

				var _this = this;
				this._settingVolume = true;
				this.session.setReceiverVolumeLevel(level, function () {
					_this._settingVolume = false;
				}, function () {
					_this._settingVolume = false;
				});
			},

			getVolume: function getVolume() {
				return this.session && this.session.receiver.volume.level;
			},

			mute: function mute(shouldMute) {
				if (!this.session) {
					return;
				}

				var _this = this;
				this._settingVolume = true;
				this.session.setReceiverMuted(shouldMute, function () {
					_this._settingVolume = false;
					_sendEvent('volumechange');
				}, function () {
					_this._settingVolume = false;
				});
			},

			isMuted: function isMuted() {
				return this.session && this.session.receiver.volume.muted;
			},

			showCaptions: function showCaptions(shouldShow) {
				var command = shouldShow ? COMMANDS.SUBS_ON : COMMANDS.SUBS_OFF;
				this._sendCommand(command, false, function (e) {
					Debug.error(e);
				});
			},

			setAudioTrack: function setAudioTrack(trackId) {
				var command = trackId === _audioTrack2.default.SPOKEN_TEXT ? COMMANDS.AUDIO_SPOKEN : COMMANDS.AUDIO_DEFAULT;
				this._sendCommand(command, false, function (e) {
					Debug.error(e);
				});
			},

			getMedia: function getMedia() {
				var mediaObject = this.session && this.session.media && this.session.media.length && this.session.media[0].media.customData ? this.session.media[0] : null;
				// The media object is only valid if it belongs to the current video being browsed.

				return mediaObject && this._videoData && mediaObject.media.customData.videoId === this._videoData.programVersionId ? mediaObject : null;
			},

			isActive: function isActive() {
				return this.session !== null;
			},

			hasLocalSession: function hasLocalSession() {
				return Boolean((0, _sessionStorageWrapper.getFromSessionStorage)(SESSION_KEY));
			},

			_getVideoUrl: function _getVideoUrl() {
				if (!this._videoData) {
					return '';
				}

				var videoRefs = this._videoData.videoReferences,
				    videoUrl,
				    hlsUrl,
				    hlsWebVttUrl;
				for (var i = 0; i < videoRefs.length; i++) {
					if (videoRefs[i].format === 'hlswebvtt') {
						hlsWebVttUrl = videoRefs[i].url;
					} else if (videoRefs[i].format === 'hls') {
						hlsUrl = videoRefs[i].url;
					}
				}

				videoUrl = hlsWebVttUrl || hlsUrl;

				if (videoUrl && !videoUrl.match(/svtklipp/)) {
					var newUrlQueryMarker = videoUrl.indexOf('?') > -1 ? '&' : '?';
					videoUrl += newUrlQueryMarker + '__b__=' + START_BITRATE + '&b=0-' + MAX_BITRATE;
				}

				return videoUrl;
			},

			_sendCommand: function _sendCommand(command, successFn, errFn) {
				if (!this.session) {
					if (errFn) {
						errFn('SESSION_ERROR');
					}

					return;
				}

				var success = successFn || function () {
					// empty
				};
				var cmdJsonString = (0, _stringify2.default)({ command: command });

				this.session.sendMessage(NAMESPACE.SEND_COMMAND, cmdJsonString, success, errFn);
			},

			_setChromecastButtonIcon: function _setChromecastButtonIcon(iconClass) {
				var _this = this;
				[ICON.CC_CONNECTING_0, ICON.CC_CONNECTING_1, ICON.CC_CONNECTING_2, ICON.CC_OFF, ICON.CC_ON].forEach(function (className) {
					domUtils.removeClass(_this._getChromecastButton(), className);
				});
				domUtils.addClass(this._getChromecastButton(), iconClass);
			},

			_setChromecastButtonState: function _setChromecastButtonState(state) {

				clearInterval(this._buttonIconLoadingTimer);
				switch (state) {
					case STATUS.ACTIVE:
						this._setChromecastButtonIcon(ICON.CC_ON);
						break;
					case STATUS.CONNECTING:
						this._setChromecastButtonIcon(ICON.CC_CONNECTING_0);
						this._startLoadingIndicator();
						break;
					default:
						this._setChromecastButtonIcon(ICON.CC_OFF);
				}
			},

			_startLoadingIndicator: function _startLoadingIndicator() {
				var counter = 1,
				    _this = this;

				this._buttonIconLoadingTimer = setInterval(function () {
					var nextIcon = counter % 4;
					counter++;

					_this._setChromecastButtonIcon(ICON['CC_CONNECTING_' + nextIcon]);
				}, 400);
			}
		};

		if (typeof chrome !== 'undefined') {
			this.chromecastController.loadChromeCast();
			var _this = this;
			api.filters.push({
				load: function load() {
					if (_this.chromecastController.isActive()) {
						_this.chromecastController._loading = true;
					}
				},
				play: function play() {
					if (_this.chromecastController.isActive()) {
						_this.chromecastController.play();

						return true;
					}
				},
				pause: function pause() {
					if (_this.chromecastController.isActive()) {
						_this.chromecastController.pause();

						return true;
					}
				},
				seek: function seek(position) {
					if (_this.chromecastController.isActive()) {
						_this.chromecastController.seek(position);

						return true;
					}
				},
				getDuration: function getDuration() {
					if (_this.chromecastController.isActive()) {
						return _this.chromecastController.duration;
					}

					return null;
				},
				getCurrentTime: function getCurrentTime() {
					if (_this.chromecastController.isActive()) {
						return _this.chromecastController.currentTime;
					}

					return null;
				},
				getVolume: function getVolume() {
					if (_this.chromecastController.isActive()) {
						return _this.chromecastController.getVolume();
					}

					return null;
				},
				isMuted: function isMuted() {
					if (_this.chromecastController.isActive()) {
						return _this.chromecastController.isMuted();
					}

					return null;
				},
				mute: function mute(shouldMute) {
					if (_this.chromecastController.isActive()) {
						_this.chromecastController.mute(shouldMute);

						return true;
					}
				},
				showCaptions: function showCaptions(shouldShow) {
					if (_this.chromecastController.isActive()) {
						_this.chromecastController.showCaptions(shouldShow);

						return true;
					}
				},
				setAudioTrack: function setAudioTrack(trackId) {
					if (_this.chromecastController.isActive()) {
						_this.chromecastController.setAudioTrack(trackId);
					}
				},
				setVolume: function setVolume(volume) {
					if (_this.chromecastController.isActive()) {
						_this.chromecastController.setVolume(volume);

						return true;
					}
				}
			});

			api.on(EVENT_NAMESPACE + '.metadata', this.chromecastController.setMetadata.bind(this.chromecastController));
			// This is a workaround for Flash -- hide the button if the flash-player is initialized
			api.on(EVENT_NAMESPACE + '.initialized', function () {
				_this.chromecastController.disallowed = true;
				domUtils.hide(_this.chromecastController._getChromecastButton());
			});
		}
	},
	destroy: function destroy(api) {
		api.off(EVENT_NAMESPACE + '.metadata');
		api.off(EVENT_NAMESPACE + '.error');
	}
};

/***/ }),

/***/ "6rdy":
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__("pEGt");
var gOPS = __webpack_require__("THEY");
var pIE = __webpack_require__("bSeU");
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),

/***/ "6tLb":
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__("ksFB");
var gOPN = __webpack_require__("2m2c").f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),

/***/ "74ZT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {

	var startOfYear;
	var startOfYesterday;
	var startOfToday;
	var startOfTomorrow;
	var startOfDayAfterTomorrow;
	var startOfNextYear;
	var monthNames = ["jan", "feb", "mar", "apr", "maj", "jun", "jul", "aug", "sep", "okt", "nov", "dec"];
	var weekDays = ["sön", "mån", "tis", "ons", "tor", "fre", "lör"];

	function _initDays(now) {
		var oneDay = 24 * 60 * 60 * 1000;

		startOfToday = new Date(now);
		startOfToday.setHours(0, 0, 0, 0);

		startOfTomorrow = new Date();
		startOfTomorrow.setTime(startOfToday.getTime() + oneDay);

		startOfDayAfterTomorrow = new Date(startOfToday.getTime() + 2 * oneDay);

		startOfNextYear = new Date(startOfToday.getTime());
		startOfNextYear.setFullYear(startOfNextYear.getFullYear() + 1);
		startOfNextYear.setMonth(0, 1);

		startOfYesterday = new Date(startOfToday.getTime() - oneDay);

		startOfYear = new Date(startOfToday.getTime());
		startOfYear.setMonth(0, 1);
	}

	return {
		getFormattedTime: function getFormattedTime(timestamp) {
			if (timestamp < 0) {
				return '--:--';
			}

			var hours = timestamp > 3600 ? Math.floor(timestamp / 3600) : null;
			var minutes = timestamp >= 60 ? Math.floor(timestamp % 3600 / 60) : 0;
			var seconds = timestamp >= 60 ? Math.floor(timestamp % 60) : Math.floor(timestamp);

			if (isNaN(seconds)) {
				seconds = 0;
			}

			minutes = minutes <= 9 ? '0' + minutes : minutes;
			seconds = seconds <= 9 ? '0' + seconds : seconds;

			return (hours !== null ? hours + ':' : '') + minutes + ':' + seconds;
		},
		getFormattedVideoLength: function getFormattedVideoLength(timestamp) {
			var roundedHours = timestamp >= 3600 ? Math.round(timestamp / 3600) : null;
			var hours = timestamp >= 3600 ? Math.floor(timestamp / 3600) : null;
			var minutes = timestamp >= 60 ? Math.round(timestamp % 3600 / 60) : 0;
			var seconds = timestamp >= 60 ? Math.round(timestamp % 60) : Math.round(timestamp);

			//follow the rules from styleguide http://styleguide.svt.se/style/text.html
			if (hours && hours >= 8) {
				return roundedHours + ' tim';
			} else if (hours && minutes) {
				return hours + ' tim ' + minutes + ' min';
			} else if (hours) {
				return hours + ' tim';
			} else if (minutes) {
				return minutes + ' min';
			} else {
				return seconds ? seconds + ' sek' : '';
			}
		},
		formatPrettyVideoDate: function formatPrettyVideoDate(date) {
			var now = new Date();
			var hours = date.getHours();
			var minutes = date.getMinutes();
			minutes = minutes <= 9 ? '0' + minutes : minutes;
			hours = hours <= 9 ? '0' + hours : hours;
			var time = hours + '.' + minutes;
			var result = '';

			if (startOfTomorrow === undefined || startOfTomorrow < now) {
				_initDays(now);
			}

			if (date > startOfNextYear) {
				//d LLL yyy
				result = date.getDate() + ' ' + monthNames[date.getMonth()] + ' ' + date.getFullYear();
			} else if (date > startOfDayAfterTomorrow) {
				//EEE d LLL
				result = weekDays[date.getDay()] + ' ' + date.getDate() + ' ' + monthNames[date.getMonth()] + ' ' + date.getFullYear();
			} else if (date > startOfTomorrow) {
				//imorgon HH.mm
				result = 'imorgon ' + time;
			} else if (date > startOfToday && date.getHours() >= 18) {
				//ikväll' HH.mm
				result = 'ikväll ' + time;
			} else if (date > startOfToday && date.getHours() < 18) {
				//'idag' HH.mm'
				result = 'idag ' + time;
			} else if (date > startOfYesterday) {
				//'igår' HH.mm'
				result = 'igår ' + time;
			} else if (date > startOfYear) {
				//'EEE d LLL'
				result = weekDays[date.getDay()] + ' ' + monthNames[date.getMonth()] + ' ' + date.getFullYear();
			} else {
				//'d LLL yyy'
				result = date.getDate() + ' ' + monthNames[date.getMonth()] + ' ' + date.getFullYear();
			}

			return result;
		}
	};
}();

/***/ }),

/***/ "74xK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__("nJ75");
var getWeak = __webpack_require__("+zJ9").getWeak;
var anObject = __webpack_require__("FKWp");
var isObject = __webpack_require__("8ANE");
var anInstance = __webpack_require__("4S0F");
var forOf = __webpack_require__("dudK");
var createArrayMethod = __webpack_require__("eAa1");
var $has = __webpack_require__("x//u");
var validate = __webpack_require__("fTPD");
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),

/***/ "7O1s":
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__("DIVP");
var aFunction = __webpack_require__("XSOZ");
var SPECIES = __webpack_require__("kkCw")('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),

/***/ "7gX0":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.1' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ "7ylX":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__("DIVP");
var dPs = __webpack_require__("twxM");
var enumBugKeys = __webpack_require__("QKXm");
var IE_PROTO = __webpack_require__("mZON")('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__("jhxf")('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__("d075").appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ "8ANE":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "8AVD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*global SvtPlayAndroid */


var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _errorType = __webpack_require__("0PB5");

var _errorType2 = _interopRequireDefault(_errorType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Sizzle = __webpack_require__("zZaF");
var External = __webpack_require__("Wzv4");
var device = __webpack_require__("xOtj");
var VideoConfig = __webpack_require__("Pqsl");
var VideoDataBuilder = __webpack_require__("0t/H");

var Debug = __webpack_require__("BF+C")('android-native');
module.exports = {
	create: function create(api) {

		if (!device.isAndroidApp()) {
			return;
		}

		var videoData,
		    _positions = {};

		function _sendEvent(eventType, data) {
			Debug('Send event: ' + eventType, data);
			api.fire(eventType, data);
		}

		var androidController = {
			_uid: null,
			_videoSettings: null,

			/* Public Methods */
			load: function load(videoId) {
				this._uid = Math.round(Math.random() * 1000000) + '';
				Debug('This.uid: ' + this._uid);
				this._addAndroidListener('ended', this._videoCallback);
				this._addAndroidListener('error', this._videoCallback);
				this._addAndroidListener('denied', this._videoCallback);
				this._addAndroidListener('closed', this._videoCallback);
				this._addAndroidListener('onlyAvailableInSweden', this._videoCallback);

				VideoConfig.metadataFetchFunction(videoId, function (metadata) {
					api.fire('metadata', metadata);
					if (api.data().inSweden !== undefined && !api.data().inSweden && metadata.rights && metadata.rights.geoBlockedSweden) {
						api.fire('error', {
							name: _errorType2.default.GEO_BLOCK_ERROR
						});

						return;
					}

					var videoElement = Sizzle('video', api.element())[0];

					api.data()._video = videoElement;

					videoData = VideoDataBuilder.build(videoId, metadata, api);
					_positions[videoId] = Number(videoElement.getAttribute('data-video-startposition')) || 0;
					_sendEvent('ready', {
						videoId: videoData.videoId,
						externalUi: true
					});
					api.state().loading = false;
					api.state().ready = true;

					if (api.config.autoplay) {
						api.play();
					}
				}, function (error, data) {
					if (data) {
						api.fire('metadata', data);
					}
					api.fire('error', error);
				});

				return true;
			},

			unload: function unload() {
				this._removeAndroidListener('ended');
				this._removeAndroidListener('error');
				this._removeAndroidListener('denied');
				this._removeAndroidListener('closed');
				this._removeAndroidListener('onlyAvailableInSweden');
			},

			play: function play() {
				if (videoData === null) {
					Debug.error('No settings loaded!');

					return false;
				}

				if (SvtPlayAndroid.setVideoData) {
					videoData.UID = this._uid;

					videoData.video.position = _positions[videoData.videoId] || 0;

					var strSettings = (0, _stringify2.default)(videoData);
					this._currVideoId = videoData.videoId;
					SvtPlayAndroid.setVideoData(strSettings);

					return true;
				}

				return false;
			},

			/* Private Methods */
			_addAndroidListener: function _addAndroidListener(eventType, method) {
				External.addExternalListener(this._uid, eventType, this, method);
			},

			_removeAndroidListener: function _removeAndroidListener(eventType) {
				External.removeExternalListener(this._uid, eventType, this);
			},
			/**
    * handles the callbacks from the android app.
    * @param a_event   name of the event
    * @param data      data of the callback, different depending of the event type.
    */
			_videoCallback: function _videoCallback(a_event, data) {
				Debug('_videoCallback(), a_event = ' + a_event + ', data = ' + data);
				var self = this,
				    closedFn = function closedFn(inData) {
					_positions[self._currVideoId] = inData ? inData.videoPosition : 0;
					_sendEvent('ready', {
						videoId: videoData.videoId,
						externalUi: true
					});
				};
				switch (a_event) {
					case 'ended':
						SvtPlayAndroid.closeVideoPlayer();
						_sendEvent('ended');
						closedFn(data);
						api.reset();
						break;
					case 'closed':
						closedFn(data);
						break;
					case 'error':
					case 'denied':
					case 'onlyAvailableInSweden':
						_sendEvent('error', {
							detail: a_event
						});
						break;
				}
			}

		};

		// Unload old androidController if any
		if (api.androidController) {
			api.androidController.unload();
		}

		api.filters.push({
			load: function load(videoId) {
				androidController.load(videoId);
				api.element().on('click', function () {
					api.play();
				});

				return true;
			},
			play: function play() {
				return !!androidController.play();
			},
			pause: function pause() {
				// no-op
				return true;
			},
			seek: function seek() {
				// no-op
				return true;
			},
			getDuration: function getDuration() {
				return true;
			},
			getCurrentTime: function getCurrentTime() {
				return true;
			},
			getVolume: function getVolume() {
				return true;
			},
			isMuted: function isMuted() {
				return true;
			},
			mute: function mute() {
				return true;
			},
			showCaptions: function showCaptions() {
				return true;
			},
			setVolume: function setVolume() {
				return true;
			}
		});

		api.androidController = androidController;
	},

	destroy: function destroy(api) {
		var androidController = api.androidController;
		if (androidController) {
			androidController.unload();
		}
		api.androidController = undefined;
	}
};

/***/ }),

/***/ "8MO0":
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__("dudK");

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),

/***/ "9GpA":
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),

/***/ "9MbE":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("8ANE");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "9h1I":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__("FHqv");
var from = __webpack_require__("8MO0");
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),

/***/ "9vb1":
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__("bN1p");
var ITERATOR = __webpack_require__("kkCw")('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),

/***/ "A16L":
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__("R3AP");
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),

/***/ "A1Hb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__("Wdy1");
var aFunction = __webpack_require__("SWGL");
var ctx = __webpack_require__("3fMt");
var forOf = __webpack_require__("dudK");

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),

/***/ "AgWD":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),

/***/ "Aq0r":
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),

/***/ "AtL8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _dom = __webpack_require__("TdxG");

var domUtils = _interopRequireWildcard(_dom);

var _time = __webpack_require__("74ZT");

var _time2 = _interopRequireDefault(_time);

var _sizzle = __webpack_require__("zZaF");

var _sizzle2 = _interopRequireDefault(_sizzle);

var _uiConstants = __webpack_require__("W1Zj");

var Constants = _interopRequireWildcard(_uiConstants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NAMESPACE = 'ui-timeline-controls';

var CLASSNAMES = {
    buffer: 'svp_js-controls-timeline--buffer',
    progress: 'svp_js-controls-timeline--progress',
    progressHandle: 'svp_js-controls-timeline--progress-handle',
    progressMetadata: 'svp_js-controls-timeline--progress-metadata',
    progressTimeIndicator: 'svp_js-controls-timeline--progress-time-indicator',
    progressTimeRemainingIndicator: 'svp_js-controls-timeline--progress-time-remaining',
    progressLivePosition: 'svp_js-controls-timeline--progress-live-position',
    timelineInner: 'svp_js-controls-timeline--inner',
    timeline: 'svp_js-controls-timeline'
};

var OVERRIDE_CLASSNAMES = {
    progress: 'svp_css-timeline--progress',
    progressHandle: 'svp_css-timeline--progress-handle',
    seek: 'svp_css-timeline--progress-seek',
    preHandleProgress: 'svp_css-timeline--pre-handle-progress',
    preHandleSeek: 'svp_css-timeline--pre-handle-seek'
};

var STATE_CLASSNAMES = {
    isAtLive: 'svp_is--at-live-position'
};

var TimelineControls = function () {
    function TimelineControls(api) {
        var _this = this;

        (0, _classCallCheck3.default)(this, TimelineControls);

        this.api = api;
        this.manualSeekInProgress = false;
        this.isEnabled = true;
        this.isControlsVisible = false;
        this.isLiveTimeshift = false;
        this.isProgressTimeIndicatorInFocus = false;
        this.isSecondaryBufferActive = false;
        this.isProgressTimeIndicatorVisible = false;

        this.api.on(NAMESPACE + '.metadata', function (data) {
            _this.isLiveTimeshift = data && data.detail.live && data.detail.timeshiftEnabled;
            _this.isEnabled = data && _this.isLiveTimeshift || !(data.detail.live || data.detail.simulcast);

            if (!_this.isEnabled) {
                domUtils.removeClass(_this._getElement(CLASSNAMES.timeline), Constants.STATE_CLASS.visible);
            } else {
                domUtils.addClass(_this._getElement(CLASSNAMES.timeline), Constants.STATE_CLASS.visible);
            }

            if (_this.isLiveTimeshift) {
                domUtils.addClass(_this._getElement(CLASSNAMES.progressLivePosition), Constants.STATE_CLASS.visible);
                domUtils.addClass(_this._getElement(CLASSNAMES.progressHandle), STATE_CLASSNAMES.isAtLive);
            } else {
                domUtils.removeClass(_this._getElement(CLASSNAMES.progressLivePosition), Constants.STATE_CLASS.visible);
                domUtils.removeClass(_this._getElement(CLASSNAMES.progressHandle), STATE_CLASSNAMES.isAtLive);
            }
        });
    }

    (0, _createClass3.default)(TimelineControls, [{
        key: '_getElement',
        value: function _getElement(className) {
            return this.api && (0, _sizzle2.default)('.' + className, this.api.element())[0];
        }
    }, {
        key: '_isAtLive',
        value: function _isAtLive(position) {
            return this.isLiveTimeshift && Math.abs(this.api.getMaxSeekable() - position) <= 30;
        }
    }, {
        key: '_setNewProgressPosition',
        value: function _setNewProgressPosition(newPos, isFraction, shouldSeek) {
            var timelineInner = this._getElement(CLASSNAMES.timelineInner);

            var rect = timelineInner.getBoundingClientRect();
            var left = 0;
            var newTime = void 0;

            var newPosition = isFraction ? rect.left + newPos * timelineInner.clientWidth : newPos;
            if (newPosition > rect.left) {
                if (newPosition >= rect.left + timelineInner.clientWidth) {
                    left = 100;
                } else {
                    var position = newPosition - (rect.left + window.pageXOffset);
                    left = 100 * (position / timelineInner.clientWidth);
                }
            }

            var duration = this.api.getDuration();
            newTime = left / 100 * duration;

            var formattedTime = _time2.default.getFormattedTime(newTime);

            var progress = this._getElement(CLASSNAMES.progress);
            var progressHandle = this._getElement(CLASSNAMES.progressHandle);
            var progressMetadata = this._getElement(CLASSNAMES.progressMetadata);

            progressHandle.style.left = left + '%';
            progressMetadata.style.left = left + '%';
            progress.style.width = left + '%';

            var progressTimeIndicator = this._getElement(CLASSNAMES.progressTimeIndicator);
            var timeRemainingIndicator = this._getElement(CLASSNAMES.progressTimeRemainingIndicator);

            progressTimeIndicator.innerHTML = formattedTime;
            timeRemainingIndicator.innerHTML = _time2.default.getFormattedTime(Math.max(duration - newTime, 0));

            if (shouldSeek) {
                this.api.seek(newTime);

                var _timelineInner = this._getElement(CLASSNAMES.timelineInner);

                _timelineInner.setAttribute('aria-valuenow', String(Math.floor(newTime)));
                _timelineInner.setAttribute('aria-valuetext', formattedTime + ' av ' + _time2.default.getFormattedTime(duration));
            }

            domUtils.forceRedraw(timelineInner);

            return newPosition;
        }
    }, {
        key: '_seekToCurrentProgressPosition',
        value: function _seekToCurrentProgressPosition() {
            var progressHandle = this._getElement(CLASSNAMES.progressHandle);

            var progressTimeIndicator = this._getElement(CLASSNAMES.progressTimeIndicator);
            var handleCenter = progressHandle.getBoundingClientRect().left + Math.ceil(progressHandle.offsetWidth / 2);

            this._setNewProgressPosition(handleCenter, false, true);

            if (!this.isProgressTimeIndicatorInFocus && this.isProgressTimeIndicatorVisible) {
                progressTimeIndicator.style.opacity = 0;
                this.isProgressTimeIndicatorVisible = false;
            }
        }
    }, {
        key: '_setProgressbarFocus',
        value: function _setProgressbarFocus(shouldFocus) {
            var progressTimeIndicator = this._getElement(CLASSNAMES.progressTimeIndicator);
            if (shouldFocus && !this.isProgressTimeIndicatorVisible) {
                progressTimeIndicator.style.opacity = 1;
                this.isProgressTimeIndicatorVisible = true;
            } else if (!shouldFocus && this.isProgressTimeIndicatorVisible && !this.isVideoSeeking) {
                progressTimeIndicator.style.opacity = 0;
                this.isProgressTimeIndicatorVisible = false;
            }
            this.isSecondaryBufferActive = shouldFocus;
            this.isProgressTimeIndicatorInFocus = shouldFocus;
        }
    }, {
        key: '_timelineMousemoveHandler',
        value: function _timelineMousemoveHandler(e) {
            if (!this.isProgressTimeIndicatorInFocus) {
                return;
            }

            this.isSecondaryBufferActive = true;

            var fraction = this._calculateSeekFraction(e.clientX);
            var newPosition = this.api.getDuration() * fraction;
            var progressPercent = 100 * fraction;

            var buffer = this._getElement(CLASSNAMES.buffer);
            buffer.style.width = progressPercent + '%';

            var progress = this._getElement(CLASSNAMES.progress);
            if (progressPercent > Number(progress.style.width.replace('%', ''))) {
                domUtils.removeClass(buffer, OVERRIDE_CLASSNAMES.preHandleSeek);
                domUtils.removeClass(progress, OVERRIDE_CLASSNAMES.preHandleProgress);
            } else {
                domUtils.addClass(buffer, OVERRIDE_CLASSNAMES.preHandleSeek);
                domUtils.addClass(progress, OVERRIDE_CLASSNAMES.preHandleProgress);
            }

            var progressMetadata = this._getElement(CLASSNAMES.progressMetadata);
            var progressTimeIndicator = this._getElement(CLASSNAMES.progressTimeIndicator);

            progressMetadata.style.left = progressPercent + '%';
            progressTimeIndicator.innerHTML = _time2.default.getFormattedTime(newPosition);
            progressTimeIndicator.style.opacity = 1;

            this.isProgressTimeIndicatorVisible = true;
        }
    }, {
        key: '_timelineClickHandler',
        value: function _timelineClickHandler(e) {
            e.stopPropagation();

            var fraction = this._calculateSeekFraction(e.clientX);
            var newPosition = this.api.getDuration() * fraction;
            var progressPercent = 100 * fraction;

            this.api.seek(newPosition);

            this._getElement(CLASSNAMES.progressHandle).style.left = progressPercent + '%';

            var progress = this._getElement(CLASSNAMES.progress);
            progress.style.width = progressPercent + '%';

            var progressMetadata = this._getElement(CLASSNAMES.progressMetadata);
            progressMetadata.style.left = progressPercent + '%';

            var progressTimeIndicator = this._getElement(CLASSNAMES.progressTimeIndicator);
            progressTimeIndicator.innerHTML = _time2.default.getFormattedTime(newPosition);
            progressTimeIndicator.style.opacity = 1;

            domUtils.removeClass(this._getElement(CLASSNAMES.buffer), OVERRIDE_CLASSNAMES.preHandleSeek);
            domUtils.removeClass(progress, OVERRIDE_CLASSNAMES.preHandleProgress);

            this.isProgressTimeIndicatorVisible = true;
            this.isSecondaryBufferActive = false;
        }
    }, {
        key: '_calculateSeekFraction',
        value: function _calculateSeekFraction(clientX) {
            var timelineContainer = this._getElement(CLASSNAMES.timelineInner);
            var position = clientX - (timelineContainer.getBoundingClientRect().left + window.pageXOffset);

            var fraction = position / timelineContainer.clientWidth;
            if (fraction < 0) {
                fraction = 0;
            }
            if (fraction > 1) {
                fraction = 1;
            }

            return fraction;
        }
    }, {
        key: '_setupTimelineClickEvents',
        value: function _setupTimelineClickEvents() {
            var _this2 = this;

            var stopEvent = function stopEvent(e) {
                e.stopPropagation();
            };

            domUtils.addEvents(this._getElement(CLASSNAMES.timelineInner), 'mouseover', this._setProgressbarFocus.bind(this, true));

            domUtils.addEvents(this._getElement(CLASSNAMES.progressLivePosition), 'click', function (e) {
                e.stopPropagation();
                _this2.api.seek(_this2.api.getMaxSeekable());
            });

            domUtils.addEvents(this._getElement(CLASSNAMES.progressHandle), 'touchstart', function (e) {

                // should stop propagation on touch since we don't want the handle click to trickle down to become a timeline click/seek event (fat fingers etc).
                e.stopPropagation();

                _this2._setProgressbarFocus.bind(_this2, true);
            });

            domUtils.addEvents(this._getElement(CLASSNAMES.timelineInner), 'mouseout', function () {
                var progressElement = _this2._getElement(CLASSNAMES.progress);
                var bufferElement = _this2._getElement(CLASSNAMES.buffer);
                var liveProgressPercent = (_this2._isAtLive(_this2.api.getCurrentTime()) ? _this2.api.getCurrentTime() : _this2.api.getMaxSeekable()) * (100 / _this2.api.getDuration());

                bufferElement.style.width = _this2.isLiveTimeshift ? liveProgressPercent + '%' : '0%';

                domUtils.removeClass(bufferElement, OVERRIDE_CLASSNAMES.preHandleSeek);
                domUtils.removeClass(progressElement, OVERRIDE_CLASSNAMES.preHandleProgress);
                _this2._setProgressbarFocus(false);
            });

            domUtils.addEvents(this._getElement(CLASSNAMES.progressHandle), 'touchend', this._setProgressbarFocus.bind(this, false));

            domUtils.addEvents(this._getElement(CLASSNAMES.timelineInner), 'mousedown', function (e) {
                return e.preventDefault();
            });

            domUtils.addEvents(this._getElement(CLASSNAMES.timelineInner), 'touchstart', function (e) {
                domUtils.removeEvents(e.currentTarget, 'touchstart, mousemove');
            });

            domUtils.addEvents(this._getElement(CLASSNAMES.timelineInner), 'mousemove', this._timelineMousemoveHandler.bind(this));

            domUtils.addEvents(this._getElement(CLASSNAMES.timelineInner), 'click', this._timelineClickHandler.bind(this));

            domUtils.addEvents(this._getElement(CLASSNAMES.progressLivePosition), 'mouseover', stopEvent);
            domUtils.addEvents(this._getElement(CLASSNAMES.progressMetadata), 'mouseover', stopEvent);
        }
    }, {
        key: '_setupTimelineKeyEvents',
        value: function _setupTimelineKeyEvents() {
            var _this3 = this;

            var numFired = 0;
            var startTime = void 0;
            var seekTimer = void 0;

            domUtils.addEvents(this.api.element(), 'keydown', function (e) {
                var keyName = domUtils.getKeyFromKeyEvent(e);
                if (keyName === 'arrowleft' || keyName === 'arrowright') {
                    e.stopPropagation();
                    e.preventDefault();
                    clearTimeout(seekTimer);

                    var step = e.shiftKey ? 1 : 10;
                    var increment = keyName === 'arrowleft' ? -step : step;
                    _this3.isVideoSeeking = true;
                    _this3.manualSeekInProgress = true;

                    if (!numFired) {
                        startTime = _this3.api.getCurrentTime();
                    }
                    numFired++;

                    var progressFraction = (startTime + numFired * increment) / _this3.api.getDuration();
                    _this3._setProgressbarFocus(true);
                    _this3._setNewProgressPosition(progressFraction, true);
                    _this3.api.fire('showControls', { shouldShow: true });

                    return false;
                }

                return true;
            });

            domUtils.addEvents(this.api.element(), 'keyup', function (e) {
                var keyName = domUtils.getKeyFromKeyEvent(e);
                if (keyName === 'arrowleft' || keyName === 'arrowright') {
                    // Seek in timer to allow for fast tapping key navigation
                    seekTimer = setTimeout(function () {
                        _this3._seekToCurrentProgressPosition();
                        _this3.manualSeekInProgress = false;
                        numFired = 0;
                        startTime = 0;
                    }, 200);
                    e.stopPropagation();
                    e.preventDefault();
                } else if (keyName === 'enter') {
                    e.stopPropagation();
                }
            });
        }
    }, {
        key: '_setupTimelineDraggingEvents',
        value: function _setupTimelineDraggingEvents() {
            var _this4 = this;

            var namespace = NAMESPACE + '-timeline';

            var dragEventFn = function dragEventFn(e) {
                var xPos = e.changedTouches ? e.changedTouches[0].clientX : e.clientX;
                _this4.manualSeekInProgress = true;
                _this4._setNewProgressPosition(xPos, false);
            };

            var mouseupFn = function mouseupFn() {
                domUtils.removeEvents(document, 'mousemove, touchmove', namespace);
                domUtils.removeEvents(document, 'mouseup, touchend', namespace);

                if (_this4.manualSeekInProgress) {
                    _this4._seekToCurrentProgressPosition();
                    _this4.manualSeekInProgress = false;
                }
            };

            var dragStartFn = function dragStartFn() {
                _this4.isVideoSeeking = true;
                domUtils.addEvents(document, 'mousemove, touchmove', dragEventFn.bind(_this4), namespace);
                domUtils.addEvents(document, 'mouseup, touchend', mouseupFn.bind(_this4), namespace);
            };

            domUtils.addEvents(this._getElement(CLASSNAMES.progressHandle), 'mousedown, touchstart', dragStartFn);
        }
    }, {
        key: '_setProgress',
        value: function _setProgress(currentTime, duration) {
            var progressPercent = duration ? currentTime * (100 / duration) : 0;
            progressPercent = Math.min(progressPercent, 100);

            var liveProgressPercent = this._isAtLive(currentTime) ? progressPercent : this.api.getMaxSeekable() * (100 / duration);
            liveProgressPercent = Math.min(liveProgressPercent, 100);

            this._getElement(CLASSNAMES.progress).style.width = progressPercent + '%';

            var progressHandle = this._getElement(CLASSNAMES.progressHandle);
            progressHandle.style.left = progressPercent + '%';
            domUtils.forceRedraw(progressHandle);

            var progressLivePosition = this._getElement(CLASSNAMES.progressLivePosition);
            if (liveProgressPercent !== progressLivePosition.style.left) {
                progressLivePosition.style.left = liveProgressPercent + '%';
                domUtils.forceRedraw(progressLivePosition);
            }

            var formattedTime = _time2.default.getFormattedTime(currentTime);
            if (!this.isSecondaryBufferActive) {
                this._getElement(CLASSNAMES.progressMetadata).style.left = progressPercent + '%';
                var progressTimeIndicator = this._getElement(CLASSNAMES.progressTimeIndicator);
                progressTimeIndicator.innerHTML = formattedTime;
                domUtils.forceRedraw(progressTimeIndicator);
                if (this.isLiveTimeshift) {
                    this._getElement(CLASSNAMES.buffer).style.width = liveProgressPercent + '%';
                }
            }

            var formattedTimeRemaining = Math.round(duration) !== Math.round(currentTime) ? '-' + _time2.default.getFormattedTime(duration - currentTime) : '--:--';
            var timeRemainingIndicator = this._getElement(CLASSNAMES.progressTimeRemainingIndicator);
            if (formattedTimeRemaining !== timeRemainingIndicator.innerHTML) {
                timeRemainingIndicator.innerHTML = formattedTimeRemaining;
                domUtils.forceRedraw(timeRemainingIndicator);
            }

            var flooredTime = Math.floor(currentTime);
            if (flooredTime % 10 === 0) {
                var timelineInner = this._getElement(CLASSNAMES.timelineInner);
                timelineInner.setAttribute('aria-valuenow', String(flooredTime));
                timelineInner.setAttribute('aria-valuemax', String(Math.floor(duration)));
                timelineInner.setAttribute('aria-valuetext', formattedTime + ' av ' + _time2.default.getFormattedTime(duration));
            }
        }
    }, {
        key: 'createElement',
        value: function createElement() {
            return domUtils.fromString('<div class="svp_ui-controls__timeline ' + CLASSNAMES.timeline + ' svp_ui-controls--hide-initial svp_ui-controls--hide-on-error">\
                <div class="svp_ui-controls__timeline-inner ' + CLASSNAMES.timelineInner + '" tabindex="0"\
                    role="slider"\
                    aria-label="Tid"\
                    draggable="true" \
                    aria-valuemin="0"\
                    aria-valuemax="0"\
                    aria-valuenow="0"\
                    aria-valuetext="00:00 av 00:00">\
                    <div class="svp_ui-controls__timeline-buffer ' + CLASSNAMES.buffer + ' ' + OVERRIDE_CLASSNAMES.seek + '"></div>\
                    <div class="svp_ui-controls__timeline-progress ' + CLASSNAMES.progress + ' ' + OVERRIDE_CLASSNAMES.progress + '"></div>\
                    <div class="svp_ui-controls__timeline-progress--handle ' + CLASSNAMES.progressHandle + ' ' + OVERRIDE_CLASSNAMES.progressHandle + '"></div>\
                    <div class="svp_ui-controls__timeline-progress--metadata ' + CLASSNAMES.progressMetadata + '">\
                        <span class="svp_ui-controls__timeline-progress--time-indicator ' + CLASSNAMES.progressTimeIndicator + '">00:00</span>\
                    </div>\
                    <div class="svp_ui-controls__timeline-progress--live-position ' + CLASSNAMES.progressLivePosition + '">\
                        <div class="svp_ui-controls__timeline-progress--live-position-indicator">\
                            <span class="svp_ui-controls__timeline-progress--live-position__icon"></span>\
                            <span class="svp_ui-controls__timeline-progress--live-position__text">Direkt</span>\
                        </div>\
                        <div class="svp_ui-controls__timeline-progress--live-position-arrow"></div>\
                    </div>\
                    <div class="svp_ui-controls__timeline-spacing" data-rt="video-player-timeline"></div>\
                </div>\
                <div class="svp_ui-controls__timeline-progress--time-remaining svp_js-controls-timeline--progress-time-remaining">00:00</div>\
            </div>');
        }
    }, {
        key: 'reset',
        value: function reset() {
            this._setProgress(0, 0);
        }
    }, {
        key: 'bindEvents',
        value: function bindEvents() {
            var _this5 = this;

            this.api.on(NAMESPACE + '.timeupdate', function () {
                if (_this5.isEnabled && !(_this5.isVideoSeeking || _this5.manualSeekInProgress)) {
                    _this5._setProgress(_this5.api.getCurrentTime(), _this5.api.getDuration());

                    var progressHandle = _this5._getElement(CLASSNAMES.progressHandle);
                    if (_this5._isAtLive(_this5.api.getCurrentTime())) {
                        domUtils.addClass(progressHandle, STATE_CLASSNAMES.isAtLive);
                    } else {
                        domUtils.removeClass(progressHandle, STATE_CLASSNAMES.isAtLive);
                    }
                }
            });

            this.api.on(NAMESPACE + '.playing', function () {
                _this5.isVideoSeeking = false;
                var progressTimeIndicator = _this5._getElement(CLASSNAMES.progressTimeIndicator);
                if (!_this5.isProgressTimeIndicatorInFocus && _this5.isControlsVisible) {
                    progressTimeIndicator.style.opacity = 0;
                    _this5.isProgressTimeIndicatorVisible = false;
                }
            });

            this.api.on(NAMESPACE + '.controls', function (data) {
                _this5.isControlsVisible = data && data.detail.visible;

                if (!_this5.isControlsVisible) {
                    _this5._setProgressbarFocus(false);
                }
            });

            this.api.on(NAMESPACE + '.seeked', function () {
                _this5.isVideoSeeking = false;
            });

            this._setupTimelineDraggingEvents();
            this._setupTimelineKeyEvents();
            this._setupTimelineClickEvents();
        }
    }]);
    return TimelineControls;
}();

module.exports = {
    create: function create(api) {
        return new TimelineControls(api);
    },

    destroy: function destroy(api) {
        if (api) {
            var element = api.element();
            var timelineContainer = (0, _sizzle2.default)('.' + CLASSNAMES.timeline, element)[0];
            var currItem = void 0;

            if (timelineContainer) {
                for (var className in CLASSNAMES) {
                    if (Object.prototype.hasOwnProperty.call(CLASSNAMES, className)) {
                        currItem = (0, _sizzle2.default)('.' + CLASSNAMES[className], element)[0];
                        if (currItem.destroy) {
                            currItem.destroy();
                        }
                    }
                }
                timelineContainer.parentElement.removeChild(timelineContainer);
            }

            api.off(NAMESPACE + '.timeupdate');
            api.off(NAMESPACE + '.playing');
            api.off(NAMESPACE + '.controls');
            api.off(NAMESPACE + '.seeked');
            api.off(NAMESPACE + '.metadata');
        }
    }
};

/***/ }),

/***/ "B5V0":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ "BF+C":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var NAMESPACE = 'svp';

module.exports = function (name) {
	name = [NAMESPACE, name].join(':');

	var Debug = __webpack_require__("Fy0/"),
	    methods = {
		log: Debug(name + ':debug'),
		warn: Debug(name + ':warn'),
		error: Debug(name + ':error')
	};

	var debug = function debug() {
		methods.log.apply(this, arguments); // eslint-disable-line prefer-rest-params
	};
	debug.log = methods.log;
	debug.warn = methods.warn;
	debug.error = methods.error;
	debug.enable = function (expression) {
		if (!expression) {
			if (Debug.storage && Debug.storage.debug) {
				Debug.storage._prevDebug = Debug.storage.debug;
				expression = Debug.storage.debug + ', ' + NAMESPACE + '*';
			} else {
				expression = NAMESPACE + '*';
			}
		}

		Debug.enable(expression);
	};

	var regEx = new RegExp('^(.*?), ' + NAMESPACE + '\\*');
	debug.disable = function () {
		if (Debug.storage && Debug.storage._prevDebug) {
			var expression = Debug.storage._prevDebug.replace(regEx, '$1');
			Debug.storage._prevDebug = undefined;
			Debug.enable(expression);
		} else {
			Debug.disable();
		}
	};

	return debug;
};

/***/ }),

/***/ "BO1k":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("oY0/"), __esModule: true };

/***/ }),

/***/ "BQO6":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("tz60");
__webpack_require__("+3lO");
module.exports = __webpack_require__("4DQ7").f('iterator');


/***/ }),

/***/ "BbyF":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__("oeih");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ "BfX3":
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__("FKWp");
var aFunction = __webpack_require__("SWGL");
var SPECIES = __webpack_require__("hgbu")('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),

/***/ "C4MV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("rKx+"), __esModule: true };

/***/ }),

/***/ "CEne":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("OzIq");
var dP = __webpack_require__("lDLk");
var DESCRIPTORS = __webpack_require__("bUqO");
var SPECIES = __webpack_require__("kkCw")('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),

/***/ "DIVP":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("UKM+");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ "Ds5P":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("OzIq");
var core = __webpack_require__("7gX0");
var hide = __webpack_require__("2p1q");
var redefine = __webpack_require__("R3AP");
var ctx = __webpack_require__("rFzY");
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ "DuR2":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "DvwR":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("x//u");
var toIObject = __webpack_require__("ksFB");
var arrayIndexOf = __webpack_require__("PbQV")(false);
var IE_PROTO = __webpack_require__("+SdG")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "EFoD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("YjQv");
var core = __webpack_require__("iANj");
var dP = __webpack_require__("GCs6");
var DESCRIPTORS = __webpack_require__("qs+f");
var SPECIES = __webpack_require__("hgbu")('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),

/***/ "Eif7":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("JyN8");
module.exports = __webpack_require__("iANj").Object.assign;


/***/ }),

/***/ "EqE1":
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__("A1Hb")('WeakMap');


/***/ }),

/***/ "FHqv":
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__("NZra");
var TAG = __webpack_require__("hgbu")('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),

/***/ "FKWp":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("8ANE");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ "FryR":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__("/whu");
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ "Fy0/":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__("vmzn");
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
    // double check webkit in userAgent just in case we are in a worker
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit')

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = Object({"NODE_ENV":"production"}).DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("W2nU")))

/***/ }),

/***/ "GCs6":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("FKWp");
var IE8_DOM_DEFINE = __webpack_require__("LocR");
var toPrimitive = __webpack_require__("9MbE");
var dP = Object.defineProperty;

exports.f = __webpack_require__("qs+f") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "GhAV":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__("W6Rd");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ "Gm6T":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__("woOf");

var _assign2 = _interopRequireDefault(_assign);

exports.default = function (videoUrls, textUrls, metadata, videoElement) {
    var videoType = resolveVideoType(videoUrls, textUrls, metadata, videoElement);

    return (0, _assign2.default)({ videoType: videoType }, resolveVideoAndTextUrls(videoType, videoUrls, textUrls));
};

var _device = __webpack_require__("xOtj");

var _device2 = _interopRequireDefault(_device);

var _debug = __webpack_require__("BF+C");

var _debug2 = _interopRequireDefault(_debug);

var _config = __webpack_require__("Pqsl");

var _config2 = _interopRequireDefault(_config);

var _videoType = __webpack_require__("vlJ+");

var _videoType2 = _interopRequireDefault(_videoType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Debug = (0, _debug2.default)('resolve-video-type');

function allowDash(metadata) {

    // We have some decoding issues with simulcast in combination with DASH.js 2.6.0 and Mac OS (PIPELINE_ERROR_DECODE)
    if (_device2.default.isMacOS() && (metadata.simulcast || metadata.live)) {
        return false;
    }

    return _device2.default.supportsDash() && !((metadata.live || metadata.simulcast || metadata.timeshiftEnabled) && !_device2.default.supportsDashLive());
}

function allowFlash() {
    return _config2.default.flashEngine && _config2.default.flashEngine.load && _device2.default.isFlashCapable();
}

function resolveVideoAndTextUrls(videoType, videoUrls, textUrls) {

    switch (videoType) {
        case _videoType2.default.HLS:
            return {
                videoUrl: videoUrls.hls,
                textUrl: textUrls.webvtt
            };
        case _videoType2.default.DASH:
            return {
                videoUrl: videoUrls.dashhbbtv || videoUrls.dash264,
                textUrl: textUrls.webvtt
            };
        case _videoType2.default.FLASHLS:
            return {
                videoUrl: videoUrls.hls,
                textUrl: textUrls.websrt
            };
        case _videoType2.default.HDS:
            return {
                videoUrl: videoUrls.hds,
                textUrl: textUrls.websrt
            };
        default:
            return {};
    }
}

function resolveVideoType(videoUrls, textUrls, metadata, videoElement) {
    var dashVideoUrl = videoUrls.dashhbbtv || videoUrls.dash264;
    var hlsJsEnabled = !(textUrls.websrt && !textUrls.webvtt) && _device2.default.supportsHlsJs();

    if (dashVideoUrl && allowDash(metadata)) {
        return _videoType2.default.DASH;
    } else if (videoUrls.hls && (_device2.default.supportsHls(videoElement) || hlsJsEnabled)) {
        return _videoType2.default.HLS;
    } else if (videoUrls.hls && allowFlash()) {
        return _videoType2.default.FLASHLS;
    } else if (videoUrls.hds && allowFlash()) {
        return _videoType2.default.HDS;
    }

    return _videoType2.default.UNKNOWN;
}

module.exports = exports['default'];

/***/ }),

/***/ "GmwO":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ "GshV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*global ns2_ */


var _dom = __webpack_require__("TdxG");

var domUtils = _interopRequireWildcard(_dom);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var statsUtil = __webpack_require__("ahyN");

var device = __webpack_require__("xOtj");
var VideoConfig = __webpack_require__("Pqsl");
var Sizzle = __webpack_require__("zZaF");
var Debug = __webpack_require__("BF+C")('mms-stats');
var ns_ = __webpack_require__("QZD8");

module.exports = {
    namespace: 'mms',

    create: function create(api) {

        var settings = {
            metadata: undefined,
            isPiPMode: false,
            isAirplayMode: false
        };

        var _getElement = function _getElement() {
            return Sizzle('video', api.element())[0];
        };

        api.on(this.namespace + '.metadata', function (data) {
            settings.metadata = data.detail;
            // });
            //
            // api.on(this.namespace + '.ready', function () {
            var videoElement = _getElement();

            if (settings.metadata && settings.metadata.mmsStatistics && videoElement !== undefined) {
                var programId = settings.metadata.mmsStatistics.mms_tid || '000000';
                var programTitle = settings.metadata.mmsStatistics.ns_st_pr || 'unknown_program';
                var episodeTitle = settings.metadata.mmsStatistics.ns_st_ep || 'unknown_episode';
                var tags = settings.metadata.mmsStatistics.svt_taggar || '';

                if (!api.streamSense) {
                    Debug('Creating new StreamSense object');
                    api.streamSense = new ns_.StreamSense.Html5(videoElement, {
                        logurl: statsUtil.getScorecardResearchUrl()
                    });
                }

                var mmsData = {
                    c2: statsUtil.getComscoreC2Value(),
                    ns_site: statsUtil.getComscoreSite(),
                    ns_st_mp: 'HTML5',
                    ns_st_mv: 'svtvideoplayer-HTML5',
                    mms_clnr: statsUtil.getMmsClientNr(),
                    mms_tid: programId,
                    mms_subsite: 'svtplay.html5',
                    svt_app: 'webb',
                    svt_contenttype: settings.metadata.mmsStatistics.svt_contenttype,
                    client: statsUtil.getClient(),
                    name: statsUtil.getClient() + '.' + programTitle + '.' + episodeTitle,
                    svt_taggar: tags
                };

                if (window.SVT_STATISTICS && window.SVT_STATISTICS.contextData) {
                    var contextData = window.SVT_STATISTICS.contextData;

                    mmsData.svt_domain = contextData.svt_domain;
                    mmsData.svt_level1 = contextData.svt_level1;
                    mmsData.svt_level2 = contextData.svt_level2;
                    mmsData.svt_level3 = contextData.svt_level3;
                    mmsData.svt_pagename = mmsData.svt_domain + ':' + mmsData.svt_level1 + ':' + mmsData.svt_level2 + ':' + mmsData.svt_level3;

                    if (contextData.svt_appname && contextData.svt_appname !== 'webb') {
                        mmsData.svt_app = 'app';
                    }
                }

                api.streamSense.setLabels(mmsData);

                api.streamSense.setPlaylist({
                    ns_st_pl: settings.metadata.mmsStatistics.ns_st_pl
                });

                api.streamSense.setClip({
                    ns_st_pr: programTitle,
                    ns_st_ep: episodeTitle,
                    ns_st_cl: settings.metadata.mmsStatistics.ns_st_cl,
                    ns_st_li: settings.metadata.live || settings.metadata.simulcast ? 1 : 0
                });
            }
        });

        api.once(this.namespace + '.playing', function () {
            if (device.isPictureInPictureCapable(_getElement())) {
                this.isPiPMode = api.video().webkitPresentationMode === 'picture-in-picture';
                api.streamSense.setLabel('svt_pip', settings.isPiPMode);

                domUtils.addEvents(_getElement(), 'webkitpresentationmodechanged', function (e) {
                    settings.isPiPMode = api.video().webkitPresentationMode === 'picture-in-picture';
                    api.streamSense.setLabel('svt_pip', settings.isPiPMode);
                }, settings.namespace);
            }

            if (device.isAirplayCapable()) {
                this.isAirplayMode = api.video().webkitCurrentPlaybackTargetIsWireless;
                api.streamSense.setLabel('svt_exscreen', settings.isAirplayMode);

                domUtils.addEvents(_getElement(), 'webkitcurrentplaybacktargetiswirelesschanged', function () {
                    settings.isAirplayMode = api.video().webkitCurrentPlaybackTargetIsWireless;
                    api.streamSense.setLabel('svt_exscreen', settings.isAirplayMode);
                }, settings.namespace);
            }
        });
    },

    destroy: function destroy(api) {
        //api.off(this.namespace + '.ready');
        api.off(this.namespace + '.metadata');
        domUtils.removeEvents(Sizzle('video', api.element())[0], 'webkitpresentationmodechanged', this.namespace);
        domUtils.removeEvents(Sizzle('video', api.element())[0], 'webkitcurrentplaybacktargetiswirelesschanged', this.namespace);

        api.streamSense = undefined;
    }
};

/***/ }),

/***/ "I7B8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__("NZ8V");
var descriptor = __webpack_require__("YTz9");
var setToStringTag = __webpack_require__("LhDF");
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__("aLzV")(IteratorPrototype, __webpack_require__("hgbu")('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ "IRJ3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__("7ylX");
var descriptor = __webpack_require__("fU25");
var setToStringTag = __webpack_require__("yYvK");
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__("2p1q")(IteratorPrototype, __webpack_require__("kkCw")('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ "J9Y8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _map = __webpack_require__("ifoU");

var _map2 = _interopRequireDefault(_map);

exports.create = create;
exports.destroy = destroy;

var _dom = __webpack_require__("TdxG");

var dom = _interopRequireWildcard(_dom);

var _stats = __webpack_require__("ahyN");

var statsUtil = _interopRequireWildcard(_stats);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NAMESPACE = 'akamaiStats.';
var instances = new _map2.default();
var initialized = new _map2.default();
var currentStream = new _map2.default();

function loadLibs() {
    window.AKAMAI_MEDIA_ANALYTICS_CONFIG_FILE_PATH = 'https://ma291-r.analytics.edgekey.net/config/beacon-8803.xml?enableGenericAPI=1';

    return dom.getScript('https://79423.analytics.edgekey.net/js/csma.js');
}

var AkaHTML5AnalyticsGetters = function () {
    function AkaHTML5AnalyticsGetters(api) {
        (0, _classCallCheck3.default)(this, AkaHTML5AnalyticsGetters);

        this.api = api;
    }

    // Below is used by statistics lib

    // noinspection JSUnusedGlobalSymbols


    (0, _createClass3.default)(AkaHTML5AnalyticsGetters, [{
        key: 'streamHeadPosition',
        value: function streamHeadPosition() {
            return this.api.getCurrentTime();
        }

        // noinspection JSUnusedGlobalSymbols

    }, {
        key: 'streamLength',
        value: function streamLength() {
            return this.api.getDuration();
        }

        // noinspection JSUnusedGlobalSymbols

    }, {
        key: 'streamURL',
        value: function streamURL() {
            return this.api.getSrc();
        }
    }]);
    return AkaHTML5AnalyticsGetters;
}();

function handlePlaying(api, analytics) {
    if (!initialized.get(api)) {
        analytics.handleSessionInit();
        initialized.set(api, true);
    } else if (api.getSrc() !== currentStream.get(api)) {
        analytics.handleStreamSwitch();
    }
    currentStream.set(api, api.getSrc());

    analytics.handlePlaying();
}

function handleMetadata(analytics, metaData) {
    var client = statsUtil.getClient();
    analytics.setData('device', navigator.platform);
    analytics.setData('playerId', 'svtvideoplayer-html5-' + client);

    if (metaData.mmsStatistics) {
        var show = metaData.mmsStatistics.ns_st_pr;
        var title = show + ' - ' + metaData.mmsStatistics.ns_st_ep + ' (' + metaData.programVersionId + ')';

        analytics.setData('title', title);
        analytics.setData('show', show);
        analytics.setData('eventName', title);
    }
}

function create(api) {
    if (instances.has(api)) {
        Debug.warn('Akamai statistics plugin was already created for this api instance and has\n            not been destroyed. The previous instance may leak memory and listeners.');
    }

    loadLibs().then(function () {
        var analytics = new window.AkaHTML5MediaAnalytics(new AkaHTML5AnalyticsGetters(api));
        analytics.setData('viewerId', 'unknown viewer');
        // TODO: Only do below for SVT CDN
        analytics.disableServerIpLookUp();

        api.on(NAMESPACE + 'playing', function () {
            return handlePlaying(api, analytics);
        });
        api.on(NAMESPACE + 'pause', function () {
            return analytics.handlePause();
        });
        api.on(NAMESPACE + 'resume', function () {
            return analytics.handleResume();
        });
        api.on(NAMESPACE + 'bufferEmpty', function () {
            if (api.video().seeking === false) {
                analytics.handleBufferStart();
            }
        });
        api.on(NAMESPACE + 'bitrateswitch', function (event) {
            return analytics.handleBitRateSwitch(event.detail.bitrate);
        });
        api.on(NAMESPACE + 'ended', function () {
            return analytics.handlePlayEnd('Play.End.Detected');
        });
        api.on(NAMESPACE + 'error', function (err) {
            return analytics.handleError(err && err.name ? err.name : 'Unknown error');
        });

        api.on(NAMESPACE + 'metadata', function (data) {
            return handleMetadata(analytics, data.detail);
        });

        instances.set(api, analytics);
    });
}

function destroy(api) {
    var analytics = instances.get(api);

    if (analytics) {
        api.off(NAMESPACE + 'playing');
        api.off(NAMESPACE + 'pause');
        api.off(NAMESPACE + 'resume');
        api.off(NAMESPACE + 'waiting');
        api.off(NAMESPACE + 'bitrateswitch');
        api.off(NAMESPACE + 'ended');
        api.off(NAMESPACE + 'error');

        api.off(NAMESPACE + 'metadata');

        analytics.handleApplicationExit();

        instances.delete(api);
    }
}

/***/ }),

/***/ "JIHV":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/*global XDomainRequest:false */

var TraceKit = __webpack_require__("b98B");
var stringify = __webpack_require__("jATa");
var RavenConfigError = __webpack_require__("l/Ll");

var utils = __webpack_require__("xKeu");
var isError = utils.isError;
var isObject = utils.isObject;
var isObject = utils.isObject;
var isErrorEvent = utils.isErrorEvent;
var isUndefined = utils.isUndefined;
var isFunction = utils.isFunction;
var isString = utils.isString;
var isEmptyObject = utils.isEmptyObject;
var each = utils.each;
var objectMerge = utils.objectMerge;
var truncate = utils.truncate;
var objectFrozen = utils.objectFrozen;
var hasKey = utils.hasKey;
var joinRegExp = utils.joinRegExp;
var urlencode = utils.urlencode;
var uuid4 = utils.uuid4;
var htmlTreeAsString = utils.htmlTreeAsString;
var isSameException = utils.isSameException;
var isSameStacktrace = utils.isSameStacktrace;
var parseUrl = utils.parseUrl;
var fill = utils.fill;

var wrapConsoleMethod = __webpack_require__("Mq3M").wrapMethod;

var dsnKeys = 'source protocol user pass host port path'.split(' '),
  dsnPattern = /^(?:(\w+):)?\/\/(?:(\w+)(:\w+)?@)?([\w\.-]+)(?::(\d+))?(\/.*)/;

function now() {
  return +new Date();
}

// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
var _window =
  typeof window !== 'undefined'
    ? window
    : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
var _document = _window.document;
var _navigator = _window.navigator;

function keepOriginalCallback(original, callback) {
  return isFunction(callback)
    ? function(data) {
        return callback(data, original);
      }
    : callback;
}

// First, check for JSON support
// If there is no JSON, we no-op the core features of Raven
// since JSON is required to encode the payload
function Raven() {
  this._hasJSON = !!(typeof JSON === 'object' && JSON.stringify);
  // Raven can run in contexts where there's no document (react-native)
  this._hasDocument = !isUndefined(_document);
  this._hasNavigator = !isUndefined(_navigator);
  this._lastCapturedException = null;
  this._lastData = null;
  this._lastEventId = null;
  this._globalServer = null;
  this._globalKey = null;
  this._globalProject = null;
  this._globalContext = {};
  this._globalOptions = {
    logger: 'javascript',
    ignoreErrors: [],
    ignoreUrls: [],
    whitelistUrls: [],
    includePaths: [],
    collectWindowErrors: true,
    maxMessageLength: 0,

    // By default, truncates URL values to 250 chars
    maxUrlLength: 250,
    stackTraceLimit: 50,
    autoBreadcrumbs: true,
    instrument: true,
    sampleRate: 1
  };
  this._ignoreOnError = 0;
  this._isRavenInstalled = false;
  this._originalErrorStackTraceLimit = Error.stackTraceLimit;
  // capture references to window.console *and* all its methods first
  // before the console plugin has a chance to monkey patch
  this._originalConsole = _window.console || {};
  this._originalConsoleMethods = {};
  this._plugins = [];
  this._startTime = now();
  this._wrappedBuiltIns = [];
  this._breadcrumbs = [];
  this._lastCapturedEvent = null;
  this._keypressTimeout;
  this._location = _window.location;
  this._lastHref = this._location && this._location.href;
  this._resetBackoff();

  // eslint-disable-next-line guard-for-in
  for (var method in this._originalConsole) {
    this._originalConsoleMethods[method] = this._originalConsole[method];
  }
}

/*
 * The core Raven singleton
 *
 * @this {Raven}
 */

Raven.prototype = {
  // Hardcode version string so that raven source can be loaded directly via
  // webpack (using a build step causes webpack #1617). Grunt verifies that
  // this value matches package.json during build.
  //   See: https://github.com/getsentry/raven-js/issues/465
  VERSION: '3.19.1',

  debug: false,

  TraceKit: TraceKit, // alias to TraceKit

  /*
     * Configure Raven with a DSN and extra options
     *
     * @param {string} dsn The public Sentry DSN
     * @param {object} options Set of global options [optional]
     * @return {Raven}
     */
  config: function(dsn, options) {
    var self = this;

    if (self._globalServer) {
      this._logDebug('error', 'Error: Raven has already been configured');
      return self;
    }
    if (!dsn) return self;

    var globalOptions = self._globalOptions;

    // merge in options
    if (options) {
      each(options, function(key, value) {
        // tags and extra are special and need to be put into context
        if (key === 'tags' || key === 'extra' || key === 'user') {
          self._globalContext[key] = value;
        } else {
          globalOptions[key] = value;
        }
      });
    }

    self.setDSN(dsn);

    // "Script error." is hard coded into browsers for errors that it can't read.
    // this is the result of a script being pulled in from an external domain and CORS.
    globalOptions.ignoreErrors.push(/^Script error\.?$/);
    globalOptions.ignoreErrors.push(/^Javascript error: Script error\.? on line 0$/);

    // join regexp rules into one big rule
    globalOptions.ignoreErrors = joinRegExp(globalOptions.ignoreErrors);
    globalOptions.ignoreUrls = globalOptions.ignoreUrls.length
      ? joinRegExp(globalOptions.ignoreUrls)
      : false;
    globalOptions.whitelistUrls = globalOptions.whitelistUrls.length
      ? joinRegExp(globalOptions.whitelistUrls)
      : false;
    globalOptions.includePaths = joinRegExp(globalOptions.includePaths);
    globalOptions.maxBreadcrumbs = Math.max(
      0,
      Math.min(globalOptions.maxBreadcrumbs || 100, 100)
    ); // default and hard limit is 100

    var autoBreadcrumbDefaults = {
      xhr: true,
      console: true,
      dom: true,
      location: true
    };

    var autoBreadcrumbs = globalOptions.autoBreadcrumbs;
    if ({}.toString.call(autoBreadcrumbs) === '[object Object]') {
      autoBreadcrumbs = objectMerge(autoBreadcrumbDefaults, autoBreadcrumbs);
    } else if (autoBreadcrumbs !== false) {
      autoBreadcrumbs = autoBreadcrumbDefaults;
    }
    globalOptions.autoBreadcrumbs = autoBreadcrumbs;

    var instrumentDefaults = {
      tryCatch: true
    };

    var instrument = globalOptions.instrument;
    if ({}.toString.call(instrument) === '[object Object]') {
      instrument = objectMerge(instrumentDefaults, instrument);
    } else if (instrument !== false) {
      instrument = instrumentDefaults;
    }
    globalOptions.instrument = instrument;

    TraceKit.collectWindowErrors = !!globalOptions.collectWindowErrors;

    // return for chaining
    return self;
  },

  /*
     * Installs a global window.onerror error handler
     * to capture and report uncaught exceptions.
     * At this point, install() is required to be called due
     * to the way TraceKit is set up.
     *
     * @return {Raven}
     */
  install: function() {
    var self = this;
    if (self.isSetup() && !self._isRavenInstalled) {
      TraceKit.report.subscribe(function() {
        self._handleOnErrorStackInfo.apply(self, arguments);
      });
      if (self._globalOptions.instrument && self._globalOptions.instrument.tryCatch) {
        self._instrumentTryCatch();
      }

      if (self._globalOptions.autoBreadcrumbs) self._instrumentBreadcrumbs();

      // Install all of the plugins
      self._drainPlugins();

      self._isRavenInstalled = true;
    }

    Error.stackTraceLimit = self._globalOptions.stackTraceLimit;
    return this;
  },

  /*
     * Set the DSN (can be called multiple time unlike config)
     *
     * @param {string} dsn The public Sentry DSN
     */
  setDSN: function(dsn) {
    var self = this,
      uri = self._parseDSN(dsn),
      lastSlash = uri.path.lastIndexOf('/'),
      path = uri.path.substr(1, lastSlash);

    self._dsn = dsn;
    self._globalKey = uri.user;
    self._globalSecret = uri.pass && uri.pass.substr(1);
    self._globalProject = uri.path.substr(lastSlash + 1);

    self._globalServer = self._getGlobalServer(uri);

    self._globalEndpoint =
      self._globalServer + '/' + path + 'api/' + self._globalProject + '/store/';

    // Reset backoff state since we may be pointing at a
    // new project/server
    this._resetBackoff();
  },

  /*
     * Wrap code within a context so Raven can capture errors
     * reliably across domains that is executed immediately.
     *
     * @param {object} options A specific set of options for this context [optional]
     * @param {function} func The callback to be immediately executed within the context
     * @param {array} args An array of arguments to be called with the callback [optional]
     */
  context: function(options, func, args) {
    if (isFunction(options)) {
      args = func || [];
      func = options;
      options = undefined;
    }

    return this.wrap(options, func).apply(this, args);
  },

  /*
     * Wrap code within a context and returns back a new function to be executed
     *
     * @param {object} options A specific set of options for this context [optional]
     * @param {function} func The function to be wrapped in a new context
     * @param {function} func A function to call before the try/catch wrapper [optional, private]
     * @return {function} The newly wrapped functions with a context
     */
  wrap: function(options, func, _before) {
    var self = this;
    // 1 argument has been passed, and it's not a function
    // so just return it
    if (isUndefined(func) && !isFunction(options)) {
      return options;
    }

    // options is optional
    if (isFunction(options)) {
      func = options;
      options = undefined;
    }

    // At this point, we've passed along 2 arguments, and the second one
    // is not a function either, so we'll just return the second argument.
    if (!isFunction(func)) {
      return func;
    }

    // We don't wanna wrap it twice!
    try {
      if (func.__raven__) {
        return func;
      }

      // If this has already been wrapped in the past, return that
      if (func.__raven_wrapper__) {
        return func.__raven_wrapper__;
      }
    } catch (e) {
      // Just accessing custom props in some Selenium environments
      // can cause a "Permission denied" exception (see raven-js#495).
      // Bail on wrapping and return the function as-is (defers to window.onerror).
      return func;
    }

    function wrapped() {
      var args = [],
        i = arguments.length,
        deep = !options || (options && options.deep !== false);

      if (_before && isFunction(_before)) {
        _before.apply(this, arguments);
      }

      // Recursively wrap all of a function's arguments that are
      // functions themselves.
      while (i--) args[i] = deep ? self.wrap(options, arguments[i]) : arguments[i];

      try {
        // Attempt to invoke user-land function
        // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
        //       means Raven caught an error invoking your application code. This is
        //       expected behavior and NOT indicative of a bug with Raven.js.
        return func.apply(this, args);
      } catch (e) {
        self._ignoreNextOnError();
        self.captureException(e, options);
        throw e;
      }
    }

    // copy over properties of the old function
    for (var property in func) {
      if (hasKey(func, property)) {
        wrapped[property] = func[property];
      }
    }
    wrapped.prototype = func.prototype;

    func.__raven_wrapper__ = wrapped;
    // Signal that this function has been wrapped already
    // for both debugging and to prevent it to being wrapped twice
    wrapped.__raven__ = true;
    wrapped.__inner__ = func;

    return wrapped;
  },

  /*
     * Uninstalls the global error handler.
     *
     * @return {Raven}
     */
  uninstall: function() {
    TraceKit.report.uninstall();

    this._restoreBuiltIns();

    Error.stackTraceLimit = this._originalErrorStackTraceLimit;
    this._isRavenInstalled = false;

    return this;
  },

  /*
     * Manually capture an exception and send it over to Sentry
     *
     * @param {error} ex An exception to be logged
     * @param {object} options A specific set of options for this error [optional]
     * @return {Raven}
     */
  captureException: function(ex, options) {
    // Cases for sending ex as a message, rather than an exception
    var isNotError = !isError(ex);
    var isNotErrorEvent = !isErrorEvent(ex);
    var isErrorEventWithoutError = isErrorEvent(ex) && !ex.error;

    if ((isNotError && isNotErrorEvent) || isErrorEventWithoutError) {
      return this.captureMessage(
        ex,
        objectMerge(
          {
            trimHeadFrames: 1,
            stacktrace: true // if we fall back to captureMessage, default to attempting a new trace
          },
          options
        )
      );
    }

    // Get actual Error from ErrorEvent
    if (isErrorEvent(ex)) ex = ex.error;

    // Store the raw exception object for potential debugging and introspection
    this._lastCapturedException = ex;

    // TraceKit.report will re-raise any exception passed to it,
    // which means you have to wrap it in try/catch. Instead, we
    // can wrap it here and only re-raise if TraceKit.report
    // raises an exception different from the one we asked to
    // report on.
    try {
      var stack = TraceKit.computeStackTrace(ex);
      this._handleStackInfo(stack, options);
    } catch (ex1) {
      if (ex !== ex1) {
        throw ex1;
      }
    }

    return this;
  },

  /*
     * Manually send a message to Sentry
     *
     * @param {string} msg A plain message to be captured in Sentry
     * @param {object} options A specific set of options for this message [optional]
     * @return {Raven}
     */
  captureMessage: function(msg, options) {
    // config() automagically converts ignoreErrors from a list to a RegExp so we need to test for an
    // early call; we'll error on the side of logging anything called before configuration since it's
    // probably something you should see:
    if (
      !!this._globalOptions.ignoreErrors.test &&
      this._globalOptions.ignoreErrors.test(msg)
    ) {
      return;
    }

    options = options || {};

    var data = objectMerge(
      {
        message: msg + '' // Make sure it's actually a string
      },
      options
    );

    var ex;
    // Generate a "synthetic" stack trace from this point.
    // NOTE: If you are a Sentry user, and you are seeing this stack frame, it is NOT indicative
    //       of a bug with Raven.js. Sentry generates synthetic traces either by configuration,
    //       or if it catches a thrown object without a "stack" property.
    try {
      throw new Error(msg);
    } catch (ex1) {
      ex = ex1;
    }

    // null exception name so `Error` isn't prefixed to msg
    ex.name = null;
    var stack = TraceKit.computeStackTrace(ex);

    // stack[0] is `throw new Error(msg)` call itself, we are interested in the frame that was just before that, stack[1]
    var initialCall = stack.stack[1];

    var fileurl = (initialCall && initialCall.url) || '';

    if (
      !!this._globalOptions.ignoreUrls.test &&
      this._globalOptions.ignoreUrls.test(fileurl)
    ) {
      return;
    }

    if (
      !!this._globalOptions.whitelistUrls.test &&
      !this._globalOptions.whitelistUrls.test(fileurl)
    ) {
      return;
    }

    if (this._globalOptions.stacktrace || (options && options.stacktrace)) {
      options = objectMerge(
        {
          // fingerprint on msg, not stack trace (legacy behavior, could be
          // revisited)
          fingerprint: msg,
          // since we know this is a synthetic trace, the top N-most frames
          // MUST be from Raven.js, so mark them as in_app later by setting
          // trimHeadFrames
          trimHeadFrames: (options.trimHeadFrames || 0) + 1
        },
        options
      );

      var frames = this._prepareFrames(stack, options);
      data.stacktrace = {
        // Sentry expects frames oldest to newest
        frames: frames.reverse()
      };
    }

    // Fire away!
    this._send(data);

    return this;
  },

  captureBreadcrumb: function(obj) {
    var crumb = objectMerge(
      {
        timestamp: now() / 1000
      },
      obj
    );

    if (isFunction(this._globalOptions.breadcrumbCallback)) {
      var result = this._globalOptions.breadcrumbCallback(crumb);

      if (isObject(result) && !isEmptyObject(result)) {
        crumb = result;
      } else if (result === false) {
        return this;
      }
    }

    this._breadcrumbs.push(crumb);
    if (this._breadcrumbs.length > this._globalOptions.maxBreadcrumbs) {
      this._breadcrumbs.shift();
    }
    return this;
  },

  addPlugin: function(plugin /*arg1, arg2, ... argN*/) {
    var pluginArgs = [].slice.call(arguments, 1);

    this._plugins.push([plugin, pluginArgs]);
    if (this._isRavenInstalled) {
      this._drainPlugins();
    }

    return this;
  },

  /*
     * Set/clear a user to be sent along with the payload.
     *
     * @param {object} user An object representing user data [optional]
     * @return {Raven}
     */
  setUserContext: function(user) {
    // Intentionally do not merge here since that's an unexpected behavior.
    this._globalContext.user = user;

    return this;
  },

  /*
     * Merge extra attributes to be sent along with the payload.
     *
     * @param {object} extra An object representing extra data [optional]
     * @return {Raven}
     */
  setExtraContext: function(extra) {
    this._mergeContext('extra', extra);

    return this;
  },

  /*
     * Merge tags to be sent along with the payload.
     *
     * @param {object} tags An object representing tags [optional]
     * @return {Raven}
     */
  setTagsContext: function(tags) {
    this._mergeContext('tags', tags);

    return this;
  },

  /*
     * Clear all of the context.
     *
     * @return {Raven}
     */
  clearContext: function() {
    this._globalContext = {};

    return this;
  },

  /*
     * Get a copy of the current context. This cannot be mutated.
     *
     * @return {object} copy of context
     */
  getContext: function() {
    // lol javascript
    return JSON.parse(stringify(this._globalContext));
  },

  /*
     * Set environment of application
     *
     * @param {string} environment Typically something like 'production'.
     * @return {Raven}
     */
  setEnvironment: function(environment) {
    this._globalOptions.environment = environment;

    return this;
  },

  /*
     * Set release version of application
     *
     * @param {string} release Typically something like a git SHA to identify version
     * @return {Raven}
     */
  setRelease: function(release) {
    this._globalOptions.release = release;

    return this;
  },

  /*
     * Set the dataCallback option
     *
     * @param {function} callback The callback to run which allows the
     *                            data blob to be mutated before sending
     * @return {Raven}
     */
  setDataCallback: function(callback) {
    var original = this._globalOptions.dataCallback;
    this._globalOptions.dataCallback = keepOriginalCallback(original, callback);
    return this;
  },

  /*
     * Set the breadcrumbCallback option
     *
     * @param {function} callback The callback to run which allows filtering
     *                            or mutating breadcrumbs
     * @return {Raven}
     */
  setBreadcrumbCallback: function(callback) {
    var original = this._globalOptions.breadcrumbCallback;
    this._globalOptions.breadcrumbCallback = keepOriginalCallback(original, callback);
    return this;
  },

  /*
     * Set the shouldSendCallback option
     *
     * @param {function} callback The callback to run which allows
     *                            introspecting the blob before sending
     * @return {Raven}
     */
  setShouldSendCallback: function(callback) {
    var original = this._globalOptions.shouldSendCallback;
    this._globalOptions.shouldSendCallback = keepOriginalCallback(original, callback);
    return this;
  },

  /**
     * Override the default HTTP transport mechanism that transmits data
     * to the Sentry server.
     *
     * @param {function} transport Function invoked instead of the default
     *                             `makeRequest` handler.
     *
     * @return {Raven}
     */
  setTransport: function(transport) {
    this._globalOptions.transport = transport;

    return this;
  },

  /*
     * Get the latest raw exception that was captured by Raven.
     *
     * @return {error}
     */
  lastException: function() {
    return this._lastCapturedException;
  },

  /*
     * Get the last event id
     *
     * @return {string}
     */
  lastEventId: function() {
    return this._lastEventId;
  },

  /*
     * Determine if Raven is setup and ready to go.
     *
     * @return {boolean}
     */
  isSetup: function() {
    if (!this._hasJSON) return false; // needs JSON support
    if (!this._globalServer) {
      if (!this.ravenNotConfiguredError) {
        this.ravenNotConfiguredError = true;
        this._logDebug('error', 'Error: Raven has not been configured.');
      }
      return false;
    }
    return true;
  },

  afterLoad: function() {
    // TODO: remove window dependence?

    // Attempt to initialize Raven on load
    var RavenConfig = _window.RavenConfig;
    if (RavenConfig) {
      this.config(RavenConfig.dsn, RavenConfig.config).install();
    }
  },

  showReportDialog: function(options) {
    if (
      !_document // doesn't work without a document (React native)
    )
      return;

    options = options || {};

    var lastEventId = options.eventId || this.lastEventId();
    if (!lastEventId) {
      throw new RavenConfigError('Missing eventId');
    }

    var dsn = options.dsn || this._dsn;
    if (!dsn) {
      throw new RavenConfigError('Missing DSN');
    }

    var encode = encodeURIComponent;
    var qs = '';
    qs += '?eventId=' + encode(lastEventId);
    qs += '&dsn=' + encode(dsn);

    var user = options.user || this._globalContext.user;
    if (user) {
      if (user.name) qs += '&name=' + encode(user.name);
      if (user.email) qs += '&email=' + encode(user.email);
    }

    var globalServer = this._getGlobalServer(this._parseDSN(dsn));

    var script = _document.createElement('script');
    script.async = true;
    script.src = globalServer + '/api/embed/error-page/' + qs;
    (_document.head || _document.body).appendChild(script);
  },

  /**** Private functions ****/
  _ignoreNextOnError: function() {
    var self = this;
    this._ignoreOnError += 1;
    setTimeout(function() {
      // onerror should trigger before setTimeout
      self._ignoreOnError -= 1;
    });
  },

  _triggerEvent: function(eventType, options) {
    // NOTE: `event` is a native browser thing, so let's avoid conflicting wiht it
    var evt, key;

    if (!this._hasDocument) return;

    options = options || {};

    eventType = 'raven' + eventType.substr(0, 1).toUpperCase() + eventType.substr(1);

    if (_document.createEvent) {
      evt = _document.createEvent('HTMLEvents');
      evt.initEvent(eventType, true, true);
    } else {
      evt = _document.createEventObject();
      evt.eventType = eventType;
    }

    for (key in options)
      if (hasKey(options, key)) {
        evt[key] = options[key];
      }

    if (_document.createEvent) {
      // IE9 if standards
      _document.dispatchEvent(evt);
    } else {
      // IE8 regardless of Quirks or Standards
      // IE9 if quirks
      try {
        _document.fireEvent('on' + evt.eventType.toLowerCase(), evt);
      } catch (e) {
        // Do nothing
      }
    }
  },

  /**
     * Wraps addEventListener to capture UI breadcrumbs
     * @param evtName the event name (e.g. "click")
     * @returns {Function}
     * @private
     */
  _breadcrumbEventHandler: function(evtName) {
    var self = this;
    return function(evt) {
      // reset keypress timeout; e.g. triggering a 'click' after
      // a 'keypress' will reset the keypress debounce so that a new
      // set of keypresses can be recorded
      self._keypressTimeout = null;

      // It's possible this handler might trigger multiple times for the same
      // event (e.g. event propagation through node ancestors). Ignore if we've
      // already captured the event.
      if (self._lastCapturedEvent === evt) return;

      self._lastCapturedEvent = evt;

      // try/catch both:
      // - accessing evt.target (see getsentry/raven-js#838, #768)
      // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
      //   can throw an exception in some circumstances.
      var target;
      try {
        target = htmlTreeAsString(evt.target);
      } catch (e) {
        target = '<unknown>';
      }

      self.captureBreadcrumb({
        category: 'ui.' + evtName, // e.g. ui.click, ui.input
        message: target
      });
    };
  },

  /**
     * Wraps addEventListener to capture keypress UI events
     * @returns {Function}
     * @private
     */
  _keypressEventHandler: function() {
    var self = this,
      debounceDuration = 1000; // milliseconds

    // TODO: if somehow user switches keypress target before
    //       debounce timeout is triggered, we will only capture
    //       a single breadcrumb from the FIRST target (acceptable?)
    return function(evt) {
      var target;
      try {
        target = evt.target;
      } catch (e) {
        // just accessing event properties can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/raven-js/issues/838
        return;
      }
      var tagName = target && target.tagName;

      // only consider keypress events on actual input elements
      // this will disregard keypresses targeting body (e.g. tabbing
      // through elements, hotkeys, etc)
      if (
        !tagName ||
        (tagName !== 'INPUT' && tagName !== 'TEXTAREA' && !target.isContentEditable)
      )
        return;

      // record first keypress in a series, but ignore subsequent
      // keypresses until debounce clears
      var timeout = self._keypressTimeout;
      if (!timeout) {
        self._breadcrumbEventHandler('input')(evt);
      }
      clearTimeout(timeout);
      self._keypressTimeout = setTimeout(function() {
        self._keypressTimeout = null;
      }, debounceDuration);
    };
  },

  /**
     * Captures a breadcrumb of type "navigation", normalizing input URLs
     * @param to the originating URL
     * @param from the target URL
     * @private
     */
  _captureUrlChange: function(from, to) {
    var parsedLoc = parseUrl(this._location.href);
    var parsedTo = parseUrl(to);
    var parsedFrom = parseUrl(from);

    // because onpopstate only tells you the "new" (to) value of location.href, and
    // not the previous (from) value, we need to track the value of the current URL
    // state ourselves
    this._lastHref = to;

    // Use only the path component of the URL if the URL matches the current
    // document (almost all the time when using pushState)
    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host)
      to = parsedTo.relative;
    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host)
      from = parsedFrom.relative;

    this.captureBreadcrumb({
      category: 'navigation',
      data: {
        to: to,
        from: from
      }
    });
  },

  /**
     * Wrap timer functions and event targets to catch errors and provide
     * better metadata.
     */
  _instrumentTryCatch: function() {
    var self = this;

    var wrappedBuiltIns = self._wrappedBuiltIns;

    function wrapTimeFn(orig) {
      return function(fn, t) {
        // preserve arity
        // Make a copy of the arguments to prevent deoptimization
        // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
        var args = new Array(arguments.length);
        for (var i = 0; i < args.length; ++i) {
          args[i] = arguments[i];
        }
        var originalCallback = args[0];
        if (isFunction(originalCallback)) {
          args[0] = self.wrap(originalCallback);
        }

        // IE < 9 doesn't support .call/.apply on setInterval/setTimeout, but it
        // also supports only two arguments and doesn't care what this is, so we
        // can just call the original function directly.
        if (orig.apply) {
          return orig.apply(this, args);
        } else {
          return orig(args[0], args[1]);
        }
      };
    }

    var autoBreadcrumbs = this._globalOptions.autoBreadcrumbs;

    function wrapEventTarget(global) {
      var proto = _window[global] && _window[global].prototype;
      if (proto && proto.hasOwnProperty && proto.hasOwnProperty('addEventListener')) {
        fill(
          proto,
          'addEventListener',
          function(orig) {
            return function(evtName, fn, capture, secure) {
              // preserve arity
              try {
                if (fn && fn.handleEvent) {
                  fn.handleEvent = self.wrap(fn.handleEvent);
                }
              } catch (err) {
                // can sometimes get 'Permission denied to access property "handle Event'
              }

              // More breadcrumb DOM capture ... done here and not in `_instrumentBreadcrumbs`
              // so that we don't have more than one wrapper function
              var before, clickHandler, keypressHandler;

              if (
                autoBreadcrumbs &&
                autoBreadcrumbs.dom &&
                (global === 'EventTarget' || global === 'Node')
              ) {
                // NOTE: generating multiple handlers per addEventListener invocation, should
                //       revisit and verify we can just use one (almost certainly)
                clickHandler = self._breadcrumbEventHandler('click');
                keypressHandler = self._keypressEventHandler();
                before = function(evt) {
                  // need to intercept every DOM event in `before` argument, in case that
                  // same wrapped method is re-used for different events (e.g. mousemove THEN click)
                  // see #724
                  if (!evt) return;

                  var eventType;
                  try {
                    eventType = evt.type;
                  } catch (e) {
                    // just accessing event properties can throw an exception in some rare circumstances
                    // see: https://github.com/getsentry/raven-js/issues/838
                    return;
                  }
                  if (eventType === 'click') return clickHandler(evt);
                  else if (eventType === 'keypress') return keypressHandler(evt);
                };
              }
              return orig.call(
                this,
                evtName,
                self.wrap(fn, undefined, before),
                capture,
                secure
              );
            };
          },
          wrappedBuiltIns
        );
        fill(
          proto,
          'removeEventListener',
          function(orig) {
            return function(evt, fn, capture, secure) {
              try {
                fn = fn && (fn.__raven_wrapper__ ? fn.__raven_wrapper__ : fn);
              } catch (e) {
                // ignore, accessing __raven_wrapper__ will throw in some Selenium environments
              }
              return orig.call(this, evt, fn, capture, secure);
            };
          },
          wrappedBuiltIns
        );
      }
    }

    fill(_window, 'setTimeout', wrapTimeFn, wrappedBuiltIns);
    fill(_window, 'setInterval', wrapTimeFn, wrappedBuiltIns);
    if (_window.requestAnimationFrame) {
      fill(
        _window,
        'requestAnimationFrame',
        function(orig) {
          return function(cb) {
            return orig(self.wrap(cb));
          };
        },
        wrappedBuiltIns
      );
    }

    // event targets borrowed from bugsnag-js:
    // https://github.com/bugsnag/bugsnag-js/blob/master/src/bugsnag.js#L666
    var eventTargets = [
      'EventTarget',
      'Window',
      'Node',
      'ApplicationCache',
      'AudioTrackList',
      'ChannelMergerNode',
      'CryptoOperation',
      'EventSource',
      'FileReader',
      'HTMLUnknownElement',
      'IDBDatabase',
      'IDBRequest',
      'IDBTransaction',
      'KeyOperation',
      'MediaController',
      'MessagePort',
      'ModalWindow',
      'Notification',
      'SVGElementInstance',
      'Screen',
      'TextTrack',
      'TextTrackCue',
      'TextTrackList',
      'WebSocket',
      'WebSocketWorker',
      'Worker',
      'XMLHttpRequest',
      'XMLHttpRequestEventTarget',
      'XMLHttpRequestUpload'
    ];
    for (var i = 0; i < eventTargets.length; i++) {
      wrapEventTarget(eventTargets[i]);
    }
  },

  /**
     * Instrument browser built-ins w/ breadcrumb capturing
     *  - XMLHttpRequests
     *  - DOM interactions (click/typing)
     *  - window.location changes
     *  - console
     *
     * Can be disabled or individually configured via the `autoBreadcrumbs` config option
     */
  _instrumentBreadcrumbs: function() {
    var self = this;
    var autoBreadcrumbs = this._globalOptions.autoBreadcrumbs;

    var wrappedBuiltIns = self._wrappedBuiltIns;

    function wrapProp(prop, xhr) {
      if (prop in xhr && isFunction(xhr[prop])) {
        fill(xhr, prop, function(orig) {
          return self.wrap(orig);
        }); // intentionally don't track filled methods on XHR instances
      }
    }

    if (autoBreadcrumbs.xhr && 'XMLHttpRequest' in _window) {
      var xhrproto = XMLHttpRequest.prototype;
      fill(
        xhrproto,
        'open',
        function(origOpen) {
          return function(method, url) {
            // preserve arity

            // if Sentry key appears in URL, don't capture
            if (isString(url) && url.indexOf(self._globalKey) === -1) {
              this.__raven_xhr = {
                method: method,
                url: url,
                status_code: null
              };
            }

            return origOpen.apply(this, arguments);
          };
        },
        wrappedBuiltIns
      );

      fill(
        xhrproto,
        'send',
        function(origSend) {
          return function(data) {
            // preserve arity
            var xhr = this;

            function onreadystatechangeHandler() {
              if (xhr.__raven_xhr && xhr.readyState === 4) {
                try {
                  // touching statusCode in some platforms throws
                  // an exception
                  xhr.__raven_xhr.status_code = xhr.status;
                } catch (e) {
                  /* do nothing */
                }

                self.captureBreadcrumb({
                  type: 'http',
                  category: 'xhr',
                  data: xhr.__raven_xhr
                });
              }
            }

            var props = ['onload', 'onerror', 'onprogress'];
            for (var j = 0; j < props.length; j++) {
              wrapProp(props[j], xhr);
            }

            if ('onreadystatechange' in xhr && isFunction(xhr.onreadystatechange)) {
              fill(
                xhr,
                'onreadystatechange',
                function(orig) {
                  return self.wrap(orig, undefined, onreadystatechangeHandler);
                } /* intentionally don't track this instrumentation */
              );
            } else {
              // if onreadystatechange wasn't actually set by the page on this xhr, we
              // are free to set our own and capture the breadcrumb
              xhr.onreadystatechange = onreadystatechangeHandler;
            }

            return origSend.apply(this, arguments);
          };
        },
        wrappedBuiltIns
      );
    }

    if (autoBreadcrumbs.xhr && 'fetch' in _window) {
      fill(
        _window,
        'fetch',
        function(origFetch) {
          return function(fn, t) {
            // preserve arity
            // Make a copy of the arguments to prevent deoptimization
            // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
            var args = new Array(arguments.length);
            for (var i = 0; i < args.length; ++i) {
              args[i] = arguments[i];
            }

            var fetchInput = args[0];
            var method = 'GET';
            var url;

            if (typeof fetchInput === 'string') {
              url = fetchInput;
            } else if ('Request' in _window && fetchInput instanceof _window.Request) {
              url = fetchInput.url;
              if (fetchInput.method) {
                method = fetchInput.method;
              }
            } else {
              url = '' + fetchInput;
            }

            if (args[1] && args[1].method) {
              method = args[1].method;
            }

            var fetchData = {
              method: method,
              url: url,
              status_code: null
            };

            self.captureBreadcrumb({
              type: 'http',
              category: 'fetch',
              data: fetchData
            });

            return origFetch.apply(this, args).then(function(response) {
              fetchData.status_code = response.status;

              return response;
            });
          };
        },
        wrappedBuiltIns
      );
    }

    // Capture breadcrumbs from any click that is unhandled / bubbled up all the way
    // to the document. Do this before we instrument addEventListener.
    if (autoBreadcrumbs.dom && this._hasDocument) {
      if (_document.addEventListener) {
        _document.addEventListener('click', self._breadcrumbEventHandler('click'), false);
        _document.addEventListener('keypress', self._keypressEventHandler(), false);
      } else {
        // IE8 Compatibility
        _document.attachEvent('onclick', self._breadcrumbEventHandler('click'));
        _document.attachEvent('onkeypress', self._keypressEventHandler());
      }
    }

    // record navigation (URL) changes
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var chrome = _window.chrome;
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    var hasPushAndReplaceState =
      !isChromePackagedApp &&
      _window.history &&
      history.pushState &&
      history.replaceState;
    if (autoBreadcrumbs.location && hasPushAndReplaceState) {
      // TODO: remove onpopstate handler on uninstall()
      var oldOnPopState = _window.onpopstate;
      _window.onpopstate = function() {
        var currentHref = self._location.href;
        self._captureUrlChange(self._lastHref, currentHref);

        if (oldOnPopState) {
          return oldOnPopState.apply(this, arguments);
        }
      };

      var historyReplacementFunction = function(origHistFunction) {
        // note history.pushState.length is 0; intentionally not declaring
        // params to preserve 0 arity
        return function(/* state, title, url */) {
          var url = arguments.length > 2 ? arguments[2] : undefined;

          // url argument is optional
          if (url) {
            // coerce to string (this is what pushState does)
            self._captureUrlChange(self._lastHref, url + '');
          }

          return origHistFunction.apply(this, arguments);
        };
      };

      fill(history, 'pushState', historyReplacementFunction, wrappedBuiltIns);
      fill(history, 'replaceState', historyReplacementFunction, wrappedBuiltIns);
    }

    if (autoBreadcrumbs.console && 'console' in _window && console.log) {
      // console
      var consoleMethodCallback = function(msg, data) {
        self.captureBreadcrumb({
          message: msg,
          level: data.level,
          category: 'console'
        });
      };

      each(['debug', 'info', 'warn', 'error', 'log'], function(_, level) {
        wrapConsoleMethod(console, level, consoleMethodCallback);
      });
    }
  },

  _restoreBuiltIns: function() {
    // restore any wrapped builtins
    var builtin;
    while (this._wrappedBuiltIns.length) {
      builtin = this._wrappedBuiltIns.shift();

      var obj = builtin[0],
        name = builtin[1],
        orig = builtin[2];

      obj[name] = orig;
    }
  },

  _drainPlugins: function() {
    var self = this;

    // FIX ME TODO
    each(this._plugins, function(_, plugin) {
      var installer = plugin[0];
      var args = plugin[1];
      installer.apply(self, [self].concat(args));
    });
  },

  _parseDSN: function(str) {
    var m = dsnPattern.exec(str),
      dsn = {},
      i = 7;

    try {
      while (i--) dsn[dsnKeys[i]] = m[i] || '';
    } catch (e) {
      throw new RavenConfigError('Invalid DSN: ' + str);
    }

    if (dsn.pass && !this._globalOptions.allowSecretKey) {
      throw new RavenConfigError(
        'Do not specify your secret key in the DSN. See: http://bit.ly/raven-secret-key'
      );
    }

    return dsn;
  },

  _getGlobalServer: function(uri) {
    // assemble the endpoint from the uri pieces
    var globalServer = '//' + uri.host + (uri.port ? ':' + uri.port : '');

    if (uri.protocol) {
      globalServer = uri.protocol + ':' + globalServer;
    }
    return globalServer;
  },

  _handleOnErrorStackInfo: function() {
    // if we are intentionally ignoring errors via onerror, bail out
    if (!this._ignoreOnError) {
      this._handleStackInfo.apply(this, arguments);
    }
  },

  _handleStackInfo: function(stackInfo, options) {
    var frames = this._prepareFrames(stackInfo, options);

    this._triggerEvent('handle', {
      stackInfo: stackInfo,
      options: options
    });

    this._processException(
      stackInfo.name,
      stackInfo.message,
      stackInfo.url,
      stackInfo.lineno,
      frames,
      options
    );
  },

  _prepareFrames: function(stackInfo, options) {
    var self = this;
    var frames = [];
    if (stackInfo.stack && stackInfo.stack.length) {
      each(stackInfo.stack, function(i, stack) {
        var frame = self._normalizeFrame(stack, stackInfo.url);
        if (frame) {
          frames.push(frame);
        }
      });

      // e.g. frames captured via captureMessage throw
      if (options && options.trimHeadFrames) {
        for (var j = 0; j < options.trimHeadFrames && j < frames.length; j++) {
          frames[j].in_app = false;
        }
      }
    }
    frames = frames.slice(0, this._globalOptions.stackTraceLimit);
    return frames;
  },

  _normalizeFrame: function(frame, stackInfoUrl) {
    // normalize the frames data
    var normalized = {
      filename: frame.url,
      lineno: frame.line,
      colno: frame.column,
      function: frame.func || '?'
    };

    // Case when we don't have any information about the error
    // E.g. throwing a string or raw object, instead of an `Error` in Firefox
    // Generating synthetic error doesn't add any value here
    //
    // We should probably somehow let a user know that they should fix their code
    if (!frame.url) {
      normalized.filename = stackInfoUrl; // fallback to whole stacks url from onerror handler
    }

    normalized.in_app = !// determine if an exception came from outside of our app
    // first we check the global includePaths list.
    (
      (!!this._globalOptions.includePaths.test &&
        !this._globalOptions.includePaths.test(normalized.filename)) ||
      // Now we check for fun, if the function name is Raven or TraceKit
      /(Raven|TraceKit)\./.test(normalized['function']) ||
      // finally, we do a last ditch effort and check for raven.min.js
      /raven\.(min\.)?js$/.test(normalized.filename)
    );

    return normalized;
  },

  _processException: function(type, message, fileurl, lineno, frames, options) {
    var prefixedMessage = (type ? type + ': ' : '') + (message || '');
    if (
      !!this._globalOptions.ignoreErrors.test &&
      (this._globalOptions.ignoreErrors.test(message) ||
        this._globalOptions.ignoreErrors.test(prefixedMessage))
    ) {
      return;
    }

    var stacktrace;

    if (frames && frames.length) {
      fileurl = frames[0].filename || fileurl;
      // Sentry expects frames oldest to newest
      // and JS sends them as newest to oldest
      frames.reverse();
      stacktrace = {frames: frames};
    } else if (fileurl) {
      stacktrace = {
        frames: [
          {
            filename: fileurl,
            lineno: lineno,
            in_app: true
          }
        ]
      };
    }

    if (
      !!this._globalOptions.ignoreUrls.test &&
      this._globalOptions.ignoreUrls.test(fileurl)
    ) {
      return;
    }

    if (
      !!this._globalOptions.whitelistUrls.test &&
      !this._globalOptions.whitelistUrls.test(fileurl)
    ) {
      return;
    }

    var data = objectMerge(
      {
        // sentry.interfaces.Exception
        exception: {
          values: [
            {
              type: type,
              value: message,
              stacktrace: stacktrace
            }
          ]
        },
        culprit: fileurl
      },
      options
    );

    // Fire away!
    this._send(data);
  },

  _trimPacket: function(data) {
    // For now, we only want to truncate the two different messages
    // but this could/should be expanded to just trim everything
    var max = this._globalOptions.maxMessageLength;
    if (data.message) {
      data.message = truncate(data.message, max);
    }
    if (data.exception) {
      var exception = data.exception.values[0];
      exception.value = truncate(exception.value, max);
    }

    var request = data.request;
    if (request) {
      if (request.url) {
        request.url = truncate(request.url, this._globalOptions.maxUrlLength);
      }
      if (request.Referer) {
        request.Referer = truncate(request.Referer, this._globalOptions.maxUrlLength);
      }
    }

    if (data.breadcrumbs && data.breadcrumbs.values)
      this._trimBreadcrumbs(data.breadcrumbs);

    return data;
  },

  /**
     * Truncate breadcrumb values (right now just URLs)
     */
  _trimBreadcrumbs: function(breadcrumbs) {
    // known breadcrumb properties with urls
    // TODO: also consider arbitrary prop values that start with (https?)?://
    var urlProps = ['to', 'from', 'url'],
      urlProp,
      crumb,
      data;

    for (var i = 0; i < breadcrumbs.values.length; ++i) {
      crumb = breadcrumbs.values[i];
      if (
        !crumb.hasOwnProperty('data') ||
        !isObject(crumb.data) ||
        objectFrozen(crumb.data)
      )
        continue;

      data = objectMerge({}, crumb.data);
      for (var j = 0; j < urlProps.length; ++j) {
        urlProp = urlProps[j];
        if (data.hasOwnProperty(urlProp) && data[urlProp]) {
          data[urlProp] = truncate(data[urlProp], this._globalOptions.maxUrlLength);
        }
      }
      breadcrumbs.values[i].data = data;
    }
  },

  _getHttpData: function() {
    if (!this._hasNavigator && !this._hasDocument) return;
    var httpData = {};

    if (this._hasNavigator && _navigator.userAgent) {
      httpData.headers = {
        'User-Agent': navigator.userAgent
      };
    }

    if (this._hasDocument) {
      if (_document.location && _document.location.href) {
        httpData.url = _document.location.href;
      }
      if (_document.referrer) {
        if (!httpData.headers) httpData.headers = {};
        httpData.headers.Referer = _document.referrer;
      }
    }

    return httpData;
  },

  _resetBackoff: function() {
    this._backoffDuration = 0;
    this._backoffStart = null;
  },

  _shouldBackoff: function() {
    return this._backoffDuration && now() - this._backoffStart < this._backoffDuration;
  },

  /**
     * Returns true if the in-process data payload matches the signature
     * of the previously-sent data
     *
     * NOTE: This has to be done at this level because TraceKit can generate
     *       data from window.onerror WITHOUT an exception object (IE8, IE9,
     *       other old browsers). This can take the form of an "exception"
     *       data object with a single frame (derived from the onerror args).
     */
  _isRepeatData: function(current) {
    var last = this._lastData;

    if (
      !last ||
      current.message !== last.message || // defined for captureMessage
      current.culprit !== last.culprit // defined for captureException/onerror
    )
      return false;

    // Stacktrace interface (i.e. from captureMessage)
    if (current.stacktrace || last.stacktrace) {
      return isSameStacktrace(current.stacktrace, last.stacktrace);
    } else if (current.exception || last.exception) {
      // Exception interface (i.e. from captureException/onerror)
      return isSameException(current.exception, last.exception);
    }

    return true;
  },

  _setBackoffState: function(request) {
    // If we are already in a backoff state, don't change anything
    if (this._shouldBackoff()) {
      return;
    }

    var status = request.status;

    // 400 - project_id doesn't exist or some other fatal
    // 401 - invalid/revoked dsn
    // 429 - too many requests
    if (!(status === 400 || status === 401 || status === 429)) return;

    var retry;
    try {
      // If Retry-After is not in Access-Control-Expose-Headers, most
      // browsers will throw an exception trying to access it
      retry = request.getResponseHeader('Retry-After');
      retry = parseInt(retry, 10) * 1000; // Retry-After is returned in seconds
    } catch (e) {
      /* eslint no-empty:0 */
    }

    this._backoffDuration = retry
      ? // If Sentry server returned a Retry-After value, use it
        retry
      : // Otherwise, double the last backoff duration (starts at 1 sec)
        this._backoffDuration * 2 || 1000;

    this._backoffStart = now();
  },

  _send: function(data) {
    var globalOptions = this._globalOptions;

    var baseData = {
        project: this._globalProject,
        logger: globalOptions.logger,
        platform: 'javascript'
      },
      httpData = this._getHttpData();

    if (httpData) {
      baseData.request = httpData;
    }

    // HACK: delete `trimHeadFrames` to prevent from appearing in outbound payload
    if (data.trimHeadFrames) delete data.trimHeadFrames;

    data = objectMerge(baseData, data);

    // Merge in the tags and extra separately since objectMerge doesn't handle a deep merge
    data.tags = objectMerge(objectMerge({}, this._globalContext.tags), data.tags);
    data.extra = objectMerge(objectMerge({}, this._globalContext.extra), data.extra);

    // Send along our own collected metadata with extra
    data.extra['session:duration'] = now() - this._startTime;

    if (this._breadcrumbs && this._breadcrumbs.length > 0) {
      // intentionally make shallow copy so that additions
      // to breadcrumbs aren't accidentally sent in this request
      data.breadcrumbs = {
        values: [].slice.call(this._breadcrumbs, 0)
      };
    }

    // If there are no tags/extra, strip the key from the payload alltogther.
    if (isEmptyObject(data.tags)) delete data.tags;

    if (this._globalContext.user) {
      // sentry.interfaces.User
      data.user = this._globalContext.user;
    }

    // Include the environment if it's defined in globalOptions
    if (globalOptions.environment) data.environment = globalOptions.environment;

    // Include the release if it's defined in globalOptions
    if (globalOptions.release) data.release = globalOptions.release;

    // Include server_name if it's defined in globalOptions
    if (globalOptions.serverName) data.server_name = globalOptions.serverName;

    if (isFunction(globalOptions.dataCallback)) {
      data = globalOptions.dataCallback(data) || data;
    }

    // Why??????????
    if (!data || isEmptyObject(data)) {
      return;
    }

    // Check if the request should be filtered or not
    if (
      isFunction(globalOptions.shouldSendCallback) &&
      !globalOptions.shouldSendCallback(data)
    ) {
      return;
    }

    // Backoff state: Sentry server previously responded w/ an error (e.g. 429 - too many requests),
    // so drop requests until "cool-off" period has elapsed.
    if (this._shouldBackoff()) {
      this._logDebug('warn', 'Raven dropped error due to backoff: ', data);
      return;
    }

    if (typeof globalOptions.sampleRate === 'number') {
      if (Math.random() < globalOptions.sampleRate) {
        this._sendProcessedPayload(data);
      }
    } else {
      this._sendProcessedPayload(data);
    }
  },

  _getUuid: function() {
    return uuid4();
  },

  _sendProcessedPayload: function(data, callback) {
    var self = this;
    var globalOptions = this._globalOptions;

    if (!this.isSetup()) return;

    // Try and clean up the packet before sending by truncating long values
    data = this._trimPacket(data);

    // ideally duplicate error testing should occur *before* dataCallback/shouldSendCallback,
    // but this would require copying an un-truncated copy of the data packet, which can be
    // arbitrarily deep (extra_data) -- could be worthwhile? will revisit
    if (!this._globalOptions.allowDuplicates && this._isRepeatData(data)) {
      this._logDebug('warn', 'Raven dropped repeat event: ', data);
      return;
    }

    // Send along an event_id if not explicitly passed.
    // This event_id can be used to reference the error within Sentry itself.
    // Set lastEventId after we know the error should actually be sent
    this._lastEventId = data.event_id || (data.event_id = this._getUuid());

    // Store outbound payload after trim
    this._lastData = data;

    this._logDebug('debug', 'Raven about to send:', data);

    var auth = {
      sentry_version: '7',
      sentry_client: 'raven-js/' + this.VERSION,
      sentry_key: this._globalKey
    };

    if (this._globalSecret) {
      auth.sentry_secret = this._globalSecret;
    }

    var exception = data.exception && data.exception.values[0];
    this.captureBreadcrumb({
      category: 'sentry',
      message: exception
        ? (exception.type ? exception.type + ': ' : '') + exception.value
        : data.message,
      event_id: data.event_id,
      level: data.level || 'error' // presume error unless specified
    });

    var url = this._globalEndpoint;
    (globalOptions.transport || this._makeRequest).call(this, {
      url: url,
      auth: auth,
      data: data,
      options: globalOptions,
      onSuccess: function success() {
        self._resetBackoff();

        self._triggerEvent('success', {
          data: data,
          src: url
        });
        callback && callback();
      },
      onError: function failure(error) {
        self._logDebug('error', 'Raven transport failed to send: ', error);

        if (error.request) {
          self._setBackoffState(error.request);
        }

        self._triggerEvent('failure', {
          data: data,
          src: url
        });
        error = error || new Error('Raven send failed (no additional details provided)');
        callback && callback(error);
      }
    });
  },

  _makeRequest: function(opts) {
    var request = _window.XMLHttpRequest && new _window.XMLHttpRequest();
    if (!request) return;

    // if browser doesn't support CORS (e.g. IE7), we are out of luck
    var hasCORS = 'withCredentials' in request || typeof XDomainRequest !== 'undefined';

    if (!hasCORS) return;

    var url = opts.url;

    if ('withCredentials' in request) {
      request.onreadystatechange = function() {
        if (request.readyState !== 4) {
          return;
        } else if (request.status === 200) {
          opts.onSuccess && opts.onSuccess();
        } else if (opts.onError) {
          var err = new Error('Sentry error code: ' + request.status);
          err.request = request;
          opts.onError(err);
        }
      };
    } else {
      request = new XDomainRequest();
      // xdomainrequest cannot go http -> https (or vice versa),
      // so always use protocol relative
      url = url.replace(/^https?:/, '');

      // onreadystatechange not supported by XDomainRequest
      if (opts.onSuccess) {
        request.onload = opts.onSuccess;
      }
      if (opts.onError) {
        request.onerror = function() {
          var err = new Error('Sentry error code: XDomainRequest');
          err.request = request;
          opts.onError(err);
        };
      }
    }

    // NOTE: auth is intentionally sent as part of query string (NOT as custom
    //       HTTP header) so as to avoid preflight CORS requests
    request.open('POST', url + '?' + urlencode(opts.auth));
    request.send(stringify(opts.data));
  },

  _logDebug: function(level) {
    if (this._originalConsoleMethods[level] && this.debug) {
      // In IE<10 console methods do not have their own 'apply' method
      Function.prototype.apply.call(
        this._originalConsoleMethods[level],
        this._originalConsole,
        [].slice.call(arguments, 1)
      );
    }
  },

  _mergeContext: function(key, context) {
    if (isUndefined(context)) {
      delete this._globalContext[key];
    } else {
      this._globalContext[key] = objectMerge(this._globalContext[key] || {}, context);
    }
  }
};

// Deprecations
Raven.prototype.setUser = Raven.prototype.setUserContext;
Raven.prototype.setReleaseContext = Raven.prototype.setRelease;

module.exports = Raven;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "JeYD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _dom = __webpack_require__("TdxG");

var DomUtils = _interopRequireWildcard(_dom);

var _url = __webpack_require__("QKfw");

var UrlUtil = _interopRequireWildcard(_url);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var extend = __webpack_require__("5E+y");
var SVPCustomEvent = __webpack_require__("L+TV");

var device = __webpack_require__("xOtj");
var VideoUtil = __webpack_require__("tpcr");
var config = __webpack_require__("Pqsl");
var Debug = __webpack_require__("BF+C")('dash-video');
var DashDebug = __webpack_require__("BF+C")('dashjs');
var AudioTrack = __webpack_require__("0Gsn");

module.exports = function () {

    // Structure is {mediaPlayer: <dash.MediaPlayer>, originalAttributes: <Array>}
    var instances = {};
    var AUDIO_STORAGE_KEY = "audioTrack";

    // TODO: This is due to a bug in dashjs, should hopefully be fixed in 2.3.0
    var dvrWindowSafetyMarginSeconds = 8;

    function _extend(videoElement, uid) {
        extend(videoElement, {
            getDashInstances: function getDashInstances() {
                return instances;
            },
            getSrc: function getSrc() {
                // TODO: Use videoElement.src when we fetch url from redirector directly
                //       and set as src
                return instances[uid].manifest.originalUrl;
            },

            getCurrentTime: function getCurrentTime() {
                return instances[uid].mediaPlayer.time();
            },
            getDuration: function getDuration() {
                return videoElement.liveDuration ? Math.max(videoElement.liveDuration, instances[uid].mediaPlayer.time()) : instances[uid].mediaPlayer.duration();
            },
            getVolume: function getVolume() {
                return instances[uid].mediaPlayer.getVolume();
            },
            isPaused: function isPaused() {
                // Seeked event is sent for live dash stream before player is initialized
                return instances[uid] && instances[uid].mediaPlayer.isPaused();
            },
            isSeeking: function isSeeking() {
                return instances[uid] && instances[uid].mediaPlayer.isSeeking();
            },

            isMuted: function isMuted() {
                return instances[uid] && instances[uid].mediaPlayer.isMuted();
            },
            mute: function mute(shouldMute) {
                instances[uid].mediaPlayer.setMute(shouldMute);
            },
            seek: function seek(position) {
                var sanePosition = videoElement.liveDuration ? Math.min(instances[uid].mediaPlayer.getDVRWindowSize() - dvrWindowSafetyMarginSeconds, position) : position;
                instances[uid].mediaPlayer.seek(sanePosition);
            },
            getMaxSeekable: function getMaxSeekable() {
                return instances[uid].mediaPlayer.getDVRWindowSize() - dvrWindowSafetyMarginSeconds;
            },
            setVolume: function setVolume(volume) {
                instances[uid].mediaPlayer.setVolume(volume);
            },
            showCaptions: function showCaptions(shouldShow) {
                videoElement.parentNode.dispatchEvent(new SVPCustomEvent('captionsvisible', { detail: { shouldShow: shouldShow } }));
            },
            getTextTracks: function getTextTracks() {
                return [];
            },
            setAudioTrack: function setAudioTrack(audioTrack) {
                var tracks = instances[uid].mediaPlayer.getTracksFor('audio');
                for (var i = 0; i < tracks.length; i++) {
                    if (tracks[i].lang === audioTrack) {
                        // important to run setStoredData before setCurremtTrack
                        // setCurrentTrack will trigger audiotracksloaded event
                        DomUtils.setStoredData(AUDIO_STORAGE_KEY, audioTrack);
                        instances[uid].mediaPlayer.setCurrentTrack(tracks[i]);
                    }
                }
            },
            getAudioTracks: function getAudioTracks() {
                var activeAudioTrack = DomUtils.getStoredData(AUDIO_STORAGE_KEY) || AudioTrack.DEFAULT_AUDIO;

                return instances[uid].mediaPlayer.getTracksFor('audio').map(function (track) {
                    return {
                        id: track.lang,
                        active: track.lang === activeAudioTrack
                    };
                });
            },
            getMetrics: function getMetrics() {
                var mediaPlayer = instances[uid].mediaPlayer;
                var manifest = instances[uid].manifest;
                var metrics = mediaPlayer.getMetricsFor('video');
                var dashMetrics = mediaPlayer.getDashMetrics();
                var currentDroppedFrames = dashMetrics.getCurrentDroppedFrames(metrics);
                var isSVTCdn = manifest.originalUrl.indexOf('cdn.svt') > 0;

                return {
                    droppedFrames: currentDroppedFrames ? currentDroppedFrames.droppedFrames : 0,
                    bufferLevel: dashMetrics.getCurrentBufferLevel(metrics),
                    cdn: isSVTCdn ? 1 : 2,
                    dimensions: Math.round(videoElement.offsetWidth) + ' x ' + Math.round(videoElement.offsetHeight),
                    resolution: videoElement.videoWidth + ' x ' + videoElement.videoHeight,
                    dash: true
                };
            },
            reset: function reset() {
                // if (videoElement.currentTime) {
                // 	videoElement.currentTime = 0.01; //Bug in dash 2.0 when seeking to 0 in some streams
                // }
                instances[uid].mediaPlayer.seek(0);
            },
            unload: function unload() {
                if (instances[uid]) {

                    instances[uid].mediaPlayer.reset();

                    instances[uid].mediaPlayer = undefined;
                }

                if (videoElement) {
                    while (videoElement.lastChild) {
                        videoElement.removeChild(videoElement.lastChild);
                    }

                    videoElement.removeAttribute('src');
                }

                delete instances[uid];
            }
        });
    }

    return {
        load: function load(videoId, videoElement, videoUrl, metadata, videoConfig, api, dashjs) {
            var maxBitrate = VideoUtil.getMaxBitrate(videoElement);
            var uid = VideoUtil.getUID(videoElement) || VideoUtil.generateAndSetUID(videoElement);

            var dashObject = instances[uid];

            if (dashObject) {
                dashObject.mediaPlayer.reset();
                dashObject.mediaPlayer = undefined;
                videoElement.removeAttribute('crossorigin');
                videoElement.removeAttribute('src');

                while (videoElement.lastChild) {
                    videoElement.removeChild(videoElement.lastChild);
                }
            } else {
                dashObject = {
                    originalAttributes: DomUtils.getAttributes(videoElement)
                };
            }

            videoElement.setAttribute('data-video-uid', uid);

            var mediaPlayer = dashjs.MediaPlayer().create();
            dashObject.mediaPlayer = mediaPlayer;

            // Pipe dash.js logging to our log utility.
            mediaPlayer.getDebug().setLogToBrowserConsole(false);
            mediaPlayer.on(dashjs.MediaPlayer.events.LOG, function (e) {
                DashDebug.log(e.message);
            });
            // Customized the dash.js VideoModel to use window dimensions.
            // By using the window dimensions the user can the best quality
            // when going fullscreen, presuming bandwidth is not the limiting
            // factor.
            mediaPlayer.extend('VideoModel', function () {
                return {
                    getClientWidth: function getClientWidth() {
                        return window.outerWidth;
                    },
                    getClientHeight: function getClientHeight() {
                        return window.outerHeight;
                    }
                };
            }, true);

            var canPlayListener = function canPlayListener() {
                var startPosition = VideoUtil.getStartPosition(videoElement);
                if (startPosition > 0) {
                    videoElement.currentTime = startPosition;
                }
                videoElement.removeEventListener('canplay', canPlayListener);
            };

            videoElement.addEventListener('canplay', canPlayListener);

            var manifestLoadedListener = function manifestLoadedListener(event) {
                dashObject.manifest = event.data;
                mediaPlayer.setLimitBitrateByPortal(videoConfig.limitBitrateByPortal);
                mediaPlayer.setUsePixelRatioInLimitBitrateByPortal(true);
                mediaPlayer.setFastSwitchEnabled(true);
                if (maxBitrate) {
                    mediaPlayer.setMaxAllowedBitrateFor('video', maxBitrate);
                } else {
                    mediaPlayer.setMaxAllowedBitrateFor('video', NaN);
                }

                var audioPreference = DomUtils.getStoredData(AUDIO_STORAGE_KEY);
                if (audioPreference) {
                    mediaPlayer.setInitialMediaSettingsFor('audio', {
                        lang: audioPreference
                    });
                }

                mediaPlayer.off(dashjs.MediaPlayer.events.MANIFEST_LOADED, manifestLoadedListener);
                api.fire('dashmanifestloaded', (event || {}).data);
            };

            mediaPlayer.on(dashjs.MediaPlayer.events.STREAM_INITIALIZED, function () {
                var tracks = mediaPlayer.getTracksFor('audio');
                Debug('found ' + tracks.length + ' audio tracks');

                if (tracks.length > 1) {
                    for (var i = 0; i < tracks.length; i++) {
                        if (tracks[i].lang === AudioTrack.SPOKEN_TEXT) {
                            api.fire('audiotracksloaded');
                            break;
                        }
                    }
                }
            });

            mediaPlayer.on(dashjs.MediaPlayer.events.MANIFEST_LOADED, manifestLoadedListener);

            mediaPlayer.on(dashjs.MediaPlayer.events.ERROR, function (event) {
                api.fire('error', {
                    player: 'dash',
                    name: event.error,
                    id: event.event.id,
                    url: event.event.url
                });
            });

            mediaPlayer.on(dashjs.MediaPlayer.events.BUFFER_EMPTY, function () {
                api.fire('bufferEmpty');
            });

            //Temporary hack for the new cdn switch, remove this when stream team are ready for primetime
            var altUrl = UrlUtil.getQueryParameter('alt', videoUrl);
            if (config.useAltDashUrl && altUrl && device.isRedirectCapable()) {
                videoUrl = decodeURIComponent(altUrl);
            }

            videoElement.liveDuration = metadata && metadata.timeshiftEnabled ? metadata.contentDuration : undefined;

            var autoplay = api.isAutoplay();

            // In some cases autoplay is not allowed if the playback is not initiated by a user gesture (for instance, a click).
            // To make it possible to handle this error, we will listen on the `PLAYBACK_NOT_ALLOWED event
            // and pass by an `autoplaynotallowed` event. If the video element has an `muted` attribute,
            // the support for autoplay will increase.
            //
            // For more info about support for autoplay in combination with the `muted` attribute:
            // https://developer.jwplayer.com/articles/html5-report/tag-attributes-and-apis/autoplay-loop-muted.html

            if (autoplay) {
                mediaPlayer.on(dashjs.MediaPlayer.events.PLAYBACK_NOT_ALLOWED, function () {
                    Debug('Playback error', 'Playback must probably be initiated by a user gesture.');
                    api.fire('autoplaynotallowed');
                });
            }

            mediaPlayer.on(dashjs.MediaPlayer.events.QUALITY_CHANGE_REQUESTED, function (e) {
                var bitrateInfoList = mediaPlayer.getBitrateInfoListFor('video');

                // Find new bitrate
                var newBitrate = void 0;
                for (var i = 0; i < bitrateInfoList.length; i++) {
                    if (bitrateInfoList[i].qualityIndex === e.newQuality) {
                        newBitrate = bitrateInfoList[i].bitrate;
                        break;
                    }
                }

                if (newBitrate) {
                    api.fire('bitrateswitch', { mediaType: e.mediaType, bitrate: newBitrate });
                }
            });

            Debug('Init dash.js, url = ' + videoUrl + ' , autoplay = ' + autoplay);
            mediaPlayer.initialize(videoElement, videoUrl, autoplay);

            instances[uid] = dashObject;

            _extend(videoElement, uid);

            return videoElement;
        }
    };
}();

/***/ }),

/***/ "JyN8":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__("Wdy1");

$export($export.S + $export.F, 'Object', { assign: __webpack_require__("xVc6") });


/***/ }),

/***/ "KB1o":
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),

/***/ "KOrd":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__("WBcL");
var toObject = __webpack_require__("FryR");
var IE_PROTO = __webpack_require__("mZON")('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ "L+TV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var SVPCustomEvent = window.CustomEvent;

function _createCustomEvent() {

	SVPCustomEvent = function SVPCustomEvent(event, params) {
		var evt;
		params = params || {
			bubbles: false,
			cancelable: false,
			detail: undefined
		};

		try {
			evt = document.createEvent("CustomEvent");
			evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
		} catch (e) {
			// Older devices does not support CustomEvent
			evt = document.createEvent("Event");
			evt.initEvent(event, params.bubbles, params.cancelable);
		}

		return evt;
	};

	SVPCustomEvent.prototype = window.Event.prototype;
}

if (!SVPCustomEvent || typeof SVPCustomEvent !== 'function') {
	_createCustomEvent();
} else {
	try {
		new SVPCustomEvent();
	} catch (e) {
		_createCustomEvent();
	}
}

module.exports = SVPCustomEvent;

/***/ }),

/***/ "LKnP":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("YjQv");
var macrotask = __webpack_require__("kkvn").set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__("NZra")(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver
  } else if (Observer) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    var promise = Promise.resolve();
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),

/***/ "LfR4":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__("30vf")('getOwnPropertyNames', function () {
  return __webpack_require__("6tLb").f;
});


/***/ }),

/***/ "LhDF":
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__("GCs6").f;
var has = __webpack_require__("x//u");
var TAG = __webpack_require__("hgbu")('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ "LocR":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("qs+f") && !__webpack_require__("zyKz")(function () {
  return Object.defineProperty(__webpack_require__("PY1i")('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "Mnw5":
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__("A1Hb")('Map');


/***/ }),

/***/ "Mq3M":
/***/ (function(module, exports) {

var wrapMethod = function(console, level, callback) {
  var originalConsoleLevel = console[level];
  var originalConsole = console;

  if (!(level in console)) {
    return;
  }

  var sentryLevel = level === 'warn' ? 'warning' : level;

  console[level] = function() {
    var args = [].slice.call(arguments);

    var msg = '' + args.join(' ');
    var data = {level: sentryLevel, logger: 'console', extra: {arguments: args}};

    if (level === 'assert') {
      if (args[0] === false) {
        // Default browsers message
        msg = 'Assertion failed: ' + (args.slice(1).join(' ') || 'console.assert');
        data.extra.arguments = args.slice(1);
        callback && callback(msg, data);
      }
    } else {
      callback && callback(msg, data);
    }

    // this fails for some browsers. :(
    if (originalConsoleLevel) {
      // IE9 doesn't allow calling apply on console functions directly
      // See: https://stackoverflow.com/questions/5472938/does-ie9-support-console-log-and-is-it-a-real-function#answer-5473193
      Function.prototype.apply.call(originalConsoleLevel, originalConsole, args);
    }
  };
};

module.exports = {
  wrapMethod: wrapMethod
};


/***/ }),

/***/ "N/Vz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _assign = __webpack_require__("woOf");

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (typeof _assign2.default != 'function') {
    Object.assign = function (target, varArgs) {
        // .length of function is 2
        'use strict';

        if (target == null) {
            // TypeError if undefined or null
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var to = Object(target);

        for (var index = 1; index < arguments.length; index++) {
            var nextSource = arguments[index];

            if (nextSource != null) {
                // Skip over if undefined or null
                for (var nextKey in nextSource) {
                    // Avoid bugs when hasOwnProperty is shadowed
                    if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                        to[nextKey] = nextSource[nextKey];
                    }
                }
            }
        }
        return to;
    };
}

/***/ }),

/***/ "NH+Q":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Debug = __webpack_require__("BF+C")('fallback-old-device');
var AndroidFallback = __webpack_require__("S+dD");
var WindowsPhoneFallback = __webpack_require__("VT6N");
var VideoConfig = __webpack_require__("Pqsl");

var SHOULD_PROXY_ANDROID = false;
var SHOULD_PROXY_WP = false;

module.exports = {
	create: function create(api) {
		var plugins = VideoConfig.plugins;

		if (plugins.indexOf('android-fallback') === -1) {
			Debug('Using legacy "fallback-old-device" for Android');
			AndroidFallback.create(api);
			SHOULD_PROXY_ANDROID = true;
		}

		if (plugins.indexOf('windows-phone-fallback') === -1) {
			Debug('Using legacy "fallback-old-device" for WP');
			WindowsPhoneFallback.create(api);
			SHOULD_PROXY_WP = true;
		}
	},
	destroy: function destroy(api) {
		if (SHOULD_PROXY_ANDROID) {
			AndroidFallback.destroy(api);
			SHOULD_PROXY_ANDROID = false;
		}

		if (SHOULD_PROXY_WP) {
			WindowsPhoneFallback.destroy(api);
			SHOULD_PROXY_WP = false;
		}
	}
};

/***/ }),

/***/ "NU0k":
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__("NZra");
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ "NZ8V":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__("FKWp");
var dPs = __webpack_require__("r3+g");
var enumBugKeys = __webpack_require__("B5V0");
var IE_PROTO = __webpack_require__("+SdG")('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__("PY1i")('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__("+iDZ").appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ "NZra":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "Nhvj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _typeof2 = __webpack_require__("pFYg");

var _typeof3 = _interopRequireDefault(_typeof2);

var _debug = __webpack_require__("BF+C");

var _debug2 = _interopRequireDefault(_debug);

var _plugins = __webpack_require__("q6TJ");

var plugins = _interopRequireWildcard(_plugins);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Debug = (0, _debug2.default)('PluginManager');

/**
 * Converts a string into camel case.
 * @see {@link https://stackoverflow.com/a/15829686} for origins.
 */
var camelize = function camelize(str) {
	return str.replace(/^([A-Z])|[\s-_]+(\w)/g, function (match, p1, p2) {
		return p2 ? p2.toUpperCase() : p1.toLowerCase();
	});
};

/**
 * Constructs a plugin object from a function.
 */
var createPluginFromFunction = function createPluginFromFunction(fn) {
	return {
		create: fn,
		destroy: function destroy() {
			return null;
		}
	};
};

/**
 * Searches the bundled plugins object, i.e. the plugins/index module, by
 * performing a string key lookup.
 */
var createPluginFromString = function createPluginFromString(pluginName) {
	return plugins[camelize(pluginName)];
};

/**
 * Validates a plugin object, making sure it has a create function and a
 * destroy function.
 *
 * @param {object} plugin The plugin object to validate.
 * @param {string} pluginName String used to identify the plugin in error
 * messages.
 * @return {boolean} True if the plugin is valid.
 */
var validatePlugin = function validatePlugin(plugin, pluginName) {
	if ((typeof plugin === 'undefined' ? 'undefined' : (0, _typeof3.default)(plugin)) !== 'object') {
		Debug.error('Plugin "' + pluginName + '" (' + plugin + ') is not a valid plugin.');

		return false;
	}

	if (typeof plugin.create !== 'function') {
		Debug.error('Plugin "' + pluginName + '" (' + plugin + ') does not contain a "create" function.');

		return false;
	}

	if (typeof plugin.destroy !== 'function') {
		Debug.error('Plugin "' + pluginName + '" (' + plugin + ') does not contain a "destroy" function');

		return false;
	}

	return true;
};

/**
 * The PluginManager class maintain a collection of plugins. It provides
 * functions to manage the plugins lifecycles.
 */

var PluginManager = function () {
	function PluginManager() {
		(0, _classCallCheck3.default)(this, PluginManager);

		this.plugins = [];
	}

	/**
  * Adds a plugin to the manager.
  *
  * @param {string|function|object} param Plugin to add.
  * @param {boolean} [prepend] If true, the plugin is added to the beginning
  * of the internal plugin collection.
  */


	(0, _createClass3.default)(PluginManager, [{
		key: 'addPlugin',
		value: function addPlugin(plugin) {
			var prepend = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

			var pluginObject = void 0;
			var pluginName = void 0;

			switch (typeof plugin === 'undefined' ? 'undefined' : (0, _typeof3.default)(plugin)) {
				case 'function':
					pluginObject = createPluginFromFunction(plugin);
					pluginName = plugin.name || 'function';
					break;
				case 'string':
					pluginObject = createPluginFromString(plugin);
					pluginName = plugin;
					break;
				case 'object':
					pluginObject = plugin;
					pluginName = plugin.namespace || 'object';
					break;
				default:
					pluginObject = plugin;
					pluginName = 'unknown';
					break;
			}

			if (validatePlugin(pluginObject, pluginName)) {
				if (prepend) {
					this.plugins.unshift(pluginObject);
				} else {
					this.plugins.push(pluginObject);
				}

				Debug.log('Loaded plugin "' + pluginName + '"');
			}
		}

		/**
   * Invokes the create function on all plugins.
   */

	}, {
		key: 'createAll',
		value: function createAll(api) {
			this.plugins.forEach(function (plugin) {
				return plugin.create(api);
			});
		}

		/**
   * Invokes the destroy function on all plugins.
   */

	}, {
		key: 'destroyAll',
		value: function destroyAll(api) {
			this.plugins.forEach(function (plugin) {
				return plugin.destroy(api);
			});
		}
	}]);
	return PluginManager;
}();

module.exports = PluginManager;

/***/ }),

/***/ "Nrqz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__("Wdy1");
var newPromiseCapability = __webpack_require__("3HN9");
var perform = __webpack_require__("AgWD");

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),

/***/ "Ntt2":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("YjQv");
var core = __webpack_require__("iANj");
var LIBRARY = __webpack_require__("c8Kh");
var wksExt = __webpack_require__("4DQ7");
var defineProperty = __webpack_require__("GCs6").f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),

/***/ "OoWg":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("Ntt2")('observable');


/***/ }),

/***/ "OzIq":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "PHCx":
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),

/***/ "PHqh":
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("Q6Nf");
var defined = __webpack_require__("/whu");
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ "PY1i":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("8ANE");
var document = __webpack_require__("YjQv").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ "PbQV":
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("ksFB");
var toLength = __webpack_require__("GhAV");
var toAbsoluteIndex = __webpack_require__("+VX5");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ "Pqsl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _flashVideo = __webpack_require__("ruEN");

var _flashVideo2 = _interopRequireDefault(_flashVideo);

var _defaultMetadataFetch = __webpack_require__("r5ma");

var _defaultMetadataFetch2 = _interopRequireDefault(_defaultMetadataFetch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _basePath = '//www.svtstatic.se/video';
var CCSvtPlayReceiverId = {
    Prod: '3F70D486',
    Stage: 'D238C23D' // Only stored as reference, not used in project
};

var config = {
    basePath: _basePath,
    nojsPlayerBaseUrl: 'https://api.svt.se/videoplayer-embed/nojs/',
    defaultThumbnail: 'https://www.svtplay.se/public/images/default/play_default_998x561.jpg',
    cssPath: 'css',
    jsPath: 'js',
    imgPath: 'img',
    swfPath: 'swf',
    plugins: ['android-fallback', 'ui', 'windows-phone-fallback', 'splash', 'captions', 'error-handler', 'keyboard-navigation', 'chromecast', 'akamai-stats', 'mms-stats', 'thumbnails', 'embed', 'airplay', 'pictureinpicture', 'metrics'],
    flashEngine: _flashVideo2.default,
    resetOnEnd: true,
    splash: true,
    theme: 'standard',
    useAltDashUrl: false,
    useAltHlsUrl: false,
    chromecastReceiverId: CCSvtPlayReceiverId.Prod,
    isInNativeApp: false,
    metadataFetchFunction: _defaultMetadataFetch2.default,
    androidFallback: null,
    sentry: {
        dsn: 'https://628a611dab944712ba98fb9c6fde80b1@sentry.io/232503',
        sampleRate: 1.0,
        ignoreErrors: []
    },
    breakPoints: [{
        'svp_container--small': 'only screen and (max-width: 480px)!default' //default
    }, {
        'svp_container--medium': 'only screen and (min-width: 481px) and (max-width: 800px)'
    }, {
        'svp_container--large': 'only screen and (min-width:801px)'
    }],
    messages: {
        error: {
            defaultError: {
                text: 'Problem med uppspelningen',
                link: {
                    text: 'Få hjälp med uppspelningen',
                    url: 'https://kontakt.svt.se/guide/uppspelningsproblem'
                }
            },
            loadError: {
                text: 'Kunde inte starta uppspelningen',
                retry: true,
                link: {
                    text: 'Få hjälp med uppspelningen',
                    url: 'https://kontakt.svt.se/guide/uppspelningsproblem'
                }
            },
            mediaErrorAborted: {
                text: 'Uppspelningen avbröts',
                link: {
                    text: 'Få hjälp med uppspelningen',
                    url: 'https://kontakt.svt.se/guide/uppspelningsproblem'
                }
            },
            mediaErrorNetwork: {
                text: 'Problem med internetanslutningen',
                retry: true,
                link: {
                    text: 'Få hjälp med uppspelningen',
                    url: 'https://kontakt.svt.se/guide/uppspelningsproblem'
                }
            },
            mediaErrorDecode: {
                text: 'Tekniskt fel på videofilen'
            },
            mediaErrorSrcNotSupported: {
                text: 'Enheten kan inte spela programmet',
                link: {
                    text: 'Få hjälp med uppspelningen',
                    url: 'https://kontakt.svt.se/guide/uppspelningsproblem'
                }
            },
            loadPlayerError: {
                text: 'Problem med uppspelningen',
                retry: true,
                link: {
                    text: 'Få hjälp med uppspelningen',
                    url: 'https://kontakt.svt.se/guide/uppspelningsproblem'
                }
            },
            unknownVideoTypeError: {
                text: 'Kan inte spela programmet',
                link: {
                    text: 'Få hjälp med uppspelningen',
                    url: 'https://kontakt.svt.se/guide/uppspelningsproblem'
                }
            },
            flashNotSupported: {
                text: 'Du behöver aktivera eller ladda ned Flash',
                link: {
                    text: 'För att titta behöver du Flash',
                    url: 'https://kontakt.svt.se/guide/installera-eller-uppdatera-flash'
                }
            },
            geoblockError: {
                text: 'Programmet kan bara ses i Sverige',
                link: {
                    text: 'Mer information om rättigheter utomlands',
                    url: 'https://kontakt.svt.se/guide/anvand-svt-play-utomlands'
                }
            },
            rightsExpiredError: {
                text: 'Programmet finns inte kvar',
                link: {
                    text: 'Mer information om rättigheter',
                    url: 'https://kontakt.svt.se/guide/rattigheter'
                }
            },
            liveNotStartedError: {
                text: 'Sändningen har inte startat än'
            },
            programNotStartedError: {
                text: 'Programmet går inte att titta på än'
            },
            drmProtectionError: {
                text: 'Programmet kan inte visas på denna enhet',
                link: {
                    text: 'Information om rättighetsskyddat material',
                    url: 'https://kontakt.svt.se/guide/kopieringsskydd'
                }
            },
            immersiveNotSupported: {
                text: 'Din webbläsare kan inte spela upp 360-video',
                link: {
                    text: 'Få hjälp med 360-video',
                    url: 'https://kontakt.svt.se/guide/uppspelningsproblem'
                }
            },
            immersiveFailedToLoad: {
                text: 'Problem med uppspelning av 360-video',
                link: {
                    text: 'Få hjälp med 360-video',
                    url: 'https://kontakt.svt.se/guide/uppspelningsproblem'
                }
            }
        },
        general: {
            retry: 'Försök igen'
        }
    }
};

module.exports = config;

/***/ }),

/***/ "Q6Nf":
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("ydD5");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ "QKXm":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ "QKfw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.absolutePath = absolutePath;
exports.getQueryParameter = getQueryParameter;
exports.setQueryParameters = setQueryParameters;
function absolutePath(path) {
    var Config = __webpack_require__("Pqsl");

    var extraPath = null,
        basePath = getQueryParameter('basePath') || Config.basePath;

    if (path.match(/\.css/) && Config.cssPath) {
        extraPath = Config.cssPath;
    } else if (path.match(/\.js/) && Config.jsPath) {
        extraPath = Config.jsPath;
    } else if (path.match(/\.swf/) && Config.swfPath) {
        extraPath = Config.swfPath;
    } else if (path.match(/\.png|\.jpg/) && Config.imgPath) {
        extraPath = Config.imgPath;
    }

    return basePath + (extraPath ? extraPath + '/' : '') + path;
}

function getQueryParameter(name, url) {
    var str = url || window.location.search,
        regexp = new RegExp('.*?' + name + '=([^&$]*).*');

    return regexp.test(str) ? str.replace(regexp, '$1') : null;
}

function setQueryParameters(nameValues, url) {
    var str = url || window.location.search,
        divisor = /\?/.test(str) ? '&' : '?';

    for (var name in nameValues) {
        if (Object.prototype.hasOwnProperty.call(nameValues, name)) {
            if (nameValues[name]) {
                str += (divisor || '&') + name + '=' + nameValues[name];
                divisor = undefined;
            }
        }
    }

    return str;
}

/***/ }),

/***/ "QZD8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof2 = __webpack_require__("pFYg");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* Copyright (c) 2016 comScore, Inc.
   * All rights reserved.
   * By using this software, you are agreeing to be bound by the
   * terms of these policies: http://www.comscore.com/About_comScore/Privacy_Policy
   */
  !function (a, b) {
    "use strict";
     true ? (b(a.ns_ = a.ns_ || {}), !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
      return a.ns_;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))) : "object" == (typeof module === "undefined" ? "undefined" : (0, _typeof3.default)(module)) && module.exports ? module.exports = b({}) : b(a.ns_ = a.ns_ || {});
  }(this, function (a) {
    "use strict";
    a.ns_ = a;var b = b || {};b.indexOf = function (a, b) {
      var c = -1;return this.forEach(b, function (b, d) {
        b == a && (c = d);
      }), c;
    }, b.forEach = function (a, b, c) {
      try {
        if ("function" == typeof b) if (c = "undefined" != typeof c ? c : null, "number" != typeof a.length || "undefined" == typeof a[0]) {
          var d = "undefined" != typeof a.__proto__;for (var e in a) {
            a.hasOwnProperty(e) && (!d || d && "undefined" == typeof a.__proto__[e]) && "function" != typeof a[e] && b.call(c, a[e], e);
          }
        } else for (var f = 0, g = a.length; f < g; f++) {
          b.call(c, a[f], f);
        }
      } catch (h) {}
    };var b = b || {};b.parseBoolean = function (a, b) {
      return b = b || !1, a ? "0" != a : b;
    }, b.parseInteger = function (a, b) {
      return null == a || isNaN(a) ? b || 0 : parseInt(a);
    }, b.parseLong = function (a, b) {
      var c = Number(a);return null == a || isNaN(c) ? b || 0 : c;
    }, b.toString = function (a) {
      if ("undefined" == typeof a) return "undefined";if ("string" == typeof a) return a;if (a instanceof Array) return a.join(",");var b = "";for (var c in a) {
        a.hasOwnProperty(c) && (b += c + ":" + a[c] + ";");
      }return b || a.toString();
    };var b = b || {};b.filter = function (a, b) {
      var c = {};for (var d in b) {
        b.hasOwnProperty(d) && a(b[d]) && (c[d] = b[d]);
      }return c;
    }, b.extend = function (a) {
      var b,
          c = arguments.length;a = a || {};for (var d = 1; d < c; d++) {
        if (b = arguments[d]) for (var e in b) {
          b.hasOwnProperty(e) && (a[e] = b[e]);
        }
      }return a;
    };var b = b || {};b.cloneObject = function (a) {
      if (null == a || "object" != (typeof a === "undefined" ? "undefined" : (0, _typeof3.default)(a))) return a;var b = function () {
        function a() {}function b(b) {
          return "object" == (typeof b === "undefined" ? "undefined" : (0, _typeof3.default)(b)) ? (a.prototype = b, new a()) : b;
        }function c(a) {
          for (var b in a) {
            a.hasOwnProperty(b) && (this[b] = a[b]);
          }
        }function d() {
          this.copiedObjects = [];var a = this;this.recursiveDeepCopy = function (b) {
            return a.deepCopy(b);
          }, this.depth = 0;
        }function e(a, b) {
          var c = new d();return b && (c.maxDepth = b), c.deepCopy(a);
        }function f(a) {
          return "undefined" != typeof window && window && window.Node ? a instanceof Node : "undefined" != typeof document && a === document || "number" == typeof a.nodeType && a.attributes && a.childNodes && a.cloneNode;
        }var g = [];return c.prototype = { constructor: c, canCopy: function canCopy() {
            return !1;
          }, create: function create(a) {}, populate: function populate(a, b, c) {} }, d.prototype = { constructor: d, maxDepth: 256, cacheResult: function cacheResult(a, b) {
            this.copiedObjects.push([a, b]);
          }, getCachedResult: function getCachedResult(a) {
            for (var b = this.copiedObjects, c = b.length, d = 0; d < c; d++) {
              if (b[d][0] === a) return b[d][1];
            }
          }, deepCopy: function deepCopy(a) {
            if (null === a) return null;if ("object" != (typeof a === "undefined" ? "undefined" : (0, _typeof3.default)(a))) return a;var b = this.getCachedResult(a);if (b) return b;for (var c = 0; c < g.length; c++) {
              var d = g[c];if (d.canCopy(a)) return this.applyDeepCopier(d, a);
            }throw new Error("Unable to clone the following object " + a);
          }, applyDeepCopier: function applyDeepCopier(a, b) {
            var c = a.create(b);if (this.cacheResult(b, c), this.depth++, this.depth > this.maxDepth) throw new Error("Maximum recursion depth exceeded.");return a.populate(this.recursiveDeepCopy, b, c), this.depth--, c;
          } }, e.DeepCopier = c, e.deepCopiers = g, e.register = function (a) {
          a instanceof c || (a = new c(a)), g.unshift(a);
        }, e.register({ canCopy: function canCopy() {
            return !0;
          }, create: function create(a) {
            return a instanceof a.constructor ? b(a.constructor.prototype) : {};
          }, populate: function populate(a, b, c) {
            for (var d in b) {
              b.hasOwnProperty(d) && (c[d] = a(b[d]));
            }return c;
          } }), e.register({ canCopy: function canCopy(a) {
            return a instanceof Array;
          }, create: function create(a) {
            return new a.constructor();
          }, populate: function populate(a, b, c) {
            for (var d = 0; d < b.length; d++) {
              c.push(a(b[d]));
            }return c;
          } }), e.register({ canCopy: function canCopy(a) {
            return a instanceof Date;
          }, create: function create(a) {
            return new Date(a);
          } }), e.register({ canCopy: function canCopy(a) {
            return f(a);
          }, create: function create(a) {
            return "undefined" != typeof document && a === document ? document : a.cloneNode(!1);
          }, populate: function populate(a, b, c) {
            if ("undefined" != typeof document && b === document) return document;if (b.childNodes && b.childNodes.length) for (var d = 0; d < b.childNodes.length; d++) {
              var e = a(b.childNodes[d]);c.appendChild(e);
            }
          } }), { deepCopy: e };
      }();return b.deepCopy(a);
    };var b = b || {};b.getNamespace = function () {
      return a.ns_ || a;
    }, b.uid = function () {
      var a = 1;return function () {
        return +new Date() + "_" + a++;
      };
    }(), b.isEmpty = function (a) {
      return void 0 === a || null === a || "" === a || a instanceof Array && 0 === a.length;
    }, b.isNotEmpty = function (a) {
      return !this.isEmpty(a);
    }, b.safeGet = function (a, b) {
      return b = this.exists(b) ? b : "", this.exists(a) ? a : b;
    }, b.isTrue = function (a) {
      return "undefined" != typeof a && ("string" == typeof a ? (a = a.toLowerCase(), "true" === a || "1" === a || "on" === a) : !!a);
    }, b.regionMatches = function (a, b, c, d, e) {
      if (b < 0 || d < 0 || b + e > a.length || d + e > c.length) return !1;for (; --e >= 0;) {
        var f = a.charAt(b++),
            g = c.charAt(d++);if (f != g) return !1;
      }return !0;
    }, b.exists = function (a) {
      return "undefined" != typeof a && null != a;
    }, !function () {
      var a = [],
          c = !1,
          d = !0;b.onSystemClockJump = function (b) {
        a.push(b), c || (c = !0, d = +new Date(), setInterval(function () {
          var b = d + 1e3,
              c = +new Date();d = c;var e = c - b;if (Math.abs(e) > 1e3) for (var f = 0; f < a.length; ++f) {
            a[f](e > 0);
          }
        }, 1e3));
      };
    }();var b = b || {};b.hasPageVisibilityAPISupport = function () {
      if ("undefined" == typeof document) return !1;var a = !1;return "undefined" != typeof document.hidden ? a = !0 : "undefined" != typeof document.mozHidden ? a = !0 : "undefined" != typeof document.msHidden ? a = !0 : "undefined" != typeof document.webkitHidden && (a = !0), function () {
        return a;
      };
    }(), b.getPageVisibilityAPI = function () {
      if ("undefined" == typeof document) return null;var a, b, c;"undefined" != typeof document.hidden ? (a = "hidden", b = "visibilitychange", c = "visibilityState") : "undefined" != typeof document.mozHidden ? (a = "mozHidden", b = "mozvisibilitychange", c = "mozVisibilityState") : "undefined" != typeof document.msHidden ? (a = "msHidden", b = "msvisibilitychange", c = "msVisibilityState") : "undefined" != typeof document.webkitHidden && (a = "webkitHidden", b = "webkitvisibilitychange", c = "webkitVisibilityState");var d = { hidden: a, visibilityChange: b, state: c };return function () {
        return d;
      };
    }(), b.isTabInBackground = function () {
      if ("undefined" == typeof document) return null;var a = b.getPageVisibilityAPI();return function () {
        return document[a.hidden];
      };
    }(), b.getBrowserName = function () {
      if (!navigator) return "";var a,
          b,
          c = navigator.userAgent || "",
          d = navigator.appName || "";return (b = c.indexOf("Opera")) != -1 || (b = c.indexOf("OPR/")) != -1 ? d = "Opera" : (b = c.indexOf("Android")) != -1 ? d = "Android" : (b = c.indexOf("Chrome")) != -1 ? d = "Chrome" : (b = c.indexOf("Safari")) != -1 ? d = "Safari" : (b = c.indexOf("Firefox")) != -1 ? d = "Firefox" : (b = c.indexOf("IEMobile")) != -1 ? d = "Internet Explorer Mobile" : "Microsoft Internet Explorer" == d || "Netscape" == d ? d = "Internet Explorer" : (a = c.lastIndexOf(" ") + 1) < (b = c.lastIndexOf("/")) ? (d = c.substring(a, b), d.toLowerCase() == d.toUpperCase() && (d = navigator.appName)) : d = "unknown", d;
    }, b.getBrowserFullVersion = function () {
      if (!navigator) return "";var a,
          b,
          c,
          d,
          e = navigator.userAgent || "",
          f = navigator.appName || "",
          g = navigator.appVersion ? "" + parseFloat(navigator.appVersion) : "";return (b = e.indexOf("Opera")) != -1 ? (g = e.substring(b + 6), (b = e.indexOf("Version")) != -1 && (g = e.substring(b + 8))) : (b = e.indexOf("OPR/")) != -1 ? g = e.substring(b + 4) : (b = e.indexOf("Android")) != -1 ? g = e.substring(b + 11) : (b = e.indexOf("Chrome")) != -1 ? g = e.substring(b + 7) : (b = e.indexOf("Safari")) != -1 ? (g = e.substring(b + 7), (b = e.indexOf("Version")) != -1 && (g = e.substring(b + 8))) : (b = e.indexOf("Firefox")) != -1 ? g = e.substring(b + 8) : "Microsoft Internet Explorer" == f ? (d = new RegExp("MSIE ([0-9]{1,}[.0-9]{0,})"), null != d.exec(e) && (g = parseFloat(RegExp.$1))) : "Netscape" == f ? (d = new RegExp("Trident/.*rv:([0-9]{1,}[.0-9]{0,})"), null != d.exec(e) && (g = parseFloat(RegExp.$1))) : g = e.lastIndexOf(" ") + 1 < (b = e.lastIndexOf("/")) ? e.substring(b + 1) : "unknown", g = g.toString(), (c = g.indexOf(";")) != -1 && (g = g.substring(0, c)), (c = g.indexOf(" ")) != -1 && (g = g.substring(0, c)), (c = g.indexOf(")")) != -1 && (g = g.substring(0, c)), a = parseInt("" + g, 10), isNaN(a) && (g = "" + parseFloat(navigator.appVersion)), g;
    }, b.browserAcceptsLargeURLs = function () {
      return "undefined" == typeof window || (null !== window.ActiveXObject, !0);
    }, b.isBrowser = function () {
      return "undefined" != typeof window && "undefined" != typeof document;
    }, b.isWebSecure = function () {
      return "undefined" != typeof document && null != document && "s" === document.location.href.charAt(4);
    };var c = function () {
      var a = 1e4;return function (b, c) {
        function d(a) {
          a = a || [];var c = [h, +new Date()];return b && c.push(b), a = Array.prototype.slice.call(a), c = c.concat(a);
        }function e(a) {
          var b, d, e;if ("boolean" == typeof c || !c) return !!c;if (e = a.join(" "), c instanceof Array && c.length > 0) {
            for (b = 0; b < c.length; ++b) {
              if (d = c[b], d instanceof RegExp && d.test(e)) return !0;
            }return !1;
          }if ("object" == (typeof c === "undefined" ? "undefined" : (0, _typeof3.default)(c))) {
            var f = !1;if (c.hide instanceof Array) for (b = 0; b < c.hide.length; ++b) {
              if (d = c.hide[b], d instanceof RegExp && d.test(e)) {
                f = !0;break;
              }
            }if (c.show instanceof Array) for (b = 0; b < c.show.length; ++b) {
              if (d = c.show[b], d instanceof RegExp && d.test(e)) return !0;
            }return !f && !c.show;
          }return !0;
        }function f(b) {
          var d = i.length;(d > a || c && c.max && d > c.max) && (i = i.slice(-Math.floor(c.max / 2)), i.push("Previous logs: " + d)), i.push(b);
        }var g = this,
            h = "comScore",
            i = [];g.log = function () {
          var a = d(arguments);f(a), "undefined" != typeof console && "function" == typeof console.log && e(a) && console.log.apply(console, a);
        }, g.warn = function () {
          var a = d(arguments);f(a), "undefined" != typeof console && "function" == typeof console.warn && e(a) && console.warn.apply(console, a);
        }, g.error = function () {
          var a = d(arguments);f(a), "undefined" != typeof console && "function" == typeof console.error && e(a) && console.error.apply(console, a);
        }, g.apiCall = function (a) {
          for (var b = ["API call to:", a], c = 1; c < arguments.length; ++c) {
            b.push("arg" + c + ":", arguments[c]);
          }this.log.apply(this, b);
        }, g.infoLog = function () {
          var a = ["Trace log:"];a.push.apply(a, Array.prototype.slice.call(arguments)), this.log.apply(this, a);
        }, g.deprecation = function (a, b) {
          var c = ["Deprecated API:", a, "is deprecated and will be eventually removed."];b && c.push("Use", b, "instead."), this.warn.apply(this, c);
        }, g.getLogHistory = function () {
          return i;
        };
      };
    }();return a.StreamingAnalytics = a.StreamingAnalytics || function () {
      var d = function () {
        var a = "cs_";return function () {
          var c = "undefined" != typeof localStorage ? localStorage : null;b.extend(this, { get: function get(b) {
              return c && c.getItem(a + b);
            }, set: function set(b, d) {
              c && c.setItem(a + b, d);
            }, has: function has(b) {
              return c && c.getItem(a + b);
            }, remove: function remove(b) {
              c && c.removeItem(a + b);
            }, clear: function clear() {
              for (var b = 0; c && b < c.length; ++b) {
                var d = c.key(b);d.substr(0, a.length) === a && c.removeItem(d);
              }
            } });
        };
      }(),
          e = function e(a, b) {
        if ("undefined" == typeof Image) return void ("function" == typeof setTimeout ? b && setTimeout(b, 0) : b && b());var c = new Image();c.onload = function () {
          b && b(200), c = null;
        }, c.onerror = function () {
          b && b(), c = null;
        }, c.src = a;
      },
          f = function f(a, b, c) {
        "function" == typeof setTimeout ? c && setTimeout(function () {
          c(200);
        }, 0) : c && c(200);
      },
          g = function () {
        return { dir: function dir() {
            return null;
          }, append: function append(a, b, c) {}, write: function write(a, b, c) {}, deleteFile: function deleteFile() {
            return !1;
          }, read: function read() {
            return null;
          } };
      }(),
          h = function () {
        return { PLATFORM: "generic", httpGet: e, httpPost: f, Storage: d, IO: g, onDataFetch: function onDataFetch(a) {
            a();
          }, getCrossPublisherId: function getCrossPublisherId() {
            return null;
          }, getAppName: function getAppName() {
            return i.UNKNOWN_VALUE;
          }, getAppVersion: function getAppVersion() {
            return i.UNKNOWN_VALUE;
          }, getVisitorId: function getVisitorId() {
            return +new Date() + ~~(1e3 * Math.random());
          }, getVisitorIdSuffix: function getVisitorIdSuffix() {
            return "72";
          }, getDeviceModel: function getDeviceModel() {
            return i.UNKNOWN_VALUE;
          }, getPlatformVersion: function getPlatformVersion() {
            return i.UNKNOWN_VALUE;
          }, getPlatformName: function getPlatformName() {
            return "js";
          }, getRuntimeName: function getRuntimeName() {
            return i.UNKNOWN_VALUE;
          }, getRuntimeVersion: function getRuntimeVersion() {
            return i.UNKNOWN_VALUE;
          }, getDisplayResolution: function getDisplayResolution() {
            return i.UNKNOWN_RESOLUTION;
          }, getApplicationResolution: function getApplicationResolution() {
            return i.UNKNOWN_RESOLUTION;
          }, getLanguage: function getLanguage() {
            return i.UNKNOWN_VALUE;
          }, getPackageName: function getPackageName() {
            return null;
          }, isConnectionAvailable: function isConnectionAvailable() {
            return !0;
          }, isCompatible: function isCompatible() {
            return !0;
          }, autoSelect: function autoSelect() {}, setPlatformAPI: function setPlatformAPI() {}, isCrossPublisherIdChanged: function isCrossPublisherIdChanged() {
            return !1;
          }, setTimeout: function (_setTimeout) {
            function setTimeout(_x, _x2) {
              return _setTimeout.apply(this, arguments);
            }

            setTimeout.toString = function () {
              return _setTimeout.toString();
            };

            return setTimeout;
          }(function (a, b) {
            return setTimeout(a, b);
          }), clearTimeout: function (_clearTimeout) {
            function clearTimeout(_x3) {
              return _clearTimeout.apply(this, arguments);
            }

            clearTimeout.toString = function () {
              return _clearTimeout.toString();
            };

            return clearTimeout;
          }(function (a) {
            return clearTimeout(a);
          }), getDeviceArchitecture: function getDeviceArchitecture() {
            return i.UNKNOWN_VALUE;
          }, getConnectionType: function getConnectionType() {
            return i.UNKNOWN_VALUE;
          }, getDeviceJailBrokenFlag: function getDeviceJailBrokenFlag() {
            return i.UNKNOWN_VALUE;
          }, isConnectionSecure: function isConnectionSecure() {
            return !1;
          }, processMeasurementLabels: function processMeasurementLabels() {} };
      }(),
          i = { UNKNOWN_VALUE: "unknown", UNKNOWN_RESOLUTION: "0x0" };b.jsonObjectToStringDictionary = function (a) {
        var b = {};for (var c in a) {
          var d = a[c];null === d || void 0 === d ? b[c] = d : b[c] = a[c] + "";
        }return b;
      }, b.getKeys = function (a, b) {
        var c,
            d = [];for (c in a) {
          b && !b.test(c) || !a.hasOwnProperty(c) || (d[d.length] = c);
        }return d;
      }, b.fixEventTime = function (a) {
        if (a.ns_ts) return parseInt(a.ns_ts);var b = +new Date();return a.ns_ts = b + "", b;
      }, b.isBrowser = function () {
        return "undefined" != typeof window && "undefined" != typeof document;
      }, b.addNewPlaybackInterval = function (a, c, d, e) {
        var f = {};if (!(d >= c)) return b.cloneObject(a);if (f.start = c, f.end = d, 0 == a.length) return a.push(f), b.cloneObject(a);var g;for (g = 0; g < a.length; g++) {
          if (f.start >= a[g].start && f.end <= a[g].end) return b.cloneObject(a);
        }var h,
            i = !1;for (h = 0; h < a.length; h++) {
          if (h + 1 === a.length && f.start >= a[h].start || f.start >= a[h].start && f.start < a[h + 1].start) {
            a.splice(h + 1, 0, f), i = !0;break;
          }
        }i || a.splice(0, 0, f);var j = [a[0]];for (g = 1; g < a.length; g++) {
          j[j.length - 1].end + e < a[g].start ? j.push(a[g]) : j[j.length - 1].end < a[g].end && (j[j.length - 1].end = a[g].end);
        }return b.cloneObject(j);
      }, b.stateToString = function (a) {
        var b = I.InternalStates;for (var c in b) {
          if (b.hasOwnProperty(c) && b[c] == a) return c;
        }
      };var j = function () {
        var a = ["play", "pause", "pause-on-buffering", "end", "buffer", "buffer-stop", "keep-alive", "hb", "custom", "load", "start", "skstart", "adskip", "cta", "error", "trans", "drmfa", "drmap", "drmde", "bitrt", "playrt", "volume", "window", "audio", "video", "subs", "cdn"];return { PLAY: 0, PAUSE: 1, PAUSE_ON_BUFFERING: 2, END: 3, BUFFER: 4, BUFFER_STOP: 5, KEEPALIVE: 6, HEARTBEAT: 7, CUSTOM: 8, LOAD: 9, ENGAGE: 10, SEEK_START: 11, AD_SKIP: 12, CTA: 13, ERROR: 14, TRANSFER: 15, DRM_FAILED: 16, DRM_APPROVED: 17, DRM_DENIED: 18, BIT_RATE: 19, PLAYBACK_RATE: 20, VOLUME: 21, WINDOW_STATE: 22, AUDIO: 23, VIDEO: 24, SUBS: 25, CDN: 26, toString: function toString(b) {
            return a[b];
          } };
      }(),
          k = function () {
        return { IDLE: 0, PLAYBACK_NOT_STARTED: 1, PLAYING: 2, PAUSED: 3, BUFFERING_BEFORE_PLAYBACK: 4, BUFFERING_DURING_PLAYBACK: 5, BUFFERING_DURING_SEEKING: 6, BUFFERING_DURING_PAUSE: 7, SEEKING_BEFORE_PLAYBACK: 8, SEEKING_DURING_PLAYBACK: 9, SEEKING_DURING_BUFFERING: 10, SEEKING_DURING_PAUSE: 11, PAUSED_DURING_BUFFERING: 12 };
      }(),
          l = function () {
        var a = ["c", "s", "r"];return { SINGLE_CLIP: 0, SEGMENTED: 1, REDUCED: 2, toString: function toString(b) {
            return a[b];
          } };
      }(),
          m = { STREAMINGANALYTICS_VERSION: "6.0.0a", STREAMINGANALYTICS_V5_VERSION: "5.4.2.161122", MODEL_VERSION: "5.6", LOG_NAMESPACE: "STA", DEFAULT_PLAYERNAME: "js_api", DEFAULT_HEARTBEAT_INTERVAL: [{ playingtime: 6e4, interval: 1e4 }, { playingtime: null, interval: 6e4 }], DEFAULT_KEEP_ALIVE_INTERVAL: 12e5, DEFAULT_PAUSED_ON_BUFFERING_INTERVAL: 500, C1_VALUE: "19", C10_VALUE: "js", NS_AP_C12M_VALUE: "1", NS_NC_VALUE: "1", PAGE_NAME_LABEL: "name", RESTRICTED_URL_LENGTH_LIMIT: 2048, URL_LENGTH_LIMIT: 4096, THROTTLING_DELAY: 500, INTERVAL_MERGE_TOLERANCE: 500, STANDARD_METADATA_LABELS: ["ns_st_st", "ns_st_ci", "ns_st_pr", "ns_st_sn", "ns_st_en", "ns_st_ep", "ns_st_ty", "ns_st_ct", "ns_st_li", "ns_st_ad", "ns_st_bn", "ns_st_tb", "ns_st_an", "ns_st_ta", "ns_st_pu", "c3", "c4", "c6"], LABELS_ORDER: ["c1", "c2", "ca2", "cb2", "cc2", "cd2", "ns_site", "ca_ns_site", "cb_ns_site", "cc_ns_site", "cd_ns_site", "ns_vsite", "ca_ns_vsite", "cb_ns_vsite", "cc_ns_vsite", "cd_ns_vsite", "ns_alias", "ca_ns_alias", "cb_ns_alias", "cc_ns_alias", "cd_ns_alias", "ns_ap_an", "ca_ns_ap_an", "cb_ns_ap_an", "cc_ns_ap_an", "cd_ns_ap_an", "ns_ap_pn", "ns_ap_pv", "c12", "ca12", "cb12", "cc12", "cd12", "ns_ak", "ns_ap_hw", "name", "ns_ap_ni", "ns_ap_ec", "ns_ap_ev", "ns_ap_device", "ns_ap_id", "ns_ap_csf", "ns_ap_bi", "ns_ap_pfm", "ns_ap_pfv", "ns_ap_ver", "ca_ns_ap_ver", "cb_ns_ap_ver", "cc_ns_ap_ver", "cd_ns_ap_ver", "ns_ap_sv", "ns_ap_cv", "ns_ap_smv", "ns_type", "ca_ns_type", "cb_ns_type", "cc_ns_type", "cd_ns_type", "ns_radio", "ns_nc", "cs_partner", "cs_xcid", "cs_impid", "ns_ap_ui", "ca_ns_ap_ui", "cb_ns_ap_ui", "cc_ns_ap_ui", "cd_ns_ap_ui", "ns_ap_gs", "ns_st_sv", "ns_st_pv", "ns_st_smv", "ns_st_it", "ns_st_id", "ns_st_ec", "ns_st_sp", "ns_st_sc", "ns_st_psq", "ns_st_asq", "ns_st_sq", "ns_st_ppc", "ns_st_apc", "ns_st_spc", "ns_st_cn", "ns_st_ev", "ns_st_po", "ns_st_cl", "ns_st_el", "ns_st_sl", "ns_st_pb", "ns_st_hc", "ns_st_mp", "ca_ns_st_mp", "cb_ns_st_mp", "cc_ns_st_mp", "cd_ns_st_mp", "ns_st_mv", "ca_ns_st_mv", "cb_ns_st_mv", "cc_ns_st_mv", "cd_ns_st_mv", "ns_st_pn", "ns_st_tp", "ns_st_ad", "ns_st_li", "ns_st_ci", "ns_st_si", "ns_st_pt", "ns_st_dpt", "ns_st_ipt", "ns_st_et", "ns_st_det", "ns_st_upc", "ns_st_dupc", "ns_st_iupc", "ns_st_upa", "ns_st_dupa", "ns_st_iupa", "ns_st_lpc", "ns_st_dlpc", "ns_st_lpa", "ns_st_dlpa", "ns_st_pa", "ns_st_ie", "ns_ap_jb", "ns_ap_et", "ns_ap_res", "ns_ap_sd", "ns_ap_po", "ns_ap_ot", "ns_ap_c12m", "cs_c12u", "ca_cs_c12u", "cb_cs_c12u", "cc_cs_c12u", "cd_cs_c12u", "ns_ap_install", "ns_ap_updated", "ns_ap_lastrun", "ns_ap_cs", "ns_ap_runs", "ns_ap_usage", "ns_ap_fg", "ns_ap_ft", "ns_ap_dft", "ns_ap_bt", "ns_ap_dbt", "ns_ap_dit", "ns_ap_as", "ns_ap_das", "ns_ap_it", "ns_ap_uc", "ns_ap_aus", "ns_ap_daus", "ns_ap_us", "ns_ap_dus", "ns_ap_ut", "ns_ap_oc", "ns_ap_uxc", "ns_ap_uxs", "ns_ap_lang", "ns_ap_ar", "ns_ap_miss", "ns_ts", "ns_ap_cfg", "ns_st_ca", "ns_st_cp", "ns_st_er", "ca_ns_st_er", "cb_ns_st_er", "cc_ns_st_er", "cd_ns_st_er", "ns_st_pe", "ns_st_ui", "ca_ns_st_ui", "cb_ns_st_ui", "cc_ns_st_ui", "cd_ns_st_ui", "ns_st_bc", "ns_st_dbc", "ns_st_bt", "ns_st_dbt", "ns_st_bp", "ns_st_lt", "ns_st_skc", "ns_st_dskc", "ns_st_ska", "ns_st_dska", "ns_st_skd", "ns_st_skt", "ns_st_dskt", "ns_st_pc", "ns_st_dpc", "ns_st_pp", "ns_st_br", "ns_st_pbr", "ns_st_rt", "ns_st_prt", "ns_st_ub", "ns_st_vo", "ns_st_pvo", "ns_st_ws", "ns_st_pws", "ns_st_ki", "ns_st_rp", "ns_st_bn", "ns_st_tb", "ns_st_an", "ns_st_ta", "ns_st_pl", "ns_st_pr", "ns_st_sn", "ns_st_en", "ns_st_ep", "ns_st_sr", "ns_st_ty", "ns_st_ct", "ns_st_cs", "ns_st_ge", "ns_st_st", "ns_st_stc", "ns_st_ce", "ns_st_ia", "ns_st_dt", "ns_st_ddt", "ns_st_tdt", "ns_st_tm", "ns_st_dtm", "ns_st_ttm", "ns_st_de", "ns_st_pu", "ns_st_ti", "ns_st_cu", "ns_st_fee", "ns_st_ft", "ns_st_at", "ns_st_pat", "ns_st_vt", "ns_st_pvt", "ns_st_tt", "ns_st_ptt", "ns_st_cdn", "ns_st_pcdn", "ns_st_ami", "ns_st_amt", "ns_st_ams", "ns_ap_i1", "ns_ap_i2", "ns_ap_i3", "ns_ap_i4", "ns_ap_i5", "ns_ap_i6", "ns_ap_referrer", "ns_clid", "ns_campaign", "ns_source", "ns_mchannel", "ns_linkname", "ns_fee", "gclid", "utm_campaign", "utm_source", "utm_medium", "utm_term", "utm_content", "ns_ecommerce", "ns_ec_sv", "ns_client_id", "ns_order_id", "ns_ec_cur", "ns_orderline_id", "ns_orderlines", "ns_prod_id", "ns_qty", "ns_prod_price", "ns_prod_grp", "ns_brand", "ns_shop", "ns_category", "category", "ns_c", "ns_search_term", "ns_search_result", "ns_m_exp", "ns_m_chs", "c3", "ca3", "cb3", "cc3", "cd3", "c4", "ca4", "cb4", "cc4", "cd4", "c5", "ca5", "cb5", "cc5", "cd5", "c6", "ca6", "cb6", "cc6", "cd6", "c10", "c11", "c13", "c14", "c15", "c16", "c7", "c8", "c9", "ns_ap_er", "ns_st_amc"] },
          n = function () {
        function a() {
          function a() {
            f = {}, f.ns_st_cl = "0", f.ns_st_pn = "1", f.ns_st_tp = "0", f.ns_st_cn = "1", f.ns_st_skd = "0", f.ns_st_ci = "0", f.c3 = "*null", f.c4 = "*null", f.c6 = "*null", f.ns_st_st = "*null", f.ns_st_pu = "*null", f.ns_st_pr = "*null", f.ns_st_ep = "*null", f.ns_st_sn = "*null", f.ns_st_en = "*null", f.ns_st_ct = "*null", g = {}, e = !1, d = !1, c = i.UNKNOWN_VALUE, h = 0, j = NaN, o = 0, l = 0, k = NaN, p = 0, q = NaN, s = 0, r = 0, n = 0, v = NaN, t = [], u = [], w = 0, x = 0, y = 0, z = 0, A = 0, B = 0, C = 0, D = NaN, E = 0, F = 0, G = 0, H = !1, I = NaN, M = !1, L = 0, P = 0, J = 0, K = 0, N = 0, O = 0, R = 0, S = 0, T = 0, U = 0, V = 0, W = 0, X = 0, Y = 0, Z = 0, Q = !1;
          }var c,
              d,
              e,
              f,
              g,
              h,
              j,
              k,
              l,
              n,
              o,
              p,
              q,
              r,
              s,
              t,
              u,
              v,
              w,
              x,
              y,
              z,
              A,
              B,
              C,
              D,
              E,
              F,
              G,
              H,
              I,
              J,
              K,
              L,
              M,
              N,
              O,
              P,
              Q,
              R,
              S,
              T,
              U,
              V,
              W,
              X,
              Y,
              Z,
              $ = this,
              _ = m.INTERVAL_MERGE_TOLERANCE;b.extend(this, { getHash: function getHash() {
              return c;
            }, setHash: function setHash(a) {
              c = a;
            }, setPlaybackIntervalMergeTolerance: function setPlaybackIntervalMergeTolerance(a) {
              _ = a;
            }, getPlaybackIntervalMergeTolerance: function getPlaybackIntervalMergeTolerance() {
              return _;
            }, setInternalLabel: function setInternalLabel(a, b) {
              f[a] = b;
            }, getInternalLabel: function getInternalLabel(a) {
              return f[a];
            }, hasInternalLabel: function hasInternalLabel(a) {
              return null != f[a];
            }, setLabels: function setLabels(a) {
              a && b.extend(g, a);
            }, getLabels: function getLabels() {
              return g;
            }, setLabel: function setLabel(a, b) {
              g[a] = b;
            }, getLabel: function getLabel(a) {
              return g[a];
            }, hasLabel: function hasLabel(a) {
              return a in g;
            }, getClipNumber: function getClipNumber() {
              return parseInt($.getInternalLabel("ns_st_cn"));
            }, setClipNumber: function setClipNumber(a) {
              $.setInternalLabel("ns_st_cn", a + "");
            }, getPartNumber: function getPartNumber() {
              return $.hasLabel("ns_st_pn") ? parseInt($.getLabel("ns_st_pn")) : parseInt($.getInternalLabel("ns_st_pn"));
            }, createLabels: function createLabels(a, c) {
              var d = a || {},
                  h = b.isEmpty(d.ns_st_pt) ? $.getPlaybackTime() : parseInt(d.ns_st_pt);d.ns_st_pt = h + (isNaN(j) ? 0 : c - j) + "", d.ns_st_dpt = h + (isNaN(j) ? 0 : c - j) - l + "", d.ns_st_ipt = h + (isNaN(j) ? 0 : c - j) - n + "";var i = b.isEmpty(d.ns_st_et) ? $.getElapsedTime() : parseInt(d.ns_st_et);d.ns_st_et = i + (isNaN(q) ? 0 : c - q) + "", d.ns_st_det = i + (isNaN(q) ? 0 : c - q) - r + "";var k = b.isEmpty(d.ns_st_bt) ? $.getBufferingTime() : parseInt(d.ns_st_bt);d.ns_st_bt = k + "", d.ns_st_dbt = k + (isNaN(D) ? 0 : c - D) - E + "";for (var m, o = parseInt(d.ns_st_po), p = b.addNewPlaybackInterval(b.cloneObject($.getSegmentPlaybackIntervals()), v, o, _), s = b.addNewPlaybackInterval(b.cloneObject($.getAssetPlaybackIntervals()), v, o, _), t = 0, u = 0, C = 0; C < p.length; C++) {
                m = Math.abs(p[C].end - p[C].start), t += m, m > u && (u = m);
              }var F = 0,
                  H = 0;for (C = 0, m; C < s.length; C++) {
                m = Math.abs(s[C].end - s[C].start), F += m, m > H && (H = m);
              }d.ns_st_upc = t + "", d.ns_st_dupc = t - w + "", d.ns_st_iupc = t - x + "", t > x ? d.ns_st_iupc = t - x + "" : d.ns_st_iupc = "0", d.ns_st_lpc = u + "", d.ns_st_dlpc = u - y + "", d.ns_st_upa = F + "", d.ns_st_dupa = F - z + "", F > A ? d.ns_st_iupa = F - A + "" : d.ns_st_iupa = "0", d.ns_st_lpa = H + "", d.ns_st_dlpa = H - B + "";var I = b.isEmpty(d.ns_st_pc) ? $.getPauses() : parseInt(d.ns_st_pc);d.ns_st_pc = I + "", d.ns_st_dpc = I - S + "";var J = b.isEmpty(d.ns_st_skc) ? $.getSeeks() : parseInt(d.ns_st_skc);d.ns_st_skc = J + "", d.ns_st_dskc = J - U + "";var L = b.isEmpty(d.ns_st_bc) ? $.getBuffers() : parseInt(d.ns_st_bc);d.ns_st_bc = L + "", d.ns_st_dbc = L - G + "";var M = b.isEmpty(d.ns_st_skt) ? $.getSeekingTime() : parseInt(d.ns_st_skt);d.ns_st_skt = M + "", d.ns_st_dskt = M - K + "";var N = b.isEmpty(d.ns_st_ska) ? $.getSeekingAmount() : parseInt(d.ns_st_ska);return d.ns_st_ska = N + "", d.ns_st_dska = N - O + "", e && (d.ns_st_spc = V + "", d.ns_st_apc = W + "", d.ns_st_sq = X + "", d.ns_st_asq = Y + ""), e || 0 != Z ? d.ns_st_sc = Z + "" : d.ns_st_sc = "1", b.extend(d, f, g), d;
            }, updateDeltaLabels: function updateDeltaLabels(a) {
              l = parseInt(a.ns_st_pt), r = parseInt(a.ns_st_et), E = parseInt(a.ns_st_bt), w = parseInt(a.ns_st_upc), y = parseInt(a.ns_st_lpc), z = parseInt(a.ns_st_upa), B = parseInt(a.ns_st_lpa), S = parseInt(a.ns_st_pc), U = parseInt(a.ns_st_skc), G = parseInt(a.ns_st_bc), K = parseInt(a.ns_st_skt), O = parseInt(a.ns_st_ska), $.setSeekingDirection(0);
            }, updateIndependentLabels: function updateIndependentLabels(a) {
              n = parseInt(a.ns_st_pt), x = parseInt(a.ns_st_upc), A = parseInt(a.ns_st_upa);
            }, getVideoTrack: function getVideoTrack() {
              return $.getInternalLabel("ns_st_vt");
            }, setVideoTrack: function setVideoTrack(a) {
              $.setInternalLabel("ns_st_vt", a + "");
            }, getAudioTrack: function getAudioTrack() {
              return $.getInternalLabel("ns_st_at");
            }, setAudioTrack: function setAudioTrack(a) {
              $.setInternalLabel("ns_st_at", a + "");
            }, getSubtitleTrack: function getSubtitleTrack() {
              return $.getInternalLabel("ns_st_tt");
            }, setSubtitleTrack: function setSubtitleTrack(a) {
              $.setInternalLabel("ns_st_tt", a + "");
            }, getCDN: function getCDN() {
              return $.getInternalLabel("ns_st_cdn");
            }, setCDN: function setCDN(a) {
              $.setInternalLabel("ns_st_cdn", a + "");
            }, getSegmentPlaybackIntervals: function getSegmentPlaybackIntervals() {
              return t;
            }, setAssetPlaybackIntervals: function setAssetPlaybackIntervals(a) {
              t = a;
            }, getAssetPlaybackIntervals: function getAssetPlaybackIntervals() {
              return u;
            }, incrementPauses: function incrementPauses() {
              R++;
            }, incrementSeeks: function incrementSeeks() {
              T++;
            }, incrementPlayCounter: function incrementPlayCounter() {
              X++;
            }, getPlayCounter: function getPlayCounter() {
              return X;
            }, getBufferingTime: function getBufferingTime() {
              return C;
            }, setBufferingTime: function setBufferingTime(a) {
              C = a;
            }, addBufferingTime: function addBufferingTime(a) {
              if (!isNaN(D)) {
                var b = $.getBufferingTime();b += a - D, $.setBufferingTime(b), D = NaN;
              }
            }, setPlaybackStartPosition: function setPlaybackStartPosition(a) {
              v = parseInt(a);
            }, getPlaybackStartPosition: function getPlaybackStartPosition() {
              return v;
            }, addInterval: function addInterval(a) {
              isNaN(v) || isNaN(a) || (t = b.addNewPlaybackInterval(t, v, a, _), u = b.addNewPlaybackInterval(u, v, a, _), v = NaN);
            }, getElapsedTime: function getElapsedTime() {
              return p;
            }, setElapsedTime: function setElapsedTime(a) {
              p = a;
            }, addElapsedTime: function addElapsedTime(a) {
              if (!isNaN(q)) {
                var b = $.getElapsedTime();b += a - q, $.setElapsedTime(b), q = NaN;
              }
            }, getElapsedTimestamp: function getElapsedTimestamp() {
              return q;
            }, setElapsedTimestamp: function setElapsedTimestamp(a) {
              q = a;
            }, addPlaybackTime: function addPlaybackTime(a) {
              if (!isNaN(j)) {
                var b = $.getPlaybackTime();b += a - j, $.setPlaybackTime(b), j = NaN;
              }
            }, getPlaybackTime: function getPlaybackTime() {
              return h;
            }, getExpectedPlaybackPosition: function getExpectedPlaybackPosition(a) {
              return isNaN(j) ? o : o + (a - j);
            }, setPlaybackTimeOffset: function setPlaybackTimeOffset(a) {
              o = a;
            }, getPlaybackTimeOffset: function getPlaybackTimeOffset() {
              return o;
            }, setPlaybackTime: function setPlaybackTime(a) {
              h = a;
            }, getPlaybackTimestamp: function getPlaybackTimestamp() {
              return j;
            }, setPlaybackTimestamp: function setPlaybackTimestamp(a) {
              j = a;
            }, setPreviousPlaybackTime: function setPreviousPlaybackTime(a) {
              l = a;
            }, setPreviousPlaybackTimestamp: function setPreviousPlaybackTimestamp(a) {
              k = a;
            }, getBufferingTimestamp: function getBufferingTimestamp() {
              return D;
            }, setBufferingTimestamp: function setBufferingTimestamp(a) {
              D = a;
            }, getPauses: function getPauses() {
              return R;
            }, setPauses: function setPauses(a) {
              R = a;
            }, getSeeks: function getSeeks() {
              return T;
            }, setSeeks: function setSeeks(a) {
              T = a;
            }, setSeeking: function setSeeking(a) {
              H = a;
            }, isSeeking: function isSeeking() {
              return H;
            }, setCollectingSeekingTime: function setCollectingSeekingTime(a) {
              M = a;
            }, isCollectingSeekingTime: function isCollectingSeekingTime() {
              return M;
            }, setAssetStarted: function setAssetStarted(a) {
              d = a;
            }, isAssetStarted: function isAssetStarted() {
              return d;
            }, setPlaybackStarted: function setPlaybackStarted(a) {
              e = a;
            }, isPlaybackStarted: function isPlaybackStarted() {
              return e;
            }, setSeekingTimestamp: function setSeekingTimestamp(a) {
              I = a;
            }, getSeekingTimestamp: function getSeekingTimestamp() {
              return I;
            }, addSeekingTime: function addSeekingTime(a) {
              if (!isNaN(I)) {
                var b = $.getSeekingTime();b += a - I, $.setSeekingTime(b), I = NaN;
              }
            }, getSeekingTime: function getSeekingTime() {
              return J;
            }, setSeekingTime: function setSeekingTime(a) {
              J = a;
            }, setSeekingTimeBeforeEnd: function setSeekingTimeBeforeEnd(a) {
              P = a;
            }, getSeekingTimeBeforeEnd: function getSeekingTimeBeforeEnd() {
              return P;
            }, setSeekStartPosition: function setSeekStartPosition(a) {
              L = a;
            }, getSeekStartPosition: function getSeekStartPosition() {
              return L;
            }, setSeekingAmount: function setSeekingAmount(a) {
              N = a;
            }, getSeekingAmount: function getSeekingAmount() {
              return N;
            }, addSeekingAmount: function addSeekingAmount(a) {
              var b = $.getSeekingAmount();b += Math.abs(a - L), $.setSeekingAmount(b);var c;L == a ? c = 0 : L > a ? c = -1 : L < a && (c = 1), $.setSeekingDirection(c), L = 0;
            }, getSeekingDirection: function getSeekingDirection() {
              return parseInt($.getInternalLabel("ns_st_skd"));
            }, setSeekingDirection: function setSeekingDirection(a) {
              $.setInternalLabel("ns_st_skd", a + "");
            }, resetAssetLifecycleLabels: function resetAssetLifecycleLabels() {
              h = 0, l = 0, n = 0, C = 0, E = 0, F = 0, G = 0, R = 0, S = 0, X = 0, u = [], z = 0, A = 0, B = 0, p = 0, r = 0, J = 0, K = 0, N = 0, O = 0, T = 0, U = 0;
            }, incrementSegmentPlaybackCounter: function incrementSegmentPlaybackCounter() {
              V++;
            }, incrementAssetLoadCounter: function incrementAssetLoadCounter() {
              Z++;
            }, incrementAssetPlaybackCounter: function incrementAssetPlaybackCounter() {
              W++;
            }, getPreviousUniquePlaybackInterval: function getPreviousUniquePlaybackInterval() {
              return w;
            }, setPreviousUniquePlaybackInterval: function setPreviousUniquePlaybackInterval(a) {
              w = a;
            }, getPreviousEventIndependentUniquePlaybackInterval: function getPreviousEventIndependentUniquePlaybackInterval() {
              return x;
            }, setPreviousEventIndependentUniquePlaybackInterval: function setPreviousEventIndependentUniquePlaybackInterval(a) {
              x = a;
            }, setPreviousLongestPlaybackInterval: function setPreviousLongestPlaybackInterval(a) {
              y = a;
            }, getPreviousLongestPlaybackInterval: function getPreviousLongestPlaybackInterval() {
              return y;
            }, resetAssetPlaybackIntervals: function resetAssetPlaybackIntervals() {
              u = [], z = 0, A = 0, B = 0;
            }, setSegmentPlaybackCounter: function setSegmentPlaybackCounter(a) {
              V = a;
            }, setAssetLoadCounter: function setAssetLoadCounter(a) {
              Z = a;
            }, setAssetPlaybackCounter: function setAssetPlaybackCounter(a) {
              W = a;
            }, setLowestPartNumberPlayed: function setLowestPartNumberPlayed(a) {
              s = a;
            }, getSegmentPlaybackCounter: function getSegmentPlaybackCounter() {
              return V;
            }, getAssetLoadCounter: function getAssetLoadCounter() {
              return Z;
            }, getAssetPlaybackCounter: function getAssetPlaybackCounter() {
              return W;
            }, getLowestPartNumberPlayed: function getLowestPartNumberPlayed() {
              return s;
            }, getBuffers: function getBuffers() {
              return F;
            }, incrementBufferCount: function incrementBufferCount() {
              F++;
            }, getPreviousBufferingTime: function getPreviousBufferingTime() {
              return E;
            }, setPlaySequenceCounter: function setPlaySequenceCounter(a) {
              Y = a;
            }, incrementPlaySequenceCounter: function incrementPlaySequenceCounter() {
              Y++;
            }, getPlaySequenceCounter: function getPlaySequenceCounter() {
              return Y;
            }, isPlaybackSessionLooping: function isPlaybackSessionLooping() {
              return Q;
            }, setPlaybackSessionLooping: function setPlaybackSessionLooping(a) {
              Q = a;
            } }), a();
        }return a.resetAsset = function (a, b, c) {
          for (var d = a.getLabels(), e = {}, f = 0; c && f < c.length; ++f) {
            d.hasOwnProperty(c[f]) && (e[c[f]] = d[c[f]]);
          }b.setLabels(e), b.setPlaybackIntervalMergeTolerance(a.getPlaybackIntervalMergeTolerance());
        }, a;
      }(),
          o = function () {
        function a(a) {
          function c() {
            d = new n(), h = {}, h.ns_st_id = +new Date() + "", i = {}, e = NaN, f = 0, g = NaN, o = {}, p = 0, l = !1, q = !1, r = 0, t = 0, s = 0, u = 1, v = 0;
          }var d,
              e,
              f,
              g,
              h,
              i,
              l,
              o,
              p,
              q,
              r,
              s,
              t,
              u,
              v,
              w = this;b.extend(this, { resetAsset: function resetAsset() {
              var a = d;d = new n(), n.resetAsset(a, d);
            }, hashExists: function hashExists(a) {
              return null != o[a];
            }, storeHash: function storeHash(a) {
              o[a] = {};
            }, removeHash: function removeHash(a) {
              delete o[a];
            }, storeAssetPlaybackCounters: function storeAssetPlaybackCounters() {
              for (var a in o) {
                if (o.hasOwnProperty(a) && o[a].clipNumber === d.getClipNumber()) {
                  b.extend(o[a], { segmentPlaybackCounter: d.getSegmentPlaybackCounter(), assetLoadCounter: d.getAssetLoadCounter(), assetPlaybackCounter: d.getAssetPlaybackCounter(), lowestPartNumberPlayed: d.getLowestPartNumberPlayed(), seeking: d.isSeeking(), seekingTimeBeforeEnd: d.getSeekingTimeBeforeEnd(), seekingStartPosition: d.getSeekStartPosition(), segmentPlaybackIntervals: d.getSegmentPlaybackIntervals(), videoTrack: d.getVideoTrack(), audioTrack: d.getAudioTrack(), subtitleTrack: d.getSubtitleTrack(), cdn: d.getCDN(), playSequenceCounter: d.getPlaySequenceCounter(), previousUniquePlaybackInterval: d.getPreviousUniquePlaybackInterval(), previousEventIndependentUniquePlaybackInterval: d.getPreviousEventIndependentUniquePlaybackInterval(), previousLongestPlaybackInterval: d.getPreviousLongestPlaybackInterval() });break;
                }
              }
            }, getStoredAssetRegisters: function getStoredAssetRegisters(a) {
              return o[a];
            }, getClipNumber: function getClipNumber(a) {
              return o[a].clipNumber;
            }, getMaxClipNumber: function getMaxClipNumber() {
              return p;
            }, storeClipNumber: function storeClipNumber(a, b) {
              o[a].clipNumber = b, b > p && (p = b);
            }, setLabels: function setLabels(a) {
              null != a && b.extend(i, a);
            }, getLabels: function getLabels() {
              return i;
            }, setLabel: function setLabel(a, b) {
              var c = {};c[a] = b, w.setLabels(c);
            }, getLabel: function getLabel(a) {
              return i[a];
            }, getAsset: function getAsset() {
              return d;
            }, createLabels: function createLabels(a, c) {
              var e = a || {},
                  f = b.isEmpty(e.ns_st_pa) ? w.getPlaybackTime() : parseInt(e.ns_st_pa);return e.ns_st_pa = f + (isNaN(g) ? 0 : c - g) + "", e.ns_st_pp = t + "", e.ns_st_sp = u + "", e.ns_st_bp = v + "", q || (e.ns_st_pb = null != e.ns_st_pb ? e.ns_st_pb : "1"), d.isPlaybackStarted() && (e.ns_st_ppc = r + "", e.ns_st_psq = s + ""), b.extend(e, h, i), e;
            }, incrementPlayCounter: function incrementPlayCounter() {
              u++;
            }, incrementPauses: function incrementPauses() {
              t++;
            }, addPlaybackTime: function addPlaybackTime(a) {
              if (!isNaN(g)) {
                var b = w.getPlaybackTime();b += a - g, w.setPlaybackTime(b), g = NaN;
              }
            }, addBufferingTime: function addBufferingTime(a) {
              if (!isNaN(e)) {
                var b = w.getBufferingTime();b += a - e, w.setBufferingTime(b), e = NaN;
              }
            }, getBufferingTime: function getBufferingTime() {
              return v;
            }, setBufferingTime: function setBufferingTime(a) {
              v = a;
            }, getPlaybackTime: function getPlaybackTime() {
              return f;
            }, setBufferingTimestamp: function setBufferingTimestamp(a) {
              e = a;
            }, getBufferingTimestamp: function getBufferingTimestamp() {
              return e;
            }, setPlaybackTime: function setPlaybackTime(a) {
              f = a;
            }, setPlaybackTimestamp: function setPlaybackTimestamp(a) {
              g = a;
            }, getPlaybackTimestamp: function getPlaybackTimestamp() {
              return g;
            }, getPauses: function getPauses() {
              return t;
            }, setPauses: function setPauses(a) {
              t = a;
            }, isPlaybackSessionStarted: function isPlaybackSessionStarted() {
              return l;
            }, setPlaybackSessionStarted: function setPlaybackSessionStarted(a) {
              l = a;
            }, getPlaybackCounter: function getPlaybackCounter() {
              return r;
            }, incrementPlaybackCounter: function incrementPlaybackCounter() {
              r++;
            }, setFirstEventSent: function setFirstEventSent(a) {
              q = a;
            }, setPlaySequenceCounter: function setPlaySequenceCounter(a) {
              s = a;
            }, incrementPlaySequenceCounter: function incrementPlaySequenceCounter() {
              s++;
            }, getPlaybackSessionID: function getPlaybackSessionID() {
              return h.ns_st_id;
            }, setAsset: function setAsset(c, d) {
              a.getLogging().apiCall("setAsset", c, d), c = b.jsonObjectToStringDictionary(c);var e = a.getStateMachine().getCurrentState();if (e != k.IDLE) {
                a.getLogging().infoLog("Ending the current Clip. It was in state:", b.stateToString(e));var f = {};a.getStaCore().newEvent(j.END, b.fixEventTime(f), f);
              }var g = "",
                  h = 0;if (null != c.ns_st_cn) g = c.ns_st_cn;else for (var i = 0; i < m.STANDARD_METADATA_LABELS.length; i++) {
                c[m.STANDARD_METADATA_LABELS[i]] && (g += m.STANDARD_METADATA_LABELS[i] + ":" + c[m.STANDARD_METADATA_LABELS[i]] + ";");
              }var l = w,
                  n = l.getAsset();n.isAssetStarted() ? (l.hashExists(n.getHash()) || (l.storeHash(n.getHash()), l.storeClipNumber(n.getHash(), n.getClipNumber())), l.storeAssetPlaybackCounters(), h = l.hashExists(g) ? l.getClipNumber(g) : b.exists(c.ns_st_cn) ? parseInt(c.ns_st_cn) : l.getMaxClipNumber() + 1) : h = l.hashExists(g) ? l.getClipNumber(g) : n.getClipNumber(), l.resetAsset(), n = l.getAsset(), n.setHash(g), n.setClipNumber(h), n.setLabels(c);var o = l.getStoredAssetRegisters(g);o && (n.setAssetStarted(!0), n.setSegmentPlaybackCounter(o.segmentPlaybackCounter), n.setAssetLoadCounter(o.assetLoadCounter), n.setAssetPlaybackCounter(o.assetPlaybackCounter), n.setLowestPartNumberPlayed(o.lowestPartNumberPlayed), n.setSeeking(o.seeking), n.setSeekingTimeBeforeEnd(o.seekingTimeBeforeEnd), n.setSeekStartPosition(o.seekingStartPosition), n.setAssetPlaybackIntervals(o.segmentPlaybackIntervals), o.videoTrack && n.setVideoTrack(o.videoTrack), o.audioTrack && n.setAudioTrack(o.audioTrack), o.subtitleTrack && n.setSubtitleTrack(o.subtitleTrack), o.cdn && n.setCDN(o.cdn), n.setPlaySequenceCounter(o.playSequenceCounter), n.setPreviousUniquePlaybackInterval(o.previousUniquePlaybackInterval), n.setPreviousEventIndependentUniquePlaybackInterval(o.previousEventIndependentUniquePlaybackInterval), n.setPreviousLongestPlaybackInterval(o.previousLongestPlaybackInterval)), n.incrementAssetLoadCounter(), n.isAssetStarted() && d && l.incrementPlayCounter(), d && (l.setPlaySequenceCounter(0), n.setPlaybackSessionLooping(!0)), !b.exists(c.ns_st_tp) && b.exists(c.ns_st_ad) && b.isNotEmpty(c.ns_st_ad) && "0" !== c.ns_st_ad && n.setInternalLabel("ns_st_tp", "1");
            } }), c(), function (a) {
            var b = a;b.getClip = function () {
              return b._log.deprecation("playlist.getClip()", "playbackSession.getAsset()"), b.getAsset();
            };
          }(w);
        }return a.resetPlaybackSession = function (a, b, c) {
          for (var d = b.getAsset(), e = b.getLabels(), f = {}, g = 0; c && g < c.length; g++) {
            e.hasOwnProperty(c[g]) && (f[c[g]] = e[c[g]]);
          }a.getPlaybackSession().setLabels(f), n.resetAsset(d, a.getPlaybackSession().getAsset(), c);
        }, function (a) {
          a.resetPlaybackSession = function (a) {
            return function (b, c, d) {
              var e = this;a.apply(e, Array.prototype.slice.call(arguments)), b.getPlaybackSession()._log = c._log;
            };
          }(a.resetPlaybackSession);
        }(a), a;
      }(),
          p = function () {
        return function (a) {
          function c() {
            e = 1;
          }function d(c) {
            f = b.extend({}, c);var d = a.getStaCore().getLiveEndpointURL();if (a.getAppCore()) {
              if (a.getStaCore().isProperlyInitialized()) {
                var e = a.getStaCore().getExports().et;if ("function" == typeof a.getAppCore().getMeasurementDispatcher) {
                  var g = a.getAppCore().getMeasurementDispatcher();g.send(e.HIDDEN, c, d);
                } else {
                  var h = a.getStaCore().getExports().am,
                      i = h.newApplicationMeasurement(a.getAppCore(), e.HIDDEN, c, d);a.getAppCore().getQueue().offer(i);
                }
              }
            } else d && a.getStaCore().getPlatformAPI().httpGet(a.getStaCore().prepareUrl(d, c));
          }var e,
              f,
              g = this,
              h = [];b.extend(this, { newEvent: function newEvent(a) {
              for (var b = 0; b < h.length; ++b) {
                h[b](a.eventLabels);
              }d(a.eventLabels), a.eventType != j.HEARTBEAT && g.incrementEventCounter();
            }, addMeasurementListener: function addMeasurementListener(a) {
              "function" == typeof a && h.push(a);
            }, removeMeasurementListener: function removeMeasurementListener(a) {
              for (var b = NaN, c = 0; c < h.length; ++c) {
                if (h[c] == a) {
                  b = c;break;
                }
              }isNaN(b) || h.splice(b, 1);
            }, getEventCounter: function getEventCounter() {
              return e;
            }, incrementEventCounter: function incrementEventCounter() {
              e++;
            }, setEventCounter: function setEventCounter(a) {
              e = a;
            }, getMeasurementSnapshot: function getMeasurementSnapshot() {
              return f;
            } }), c();
        };
      }(),
          q = function () {
        return function (a) {
          function c() {
            g = 0, h = 0;
          }function d() {
            h++;var c = {},
                d = b.fixEventTime(c);c.ns_st_po = a.getPlaybackSession().getAsset().getExpectedPlaybackPosition(d) + "", c.ns_st_hc = a.getHeartbeat().getCount() + "";var e = a.getStaCore().createLabels(j.HEARTBEAT, c, d);a.getPlaybackSession().getAsset().updateIndependentLabels(e.eventLabels), a.getEventManager().newEvent(e), g = 0, i.resume();
          }function e() {
            null != f && (a.getStaCore().getPlatformAPI().clearTimeout(f), f = null);
          }var f,
              g,
              h,
              i = this,
              k = m.DEFAULT_HEARTBEAT_INTERVAL;b.extend(this, { getCount: function getCount() {
              return h;
            }, setIntervals: function setIntervals(a) {
              k = a;
            }, getInterval: function getInterval(a) {
              var b = 0;if (null != k) for (var c = 0; c < k.length; c++) {
                var d = k[c],
                    e = d.playingtime;if (!e || a < e) {
                  b = d.interval;break;
                }
              }return b;
            }, getIntervals: function getIntervals() {
              return k;
            }, resume: function resume() {
              e();var b = i.getInterval(a.getPlaybackSession().getAsset().getPlaybackTime() + (+new Date() - a.getPlaybackSession().getAsset().getPlaybackTimestamp()));if (b > 0) {
                var c = g > 0 ? g : b;f = a.getStaCore().getPlatformAPI().setTimeout(d, c);
              }g = 0;
            }, pause: function pause() {
              e();var b = i.getInterval(a.getPlaybackSession().getAsset().getPlaybackTime() + (+new Date() - a.getPlaybackSession().getAsset().getPlaybackTimestamp()));g = b - (a.getPlaybackSession().getAsset().getPlaybackTime() + (+new Date() - a.getPlaybackSession().getAsset().getPlaybackTimestamp())) % b;
            } }), c();
        };
      }(),
          r = function () {
        return function (a) {
          function c() {}function d() {
            var c = {},
                d = b.fixEventTime(c);a.getStaCore().newPseudoEvent(j.KEEPALIVE, d, c), g.start();
          }function e() {
            null != f && (a.getStaCore().getPlatformAPI().clearTimeout(f), f = null);
          }var f,
              g = this,
              h = m.DEFAULT_KEEP_ALIVE_INTERVAL;b.extend(g, { start: function start() {
              e(), f = a.getStaCore().getPlatformAPI().setTimeout(d, h);
            }, stop: e, setInterval: function setInterval(a) {
              h = a;
            }, getInterval: function getInterval() {
              return h;
            } }), c();
        };
      }(),
          s = function () {
        return function (a) {
          function c() {
            f = k.IDLE, e = null, d = NaN;
          }var d,
              e,
              f,
              g = this;b.extend(g, { eventTypeToState: function eventTypeToState(a) {
              if (f == k.IDLE) {
                if (a == j.PLAY) return k.PLAYING;if (a == j.SEEK_START) return k.SEEKING_BEFORE_PLAYBACK;if (a == j.BUFFER) return k.BUFFERING_BEFORE_PLAYBACK;
              } else if (f == k.PLAYBACK_NOT_STARTED) {
                if (a == j.PLAY) return k.PLAYING;if (a == j.SEEK_START) return k.SEEKING_BEFORE_PLAYBACK;if (a == j.BUFFER) return k.BUFFERING_BEFORE_PLAYBACK;if (a == j.END || a == j.AD_SKIP) return k.IDLE;
              } else if (f == k.PLAYING) {
                if (a == j.END || a == j.AD_SKIP) return k.IDLE;if (a == j.BUFFER) return k.BUFFERING_DURING_PLAYBACK;if (a == j.PAUSE) return k.PAUSED;if (a == j.SEEK_START) return k.SEEKING_DURING_PLAYBACK;
              } else if (f == k.PAUSED) {
                if (a == j.END || a == j.AD_SKIP) return k.IDLE;if (a == j.BUFFER) return k.BUFFERING_DURING_PAUSE;if (a == j.PLAY) return k.PLAYING;if (a == j.SEEK_START) return k.SEEKING_DURING_PAUSE;
              } else if (f == k.BUFFERING_BEFORE_PLAYBACK) {
                if (a == j.END || a == j.AD_SKIP) return k.IDLE;if (a == j.PAUSE || a == j.BUFFER_STOP) return k.PLAYBACK_NOT_STARTED;if (a == j.PLAY) return k.PLAYING;if (a == j.SEEK_START) return k.SEEKING_BEFORE_PLAYBACK;
              } else if (f == k.BUFFERING_DURING_PLAYBACK) {
                if (a == j.END || a == j.AD_SKIP) return k.IDLE;if (a == j.PLAY || a == j.BUFFER_STOP) return k.PLAYING;if (a == j.PAUSE_ON_BUFFERING) return k.PAUSED_DURING_BUFFERING;if (a == j.SEEK_START) return k.SEEKING_DURING_BUFFERING;if (a == j.PAUSE) return k.PAUSED;
              } else if (f == k.BUFFERING_DURING_SEEKING) {
                if (a == j.END || a == j.AD_SKIP) return k.IDLE;if (a == j.PLAY) return k.PLAYING;if (a == j.BUFFER_STOP) return k.SEEKING_DURING_PLAYBACK;if (a == j.PAUSE) return k.PAUSED;
              } else if (f == k.BUFFERING_DURING_PAUSE) {
                if (a == j.END || a == j.AD_SKIP) return k.IDLE;if (a == j.PLAY) return k.PLAYING;if (a == j.SEEK_START) return k.SEEKING_DURING_PAUSE;if (a == j.BUFFER_STOP || a == j.PAUSE) return k.PAUSED;
              } else if (f == k.SEEKING_BEFORE_PLAYBACK) {
                if (a == j.END || a == j.AD_SKIP) return k.IDLE;if (a == j.PAUSE) return k.PLAYBACK_NOT_STARTED;if (a == j.PLAY) return k.PLAYING;if (a == j.BUFFER) return k.BUFFERING_BEFORE_PLAYBACK;
              } else if (f == k.SEEKING_DURING_PLAYBACK) {
                if (a == j.END || a == j.AD_SKIP) return k.IDLE;if (a == j.PLAY) return k.PLAYING;if (a == j.PAUSE) return k.PAUSED;if (a == j.BUFFER) return k.BUFFERING_DURING_SEEKING;
              } else if (f == k.SEEKING_DURING_BUFFERING) {
                if (a == j.END || a == j.AD_SKIP) return k.IDLE;if (a == j.PLAY) return k.PLAYING;if (a == j.PAUSE || a == j.BUFFER_STOP) return k.PAUSED;if (a == j.BUFFER) return k.BUFFERING_DURING_SEEKING;
              } else if (f == k.SEEKING_DURING_PAUSE) {
                if (a == j.END || a == j.AD_SKIP) return k.IDLE;if (a == j.PLAY) return k.PLAYING;if (a == j.PAUSE || a == j.BUFFER_STOP) return k.PAUSED;if (a == j.BUFFER) return k.BUFFERING_DURING_PAUSE;
              } else if (f == k.PAUSED_DURING_BUFFERING) {
                if (a == j.END || a == j.AD_SKIP) return k.IDLE;if (a == j.SEEK_START) return k.SEEKING_DURING_BUFFERING;if (a == j.PAUSE) return k.PAUSED;if (a == j.PLAY || a == j.BUFFER_STOP) return k.PLAYING;
              }return null;
            }, getCurrentState: function getCurrentState() {
              return f;
            }, newEvent: function newEvent(a, b) {
              var c = g.eventTypeToState(a);f != c && (e = f, f = c, d = b);
            }, getPreviousState: function getPreviousState() {
              return e;
            }, getLastStateChangeTimestamp: function getLastStateChangeTimestamp() {
              return d;
            } }), c();
        };
      }(),
          t = function () {
        return function (a) {
          var c = this;b.extend(c, { onSeekStartWhenPausedOrBufferingDuringPause: function onSeekStartWhenPausedOrBufferingDuringPause(b, c) {
              var d = parseInt(c.ns_st_po);a.getPlaybackSession().getAsset().isSeeking() ? a.getPlaybackSession().getAsset().isCollectingSeekingTime() || (a.getPlaybackSession().getAsset().setSeekingTimestamp(b), a.getPlaybackSession().getAsset().setCollectingSeekingTime(!0)) : a.getPlaybackSession().getAsset().incrementSeeks(), a.getPlaybackSession().getAsset().isSeeking() || (a.getPlaybackSession().getAsset().setSeeking(!0), a.getPlaybackSession().getAsset().setCollectingSeekingTime(!0), a.getPlaybackSession().getAsset().setSeekStartPosition(d), a.getPlaybackSession().getAsset().setSeekingTimestamp(b));
            }, onBufferWhenSeekingOrPlayBackNotStartedOrPaused: function onBufferWhenSeekingOrPlayBackNotStartedOrPaused(b, c) {
              a.getPlaybackSession().setBufferingTimestamp(b), a.getPlaybackSession().getAsset().setBufferingTimestamp(b);
            }, onPlayWhenSeekingDuringBufferingOrSeekingDuringPause: function onPlayWhenSeekingDuringBufferingOrSeekingDuringPause(b, c) {
              var d = parseInt(c.ns_st_po);a.getPlaybackSession().incrementPlaySequenceCounter(), a.getPlaybackSession().getAsset().incrementPlaySequenceCounter(), a.getPlaybackSession().getAsset().isSeeking() && (a.getPlaybackSession().getAsset().isCollectingSeekingTime() && (a.getPlaybackSession().getAsset().addSeekingTime(b), a.getPlaybackSession().getAsset().setCollectingSeekingTime(!1)), a.getPlaybackSession().getAsset().addSeekingAmount(d), a.getPlaybackSession().getAsset().setSeeking(!1)), a.getPlaybackSession().getAsset().incrementPlayCounter(), a.getPlaybackSession().setPlaybackTimestamp(b), a.getPlaybackSession().getAsset().setPlaybackTimestamp(b), a.getPlaybackSession().getAsset().addElapsedTime(b), a.getPlaybackSession().getAsset().setElapsedTimestamp(b), a.getPlaybackSession().getAsset().setPlaybackStartPosition(d), a.getHeartbeat().resume(), a.getKeepAlive().start();var e = a.getStaCore().createLabels(j.PLAY, c, b);a.getPlaybackSession().getAsset().updateDeltaLabels(e.eventLabels), a.getPlaybackSession().getAsset().updateIndependentLabels(e.eventLabels), a.getEventManager().newEvent(e);
            }, onBufferStopWhenBufferingDuringSeekingOrBufferingDuringPause: function onBufferStopWhenBufferingDuringSeekingOrBufferingDuringPause(b, c) {
              a.getPlaybackSession().addBufferingTime(b), a.getPlaybackSession().getAsset().addBufferingTime(b);
            }, onPauseWhenSeekingDuringPlaybackOrSeekingDuringPause: function onPauseWhenSeekingDuringPlaybackOrSeekingDuringPause(b, c) {
              a.getPlaybackSession().getAsset().isSeeking() && a.getPlaybackSession().getAsset().isCollectingSeekingTime() && (a.getPlaybackSession().getAsset().addSeekingTime(b), a.getPlaybackSession().getAsset().setCollectingSeekingTime(!1));
            }, onEndOrAdSkipWhenSeekingDuringBufferingOrSeekingDuringPause: function onEndOrAdSkipWhenSeekingDuringBufferingOrSeekingDuringPause(c, d) {
              a.getStaCore().resetHeartbeat(), a.getKeepAlive().stop(), a.getPlaybackSession().getAsset().addElapsedTime(c);var e = a.getStaCore().createLabels(j.END, d, c);a.getPlaybackSession().getAsset().updateDeltaLabels(e.eventLabels), a.getPlaybackSession().getAsset().updateIndependentLabels(e.eventLabels), a.getEventManager().newEvent(e), a.getPlaybackSession().getAsset().isSeeking() && a.getPlaybackSession().getAsset().isCollectingSeekingTime() && (a.getPlaybackSession().getAsset().setSeekingTimeBeforeEnd(c - a.getPlaybackSession().getAsset().getSeekingTimestamp()), a.getPlaybackSession().getAsset().setCollectingSeekingTime(!1)), a.getPlaybackSession().storeAssetPlaybackCounters(), a.getPlaybackSession().getAsset().resetAssetLifecycleLabels(), a.getPlaybackSession().getAsset().setPlaybackStarted(!1), d.hasOwnProperty("ns_st_pe") && b.parseBoolean(d.ns_st_pe, !1) && a.getStaCore().resetPlaybackSession();
            }, onBufferStopWhenSeekingDuringBufferingOrSeekingDuringPause: function onBufferStopWhenSeekingDuringBufferingOrSeekingDuringPause(b, c) {
              a.getPlaybackSession().getAsset().isSeeking() && a.getPlaybackSession().getAsset().isCollectingSeekingTime() && (a.getPlaybackSession().getAsset().addSeekingTime(b), a.getPlaybackSession().getAsset().setCollectingSeekingTime(!1));
            } });
        };
      }(),
          u = function () {
        return function (a) {
          var c = this;b.extend(c, { onEndOrAdSkip: function onEndOrAdSkip(c, d) {
              a.getPlaybackSession().addBufferingTime(c), a.getPlaybackSession().getAsset().addBufferingTime(c), a.getPlaybackSession().getAsset().isSeeking() && a.getPlaybackSession().getAsset().isCollectingSeekingTime() && a.getPlaybackSession().getAsset().setSeekingTimeBeforeEnd(c - a.getPlaybackSession().getAsset().getSeekingTimestamp()), a.getPlaybackSession().getAsset().resetAssetLifecycleLabels(), a.getPlaybackSession().getAsset().setPlaybackStarted(!1), d.hasOwnProperty("ns_st_pe") && b.parseBoolean(d.ns_st_pe, !1) && a.getStaCore().resetPlaybackSession();
            }, onBufferStop: function onBufferStop(b, c) {
              a.getPlaybackSession().addBufferingTime(b), a.getPlaybackSession().getAsset().addBufferingTime(b), a.getPlaybackSession().getAsset().isSeeking() && a.getPlaybackSession().getAsset().isCollectingSeekingTime() && (a.getPlaybackSession().getAsset().addSeekingTime(b), a.getPlaybackSession().getAsset().setCollectingSeekingTime(!1));
            }, onSeekStart: function onSeekStart(b, c) {
              var d = parseInt(c.ns_st_po);a.getPlaybackSession().addBufferingTime(b), a.getPlaybackSession().getAsset().addBufferingTime(b), a.getPlaybackSession().getAsset().isSeeking() ? a.getPlaybackSession().getAsset().isCollectingSeekingTime() || (a.getPlaybackSession().getAsset().setSeekingTimestamp(b), a.getPlaybackSession().getAsset().setCollectingSeekingTime(!0)) : a.getPlaybackSession().getAsset().incrementSeeks(), a.getPlaybackSession().getAsset().isSeeking() || (a.getPlaybackSession().getAsset().setSeeking(!0), a.getPlaybackSession().getAsset().setCollectingSeekingTime(!0), a.getPlaybackSession().getAsset().setSeekStartPosition(d), a.getPlaybackSession().getAsset().setSeekingTimestamp(b));
            }, onPause: function onPause(b, c) {
              a.getPlaybackSession().addBufferingTime(b), a.getPlaybackSession().getAsset().addBufferingTime(b), a.getPlaybackSession().getAsset().isSeeking() && a.getPlaybackSession().getAsset().isCollectingSeekingTime() && (a.getPlaybackSession().getAsset().addSeekingTime(b), a.getPlaybackSession().getAsset().setCollectingSeekingTime(!1));
            }, onPlay: function onPlay(b, c) {
              var d = parseInt(c.ns_st_po);a.getPlaybackSession().addBufferingTime(b), a.getPlaybackSession().getAsset().addBufferingTime(b), a.getPlaybackSession().getAsset().isSeeking() && (a.getPlaybackSession().getAsset().isCollectingSeekingTime() && (a.getPlaybackSession().getAsset().addSeekingTime(b), a.getPlaybackSession().getAsset().setCollectingSeekingTime(!1)), a.getPlaybackSession().getAsset().addSeekingAmount(d), a.getPlaybackSession().getAsset().setSeeking(!1)), a.getPlaybackSession().getAsset().setPlaybackStarted(!0), (a.getPlaybackSession().getAsset().isPlaybackSessionLooping() || 0 == a.getPlaybackSession().getPlaybackCounter()) && (a.getPlaybackSession().incrementPlaybackCounter(), a.getPlaybackSession().getAsset().setPlaybackSessionLooping(!1)), a.getPlaybackSession().incrementPlaySequenceCounter(), a.getPlaybackSession().getAsset().setPlaybackStarted(!0), a.getPlaybackSession().getAsset().incrementSegmentPlaybackCounter(), a.getPlaybackSession().getAsset().incrementPlayCounter(), a.getPlaybackSession().setPlaybackTimestamp(b), a.getPlaybackSession().getAsset().setPlaybackTimestamp(b), a.getPlaybackSession().getAsset().setElapsedTimestamp(b), a.getPlaybackSession().getAsset().setPlaybackStartPosition(d), (0 == a.getPlaybackSession().getAsset().getLowestPartNumberPlayed() || a.getPlaybackSession().getAsset().getPartNumber() <= a.getPlaybackSession().getAsset().getLowestPartNumberPlayed()) && (a.getPlaybackSession().getAsset().setLowestPartNumberPlayed(a.getPlaybackSession().getAsset().getPartNumber()), a.getPlaybackSession().getAsset().incrementAssetPlaybackCounter(), a.getPlaybackSession().getAsset().setPlaySequenceCounter(0), a.getPlaybackSession().getAsset().resetAssetPlaybackIntervals()), a.getPlaybackSession().getAsset().incrementPlaySequenceCounter(), a.getStaCore().isLoadingTimeSent() || (c.ns_st_lt = a.getStaCore().getLoadTimeOffset() + b - a.getStaCore().getInitTimestamp() + "", a.getStaCore().setLoadingTimeSent(!0)), a.getHeartbeat().resume(), a.getKeepAlive().start();var e = a.getStaCore().createLabels(j.PLAY, c, b);a.getPlaybackSession().getAsset().updateDeltaLabels(e.eventLabels), a.getPlaybackSession().getAsset().updateIndependentLabels(e.eventLabels), a.getEventManager().newEvent(e);
            } });
        };
      }(),
          v = function () {
        return function (a) {
          var c = this;b.extend(c, { onEndAndSkip: function onEndAndSkip(c, d) {
              a.getStaCore().resetHeartbeat(), a.getKeepAlive().stop(), a.getPlaybackSession().addBufferingTime(c), a.getPlaybackSession().getAsset().addBufferingTime(c), a.getPlaybackSession().getAsset().addElapsedTime(c);var e = a.getStaCore().createLabels(j.END, d, c);a.getPlaybackSession().getAsset().updateDeltaLabels(e.eventLabels), a.getPlaybackSession().getAsset().updateIndependentLabels(e.eventLabels), a.getEventManager().newEvent(e), a.getPlaybackSession().getAsset().isSeeking() && a.getPlaybackSession().getAsset().isCollectingSeekingTime() && (a.getPlaybackSession().getAsset().setSeekingTimeBeforeEnd(c - a.getPlaybackSession().getAsset().getSeekingTimestamp()), a.getPlaybackSession().getAsset().setCollectingSeekingTime(!1)), a.getPlaybackSession().storeAssetPlaybackCounters(), a.getPlaybackSession().getAsset().resetAssetLifecycleLabels(), a.getPlaybackSession().getAsset().setPlaybackStarted(!1), d.hasOwnProperty("ns_st_pe") && b.parseBoolean(d.ns_st_pe, !1) && a.getStaCore().resetPlaybackSession();
            }, onPause: function onPause(b, c) {
              a.getPlaybackSession().addBufferingTime(b), a.getPlaybackSession().getAsset().addBufferingTime(b);
            }, onPlay: function onPlay(b, c) {
              var d = parseInt(c.ns_st_po);a.getPlaybackSession().incrementPlaySequenceCounter(), a.getPlaybackSession().getAsset().incrementPlaySequenceCounter(), a.getPlaybackSession().getAsset().incrementPlayCounter(), a.getPlaybackSession().addBufferingTime(b), a.getPlaybackSession().getAsset().addBufferingTime(b), a.getPlaybackSession().getAsset().isSeeking() && (a.getPlaybackSession().getAsset().isCollectingSeekingTime() && (a.getPlaybackSession().getAsset().addSeekingTime(b), a.getPlaybackSession().getAsset().setCollectingSeekingTime(!1)), a.getPlaybackSession().getAsset().addSeekingAmount(d), a.getPlaybackSession().getAsset().setSeeking(!1)), a.getPlaybackSession().getAsset().addElapsedTime(b), a.getPlaybackSession().getAsset().setElapsedTimestamp(b), a.getPlaybackSession().setPlaybackTimestamp(b), a.getPlaybackSession().getAsset().setPlaybackTimestamp(b), a.getPlaybackSession().getAsset().setPlaybackStartPosition(d), a.getHeartbeat().resume(), a.getKeepAlive().start();var e = a.getStaCore().createLabels(j.PLAY, c, b);a.getPlaybackSession().getAsset().updateDeltaLabels(e.eventLabels), a.getPlaybackSession().getAsset().updateIndependentLabels(e.eventLabels), a.getEventManager().newEvent(e);
            } });
        };
      }(),
          w = function () {
        return function (a) {
          var c = this;b.extend(c, { onPauseOnBuffering: function onPauseOnBuffering(b, c) {
              parseInt(c.ns_st_po);a.getStaCore().stopPausedOnBufferingTimer(), a.getPlaybackSession().getAsset().addElapsedTime(b), a.getPlaybackSession().getAsset().setElapsedTimestamp(b), a.getPlaybackSession().addBufferingTime(b), a.getPlaybackSession().getAsset().addBufferingTime(b), a.getPlaybackSession().incrementPauses(), a.getPlaybackSession().getAsset().incrementPauses();var d = a.getStaCore().createLabels(j.PAUSE, c, b);a.getPlaybackSession().getAsset().updateDeltaLabels(d.eventLabels), a.getPlaybackSession().getAsset().updateIndependentLabels(d.eventLabels), a.getEventManager().newEvent(d), a.getPlaybackSession().setBufferingTimestamp(b), a.getPlaybackSession().getAsset().setBufferingTimestamp(b);
            }, onBufferStop: function onBufferStop(b, c) {
              a.getPlaybackSession().addBufferingTime(b), a.getPlaybackSession().getAsset().addBufferingTime(b);
            }, onEndOrAdSkip: function onEndOrAdSkip(c, d) {
              parseInt(d.ns_st_po);a.getStaCore().stopPausedOnBufferingTimer(), a.getStaCore().resetHeartbeat(), a.getKeepAlive().stop(), a.getPlaybackSession().addBufferingTime(c), a.getPlaybackSession().getAsset().addBufferingTime(c), a.getPlaybackSession().getAsset().addElapsedTime(c);var e = a.getStaCore().createLabels(j.END, d, c);a.getPlaybackSession().getAsset().updateDeltaLabels(e.eventLabels), a.getPlaybackSession().getAsset().updateIndependentLabels(e.eventLabels), a.getEventManager().newEvent(e), a.getPlaybackSession().getAsset().resetAssetLifecycleLabels(), a.getPlaybackSession().getAsset().setPlaybackStarted(!1), d.hasOwnProperty("ns_st_pe") && b.parseBoolean(d.ns_st_pe, !1) && a.getStaCore().resetPlaybackSession();
            }, onSeekStart: function onSeekStart(b, c) {
              var d = parseInt(c.ns_st_po);a.getStaCore().stopPausedOnBufferingTimer(), a.getHeartbeat().pause(), a.getKeepAlive().stop(), a.getPlaybackSession().getAsset().addElapsedTime(b), a.getPlaybackSession().getAsset().setElapsedTimestamp(b), a.getPlaybackSession().addBufferingTime(b), a.getPlaybackSession().getAsset().addBufferingTime(b), a.getPlaybackSession().getAsset().incrementSeeks(), a.getPlaybackSession().getAsset().setSeeking(!0), a.getPlaybackSession().getAsset().setCollectingSeekingTime(!0), a.getPlaybackSession().getAsset().setSeekStartPosition(d), a.getPlaybackSession().getAsset().setSeekingTimestamp(b), a.getPlaybackSession().incrementPauses(), a.getPlaybackSession().getAsset().incrementPauses();var e = a.getStaCore().createLabels(j.PAUSE, c, b);a.getPlaybackSession().getAsset().updateDeltaLabels(e.eventLabels), a.getPlaybackSession().getAsset().updateIndependentLabels(e.eventLabels), a.getEventManager().newEvent(e);
            }, onPause: function onPause(b, c) {
              parseInt(c.ns_st_po);a.getStaCore().stopPausedOnBufferingTimer(), a.getPlaybackSession().getAsset().addElapsedTime(b), a.getPlaybackSession().getAsset().setElapsedTimestamp(b), a.getPlaybackSession().addBufferingTime(b), a.getPlaybackSession().getAsset().addBufferingTime(b), a.getPlaybackSession().incrementPauses(), a.getPlaybackSession().getAsset().incrementPauses();var d = a.getStaCore().createLabels(j.PAUSE, c, b);a.getPlaybackSession().getAsset().updateDeltaLabels(d.eventLabels), a.getPlaybackSession().getAsset().updateIndependentLabels(d.eventLabels), a.getEventManager().newEvent(d);
            }, onPlay: function onPlay(b, c) {
              var d = parseInt(c.ns_st_po);a.getStaCore().stopPausedOnBufferingTimer(), a.getPlaybackSession().incrementPlaySequenceCounter(), a.getPlaybackSession().getAsset().incrementPlayCounter(), a.getPlaybackSession().getAsset().incrementPlaySequenceCounter(), a.getPlaybackSession().addBufferingTime(b), a.getPlaybackSession().getAsset().addBufferingTime(b), a.getPlaybackSession().setPlaybackTimestamp(b), a.getPlaybackSession().getAsset().setPlaybackTimestamp(b), a.getPlaybackSession().getAsset().setPlaybackStartPosition(d), a.getHeartbeat().resume(), a.getKeepAlive().start();
            } });
        };
      }(),
          x = function () {
        return function (a) {
          var c = this;b.extend(c, { onEndOrAdSkip: function onEndOrAdSkip(c, d) {
              a.getStaCore().resetHeartbeat(), a.getKeepAlive().stop(), a.getStaCore().stopPausedOnBufferingTimer(), a.getPlaybackSession().addBufferingTime(c), a.getPlaybackSession().getAsset().addBufferingTime(c), a.getPlaybackSession().getAsset().addElapsedTime(c);var e = a.getStaCore().createLabels(j.END, d, c);a.getPlaybackSession().getAsset().updateDeltaLabels(e.eventLabels), a.getPlaybackSession().getAsset().updateIndependentLabels(e.eventLabels), a.getEventManager().newEvent(e), a.getPlaybackSession().getAsset().isSeeking() && a.getPlaybackSession().getAsset().isCollectingSeekingTime() && (a.getPlaybackSession().getAsset().setSeekingTimeBeforeEnd(c - a.getPlaybackSession().getAsset().getSeekingTimestamp()), a.getPlaybackSession().getAsset().setCollectingSeekingTime(!1)), a.getPlaybackSession().storeAssetPlaybackCounters(), a.getPlaybackSession().getAsset().resetAssetLifecycleLabels(), a.getPlaybackSession().getAsset().setPlaybackStarted(!1), d.hasOwnProperty("ns_st_pe") && b.parseBoolean(d.ns_st_pe, !1) && a.getStaCore().resetPlaybackSession();
            }, onPause: function onPause(b, c) {
              a.getPlaybackSession().addBufferingTime(b), a.getPlaybackSession().getAsset().addBufferingTime(b), a.getPlaybackSession().incrementPauses(), a.getPlaybackSession().getAsset().incrementPauses(), a.getPlaybackSession().getAsset().isSeeking() && a.getPlaybackSession().getAsset().isCollectingSeekingTime() && (a.getPlaybackSession().getAsset().addSeekingTime(b), a.getPlaybackSession().getAsset().setCollectingSeekingTime(!1));
            }, onPlay: function onPlay(b, c) {
              var d = parseInt(c.ns_st_po);a.getPlaybackSession().incrementPlaySequenceCounter(), a.getPlaybackSession().getAsset().incrementPlaySequenceCounter(), a.getPlaybackSession().getAsset().incrementPlayCounter(), a.getPlaybackSession().addBufferingTime(b), a.getPlaybackSession().getAsset().addBufferingTime(b), a.getPlaybackSession().getAsset().isSeeking() && (a.getPlaybackSession().getAsset().isCollectingSeekingTime() && (a.getPlaybackSession().getAsset().addSeekingTime(b), a.getPlaybackSession().getAsset().setCollectingSeekingTime(!1)), a.getPlaybackSession().getAsset().addSeekingAmount(d), a.getPlaybackSession().getAsset().setSeeking(!1)), a.getPlaybackSession().getAsset().addElapsedTime(b), a.getPlaybackSession().getAsset().setElapsedTimestamp(b), a.getPlaybackSession().setPlaybackTimestamp(b), a.getPlaybackSession().getAsset().setPlaybackTimestamp(b), a.getPlaybackSession().getAsset().setPlaybackStartPosition(d), a.getHeartbeat().resume(), a.getKeepAlive().start();var e = a.getStaCore().createLabels(j.PLAY, c, b);a.getPlaybackSession().getAsset().updateDeltaLabels(e.eventLabels), a.getPlaybackSession().getAsset().updateIndependentLabels(e.eventLabels), a.getEventManager().newEvent(e);
            } });
        };
      }(),
          y = function () {
        return function (a) {
          var c = this;b.extend(c, { onBuffer: function onBuffer(b, c) {
              a.getPlaybackSession().setPlaybackSessionStarted(!0), a.getPlaybackSession().getAsset().setAssetStarted(!0), a.getPlaybackSession().getAsset().isSeeking() && a.getPlaybackSession().getAsset().setSeekingTime(a.getPlaybackSession().getAsset().getSeekingTimeBeforeEnd()), a.getPlaybackSession().setBufferingTimestamp(b), a.getPlaybackSession().getAsset().setBufferingTimestamp(b);
            }, onSeekStart: function onSeekStart(b, c) {
              var d = parseInt(c.ns_st_po);a.getPlaybackSession().setPlaybackSessionStarted(!0), a.getPlaybackSession().getAsset().setAssetStarted(!0), a.getPlaybackSession().getAsset().isSeeking() && a.getPlaybackSession().getAsset().setSeekingTime(a.getPlaybackSession().getAsset().getSeekingTimeBeforeEnd()), a.getPlaybackSession().getAsset().incrementSeeks(), a.getPlaybackSession().getAsset().setSeeking(!0), a.getPlaybackSession().getAsset().setCollectingSeekingTime(!0), a.getPlaybackSession().getAsset().setSeekStartPosition(d), a.getPlaybackSession().getAsset().setSeekingTimestamp(b);
            }, onPlay: function onPlay(b, c) {
              var d = parseInt(c.ns_st_po);a.getPlaybackSession().setPlaybackSessionStarted(!0), a.getPlaybackSession().getAsset().setAssetStarted(!0), (a.getPlaybackSession().getAsset().isPlaybackSessionLooping() || 0 == a.getPlaybackSession().getPlaybackCounter()) && (a.getPlaybackSession().incrementPlaybackCounter(), a.getPlaybackSession().getAsset().setPlaybackSessionLooping(!1)), a.getPlaybackSession().getAsset().isSeeking() && (a.getPlaybackSession().getAsset().setSeekingTime(a.getPlaybackSession().getAsset().getSeekingTimeBeforeEnd()), a.getPlaybackSession().getAsset().addSeekingAmount(d), a.getPlaybackSession().getAsset().setSeeking(!1)), a.getPlaybackSession().incrementPlaySequenceCounter(), a.getPlaybackSession().getAsset().setPlaybackStarted(!0), a.getPlaybackSession().getAsset().incrementSegmentPlaybackCounter(), (0 == a.getPlaybackSession().getAsset().getLowestPartNumberPlayed() || a.getPlaybackSession().getAsset().getPartNumber() <= a.getPlaybackSession().getAsset().getLowestPartNumberPlayed()) && (a.getPlaybackSession().getAsset().setLowestPartNumberPlayed(a.getPlaybackSession().getAsset().getPartNumber()), a.getPlaybackSession().getAsset().incrementAssetPlaybackCounter(), a.getPlaybackSession().getAsset().setPlaySequenceCounter(0), a.getPlaybackSession().getAsset().resetAssetPlaybackIntervals()), a.getPlaybackSession().getAsset().incrementPlaySequenceCounter(), a.getPlaybackSession().getAsset().incrementPlayCounter(), a.getPlaybackSession().setPlaybackTimestamp(b), a.getPlaybackSession().getAsset().setPlaybackTimestamp(b), a.getPlaybackSession().getAsset().setElapsedTimestamp(b), a.getPlaybackSession().getAsset().setPlaybackStartPosition(d), a.getStaCore().isLoadingTimeSent() || (c.ns_st_lt = a.getStaCore().getLoadTimeOffset() + b - a.getStaCore().getInitTimestamp() + "", a.getStaCore().setLoadingTimeSent(!0)), a.getHeartbeat().resume(), a.getKeepAlive().start();var e = a.getStaCore().createLabels(j.PLAY, c, b);a.getPlaybackSession().getAsset().updateDeltaLabels(e.eventLabels), a.getPlaybackSession().getAsset().updateIndependentLabels(e.eventLabels), a.getEventManager().newEvent(e);
            } });
        };
      }(),
          z = function () {
        return function (a) {
          var c = this;b.extend(c, { onEndOrAdSkip: function onEndOrAdSkip(c, d) {
              a.getStaCore().resetHeartbeat(), a.getKeepAlive().stop(), a.getPlaybackSession().getAsset().addElapsedTime(c);var e = a.getStaCore().createLabels(j.END, d, c);a.getPlaybackSession().getAsset().updateDeltaLabels(e.eventLabels), a.getPlaybackSession().getAsset().updateIndependentLabels(e.eventLabels), a.getEventManager().newEvent(e), a.getPlaybackSession().getAsset().isSeeking() && a.getPlaybackSession().getAsset().isCollectingSeekingTime() && (a.getPlaybackSession().getAsset().setSeekingTimeBeforeEnd(c - a.getPlaybackSession().getAsset().getSeekingTimestamp()), a.getPlaybackSession().getAsset().setSeeking(!1)), a.getPlaybackSession().storeAssetPlaybackCounters(), a.getPlaybackSession().getAsset().resetAssetLifecycleLabels(), a.getPlaybackSession().getAsset().setPlaybackStarted(!1), d.hasOwnProperty("ns_st_pe") && b.parseBoolean(d.ns_st_pe, !1) && a.getStaCore().resetPlaybackSession();
            }, onPlay: function onPlay(b, c) {
              var d = parseInt(c.ns_st_po);a.getPlaybackSession().incrementPlaySequenceCounter(), a.getPlaybackSession().getAsset().isSeeking() && (a.getPlaybackSession().getAsset().isCollectingSeekingTime() && (a.getPlaybackSession().getAsset().addSeekingTime(b), a.getPlaybackSession().getAsset().setCollectingSeekingTime(!1)), a.getPlaybackSession().getAsset().addSeekingAmount(d), a.getPlaybackSession().getAsset().setSeeking(!1)), a.getPlaybackSession().getAsset().incrementPlayCounter(), a.getPlaybackSession().getAsset().incrementPlaySequenceCounter(), a.getPlaybackSession().setPlaybackTimestamp(b), a.getPlaybackSession().getAsset().setPlaybackTimestamp(b), a.getPlaybackSession().getAsset().addElapsedTime(b), a.getPlaybackSession().getAsset().setElapsedTimestamp(b), a.getPlaybackSession().getAsset().setPlaybackStartPosition(d), a.getHeartbeat().resume(), a.getKeepAlive().start();var e = a.getStaCore().createLabels(j.PLAY, c, b);a.getPlaybackSession().getAsset().updateDeltaLabels(e.eventLabels), a.getPlaybackSession().getAsset().updateIndependentLabels(e.eventLabels), a.getEventManager().newEvent(e);
            } });
        };
      }(),
          A = function () {
        return function (a) {
          var c = this;b.extend(c, { onEndOrAdSkip: function onEndOrAdSkip(c, d) {
              a.getStaCore().resetHeartbeat(), a.getKeepAlive().stop(), a.getPlaybackSession().addBufferingTime(c), a.getPlaybackSession().getAsset().addBufferingTime(c), a.getPlaybackSession().getAsset().addElapsedTime(c), a.getPlaybackSession().getAsset().isSeeking() && a.getPlaybackSession().getAsset().isCollectingSeekingTime() && (a.getPlaybackSession().getAsset().setSeekingTimeBeforeEnd(c - a.getPlaybackSession().getAsset().getSeekingTimestamp()), a.getPlaybackSession().getAsset().setCollectingSeekingTime(!1));var e = a.getStaCore().createLabels(j.END, d, c);a.getPlaybackSession().getAsset().updateDeltaLabels(e.eventLabels), a.getPlaybackSession().getAsset().updateIndependentLabels(e.eventLabels), a.getEventManager().newEvent(e), a.getPlaybackSession().getAsset().resetAssetLifecycleLabels(), a.getPlaybackSession().getAsset().setPlaybackStarted(!1), d.hasOwnProperty("ns_st_pe") && b.parseBoolean(d.ns_st_pe, !1) && a.getStaCore().resetPlaybackSession();
            }, onBufferStop: function onBufferStop(b, c) {
              var d = parseInt(c.ns_st_po);a.getPlaybackSession().addBufferingTime(b), a.getPlaybackSession().getAsset().addBufferingTime(b), a.getPlaybackSession().setPlaybackTimestamp(b), a.getPlaybackSession().getAsset().setPlaybackTimestamp(b), a.getPlaybackSession().getAsset().addElapsedTime(b), a.getPlaybackSession().getAsset().setElapsedTimestamp(b), a.getPlaybackSession().getAsset().setPlaybackStartPosition(d), a.getHeartbeat().resume(), a.getKeepAlive().start();var e = a.getStaCore().createLabels(j.PLAY, c, b);a.getPlaybackSession().getAsset().updateDeltaLabels(e.eventLabels), a.getPlaybackSession().getAsset().updateIndependentLabels(e.eventLabels), a.getEventManager().newEvent(e);
            }, onSeekStart: function onSeekStart(b, c) {
              var d = parseInt(c.ns_st_po);a.getPlaybackSession().addBufferingTime(b), a.getPlaybackSession().getAsset().addBufferingTime(b), a.getPlaybackSession().getAsset().isSeeking() ? a.getPlaybackSession().getAsset().isCollectingSeekingTime() || (a.getPlaybackSession().getAsset().setSeekingTimestamp(b), a.getPlaybackSession().getAsset().setCollectingSeekingTime(!0)) : a.getPlaybackSession().getAsset().incrementSeeks(), a.getPlaybackSession().getAsset().isSeeking() || (a.getPlaybackSession().getAsset().setSeeking(!0), a.getPlaybackSession().getAsset().setCollectingSeekingTime(!0), a.getPlaybackSession().getAsset().setSeekStartPosition(d), a.getPlaybackSession().getAsset().setSeekingTimestamp(b));
            }, onPause: function onPause(b, c) {
              a.getPlaybackSession().addBufferingTime(b), a.getPlaybackSession().getAsset().addBufferingTime(b);
            }, onPlay: function onPlay(b, c) {
              var d = parseInt(c.ns_st_po);a.getPlaybackSession().incrementPlaySequenceCounter(), a.getPlaybackSession().getAsset().incrementPlaySequenceCounter(), a.getPlaybackSession().addBufferingTime(b), a.getPlaybackSession().getAsset().addBufferingTime(b), a.getPlaybackSession().getAsset().incrementPlayCounter(), a.getPlaybackSession().setPlaybackTimestamp(b), a.getPlaybackSession().getAsset().setPlaybackTimestamp(b), a.getPlaybackSession().getAsset().addElapsedTime(b), a.getPlaybackSession().getAsset().setElapsedTimestamp(b), a.getPlaybackSession().getAsset().setPlaybackStartPosition(d), a.getHeartbeat().resume(), a.getKeepAlive().start();var e = a.getStaCore().createLabels(j.PLAY, c, b);a.getPlaybackSession().getAsset().updateDeltaLabels(e.eventLabels), a.getPlaybackSession().getAsset().updateIndependentLabels(e.eventLabels), a.getEventManager().newEvent(e);
            } });
        };
      }(),
          B = function () {
        return function (a) {
          var c = this;b.extend(c, { onEndOrAdSkip: function onEndOrAdSkip(c, d) {
              a.getPlaybackSession().getAsset().isSeeking() && a.getPlaybackSession().getAsset().isCollectingSeekingTime() && (a.getPlaybackSession().getAsset().setSeekingTimeBeforeEnd(c - a.getPlaybackSession().getAsset().getSeekingTimestamp()), a.getPlaybackSession().getAsset().setCollectingSeekingTime(!1)), a.getPlaybackSession().storeAssetPlaybackCounters(), a.getPlaybackSession().getAsset().resetAssetLifecycleLabels(), a.getPlaybackSession().getAsset().setPlaybackStarted(!1), d.hasOwnProperty("ns_st_pe") && b.parseBoolean(d.ns_st_pe, !1) && a.getStaCore().resetPlaybackSession();
            }, onSeekStart: function onSeekStart(b, c) {
              var d = parseInt(c.ns_st_po);a.getPlaybackSession().getAsset().isSeeking() ? a.getPlaybackSession().getAsset().setSeekingTimestamp(b) : a.getPlaybackSession().getAsset().incrementSeeks(), a.getPlaybackSession().getAsset().isSeeking() || (a.getPlaybackSession().getAsset().setSeeking(!0), a.getPlaybackSession().getAsset().setCollectingSeekingTime(!0), a.getPlaybackSession().getAsset().setSeekStartPosition(d), a.getPlaybackSession().getAsset().setSeekingTimestamp(b));
            }, onPlay: function onPlay(b, c) {
              var d = parseInt(c.ns_st_po);a.getPlaybackSession().getAsset().isSeeking() && (a.getPlaybackSession().getAsset().addSeekingAmount(d), a.getPlaybackSession().getAsset().setSeeking(!1)), a.getPlaybackSession().setPlaybackSessionStarted(!0), (a.getPlaybackSession().getAsset().isPlaybackSessionLooping() || 0 == a.getPlaybackSession().getPlaybackCounter()) && (a.getPlaybackSession().incrementPlaybackCounter(), a.getPlaybackSession().getAsset().setPlaybackSessionLooping(!1)), a.getPlaybackSession().incrementPlaySequenceCounter(), a.getPlaybackSession().getAsset().setPlaybackStarted(!0), a.getPlaybackSession().getAsset().incrementSegmentPlaybackCounter(), (0 == a.getPlaybackSession().getAsset().getLowestPartNumberPlayed() || a.getPlaybackSession().getAsset().getPartNumber() <= a.getPlaybackSession().getAsset().getLowestPartNumberPlayed()) && (a.getPlaybackSession().getAsset().setLowestPartNumberPlayed(a.getPlaybackSession().getAsset().getPartNumber()), a.getPlaybackSession().getAsset().incrementAssetPlaybackCounter(), a.getPlaybackSession().getAsset().setPlaySequenceCounter(0), a.getPlaybackSession().getAsset().resetAssetPlaybackIntervals()), a.getPlaybackSession().getAsset().incrementPlaySequenceCounter(), a.getPlaybackSession().getAsset().incrementPlayCounter(), a.getPlaybackSession().setPlaybackTimestamp(b), a.getPlaybackSession().getAsset().setPlaybackTimestamp(b), a.getPlaybackSession().getAsset().setElapsedTimestamp(b), a.getPlaybackSession().getAsset().setPlaybackStartPosition(d), a.getStaCore().isLoadingTimeSent() || (c.ns_st_lt = a.getStaCore().getLoadTimeOffset() + b - a.getStaCore().getInitTimestamp() + "", a.getStaCore().setLoadingTimeSent(!0)), a.getHeartbeat().resume(), a.getKeepAlive().start();var e = a.getStaCore().createLabels(j.PLAY, c, b);a.getPlaybackSession().getAsset().updateDeltaLabels(e.eventLabels), a.getPlaybackSession().getAsset().updateIndependentLabels(e.eventLabels), a.getEventManager().newEvent(e);
            } });
        };
      }(),
          C = function () {
        return function (a) {
          var c = this;b.extend(c, { onEndOrAdSkip: function onEndOrAdSkip(c, d) {
              var e = parseInt(d.ns_st_po);a.getStaCore().resetHeartbeat(), a.getKeepAlive().stop(), a.getPlaybackSession().addPlaybackTime(c), a.getPlaybackSession().getAsset().addPlaybackTime(c), a.getPlaybackSession().getAsset().addElapsedTime(c), a.getPlaybackSession().getAsset().addInterval(e);var f = a.getStaCore().createLabels(j.END, d, c);a.getPlaybackSession().getAsset().updateDeltaLabels(f.eventLabels), a.getPlaybackSession().getAsset().updateIndependentLabels(f.eventLabels), a.getEventManager().newEvent(f), a.getPlaybackSession().getAsset().resetAssetLifecycleLabels(), a.getPlaybackSession().getAsset().setPlaybackStarted(!1), d.hasOwnProperty("ns_st_pe") && b.parseBoolean(d.ns_st_pe, !1) && a.getStaCore().resetPlaybackSession();
            }, onBuffer: function onBuffer(b, c) {
              var d = parseInt(c.ns_st_po);a.getHeartbeat().pause(), a.getKeepAlive().stop(), a.getPlaybackSession().addPlaybackTime(b), a.getPlaybackSession().getAsset().addPlaybackTime(b), a.getPlaybackSession().getAsset().addInterval(d), a.getStaCore().isPauseOnBufferingEnabled() && a.getStaCore().startPausedOnBufferingTimer(b, c), a.getPlaybackSession().getAsset().incrementBufferCount(), a.getPlaybackSession().setBufferingTimestamp(b), a.getPlaybackSession().getAsset().setBufferingTimestamp(b);
            }, onSeekStart: function onSeekStart(b, c) {
              var d = parseInt(c.ns_st_po);a.getHeartbeat().pause(), a.getKeepAlive().stop(), a.getPlaybackSession().addPlaybackTime(b), a.getPlaybackSession().getAsset().addPlaybackTime(b), a.getPlaybackSession().getAsset().addInterval(d), a.getPlaybackSession().getAsset().incrementSeeks(), a.getPlaybackSession().getAsset().setSeeking(!0), a.getPlaybackSession().getAsset().setCollectingSeekingTime(!0), a.getPlaybackSession().getAsset().setSeekStartPosition(d), a.getPlaybackSession().getAsset().setSeekingTimestamp(b), a.getPlaybackSession().getAsset().addElapsedTime(b), a.getPlaybackSession().getAsset().setElapsedTimestamp(b), a.getPlaybackSession().incrementPauses(), a.getPlaybackSession().getAsset().incrementPauses();var e = a.getStaCore().createLabels(j.PAUSE, c, b);a.getPlaybackSession().getAsset().updateDeltaLabels(e.eventLabels), a.getPlaybackSession().getAsset().updateIndependentLabels(e.eventLabels), a.getEventManager().newEvent(e);
            }, onPause: function onPause(b, c) {
              var d = parseInt(c.ns_st_po);a.getHeartbeat().pause(), a.getKeepAlive().stop(), a.getPlaybackSession().addPlaybackTime(b), a.getPlaybackSession().getAsset().addPlaybackTime(b), a.getPlaybackSession().getAsset().addInterval(d), a.getPlaybackSession().getAsset().addElapsedTime(b), a.getPlaybackSession().getAsset().setElapsedTimestamp(b), a.getPlaybackSession().incrementPauses(), a.getPlaybackSession().getAsset().incrementPauses();var e = a.getStaCore().createLabels(j.PAUSE, c, b);a.getPlaybackSession().getAsset().updateDeltaLabels(e.eventLabels), a.getPlaybackSession().getAsset().updateIndependentLabels(e.eventLabels), a.getEventManager().newEvent(e);
            } });
        };
      }(),
          D = function () {
        return function (a) {
          var c = this;b.extend(c, { onEndOrAdSkip: function onEndOrAdSkip(c, d) {
              a.getPlaybackSession().getAsset().isSeeking() && a.getPlaybackSession().getAsset().isCollectingSeekingTime() && (a.getPlaybackSession().getAsset().setSeekingTimeBeforeEnd(c - a.getPlaybackSession().getAsset().getSeekingTimestamp()), a.getPlaybackSession().getAsset().setCollectingSeekingTime(!1)), a.getPlaybackSession().storeAssetPlaybackCounters(), a.getPlaybackSession().getAsset().resetAssetLifecycleLabels(), a.getPlaybackSession().getAsset().setPlaybackStarted(!1), d.hasOwnProperty("ns_st_pe") && b.parseBoolean(d.ns_st_pe, !1) && a.getStaCore().resetPlaybackSession();
            }, onPause: function onPause(b, c) {
              a.getPlaybackSession().getAsset().isSeeking() && a.getPlaybackSession().getAsset().isCollectingSeekingTime() && (a.getPlaybackSession().getAsset().addSeekingTime(b), a.getPlaybackSession().getAsset().setCollectingSeekingTime(!1));
            }, onPlay: function onPlay(b, c) {
              var d = parseInt(c.ns_st_po);a.getPlaybackSession().getAsset().isSeeking() && (a.getPlaybackSession().getAsset().isCollectingSeekingTime() && (a.getPlaybackSession().getAsset().addSeekingTime(b), a.getPlaybackSession().getAsset().setCollectingSeekingTime(!1)), a.getPlaybackSession().getAsset().addSeekingAmount(d), a.getPlaybackSession().getAsset().setSeeking(!1)), (a.getPlaybackSession().getAsset().isPlaybackSessionLooping() || 0 == a.getPlaybackSession().getPlaybackCounter()) && (a.getPlaybackSession().incrementPlaybackCounter(), a.getPlaybackSession().getAsset().setPlaybackSessionLooping(!1)), a.getPlaybackSession().incrementPlaySequenceCounter(), a.getPlaybackSession().getAsset().incrementPlaySequenceCounter(), a.getPlaybackSession().getAsset().incrementPlayCounter(), a.getPlaybackSession().getAsset().setPlaybackStarted(!0), a.getPlaybackSession().getAsset().incrementSegmentPlaybackCounter(), (0 == a.getPlaybackSession().getAsset().getLowestPartNumberPlayed() || a.getPlaybackSession().getAsset().getPartNumber() <= a.getPlaybackSession().getAsset().getLowestPartNumberPlayed()) && (a.getPlaybackSession().getAsset().setLowestPartNumberPlayed(a.getPlaybackSession().getAsset().getPartNumber()), a.getPlaybackSession().getAsset().incrementAssetPlaybackCounter(), a.getPlaybackSession().getAsset().setPlaySequenceCounter(0), a.getPlaybackSession().getAsset().resetAssetPlaybackIntervals()), a.getPlaybackSession().setPlaybackTimestamp(b), a.getPlaybackSession().getAsset().setPlaybackTimestamp(b), a.getPlaybackSession().getAsset().setElapsedTimestamp(b), a.getPlaybackSession().getAsset().setPlaybackStartPosition(d), a.getStaCore().isLoadingTimeSent() || (c.ns_st_lt = a.getStaCore().getLoadTimeOffset() + b - a.getStaCore().getInitTimestamp() + "", a.getStaCore().setLoadingTimeSent(!0)), a.getHeartbeat().resume(), a.getKeepAlive().start();var e = a.getStaCore().createLabels(j.PLAY, c, b);a.getPlaybackSession().getAsset().updateDeltaLabels(e.eventLabels), a.getPlaybackSession().getAsset().updateIndependentLabels(e.eventLabels), a.getEventManager().newEvent(e);
            } });
        };
      }(),
          E = function () {
        return function (a) {
          var c = this;b.extend(c, { onPause: function onPause(b, c) {
              a.getPlaybackSession().incrementPauses(), a.getPlaybackSession().getAsset().incrementPauses(), a.getPlaybackSession().getAsset().isSeeking() && a.getPlaybackSession().getAsset().isCollectingSeekingTime() && (a.getPlaybackSession().getAsset().addSeekingTime(b), a.getPlaybackSession().getAsset().setCollectingSeekingTime(!1));
            } });
        };
      }(),
          F = function () {
        return function (a) {
          var c = this;b.extend(c, { onEndOrAdSkip: function onEndOrAdSkip(c, d) {
              parseInt(d.ns_st_po);a.getStaCore().resetHeartbeat(), a.getKeepAlive().stop(), a.getPlaybackSession().getAsset().addElapsedTime(c);var e = a.getStaCore().createLabels(j.END, d, c);a.getPlaybackSession().getAsset().updateDeltaLabels(e.eventLabels), a.getPlaybackSession().getAsset().updateIndependentLabels(e.eventLabels), a.getEventManager().newEvent(e), a.getPlaybackSession().getAsset().isSeeking() && a.getPlaybackSession().getAsset().isCollectingSeekingTime() && (a.getPlaybackSession().getAsset().setSeekingTimeBeforeEnd(c - a.getPlaybackSession().getAsset().getSeekingTimestamp()), a.getPlaybackSession().getAsset().setCollectingSeekingTime(!1)), a.getPlaybackSession().storeAssetPlaybackCounters(), a.getPlaybackSession().getAsset().resetAssetLifecycleLabels(), a.getPlaybackSession().getAsset().setPlaybackStarted(!1), d.hasOwnProperty("ns_st_pe") && b.parseBoolean(d.ns_st_pe, !1) && a.getStaCore().resetPlaybackSession();
            }, onPlay: function onPlay(b, c) {
              var d = parseInt(c.ns_st_po);a.getPlaybackSession().incrementPlaySequenceCounter(), a.getPlaybackSession().getAsset().incrementPlaySequenceCounter(), a.getPlaybackSession().getAsset().incrementPlayCounter(), a.getPlaybackSession().getAsset().isSeeking() && (a.getPlaybackSession().getAsset().isCollectingSeekingTime() && (a.getPlaybackSession().getAsset().addSeekingTime(b), a.getPlaybackSession().getAsset().setCollectingSeekingTime(!1)), a.getPlaybackSession().getAsset().addSeekingAmount(d), a.getPlaybackSession().getAsset().setSeeking(!1)), a.getPlaybackSession().getAsset().addElapsedTime(b), a.getPlaybackSession().getAsset().setElapsedTimestamp(b), a.getPlaybackSession().setPlaybackTimestamp(b), a.getPlaybackSession().getAsset().setPlaybackTimestamp(b), a.getPlaybackSession().getAsset().setPlaybackStartPosition(d), a.getStaCore().isLoadingTimeSent() || (c.ns_st_lt = a.getStaCore().getLoadTimeOffset() + b - a.getStaCore().getInitTimestamp() + "", a.getStaCore().setLoadingTimeSent(!0)), a.getHeartbeat().resume(), a.getKeepAlive().start();var e = a.getStaCore().createLabels(j.PLAY, c, b);a.getPlaybackSession().getAsset().updateDeltaLabels(e.eventLabels), a.getPlaybackSession().getAsset().updateIndependentLabels(e.eventLabels), a.getEventManager().newEvent(e);
            } });
        };
      }(),
          G = function () {
        return function (a) {
          function d() {
            if (n = new H(ba), b.getNamespace().comScore ? (ca = b.getNamespace().comScore.exports, n.setAppCore(ca.c())) : n.setAppCore(null), a.publisherId) {
              ba.setLabel("c2", a.publisherId);var d = a.secure;!d && n.getAppCore() ? d = n.getAppCore().isSecure() : !d && b.isBrowser() && (d = b.isWebSecure());var e = (d ? "https://sb" : "http://b") + ".scorecardresearch.com/p?c1=2";ba.setLiveEndpointURL(e);
            }a.liveEndpointURL && ba.setLiveEndpointURL(a.liveEndpointURL), n.setKeepAlive(new r(n)), n.setHeartbeat(new q(n)), n.setEventManager(new p(n)), n.setStateMachine(new s()), n.setLogging(new c(m.LOG_NAMESPACE, a.debug)), n.setPlaybackSession(new o(n)), G = new y(n), I = new z(n), J = new B(n), K = new C(n), L = new u(n), M = new w(n), N = new x(n), O = new v(n), P = new A(n), Q = new D(n), R = new E(n), S = new F(n), T = new t(n), U = !1, V = 0, W = +new Date(), X = !0, Z = !1, _ = [];
          }function e(a) {
            var b = n.getStateMachine().getCurrentState();if (b == k.IDLE || b == k.PLAYBACK_NOT_STARTED || b == k.BUFFERING_BEFORE_PLAYBACK || b == k.SEEKING_BEFORE_PLAYBACK) {
              if (a == j.PLAY) return !0;
            } else if (b == k.PLAYING) {
              if (a == j.END || a == j.AD_SKIP || a == j.SEEK_START || a == j.PAUSE) return !0;
            } else if (b == k.PAUSED || b == k.BUFFERING_DURING_PAUSE || b == k.SEEKING_DURING_PLAYBACK || b == k.SEEKING_DURING_BUFFERING || b == k.SEEKING_DURING_PAUSE) {
              if (a == j.END || a == j.AD_SKIP || a == j.PLAY) return !0;
            } else if (b == k.BUFFERING_DURING_PLAYBACK) {
              if (a == j.PAUSE_ON_BUFFERING || a == j.END || a == j.AD_SKIP || a == j.SEEK_START || a == j.PAUSE || a == j.PLAY) return !0;
            } else if (b == k.BUFFERING_DURING_SEEKING) {
              if (a == j.END || a == j.AD_SKIP || a == j.PAUSE || a == j.PLAY) return !0;
            } else if (b == k.PAUSED_DURING_BUFFERING && (a == j.END || a == j.AD_SKIP || a == j.BUFFER_STOP || a == j.PLAY)) return !0;return !1;
          }function f(a, b, c) {
            var d = n.getStateMachine().getCurrentState();a == j.AD_SKIP && !c.hasOwnProperty("ns_st_ui") && e(a) ? c.ns_st_ui = "skip" : a == j.SEEK_START && !c.hasOwnProperty("ns_st_ui") && e(a) && (c.ns_st_ui = "seek"), d == k.IDLE ? a == j.BUFFER ? G.onBuffer(b, c) : a == j.SEEK_START ? G.onSeekStart(b, c) : a == j.PLAY && G.onPlay(b, c) : d == k.PLAYBACK_NOT_STARTED ? a == j.END || a == j.AD_SKIP ? J.onEndOrAdSkip(b, c) : a == j.SEEK_START ? J.onSeekStart(b, c) : a == j.PLAY ? J.onPlay(b, c) : a == j.BUFFER && T.onBufferWhenSeekingOrPlayBackNotStartedOrPaused(b, c) : d == k.PLAYING ? a == j.END || a == j.AD_SKIP ? K.onEndOrAdSkip(b, c) : a == j.BUFFER ? K.onBuffer(b, c) : a == j.SEEK_START ? K.onSeekStart(b, c) : a == j.PAUSE && K.onPause(b, c) : d == k.PAUSED ? a == j.END || a == j.AD_SKIP ? I.onEndOrAdSkip(b, c) : a == j.PLAY ? I.onPlay(b, c) : a == j.BUFFER ? T.onBufferWhenSeekingOrPlayBackNotStartedOrPaused(b, c) : a == j.SEEK_START && T.onSeekStartWhenPausedOrBufferingDuringPause(b, c) : d == k.BUFFERING_BEFORE_PLAYBACK ? a == j.END || a == j.AD_SKIP ? L.onEndOrAdSkip(b, c) : a == j.BUFFER_STOP ? L.onBufferStop(b, c) : a == j.SEEK_START ? L.onSeekStart(b, c) : a == j.PAUSE ? L.onPause(b, c) : a == j.PLAY && L.onPlay(b, c) : d == k.BUFFERING_DURING_PLAYBACK ? a == j.PAUSE_ON_BUFFERING ? M.onPauseOnBuffering(b, c) : a == j.BUFFER_STOP ? M.onBufferStop(b, c) : a == j.END || a == j.AD_SKIP ? M.onEndOrAdSkip(b, c) : a == j.SEEK_START ? M.onSeekStart(b, c) : a == j.PAUSE ? M.onPause(b, c) : a == j.PLAY && M.onPlay(b, c) : d == k.BUFFERING_DURING_SEEKING ? a == j.END || a == j.AD_SKIP ? N.onEndOrAdSkip(b, c) : a == j.PAUSE ? N.onPause(b, c) : a == j.PLAY ? N.onPlay(b, c) : a == j.BUFFER_STOP && T.onBufferStopWhenBufferingDuringSeekingOrBufferingDuringPause(b, c) : d == k.BUFFERING_DURING_PAUSE ? a == j.END || a == j.AD_SKIP ? O.onEndAndSkip(b, c) : a == j.PAUSE ? O.onPause(b, c) : a == j.PLAY ? O.onPlay(b, c) : a == j.SEEK_START ? T.onSeekStartWhenPausedOrBufferingDuringPause(b, c) : a == j.BUFFER_STOP && T.onBufferStopWhenBufferingDuringSeekingOrBufferingDuringPause(b, c) : d == k.SEEKING_BEFORE_PLAYBACK ? a == j.END || a == j.AD_SKIP ? Q.onEndOrAdSkip(b, c) : a == j.PAUSE ? Q.onPause(b, c) : a == j.PLAY ? Q.onPlay(b, c) : a == j.BUFFER && T.onBufferWhenSeekingOrPlayBackNotStartedOrPaused(b, c) : d == k.SEEKING_DURING_PLAYBACK ? a == j.END || a == j.AD_SKIP ? S.onEndOrAdSkip(b, c) : a == j.PLAY ? S.onPlay(b, c) : a == j.BUFFER ? T.onBufferWhenSeekingOrPlayBackNotStartedOrPaused(b, c) : a == j.PAUSE && T.onPauseWhenSeekingDuringPlaybackOrSeekingDuringPause(b, c) : d == k.SEEKING_DURING_BUFFERING ? a == j.PAUSE ? R.onPause(b, c) : a == j.BUFFER ? T.onBufferWhenSeekingOrPlayBackNotStartedOrPaused(b, c) : a == j.PLAY ? T.onPlayWhenSeekingDuringBufferingOrSeekingDuringPause(b, c) : a == j.END || a == j.AD_SKIP ? T.onEndOrAdSkipWhenSeekingDuringBufferingOrSeekingDuringPause(b, c) : a == j.BUFFER_STOP && T.onBufferStopWhenSeekingDuringBufferingOrSeekingDuringPause(b, c) : d == k.PAUSED_DURING_BUFFERING ? a == j.END || a == j.AD_SKIP ? P.onEndOrAdSkip(b, c) : a == j.BUFFER_STOP ? P.onBufferStop(b, c) : a == j.SEEK_START ? P.onSeekStart(b, c) : a == j.PAUSE ? P.onPause(b, c) : a == j.PLAY && P.onPlay(b, c) : d == k.SEEKING_DURING_PAUSE && (a == j.BUFFER ? T.onBufferWhenSeekingOrPlayBackNotStartedOrPaused(b, c) : a == j.PLAY ? T.onPlayWhenSeekingDuringBufferingOrSeekingDuringPause(b, c) : a == j.PAUSE ? T.onPauseWhenSeekingDuringPlaybackOrSeekingDuringPause(b, c) : a == j.END || a == j.AD_SKIP ? T.onEndOrAdSkipWhenSeekingDuringBufferingOrSeekingDuringPause(b, c) : a == j.BUFFER_STOP && T.onBufferStopWhenSeekingDuringBufferingOrSeekingDuringPause(b, c)), e(a) && n.getPlaybackSession().setFirstEventSent(!0);
          }function g(a, c) {
            for (var d, e = ga.encodeURIComponent || escape, f = [], g = m.LABELS_ORDER, h = a.split("?"), i = h[0], j = h[1], k = j.split("&"), l = 0, n = k.length; l < n; l++) {
              var o = k[l].split("="),
                  p = unescape(o[0]),
                  q = unescape(o[1]);p && (c[p] = q);
            }for (var r = {}, s = 0, t = g.length; s < t; s++) {
              var u = g[s];if (c.hasOwnProperty(u)) {
                var v = c[u];"undefined" != typeof v && null != v && (r[u] = !0, f.push(e(u) + "=" + e(c[u])));
              }
            }for (var w in c) {
              if (c.hasOwnProperty(w)) {
                if (r[w]) continue;var x = c[w];"undefined" != typeof x && null != x && f.push(e(w) + "=" + e(c[w]));
              }
            }d = i + "?" + f.join("&"), d = d + (d.indexOf("&c8=") < 0 ? "&c8=" + e(ha.title) : "") + (d.indexOf("&c7=") < 0 ? "&c7=" + e(ha.URL) : "") + (d.indexOf("&c9=") < 0 ? "&c9=" + e(ha.referrer) : "");var y = b.browserAcceptsLargeURLs() ? m.URL_LENGTH_LIMIT : m.RESTRICTED_URL_LENGTH_LIMIT;if (d.length > y && d.indexOf("&") > 0) {
              var z = d.substr(0, y - 8).lastIndexOf("&");d = (d.substring(0, z) + "&ns_cut=" + e(d.substring(z + 1))).substr(0, y);
            }return d;
          }var n,
              G,
              I,
              J,
              K,
              L,
              M,
              N,
              O,
              P,
              Q,
              R,
              S,
              T,
              U,
              V,
              W,
              X,
              Y,
              Z,
              $,
              _,
              aa,
              ba = this,
              ca = {},
              da = m.DEFAULT_PAUSED_ON_BUFFERING_INTERVAL,
              ea = m.THROTTLING_DELAY,
              fa = {};b.extend(ba, { getConfiguration: function getConfiguration() {
              return a || {};
            }, createLabels: function createLabels(a, c, d) {
              var e = {};if ("undefined" != typeof document) {
                var f = document;e.c7 = f.URL, e.c8 = f.title, e.c9 = f.referrer;
              }return e.ns_ts = +new Date() + "", e.ns_st_ev = j.toString(a), e.ns_st_mp = m.DEFAULT_PLAYERNAME, e.ns_st_mv = m.STREAMINGANALYTICS_VERSION, e.ns_st_ub = "0", e.ns_st_br = "0", e.ns_st_pn = "1", e.ns_st_tp = "0", e.ns_st_it = l.toString(l.SINGLE_CLIP), e.ns_st_sv = m.STREAMINGANALYTICS_VERSION, e.ns_st_smv = m.MODEL_VERSION, e.ns_type = "hidden", e.ns_st_ec = n.getEventManager().getEventCounter() + "", e.ns_st_po = n.getPlaybackSession().getAsset().getExpectedPlaybackPosition(d) + "", e.ns_st_ki = n.getKeepAlive().getInterval() + "", b.extend(e, ba.getLabels()), n.getPlaybackSession().createLabels(e, d), n.getPlaybackSession().getAsset().createLabels(e, d), b.extend(e, c), { eventType: a, eventLabels: e };
            }, newEvent: function newEvent(a, c, d, e) {
              ba.stopDelayedTransitionTimer();var g = n.getStateMachine().getCurrentState(),
                  h = n.getStateMachine().eventTypeToState(a);if (null == h || h == g) return void n.getLogging().infoLog("Ignored event:", j.toString(a), "during state", b.stateToString(g), d);if (!ba.isThrottlingEnabled() || g != k.PLAYING && g != k.PAUSED || h != k.PLAYING && h != k.PAUSED || e) {
                d.ns_st_po || (n.getStateMachine().getCurrentState() == k.IDLE ? d.ns_st_po = "0" : d.ns_st_po = n.getPlaybackSession().getAsset().getExpectedPlaybackPosition(c) + ""), n.getPlaybackSession().getAsset().setPlaybackTimeOffset(parseInt(d.ns_st_po)), f(a, c, d);var i = 0;isNaN(n.getStateMachine().getLastStateChangeTimestamp()) || (i = c - n.getStateMachine().getLastStateChangeTimestamp()), n.getStateMachine().newEvent(a, c), n.getLogging().log("Transition from", b.stateToString(g), "to", b.stateToString(h), "due to event:", j.toString(a));for (var l = 0, m = _.length; l < m; l++) {
                  _[l](g, h, d, i);
                }
              } else {
                n.getLogging().infoLog("Throttled event:", j.toString(a), "during state", b.stateToString(g), d, ba.getThrottlingDelay(), "ms");var o = function (a, b, d) {
                  return function () {
                    ba.newEvent(a, c, d, !0);
                  };
                }(a, h, d);$ = n.getPlatformAPI().setTimeout(o, ba.getThrottlingDelay());
              }
            }, newPseudoEvent: function newPseudoEvent(a, c, d) {
              if ((a == j.LOAD || a == j.ENGAGE) && n.getStateMachine().getCurrentState() != k.IDLE) return void n.getLogging().infoLog("Ignored pseudo-event:", j.toString(a), "during state", b.stateToString(n.getStateMachine().getCurrentState()), d);a == j.ERROR && null == d.ns_st_er && (d.ns_st_er = i.UNKNOWN_VALUE), a == j.TRANSFER && null == d.ns_st_rp && (d.ns_st_rp = i.UNKNOWN_VALUE), n.getStateMachine().getCurrentState() != k.IDLE && n.getStateMachine().getCurrentState() != k.PLAYBACK_NOT_STARTED && n.getStateMachine().getCurrentState() != k.SEEKING_BEFORE_PLAYBACK && n.getStateMachine().getCurrentState() != k.BUFFERING_BEFORE_PLAYBACK && (n.getPlaybackSession().getAsset().addElapsedTime(c), n.getPlaybackSession().getAsset().setElapsedTimestamp(c));var e,
                  f,
                  g,
                  h = !0,
                  l = !1;switch (a) {case j.BIT_RATE:
                  e = "ns_st_br", f = "ns_st_pbr", l = !0;break;case j.PLAYBACK_RATE:
                  e = "ns_st_rt", f = "ns_st_prt", l = !0;break;case j.VOLUME:
                  e = "ns_st_vo", f = "ns_st_pvo", l = !0;break;case j.WINDOW_STATE:
                  e = "ns_st_ws", f = "ns_st_pws", l = !0;break;case j.AUDIO:
                  e = "ns_st_at", f = "ns_st_pat", l = !1;break;case j.VIDEO:
                  e = "ns_st_vt", f = "ns_st_pvt", l = !1;break;case j.SUBS:
                  e = "ns_st_tt", f = "ns_st_ptt", l = !1;break;case j.CDN:
                  e = "ns_st_cdn", f = "ns_st_pcdn", l = !1;break;default:
                  h = !1;}if (h && d.hasOwnProperty(e) && (l ? (ba.getLabels().hasOwnProperty(e) && (g = ba.getLabels()[e], d[f] = g), ba.setLabel(e, d[e])) : (n.getPlaybackSession().getAsset().hasInternalLabel(e) && (g = n.getPlaybackSession().getAsset().getInternalLabel(e), d[f] = g), n.getPlaybackSession().getAsset().setInternalLabel(e, d[e]))), h && n.getStateMachine().getCurrentState() != k.PLAYING && n.getStateMachine().getCurrentState() != k.BUFFERING_DURING_PLAYBACK) return void n.getLogging().infoLog("No measurement send for the pseudo-event:", j.toString(a), "during state", b.stateToString(n.getStateMachine().getCurrentState()), d);d.ns_st_po || (d.ns_st_po = n.getPlaybackSession().getAsset().getExpectedPlaybackPosition(c) + ""), n.getPlaybackSession().getAsset().setPlaybackTimeOffset(parseInt(d.ns_st_po)), n.getStateMachine().getCurrentState() != k.PLAYING && n.getStateMachine().getCurrentState() != k.BUFFERING_DURING_PLAYBACK || (n.getPlaybackSession().addPlaybackTime(c), n.getPlaybackSession().setPlaybackTimestamp(c), n.getPlaybackSession().getAsset().addPlaybackTime(c), n.getPlaybackSession().getAsset().setPlaybackTimestamp(c), n.getPlaybackSession().getAsset().addInterval(parseInt(d.ns_st_po)), n.getPlaybackSession().getAsset().setPlaybackStartPosition(parseInt(d.ns_st_po))), n.getStateMachine().getCurrentState() != k.BUFFERING_BEFORE_PLAYBACK && n.getStateMachine().getCurrentState() != k.BUFFERING_DURING_PAUSE && n.getStateMachine().getCurrentState() != k.BUFFERING_DURING_PLAYBACK && n.getStateMachine().getCurrentState() != k.BUFFERING_DURING_SEEKING || (n.getPlaybackSession().addBufferingTime(c), n.getPlaybackSession().setBufferingTimestamp(c), n.getPlaybackSession().getAsset().addBufferingTime(c), n.getPlaybackSession().getAsset().setBufferingTimestamp(c));var m = ba.createLabels(a, d, c);n.getPlaybackSession().getAsset().updateDeltaLabels(m.eventLabels), n.getPlaybackSession().getAsset().updateIndependentLabels(m.eventLabels), n.getEventManager().newEvent(m);
            }, getState: function getState() {
              return n.getStateMachine().getCurrentState();
            }, addListener: function addListener(a) {
              _.push(a);
            }, removeListener: function removeListener(a) {
              _.splice(b.indexOf(a, _), 1);
            }, getLabel: function getLabel(a) {
              return fa[a];
            }, getLabels: function getLabels() {
              return fa;
            }, setLabel: function setLabel(a, b) {
              null == b ? delete fa[a] : fa[a] = b;
            }, setLabels: function setLabels(a) {
              for (var b in a) {
                a.hasOwnProperty(b) && ba.setLabel(b, a[b]);
              }
            }, getPlatformAPI: function getPlatformAPI() {
              return n.getAppCore() ? n.getAppCore().getPlatformAPI() : h;
            }, getExports: function getExports() {
              return ca;
            }, isProperlyInitialized: function isProperlyInitialized() {
              var a = n.getAppCore().getAppContext(),
                  b = n.getAppCore().getSalt(),
                  c = n.getAppCore().getPixelURL();return a && c && b;
            }, setThrottlingDelay: function setThrottlingDelay(a) {
              ea = a;
            }, getThrottlingDelay: function getThrottlingDelay() {
              return ea;
            }, isThrottlingEnabled: function isThrottlingEnabled() {
              return Z;
            }, setThrottlingEnabled: function setThrottlingEnabled(a) {
              Z = a;
            }, isLoadingTimeSent: function isLoadingTimeSent() {
              return U;
            }, setLoadingTimeSent: function setLoadingTimeSent(a) {
              U = a;
            }, getLoadTimeOffset: function getLoadTimeOffset() {
              return V;
            }, setLoadTimeOffset: function setLoadTimeOffset(a) {
              V = a;
            }, getInitTimestamp: function getInitTimestamp() {
              return W;
            }, setPauseOnBufferingInterval: function setPauseOnBufferingInterval(a) {
              da = a;
            }, getPauseOnBufferingInterval: function getPauseOnBufferingInterval() {
              return da;
            }, isPauseOnBufferingEnabled: function isPauseOnBufferingEnabled() {
              return X;
            }, setPauseOnBufferingEnabled: function setPauseOnBufferingEnabled(a) {
              X = a;
            }, startPausedOnBufferingTimer: function startPausedOnBufferingTimer(a, c) {
              ba.stopPausedOnBufferingTimer(), Y = ba.getPlatformAPI().setTimeout(function () {
                var a = {},
                    d = b.fixEventTime(a),
                    e = parseInt(c.ns_st_po);a.ns_st_po = e + "", ba.newEvent(j.PAUSE_ON_BUFFERING, d, a);
              }, da);
            }, stopPausedOnBufferingTimer: function stopPausedOnBufferingTimer() {
              null != Y && (ba.getPlatformAPI().clearTimeout(Y), Y = null);
            }, stopDelayedTransitionTimer: function stopDelayedTransitionTimer() {
              $ && (ba.getPlatformAPI().clearTimeout($), $ = null);
            }, setLiveEndpointURL: function setLiveEndpointURL(a) {
              if (null == a || 0 == a.length) return null;var b = decodeURIComponent || unescape,
                  c = a.indexOf("?");if (c >= 0) {
                if (c < a.length - 1) {
                  for (var d = a.substring(c + 1).split("&"), e = 0, f = d.length; e < f; e++) {
                    var g = d[e],
                        h = g.split("=");2 == h.length ? ba.setLabel(h[0], b(h[1])) : 1 == h.length && ba.setLabel(m.PAGE_NAME_LABEL, b(h[0]));
                  }a = a.substring(0, c + 1);
                }
              } else a += "?";return aa = a;
            }, getLiveEndpointURL: function getLiveEndpointURL() {
              return aa ? aa : "undefined" != typeof ns_p && "string" == typeof ns_p.src ? aa = ns_p.src.replace(/&amp;/, "&").replace(/&ns__t=\d+/, "") : "string" == typeof ns_pixelUrl ? aa = ns_pixelUrl.replace(/&amp;/, "&").replace(/&ns__t=\d+/, "") : null;
            }, getStaSM: function getStaSM() {
              return n;
            }, resetPlaybackSession: function resetPlaybackSession(a) {
              var b = n.getPlaybackSession();n.setPlaybackSession(new o(n)), o.resetPlaybackSession(n, b, a);
            }, resetHeartbeat: function resetHeartbeat() {
              n.getHeartbeat().pause();var a = n.getHeartbeat().getIntervals();n.setHeartbeat(new q(n)), n.getHeartbeat().setIntervals(a);
            } });var ga, ha;b.isBrowser() ? (ga = window, ha = document) : (ga = {}, ha = { location: { href: "" }, title: "", URL: "", referrer: "", cookie: "" }), b.extend(ba, { prepareUrl: g }), d();
        };
      }(),
          H = function () {
        return function (a) {
          var c,
              d,
              e,
              f,
              g,
              h,
              i,
              j = this;b.extend(j, { getAppCore: function getAppCore() {
              return c;
            }, getStaCore: function getStaCore() {
              return a;
            }, getEventManager: function getEventManager() {
              return d;
            }, getStateMachine: function getStateMachine() {
              return e;
            }, getHeartbeat: function getHeartbeat() {
              return f;
            }, getKeepAlive: function getKeepAlive() {
              return g;
            }, getPlaybackSession: function getPlaybackSession() {
              return h;
            }, getLogging: function getLogging() {
              return i;
            }, setAppCore: function setAppCore(a) {
              c = a;
            }, setKeepAlive: function setKeepAlive(a) {
              g = a;
            }, setHeartbeat: function setHeartbeat(a) {
              f = a;
            }, setEventManager: function setEventManager(a) {
              d = a;
            }, setStateMachine: function setStateMachine(a) {
              e = a;
            }, setPlaybackSession: function setPlaybackSession(a) {
              h = a;
            }, setLogging: function setLogging(a) {
              i = a;
            } });
        };
      }(),
          I = function () {
        return function (a) {
          function d() {
            a = b.extend({}, a), g = new G(a), g.getStaSM().getLogging().log("New StreamingAnalytics instance with configuration", a);
          }function e(a) {
            var c, d;if (c = "object" == (0, _typeof3.default)(arguments[1]) ? arguments[1] : "object" == (0, _typeof3.default)(arguments[2]) ? arguments[2] : {}, d = "number" == typeof arguments[1] ? arguments[1] : "number" == typeof arguments[2] ? arguments[2] : NaN, j.toString(a)) {
              c = b.jsonObjectToStringDictionary(c);var e = b.fixEventTime(c);c.ns_st_po || isNaN(d) || (c.ns_st_po = b.parseInteger(d, 0) + ""), a == j.PLAY || a == j.PAUSE || a == j.BUFFER || a == j.END || a == j.SEEK_START || a == j.AD_SKIP || a == j.BUFFER_STOP ? g.newEvent(a, e, c) : g.newPseudoEvent(a, e, c);
            }
          }function f() {
            i && g.getStaSM().getStateMachine().getCurrentState() != k.IDLE && h.notifyEnd();
          }var g,
              h = this,
              i = !0,
              n = arguments;b.extend(this, { isProperlyInitialized: function isProperlyInitialized() {
              return g.isProperlyInitialized();
            }, reset: function reset(a) {
              e(j.END);var b = g;b.getStaSM().getKeepAlive().stop(), b.getStaSM().getHeartbeat().pause(), g = new G(b.getConfiguration()), o.resetPlaybackSession(g.getStaSM(), b.getStaSM().getPlaybackSession(), a);
            }, setPauseOnBufferingInterval: function setPauseOnBufferingInterval(a) {
              g.setPauseOnBufferingInterval(a);
            }, getPauseOnBufferingInterval: function getPauseOnBufferingInterval() {
              return g.getPauseOnBufferingInterval();
            }, setKeepAliveInterval: function setKeepAliveInterval(a) {
              g.getStaSM().getKeepAlive().setInterval(a);
            }, getKeepAliveInterval: function getKeepAliveInterval() {
              return g.getStaSM().getKeepAlive().getInterval();
            }, setHeartbeatIntervals: function setHeartbeatIntervals(a) {
              g.getStaSM().getHeartbeat().setIntervals(a);
            }, notifyPlay: function notifyPlay(a, b) {
              g.getStaSM().getLogging().apiCall("notifyPlay", a, b), e(j.PLAY, a, b);
            }, notifyPause: function notifyPause(a, b) {
              g.getStaSM().getLogging().apiCall("notifyPause", a, b), e(j.PAUSE, a, b);
            }, notifyEnd: function notifyEnd(a, b) {
              g.getStaSM().getLogging().apiCall("notifyEnd", a, b), e(j.END, a, b);
            }, notifyBufferStart: function notifyBufferStart(a, b) {
              g.getStaSM().getLogging().apiCall("notifyBufferStart", a, b), e(j.BUFFER, a, b);
            }, notifyBufferStop: function notifyBufferStop(a, b) {
              g.getStaSM().getLogging().apiCall("notifyBufferStop", a, b), e(j.BUFFER_STOP, a, b);
            }, notifyLoad: function notifyLoad(a, b) {
              g.getStaSM().getLogging().apiCall("notifyLoad", a, b), e(j.LOAD, a, b);
            }, notifyEngage: function notifyEngage(a, b) {
              g.getStaSM().getLogging().apiCall("notifyEngage", a, b), e(j.ENGAGE, a, b);
            }, notifySeekStart: function notifySeekStart(a, b) {
              g.getStaSM().getLogging().apiCall("notifySeekStart", a, b), e(j.SEEK_START, a, b);
            }, notifySkipAd: function notifySkipAd(a, b) {
              g.getStaSM().getLogging().apiCall("notifySkipAd", a, b), e(j.AD_SKIP, a, b);
            }, notifyCallToAction: function notifyCallToAction(a, b) {
              g.getStaSM().getLogging().apiCall("notifyCallToAction", a, b), e(j.CTA, a, b);
            }, notifyError: function notifyError(a, b) {
              g.getStaSM().getLogging().apiCall("notifyError", a, b), e(j.ERROR, a, b);
            }, notifyTransferPlayback: function notifyTransferPlayback(a, b) {
              g.getStaSM().getLogging().apiCall("notifyTransferPlayback", a, b), e(j.TRANSFER, a, b);
            }, notifyDrmFail: function notifyDrmFail(a, b) {
              g.getStaSM().getLogging().apiCall("notifyDrmFail", a, b), e(j.DRM_FAILED, a, b);
            }, notifyDrmApprove: function notifyDrmApprove(a, b) {
              g.getStaSM().getLogging().apiCall("notifyDrmApprove", a, b), e(j.DRM_APPROVED, a, b);
            }, notifyDrmDeny: function notifyDrmDeny(a, b) {
              g.getStaSM().getLogging().apiCall("notifyDrmDeny", a, b), e(j.DRM_DENIED, a, b);
            }, notifyChangeBitrate: function notifyChangeBitrate(a, b, c) {
              if (g.getStaSM().getLogging().apiCall("notifyChangeBitrate", a, b, c), null != a) {
                var d = c || {};d.ns_st_br = a + "", e(j.BIT_RATE, d, b);
              }
            }, notifyChangePlaybackRate: function notifyChangePlaybackRate(a, b, c) {
              if (g.getStaSM().getLogging().apiCall("notifyChangePlaybackRate", a, b, c), null != a) {
                var d = c || {};d.ns_st_rt = a + "", e(j.PLAYBACK_RATE, d, b);
              }
            }, notifyChangeVolume: function notifyChangeVolume(a, b, c) {
              if (g.getStaSM().getLogging().apiCall("notifyChangeVolume", a, b, c), null != a) {
                var d = c || {};d.ns_st_vo = a + "", e(j.VOLUME, d, b);
              }
            }, notifyChangeWindowState: function notifyChangeWindowState(a, b, c) {
              if (g.getStaSM().getLogging().apiCall("notifyChangeWindowState", a, b, c), null != a) {
                var d = c || {};d.ns_st_ws = a + "", e(j.WINDOW_STATE, d, b);
              }
            }, notifyChangeAudioTrack: function notifyChangeAudioTrack(a, b, c) {
              if (g.getStaSM().getLogging().apiCall("notifyChangeAudioTrack", a, b, c), null != a) {
                var d = c || {};d.ns_st_at = a + "", e(j.AUDIO, d, b);
              }
            }, notifyChangeVideoTrack: function notifyChangeVideoTrack(a, b, c) {
              if (g.getStaSM().getLogging().apiCall("notifyChangeVideoTrack", a, b, c), null != a) {
                var d = c || {};d.ns_st_vt = a + "", e(j.VIDEO, d, b);
              }
            }, notifyChangeSubtitleTrack: function notifyChangeSubtitleTrack(a, b, c) {
              if (g.getStaSM().getLogging().apiCall("notifyChangeSubtitleTrack", a, b, c), null != a) {
                var d = c || {};d.ns_st_tt = a + "", e(j.SUBS, d, b);
              }
            }, notifyChangeCdn: function notifyChangeCdn(a, b, c) {
              if (g.getStaSM().getLogging().apiCall("notifyChangeCdn", a, b, c), null != a) {
                var d = c || {};d.ns_st_cdn = a + "", e(j.CDN, d, b);
              }
            }, notifyCustomEvent: function notifyCustomEvent(a, b) {
              g.getStaSM().getLogging().apiCall("notifyCustomEvent", a, b), h.notify(j.CUSTOM, a, b);
            }, getLabels: function getLabels() {
              return g.getLabels();
            }, getState: function getState() {
              return g.getStaSM().getStateMachine().getCurrentState();
            }, setLabels: function setLabels(a) {
              g.setLabels(a);
            }, getLabel: function getLabel(a) {
              return g.getLabel(a);
            }, setLabel: function setLabel(a, b) {
              g.setLabel(a, b);
            }, getLoadTimeOffset: function getLoadTimeOffset() {
              return g.getLoadTimeOffset();
            }, setLoadTimeOffset: function setLoadTimeOffset(a) {
              g.setLoadTimeOffset(a);
            }, setLiveEndpointURL: function setLiveEndpointURL(a) {
              return g.setLiveEndpointURL(a);
            }, getLiveEndpointURL: function getLiveEndpointURL() {
              return g.getLiveEndpointURL();
            }, isPauseOnBufferingEnabled: function isPauseOnBufferingEnabled() {
              return g.isPauseOnBufferingEnabled();
            }, setPauseOnBufferingEnabled: function setPauseOnBufferingEnabled(a) {
              g.setPauseOnBufferingEnabled(a);
            }, isThrottlingEnabled: function isThrottlingEnabled() {
              return g.isThrottlingEnabled();
            }, setThrottlingEnabled: function setThrottlingEnabled(a) {
              g.setThrottlingEnabled(a);
            }, setThrottlingDelay: function setThrottlingDelay(a) {
              g.setThrottlingDelay(a);
            }, getThrottlingDelay: function getThrottlingDelay() {
              return g.getThrottlingDelay();
            }, setPlaybackIntervalMergeTolerance: function setPlaybackIntervalMergeTolerance(a) {
              g.getStaSM().getPlaybackSession().getAsset().setPlaybackIntervalMergeTolerance(a);
            }, getPlaybackIntervalMergeTolerance: function getPlaybackIntervalMergeTolerance() {
              return g.getStaSM().getPlaybackSession().getAsset().getPlaybackIntervalMergeTolerance();
            }, createPlaybackSession: function createPlaybackSession(a) {
              g.getStaSM().getLogging().apiCall("createPlaybackSession", a), a = b.jsonObjectToStringDictionary(a);var c = g.getStaSM().getStateMachine().getCurrentState();c != k.IDLE && (g.getStaSM().getLogging().infoLog("Ending the current Clip. It was in state:", b.stateToString(c)), h.notifyEnd()), g.getStaSM().getPlaybackSession().isPlaybackSessionStarted() && g.resetPlaybackSession(), g.getStaSM().getPlaybackSession().setLabels(a);
            }, getVersion: function getVersion() {
              return m.STREAMINGANALYTICS_VERSION;
            }, addListener: function addListener(a) {
              g.addListener(a);
            }, removeListener: function removeListener(a) {
              g.removeListener(a);
            }, addMeasurementListener: function addMeasurementListener(a) {
              g.getStaSM().getEventManager().addMeasurementListener(a);
            }, removeMeasurementListener: function removeMeasurementListener(a) {
              g.getStaSM().getEventManager().removeMeasurementListener(a);
            }, getPlaybackSession: function getPlaybackSession() {
              return g.getStaSM().getPlaybackSession();
            }, setHttpGet: function setHttpGet(a) {
              "function" == typeof a && (g.getPlatformAPI().httpGet = a);
            }, setHttpPost: function setHttpPost(a) {
              "function" == typeof a && (g.getPlatformAPI().httpPost = a);
            }, setExitEndEventEnabled: function setExitEndEventEnabled(a) {
              i = a;
            }, isExitEndEventEnabled: function isExitEndEventEnabled() {
              return i;
            }, getPlatformAPI: function getPlatformAPI() {
              return g.getPlatformAPI();
            }, _getLogHistory: function _getLogHistory() {
              return g.getStaSM().getLogging().getLogHistory();
            } }), b.isBrowser() && (window.addEventListener ? (window.addEventListener("beforeunload", f), window.addEventListener("unload", f)) : window.attachEvent && (window.attachEvent("onbeforeunload", f), window.attachEvent("onunload", f))), d(), function (d, e, f) {
            var h = d,
                i = e,
                j = { play: "notifyPlay", pause: "notifyPause", end: "notifyEnd", bufferStart: "notifyBufferStart", bufferStop: "notifyBufferStop", load: "notifyLoad", start: "notifyEngage", seekStart: "notifySeekStart", skipAd: "notifySkipAd", callToAction: "notifyCallToAction", error: "notifyError", transferPlayback: "notifyTransferPlayback", drmFail: "notifyDrmFail", drmApprove: "notifyDrmApprove", drmDeny: "notifyDrmDeny", changeBitrate: "notifyChangeBitrate", changePlaybackRate: "notifyChangePlaybackRate", changeVolume: "notifyChangeVolume", changeWindowState: "notifyChangeWindowState", changeAudio: "notifyChangeAudioTrack", changeVideo: "notifyChangeVideoTrack", changeSubtitle: "notifyChangeSubtitleTrack", changeCDN: "notifyChangeCdn", customNotify: "notifyCustomEvent", setPixelURL: "setLiveEndpointURL", getPixelURL: "getLiveEndpointURL", getPlaylist: "getPlaybackSession" },
                n = new c("SSE", a.debug);h._log = n, g._log = n, g.getStaSM().getPlaybackSession()._log = n;for (var o in j) {
              j.hasOwnProperty(o) && !function (a, b) {
                h[a] = function () {
                  return h._log.apiCall.apply(h._log, [a].concat(Array.prototype.slice.call(arguments))), h._log.deprecation("streamingAnalytics." + a + "(...)", "streamingAnalytics." + b + "(..)"), h[b].apply(h, Array.prototype.slice.call(arguments));
                };
              }(o, j[o]);
            }h.getClip = function () {
              return h._log.apiCall.apply(h._log, ["getClip"].concat(Array.prototype.slice.call(arguments))), h._log.deprecation("streamingAnalytics.getClip(...)", "streamingAnalytics.getPlaybackSession().getClip()"), h.getPlaybackSession().getClip.apply(h, Array.prototype.slice.call(arguments));
            }, h.setClip = function () {
              return h._log.apiCall.apply(h._log, ["setClip"].concat(Array.prototype.slice.call(arguments))), h._log.deprecation("streamingAnalytics.setClip(...)", "streamingAnalytics.getPlaybackSession().setAsset(...)"), h.getPlaybackSession().setAsset.apply(h, Array.prototype.slice.call(arguments)), !0;
            }, h.setPlaylist = function () {
              return h._log.apiCall.apply(h._log, ["setPlaylist"].concat(Array.prototype.slice.call(arguments))), h._log.deprecation("streamingAnalytics.setPlaylist(...)", "streamingAnalytics.createPlaybackSession(...)"), h.createPlaybackSession.apply(h, Array.prototype.slice.call(arguments)), !0;
            }, h.notify = function () {
              h._log.apiCall.apply(h._log, ["notify"].concat(Array.prototype.slice.call(arguments))), h._log.deprecation("streamingAnalytics.notify(...)"), i.apply(h, Array.prototype.slice.call(arguments));
            }, h.importState = function () {
              h._log.apiCall.apply(h._log, ["importState"].concat(Array.prototype.slice.call(arguments))), h._log.deprecation("streamingAnalytics.importState(...)");
            }, h.exportState = function () {
              return h._log.apiCall.apply(h._log, ["exportState"].concat(Array.prototype.slice.call(arguments))), h._log.deprecation("streamingAnalytics.exportState(...)"), {};
            }, h.setImplementationType = function () {
              h._log.apiCall.apply(h._log, ["setImplementationType"].concat(Array.prototype.slice.call(arguments))), h._log.deprecation("streamingAnalytics.setImplementationType(...)"), sseSM.getStateMachine().getCurrentState() != k.IDLE || type != l.SINGLE_CLIP && type != l.SEGMENTED && type != l.REDUCED || h.getPlaybackSession().setLabel("ns_st_it", l.toString(type));
            }, h.viewNotify = function (a, c) {
              this._log.deprecation("streamingAnalytics.viewNotify(...)");var d, e;b.isBrowser() ? (d = window, e = document) : (d = {}, e = { location: { href: "" }, title: "", URL: "", referrer: "", cookie: "" });var f = a || h.getLiveEndpointURL(),
                  g = "undefined",
                  i = d.comScore || d.sitestat || function (a) {
                var c,
                    f,
                    i,
                    j,
                    k,
                    l = "comScore=",
                    n = e.cookie,
                    o = "",
                    p = "indexOf",
                    q = "substring",
                    r = "length",
                    s = b.browserAcceptsLargeURLs() ? m.URL_LENGTH_LIMIT : m.RESTRICTED_URL_LENGTH_LIMIT,
                    t = "&ns_",
                    u = "&",
                    v = d.encodeURIComponent || escape;if (n[p](l) + 1) for (j = 0, i = n.split(";"), k = i[r]; j < k; j++) {
                  f = i[j][p](l), f + 1 && (o = u + unescape(i[j][q](f + l[r])));
                }a += t + "_t=" + +new Date() + t + "c=" + (e.characterSet || e.defaultCharset || "") + o, a.length > s && a.indexOf(u) > 0 && (c = a.substr(0, s - 8).lastIndexOf(u), a = (a.substring(0, c) + t + "cut=" + v(a.substring(c + 1))).substr(0, s)), h.getPlatformAPI().httpGet(a), (0, _typeof3.default)(d.ns_p) === g && (d.ns_p = { src: a }), d.ns_p.lastMeasurement = a;
              };if ((typeof c === "undefined" ? "undefined" : (0, _typeof3.default)(c)) !== g) {
                var j = [],
                    k = d.encodeURIComponent || escape;for (var l in c) {
                  c.hasOwnProperty(l) && j.push(k(l) + "=" + k(c[l]));
                }/[\?\&]$/.test(f) || (f += "&"), f += j.join("&");
              }return i(f);
            }, f[1] && g.setLiveEndpointURL(f[1]);
          }(h, e, n);
        };
      }();return I.PlayerEvents = j, I.InternalStates = k, I.ImplementationType = l, I.Constants = m, m.STREAMINGANALYTICS_VERSION = m.STREAMINGANALYTICS_V5_VERSION, function (c) {
        function d(a, b) {
          return x[z] || f(a, b);
        }function e() {
          z = -1;for (var b = 0; b <= y; b++) {
            if (x.hasOwnProperty(b + "")) {
              z = b;break;
            }
          }return a.StreamSense.activeIndex = z, z;
        }function f(b, c) {
          return b = b || null, c = c || null, b && "object" == (typeof b === "undefined" ? "undefined" : (0, _typeof3.default)(b)) && (c = b, b = null), x[++y] = new a.StreamSense(c, b), e(), x[y];
        }function g() {
          var b = !1,
              c = z;if ("number" == typeof arguments[0] && isFinite(arguments[0])) c = arguments[0];else if (arguments[0] instanceof a.StreamSense) for (var d in x) {
            if (x.hasOwnProperty(d) && x[d] === arguments[0]) {
              c = d;break;
            }
          }return x.hasOwnProperty(c + "") && (b = x[c], delete x[c], b.reset(), e()), b;
        }function h(a) {
          return a = a || {}, d().createPlaybackSession(a), d().getPlaybackSession();
        }function i(a, b, c) {
          return a = a || {}, "number" == typeof b && (a.ns_st_cn = b + ""), d().getPlaybackSession().setAsset(a, c), d().getPlaybackSession().getAsset();
        }function j(a, b, c) {
          return "undefined" != typeof a && (c = c || null, b = b || {}, d().notify(a, b, c));
        }function k(a) {
          "undefined" != typeof a && d().setLabels(a);
        }function l() {
          return d().getLabels();
        }function m(a) {
          "undefined" != typeof a && d().getPlaybackSession().setLabels(a);
        }function n() {
          return d().getPlaybackSession().getLabels();
        }function o(a) {
          "undefined" != typeof a && d().getPlaybackSession().getAsset().setLabels(a);
        }function p() {
          return d().getPlaybackSession().getAsset().getLabels();
        }function q(a) {
          return d().reset(a || {});
        }function r(a) {
          return d().getPlaybackSession().reset(a || {});
        }function s(a) {
          return d().getPlaybackSession().getAsset().reset(a || {});
        }function t(a) {
          return a = a || {}, d().viewNotify(null, a);
        }function u(a, b) {
          return arguments.length > 2 && (a = arguments[1], b = arguments[2]), a = a || {}, "number" == typeof b && (a.ns_st_po = b + ""), d().customNotify(a, b);
        }function v() {
          return d().exportState();
        }function w(a) {
          d().importState(a);
        }var x = {},
            y = -1,
            z = -1;b.extend(c, { activeIndex: z, newInstance: f, "new": f, destroyInstance: g, destroy: g, newPlaylist: h, newClip: i, notify: j, setLabels: k, getLabels: l, setPlaylistLabels: m, getPlaylistLabels: n, setClipLabels: o, getClipLabels: p, resetInstance: q, resetPlaylist: r, resetClip: s, viewEvent: t, customEvent: u, exportState: v, importState: w });
      }(I), I;
    }(), a.ReducedRequirementsStreamingAnalytics = a.ReducedRequirementsStreamingAnalytics || function () {
      var d = { LongFormOnDemand: "12", ShortFormOnDemand: "11", Live: "13", UserGeneratedLongFormOnDemand: "22", UserGeneratedShortFormOnDemand: "21", UserGeneratedLive: "23", Bumper: "99", Other: "00" },
          e = { LinearOnDemandPreRoll: "11", LinearOnDemandMidRoll: "12", LinearOnDemandPostRoll: "13", LinearLive: "21", BrandedOnDemandPreRoll: "31", BrandedOnDemandMidRoll: "32", BrandedOnDemandPostRoll: "33", BrandedOnDemandContent: "34", BrandedOnDemandLive: "35", Other: "00" },
          f = a.StreamingAnalytics,
          g = a.StreamingAnalytics.InternalStates || null,
          h = a.StreamingAnalytics.ImplementationType || null,
          i = null != a.StreamingAnalytics.InternalStates && null != a.StreamingAnalytics.ImplementationType,
          j = a.StreamingAnalytics.Constants,
          k = function k(a) {
        function k() {
          i && (b.exists(a) && (a.customerC2 || a.publisherId) || b.getNamespace().comScore ? t = new f(a) : w.error("Cannot instantiate StreamingAnalytics", "The property publisherId was not provided (or incorrectly provided) in the StreamingAnalytics configuration."), t && t.setLabel("ns_st_it", h.toString(h.REDUCED)));
        }function l(a) {
          for (var b in j.STANDARD_METADATA_LABELS) {
            if (j.STANDARD_METADATA_LABELS.hasOwnProperty(b) && !m(j.STANDARD_METADATA_LABELS[b], q, a)) return !1;
          }return !0;
        }function m(a, c, d) {
          return !!(b.exists(a) && b.exists(c) && b.exists(d) && (c.hasOwnProperty(a) && d.hasOwnProperty(a) && c[a] === d[a] || !c.hasOwnProperty(a) && !d.hasOwnProperty(a)));
        }function n(a) {
          t.getPlaybackSession().setAsset(a), q = a, t.notifyPlay();
        }function o(a) {
          var b = a || {};b.ns_st_ad = "1", b.ns_st_an = ++r + "", t.getPlaybackSession().setAsset(b), t.notifyPlay(), s = !1;
        }function p(a, b) {
          v == u.None && (v = b), s && v == b && l(a) ? (t.getPlaybackSession().getAsset().setLabels(a), t.getState() != g.PLAYING && t.notifyPlay()) : n(a), s = !0, v = b;
        }var q = null,
            r = 0,
            s = !1,
            t = null,
            u = { None: 0, AudioContent: 1, VideoContent: 2 },
            v = u.None,
            w = new c("TTSTA", (a || {}).debug);b.extend(this, { playVideoAdvertisement: function playVideoAdvertisement(a, c) {
            if (t) {
              w.apiCall("playVideoAdvertisement", a, c);var d = { ns_st_ct: "va" };c ? d.ns_st_ct = "va" + c : w.warn("Calling 'playVideoAdvertisement' without specifying the media type as a second parameter."), c != e.LinearLive && c != e.BrandedOnDemandLive || (d.ns_st_li = "1"), a && b.extend(d, a), o(d);
            }
          }, playAudioAdvertisement: function playAudioAdvertisement(a, c) {
            if (t) {
              w.apiCall("playAudioAdvertisement", a, c);var d = { ns_st_ct: "aa" };c ? d.ns_st_ct = "aa" + c : w.warn("Calling 'playAudioAdvertisement' without specifying the media type as a second parameter."), c != e.LinearLive && c != e.BrandedOnDemandLive || (d.ns_st_li = "1"), a && b.extend(d, a), o(d);
            }
          }, playVideoContentPart: function playVideoContentPart(a, c) {
            if (t) {
              w.apiCall("playVideoContentPart", a, c);var e = { ns_st_ct: "vc" };c ? e.ns_st_ct = "vc" + c : w.warn("Calling 'playVideoContentPart' without specifying the media type as a second parameter."), c != d.Live && c != d.UserGeneratedLive || (e.ns_st_li = "1"), a && b.extend(e, a), p(e, u.VideoContent);
            }
          }, playAudioContentPart: function playAudioContentPart(a, c) {
            if (t) {
              w.apiCall("playAudioContentPart", a, c);var e = { ns_st_ct: "ac" };c ? e.ns_st_ct = "ac" + c : w.warn("Calling 'playAudioContentPart' without specifying the media type as a second parameter."), c != d.Live && c != d.UserGeneratedLive || (e.ns_st_li = "1"), a && b.extend(e, a), p(e, u.AudioContent);
            }
          }, stop: function stop() {
            t && (w.apiCall("stop"), t.notifyPause());
          } }), k();
      };return k.ContentType = d, k.AdType = e, k;
    }(), a.StreamSense = a.StreamSense || function (b, c) {
      var d = Array.prototype.slice.call(arguments),
          e = new (a.StreamingAnalytics.bind.apply(a.StreamingAnalytics, [this].concat(d)))();return e._log.deprecation("new ns_.StreamSense(...)", "ns_.StreamingAnalytics(...)"), e;
    }, a.StreamSense.prototype = a.StreamingAnalytics.prototype, a.StreamSense.PlayerEvents = a.StreamingAnalytics.PlayerEvents, a.StreamSense.InternalStates = a.StreamingAnalytics.InternalStates, a.StreamSense.ImplementationType = a.StreamingAnalytics.ImplementationType, a.StreamSense.Constants = a.StreamingAnalytics.Constants, a.StreamingTag = a.StreamingTag || function () {
      var b = new c("SSETag", (arguments[0] || {}).debug);b.deprecation("new ns_.StreamingTag(...)", "new ns_.ReducedRequirementsStreamingAnalytics(...)");var d = Array.prototype.slice.call(arguments);return new (a.ReducedRequirementsStreamingAnalytics.bind.apply(a.ReducedRequirementsStreamingAnalytics, [this].concat(d)))();
    }, a.StreamingTag.prototype = a.ReducedRequirementsStreamingAnalytics.prototype, a.StreamingTag.ContentType = a.ReducedRequirementsStreamingAnalytics.ContentType, a.StreamingTag.AdType = a.ReducedRequirementsStreamingAnalytics.AdType, a;
  }), function (a) {
    "use strict";
    return "undefined" != typeof ns_ && ns_.StreamingAnalytics && ns_.StreamSense ? void a(ns_) : void ("undefined" != typeof console && console.error && console.error("The comScore Streaming Analytics library was not properly loaded."));
  }(function (a) {
    "use strict";
    function b(i, j, k, l, m) {
      function n() {
        var b = {};b.publisherId = i.publisherId || i.c2, b.secure = i.secure, b.liveEndpointURL = i.logurl, Ua = new a.StreamingAnalytics(b), c.extend(Ha, Ua), c.extend(Ha, { notifyPlay: Q, notifyPause: R, notifyEnd: S, notifyBufferStart: T, notifyBufferStop: U, notifyLoad: V, notifyEngage: W, notifySeekStart: X, notifySkipAd: Y, notifyCallToAction: Z, notifyError: $, notifyTransferPlayback: _, notifyDrmFail: aa, notifyDrmApprove: ba, notifyDrmDeny: ca, notifyChangeBitrate: da, notifyChangePlaybackRate: ea, notifyChangeVolume: fa, notifyChangeWindowState: ga, notifyChangeAudioTrack: ha, notifyChangeVideoTrack: ia, notifyChangeSubtitleTrack: ja, notifyChangeCDN: ka, createPlaybackSession: pa, getPlaybackSession: qa, setAsset: oa, setLabel: ra, setLabels: sa, getLabels: ta, getLabel: ua, setAssetLabel: va, setPlaybackSessionLabel: wa, onGetLabels: P, labelMapping: Ya, release: o, log: Da, handleSettings: za, getGenericPluginVersion: r, setDuration: O, setVideoSize: N, setDetectSeek: M, setDetectPause: L, setDetectPlay: K, setDetectEnd: J, setSmartStateDetection: I, setPauseDetectionErrorMargin: A, setEndDetectionErrorMargin: B, setSeekDetectionMinQuotient: C, setPulseSamplingInterval: D, setPulseSamplingIntervalBackground: E, setPulseMaxDelay: F, setMaximumNumberOfEntriesInHistory: G, setMinimumNumberOfTimeUpdateEventsBeforeDetectingSeek: H }), Ha.setLabels({ ns_st_mp: j, ns_st_pv: k, ns_st_mv: l }, !0), i && za(i), m.init && m.init.call(Ha, null), cb && t(), m.getViewabilityElement && (null == i.vce || i.vce) && p();
      }function o() {
        m.release && m.release.call(Ha), u(), Ua.reset(), Ua = null, y(), Va = [], Ea = void 0, Wa = -1, Fa = Ja, Xa = -1;
      }function p() {
        e.tryAsyncLoad(), Ua.addMeasurementListener(q);
      }function q(a) {
        var b = m.getViewabilityElement && m.getViewabilityElement();if (b) {
          var c = {};e.fillViewability(b, c);for (var d in c) {
            a[d] = a[d] || c[d];
          }
        }
      }function r() {
        return Ia;
      }function s() {
        return c.hasPageVisibilityAPISupport && c.isTabInBackground() ? Ra : Qa;
      }function t() {
        u(), eb = NaN, fb = [], nb = !0, Ga = setInterval(v, s()), x();
      }function u() {
        "undefined" != typeof Ga && (clearInterval(Ga), Ga = void 0);
      }function v() {
        if (!cb) return void u();if (gb) return void (gb = !1);var b = +new Date(),
            c = b - eb,
            d = s() + Ta,
            e = eb;if (eb = b, !isNaN(e) && c > d) return void t();var f = m.position && m.position.call(Ha, null) || 0,
            h = !1;if (f != fb[fb.length - 1]) {
          if (fb.push(Math.abs(f)), fb.length > 1 && fb[fb.length - 1] < fb[fb.length - 2]) {
            var i = fb[fb.length - 1];fb = [], fb[0] = i, $a && (h = !0);
          }if (!h && fb.length < Pa) return;
        }fb.length > Sa && (fb = fb.slice(-Math.floor(Sa / 2))), $a && !h && (h = w());var j = Ua.getState();switch (j) {case g.IDLE:case g.PAUSED:case g.PLAYBACK_NOT_STARTED:case g.BUFFERING_BEFORE_PLAYBACK:case g.BUFFERING_DURING_PLAYBACK:case g.BUFFERING_DURING_SEEKING:case g.BUFFERING_DURING_PAUSE:case g.PAUSED_DURING_BUFFERING:case g.SEEKING_BEFORE_PLAYBACK:case g.SEEKING_DURING_PLAYBACK:case g.SEEKING_DURING_BUFFERING:case g.SEEKING_DURING_PAUSE:
            if (ab && f > db && !h && !z(f)) {
              if (m.preMeasurement && !m.preMeasurement.call(Ha, j, a.StreamingAnalytics.PlayerEvents.PLAY)) break;var k = fb[fb.length - 1];nb && k < Ma ? Ha.notifyPlay(0) : Ha.notifyPlay(k), nb = !1;break;
            }$a && h && j != g.SEEKING_BEFORE_PLAYBACK && j != g.SEEKING_DURING_PLAYBACK && j != g.SEEKING_DURING_BUFFERING && j != g.SEEKING_DURING_PAUSE && Ha.notifySeekStart(fb[0]);break;case g.PLAYING:
            if ($a && h) {
              if (m.preMeasurement && !m.preMeasurement.call(Ha, j, a.StreamingAnalytics.PlayerEvents.PAUSE)) break;nb = !1, Ha.notifySeekStart(db);
            } else if (bb && z(f)) {
              if (m.preMeasurement && !m.preMeasurement.call(Ha, j, a.StreamingAnalytics.PlayerEvents.END)) break;nb = !0;var l = parseInt(hb.ns_st_cl || Ua.getPlaybackSession().getAsset().getLabel("ns_st_cl"));!isNaN(l) && l > 0 ? Ha.notifyEnd(l) : Ha.notifyEnd(f);
            } else if (_a && Math.abs(f - db) <= Ka) {
              if (m.preMeasurement && !m.preMeasurement.call(Ha, j, a.StreamingAnalytics.PlayerEvents.PAUSE)) break;nb = !1, Ha.notifyPause(db);
            }}j !== Ua.getState() && (m.postMeasurement && m.postMeasurement.call(Ha, Ua.getState()), Ua.getState() != g.PLAYING && (fb = [])), db = f;
      }function w() {
        if (fb.length < 2) return !1;if (fb[fb.length - 1] < fb[fb.length - 2]) return !0;for (var a = s(), b = 0, c = 0; c < fb.length; c++) {
          b = (parseFloat(b) + Na[fb.length - 2][c] * fb[c]).toFixed(5);
        }return b = parseFloat(b), b / a > Oa;
      }function x() {
        if ("undefined" != typeof document && document.addEventListener && c.hasPageVisibilityAPISupport() && !ob) {
          ob = !0;var a = c.getPageVisibilityAPI();document.addEventListener(a.visibilityChange, t, !1);
        }
      }function y() {
        if ("undefined" != typeof document && document.addEventListener && c.hasPageVisibilityAPISupport() && ob) {
          ob = !1;var a = c.getPageVisibilityAPI();document.removeEventListener(a.visibilityChange, t, !1);
        }
      }function z(a) {
        var b = parseInt(hb.ns_st_cl || Ua.getPlaybackSession().getAsset().getLabel("ns_st_cl"));return !isNaN(b) && b > 0 && (a > b || Math.abs(a - b) < La);
      }function A(a) {
        a && (Ka = a);
      }function B(a) {
        a && (La = a);
      }function C(a) {
        a && a > 1 && (Oa = a);
      }function D(a) {
        "number" == typeof a && a >= 0 && (Qa = a);
      }function E(a) {
        "number" == typeof a && a >= 0 && (Ra = a);
      }function F(a) {
        "number" == typeof a && a >= 0 && (Ta = a);
      }function G(a) {
        a && a <= 13 && a >= 2 && (Sa = a);
      }function H(a) {
        a && a >= 2 && a <= 13 && (Pa = a);
      }function I(a) {
        cb = a || !1, cb ? t() : u();
      }function J(a) {
        bb = a || !1;
      }function K(a) {
        ab = a || !1;
      }function L(a) {
        _a = a || !1;
      }function M(a) {
        $a = a || !1;
      }function N(a) {
        Ua.getPlaybackSession().getAsset().setLabel("ns_st_cs", a ? a : 0);
      }function O(a) {
        Ua.getPlaybackSession().getAsset().setLabel("ns_st_cl", a && a >= 0 ? a : 0);
      }function P(a) {
        "function" == typeof a && Va.push(a);
      }function Q() {
        if (!lb && !mb) {
          nb = !1;var a = na(h.PLAY, la(arguments), ma(arguments));Ua.notifyPlay(la(arguments), a);
        }
      }function R() {
        if (!lb && !mb) {
          nb = !1;var a = na(h.PAUSE, la(arguments), ma(arguments));Ua.notifyPause(la(arguments), a), cb && (fb = [], db = a);
        }
      }function S() {
        if (!lb && !mb) {
          nb = !0;var a = na(h.END, la(arguments), ma(arguments));cb && (fb = [], db = a, gb = !0), Ua.notifyEnd(la(arguments), a);
        }
      }function T() {
        if (!lb && !mb) {
          var a = na(h.BUFFER, la(arguments), ma(arguments));Ua.notifyBufferStart(la(arguments), a);
        }
      }function U() {
        if (!lb && !mb) {
          var a = na(h.BUFFER_STOP, la(arguments), ma(arguments));Ua.notifyBufferStop(la(arguments), a);
        }
      }function V() {
        if (!lb && !mb) {
          var a = na(h.LOAD, la(arguments), ma(arguments));Ua.notifyLoad(la(arguments), a);
        }
      }function W() {
        if (!lb && !mb) {
          var a = na(h.ENGAGE, la(arguments), ma(arguments));Ua.notifyEngage(la(arguments), a);
        }
      }function X() {
        if (!lb && !mb) {
          nb = !1;var a = na(h.SEEK_START, la(arguments), ma(arguments));cb && (fb = [], db = a), Ua.notifySeekStart(la(arguments), a);
        }
      }function Y() {
        if (!lb && !mb) {
          var a = na(h.AD_SKIP, la(arguments), ma(arguments));Ua.notifySkipAd(la(arguments), a);
        }
      }function Z() {
        if (!lb && !mb) {
          var a = na(h.CTA, la(arguments), ma(arguments));Ua.notifyCallToAction(la(arguments), a);
        }
      }function $() {
        if (!lb && !mb) {
          var a = na(h.ERROR, la(arguments), ma(arguments));Ua.notifyError(la(arguments), a);
        }
      }function _() {
        if (!lb && !mb) {
          var a = na(h.TRANSFER, la(arguments), ma(arguments));Ua.notifyTransferPlayback(la(arguments), a);
        }
      }function aa() {
        if (!lb && !mb) {
          var a = na(h.DRM_FAILED, la(arguments), ma(arguments));Ua.notifyDrmFail(la(arguments), a);
        }
      }function ba() {
        if (!lb && !mb) {
          var a = na(h.DRM_APPROVED, la(arguments), ma(arguments));Ua.notifyDrmApprove(la(arguments), a);
        }
      }function ca() {
        if (!lb && !mb) {
          var a = na(h.DRM_DENIED, la(arguments), ma(arguments));Ua.notifyDrmDeny(la(arguments), a);
        }
      }function da(a, b, c) {
        if (!lb && !mb) {
          var d = [b, c],
              e = na(h.BIT_RATE, la(d), ma(d));Ua.notifyChangeBitrate(a, e, la(d));
        }
      }function ea(a, b, c) {
        if (!lb && !mb) {
          var d = [b, c],
              e = na(h.PLAYBACK_RATE, la(d), ma(d));Ua.notifyChangePlaybackRate(a, e, la(d));
        }
      }function fa(a, b, c) {
        if (!lb && !mb) {
          var d = [b, c],
              e = na(h.VOLUME, la(d), ma(d));Ua.notifyChangeVolume(a, e, la(d));
        }
      }function ga(a, b, c) {
        if (!lb && !mb) {
          var d = [b, c],
              e = na(h.WINDOW_STATE, la(d), ma(d));Ua.notifyChangeWindowState(a, e, la(d));
        }
      }function ha(a, b, c) {
        if (!lb && !mb) {
          var d = [b, c],
              e = na(h.AUDIO, la(d), ma(d));Ua.notifyChangeAudioTrack(a, e, la(d));
        }
      }function ia(a, b, c) {
        if (!lb && !mb) {
          var d = [b, c],
              e = na(h.VIDEO, la(d), ma(d));Ua.notifyChangeVideoTrack(a, e, la(d));
        }
      }function ja(a, b, c) {
        if (!lb && !mb) {
          var d = [b, c],
              e = na(h.SUBS, la(d), ma(d));Ua.notifyChangeSubtitleTrack(a, e, la(d));
        }
      }function ka(a, b, c) {
        if (!lb && !mb) {
          var d = [b, c],
              e = na(h.CDN, la(d), ma(d));Ua.notifyChangeCdn(a, e, la(d));
        }
      }function la(a) {
        var b;return b = "object" == (0, _typeof3.default)(a[0]) ? a[0] : "object" == (0, _typeof3.default)(a[1]) ? a[1] : {};
      }function ma(a) {
        var b;return b = "number" == typeof a[0] ? a[0] : "number" == typeof a[1] ? a[1] : NaN;
      }function na(a, b, c) {
        for (var d = 0, e = Va.length; d < e; d++) {
          Va[d](a, b);
        }var f = NaN;return "number" != typeof c || isNaN(c) ? m.position && (f = m.position.call(Ha, a, b, c)) : f = c, f;
      }function oa(a, b, d, e) {
        var f = d || [];Ba(f, a), Ca(f, a);var g;for (var h in a) {
          a.hasOwnProperty(h) && (g = h.match(/^data-(.+)/)) && (a[g[1]] = a[h], delete a[h]);
        }return e && 1 == e ? c.extend(a, jb) : (jb = {}, c.extend(jb, a)), hb = {}, lb = !!(a && a.hasOwnProperty("ns_st_skip") && a.ns_st_skip), Ua.getPlaybackSession().setAsset(a, b);
      }function pa(a, b) {
        return b && 1 == b ? c.extend(a, ib) : (ib = {}, c.extend(ib, a)), mb = !!(a && a.hasOwnProperty("ns_st_skip") && a.ns_st_skip), Ua.createPlaybackSession(a);
      }function qa() {
        var a = Ua.getPlaybackSession();return new f(a, oa);
      }function ra(a, b, c) {
        var d = {};return d[a] = b, sa(d, c);
      }function sa(a, b) {
        return b && 1 == b ? c.extend(a, kb) : c.extend(kb, a), Ua.setLabels(a);
      }function ta() {
        return kb;
      }function ua(a) {
        return kb[a];
      }function va(a, b, c) {
        c && 1 == c ? (jb.hasOwnProperty(a) || kb.hasOwnProperty(a) || Ua.getPlaybackSession().getAsset().setLabel(a, b), hb[a] = b) : (jb[a] = b, Ua.getPlaybackSession().getAsset().setLabel(a, b));
      }function wa(a, b, c) {
        c && 1 == c ? ib.hasOwnProperty(a) || kb.hasOwnProperty(a) || Ua.getPlaybackSession().setLabel(a, b) : (ib[a] = b, Ua.getPlaybackSession().setLabel(a, b));
      }function xa(a) {
        if (a) {
          var b = /([^=, ]+)\s*=(\s*("([^"]+?)"|'([^']+?)'|[a-z0-9\[\]\._-]+)\s*\+?)+\s*/gi,
              c = a.match(b);for (var d in c) {
            if (c.hasOwnProperty(d)) {
              var e = c[d].split("=", 2);if (2 == e.length) {
                var f = e[0].replace(/(^\s+|\s+$)/g, "");"" != f && (Ya[f] = e[1]);
              }
            }
          }
        }
      }function ya(a) {
        if (a) {
          var b = a.split(",");for (var c in b) {
            if (b.hasOwnProperty(c)) {
              var d = b[c].split("=", 2);if (2 == d.length) {
                var e = d[0].replace(/(^\s+|\s+$)/g, "");"" != e && (Ua.setLabel(e, d[1]), kb[e] = d[1]);
              }
            }
          }
        }
      }function za(a) {
        if (c.isTrue(a.pageview)) {
          var b = {};if ("undefined" != typeof document) {
            var d = document;b.c7 = d.URL, b.c8 = d.title, b.c9 = d.referrer;
          }Ua.setLabels(b);
        }a.renditions, Za = c.isTrue(a.debug), a.labelmapping && xa(a.labelmapping), a.persistentlabels && ya(a.persistentlabels), "1" === a.throttling || a.throttling === !0 ? Ua.setThrottlingEnabled(!0) : Ua.setThrottlingEnabled(!1);var e;if ((e = a.include) && "string" == typeof e && (e === Ja ? Ea = Ja : e.length > 0 && (Ea = e.split(","))), Ea !== Ja && (e = a.include_prefixes) && (e === Ja ? Ea = Ja : (Ea || (Ea = []), Wa = Ea.length, Ea.push.apply(Ea, e.split(",")))), "undefined" == typeof Ea) Fa = Ja;else {
          var f;(f = a.exclude) && "string" == typeof f && (f === Ja ? Fa = Ja : f.length > 0 && (Fa = f.split(","))), Fa !== Ja && (f = a.exclude_prefixes) && (f === Ja ? Fa = Ja : (Fa || (Fa = []), Xa = Fa.length, Fa.push.apply(Fa, f.split(","))));
        }
      }function Aa(a) {
        var b,
            c,
            d,
            e,
            f = {};if (Fa === Ja) return {};if (Ea && Ea !== Ja) {
          for (b = 0, c = Ea.length; b < c; b++) {
            var g = Ea[b];e = Wa >= 0 && b >= Wa;for (d in a) {
              a.hasOwnProperty(d) && (f[d] || (f[d] = !(e ? 0 !== d.indexOf(g) : d != g)));
            }
          }for (d in f) {
            f.hasOwnProperty(d) && f[d] === !1 && delete a[d];
          }f = {};
        }if (Fa) for (b = 0, c = Fa.length; b < c; b++) {
          var h = Fa[b];e = Xa >= 0 && b >= Xa;for (d in a) {
            a.hasOwnProperty(d) && (e ? 0 === d.indexOf(h) : d == h) && (f[d] = !0);
          }for (d in f) {
            f.hasOwnProperty(d) && a.hasOwnProperty(d) && delete a[d];
          }f = {};
        }return a;
      }function Ba(a, b) {
        var d = Fa === Ja;if (a.length > 0 && "undefined" != a[0].map) {
          var e = a[0].map;d || c.extend(b, Aa(e));for (var f in e) {
            if (e.hasOwnProperty(f)) {
              var g,
                  h,
                  i,
                  j = /^([Cc][A-Da-d]_)?ns_st_.+/,
                  k = /^[Cc][A-Da-d]?([1-9]|1[0-9]|20)$/;(g = f.match(/^data-(.+)/)) ? (h = null != g[1].match(j), i = null != g[1].match(k), (h || i) && (b[g[1]] = e[f])) : (h = null != f.match(j), i = null != f.match(k), (h || i) && (b[f] = e[f]));
            }
          }
        }
      }function Ca(a, b) {
        var d = Ha.labelMapping;for (var e in d) {
          if (d.hasOwnProperty(e)) for (var f = "", g = /^("([^"]+)"|'([^']+?)'$)/i, h = /"([^"]+?)"|[a-z0-9\[\]\._-]+|'([^']+?)'\s*/gi, i = d[e].match(h), j = 0; j < i.length; j++) {
            var k = i[j].replace(/(?:^\s+|\s+$)/g, "");if (g.test(k)) {
              var l = g.exec(k);f += l[2] || l[3];
            } else try {
              var m = "",
                  n = k.lastIndexOf(".");n >= 1 && n < k.length - 1 && (m = k.substring(0, n), k = k.substring(n + 1, k.length));for (var o = 0; o < a.length; o++) {
                var p = a[o];if (m == p.prefix) {
                  p.map[k] && (f += c.toString(p.map[k]));break;
                }
              }
            } catch (q) {
              Da("Exception occurred while processing mapped labels");
            }b[e] = f;
          }
        }
      }function Da() {
        if (Za) {
          var a = new Date(),
              b = a.getDate(),
              c = a.getMonth() + 1,
              d = a.getHours(),
              e = a.getMinutes(),
              f = a.getSeconds(),
              g = a.getFullYear() + "-" + (c < 10 ? "0" + c : c) + "-" + (b < 10 ? "0" + b : b) + " " + (d < 10 ? "0" + d : d) + ":" + (e < 10 ? "0" + e : e) + ":" + (f < 10 ? "0" + f : f) + "." + a.getMilliseconds(),
              h = ["comScore", g],
              i = Array.prototype.slice.call(arguments);"undefined" != typeof console && console.log.apply(console, h.concat(i));
        }
      }m = m || {};var Ea,
          Fa,
          Ga,
          Ha = this,
          Ia = "2.4.5",
          Ja = "_all_",
          Ka = 10,
          La = 500,
          Ma = 1e3,
          Na = [[-1, 1], [-.5, 0, .5], [-.3, -.1, .1, .3], [-.2, -.1, 0, .1, .2], [-.14286, -.08571, -.02857, .02857, .08571, .14286], [-.10714, -.07143, -.03571, 0, .03571, .07143, .10714], [-.08333, -.05952, -.03571, -.0119, .0119, .03571, .05952, .08333], [-.06667, -.05, -.03333, -.01667, 0, .01667, .03333, .05, .06667], [-.05455, -.04242, -.0303, -.01818, -.00606, .00606, .01818, .0303, .04242, .05455], [-.04545, -.03636, -.02727, -.01818, -.00909, 0, .00909, .01818, .02727, .03636, .04545], [-.03846, -.03147, -.02448, -.01748, -.01049, -.0035, .0035, .01049, .01748, .02448, .03147, .03846], [-.03297, -.02747, -.02198, -.01648, -.01099, -.00549, 0, .00549, .01099, .01648, .02198, .02747, .03297]],
          Oa = 1.25,
          Pa = 2,
          Qa = 300,
          Ra = 1e3,
          Sa = 6,
          Ta = 50,
          Ua = {},
          Va = [],
          Wa = -1,
          Xa = -1,
          Ya = {},
          Za = !1,
          $a = !1,
          _a = !1,
          ab = !1,
          bb = !1,
          cb = !1,
          db = m.position && m.position.call(Ha, null) || 0,
          eb = NaN,
          fb = [],
          gb = !1,
          hb = {},
          ib = {},
          jb = {},
          kb = {},
          lb = !1,
          mb = !1,
          nb = !0;n(), c.isTrue(i.pageview) && b.viewNotify(Ua.getLabels(), Ua), function (a) {
        var b = a,
            c = new d("SSEGP", (i || {}).debug),
            e = { play: "notifyPlay", pause: "notifyPause", end: "notifyEnd", bufferStart: "notifyBufferStart", bufferStop: "notifyBufferStop", load: "notifyLoad", start: "notifyEngage", seekStart: "notifySeekStart", skipAd: "notifySkipAd", callToAction: "notifyCallToAction", error: "notifyError", transferPlayback: "notifyTransferPlayback", drmFail: "notifyDrmFail", drmApprove: "notifyDrmApprove", drmDeny: "notifyDrmDeny", changeBitrate: "notifyChangeBitrate", changePlaybackRate: "notifyChangePlaybackRate", changeVolume: "notifyChangeVolume", changeWindowState: "notifyChangeWindowState", changeAudio: "notifyChangeAudioTrack", changeVideo: "notifyChangeVideoTrack", changeSubtitle: "notifyChangeSubtitleTrack", changeCDN: "notifyChangeCdn", setClipLabel: "setAssetLabel", setPlaylistLabel: "setPlaybackSessionLabel" };for (var f in e) {
          e.hasOwnProperty(f) && !function (a, d) {
            b[a] = function () {
              return c.apiCall.apply(c, [a].concat(Array.prototype.slice.call(arguments))), c.deprecation("staPlugin." + a + "(...)", "staPlugin." + d + "(..)"), b[d].apply(b, Array.prototype.slice.call(arguments));
            };
          }(f, e[f]);
        }b.getClip = function () {
          return c.apiCall.apply(c, ["getClip"].concat(Array.prototype.slice.call(arguments))), c.deprecation("staPlugin.getClip(...)", "staPlugin.getPlaybackSession().getClip()"), b.getPlaybackSession().getClip.apply(b, Array.prototype.slice.call(arguments));
        }, b.setClip = function () {
          return c.apiCall.apply(c, ["setClip"].concat(Array.prototype.slice.call(arguments))), c.deprecation("staPlugin.setClip(...)", "staPlugin.getPlaybackSession().setAsset(...)"), b.getPlaybackSession().setAsset.apply(b, Array.prototype.slice.call(arguments)), !0;
        }, b.setPlaylist = function () {
          return c.apiCall.apply(c, ["setPlaylist"].concat(Array.prototype.slice.call(arguments))), c.deprecation("staPlugin.setPlaylist(...)", "staPlugin.createPlaybackSession(...)"), b.createPlaybackSession.apply(b, Array.prototype.slice.call(arguments)), !0;
        }, b.notify = function (a, b, c) {
          if (!lb && !mb) {
            var d = [];b && d.push(b), c && d.push(c);var e = na(a, la(d), ma(d));_instance.notify(a, la(d), e);
          }
        };
      }(Ha);var ob = !1;
    }var c = c || {};c.indexOf = function (a, b) {
      var c = -1;return this.forEach(b, function (b, d) {
        b == a && (c = d);
      }), c;
    }, c.forEach = function (a, b, c) {
      try {
        if ("function" == typeof b) if (c = "undefined" != typeof c ? c : null, "number" != typeof a.length || "undefined" == typeof a[0]) {
          var d = "undefined" != typeof a.__proto__;for (var e in a) {
            a.hasOwnProperty(e) && (!d || d && "undefined" == typeof a.__proto__[e]) && "function" != typeof a[e] && b.call(c, a[e], e);
          }
        } else for (var f = 0, g = a.length; f < g; f++) {
          b.call(c, a[f], f);
        }
      } catch (h) {}
    };var c = c || {};c.parseBoolean = function (a, b) {
      return b = b || !1, a ? "0" != a : b;
    }, c.parseInteger = function (a, b) {
      return null == a || isNaN(a) ? b || 0 : parseInt(a);
    }, c.parseLong = function (a, b) {
      var c = Number(a);return null == a || isNaN(c) ? b || 0 : c;
    }, c.toString = function (a) {
      if ("undefined" == typeof a) return "undefined";if ("string" == typeof a) return a;if (a instanceof Array) return a.join(",");var b = "";for (var c in a) {
        a.hasOwnProperty(c) && (b += c + ":" + a[c] + ";");
      }return b || a.toString();
    };var c = c || {};c.filter = function (a, b) {
      var c = {};for (var d in b) {
        b.hasOwnProperty(d) && a(b[d]) && (c[d] = b[d]);
      }return c;
    }, c.extend = function (a) {
      var b,
          c = arguments.length;a = a || {};for (var d = 1; d < c; d++) {
        if (b = arguments[d]) for (var e in b) {
          b.hasOwnProperty(e) && (a[e] = b[e]);
        }
      }return a;
    };var c = c || {};c.cloneObject = function (a) {
      if (null == a || "object" != (typeof a === "undefined" ? "undefined" : (0, _typeof3.default)(a))) return a;var b = function () {
        function a() {}function b(b) {
          return "object" == (typeof b === "undefined" ? "undefined" : (0, _typeof3.default)(b)) ? (a.prototype = b, new a()) : b;
        }function c(a) {
          for (var b in a) {
            a.hasOwnProperty(b) && (this[b] = a[b]);
          }
        }function d() {
          this.copiedObjects = [];var a = this;this.recursiveDeepCopy = function (b) {
            return a.deepCopy(b);
          }, this.depth = 0;
        }function e(a, b) {
          var c = new d();return b && (c.maxDepth = b), c.deepCopy(a);
        }function f(a) {
          return "undefined" != typeof window && window && window.Node ? a instanceof Node : "undefined" != typeof document && a === document || "number" == typeof a.nodeType && a.attributes && a.childNodes && a.cloneNode;
        }var g = [];return c.prototype = { constructor: c, canCopy: function canCopy() {
            return !1;
          }, create: function create(a) {}, populate: function populate(a, b, c) {} }, d.prototype = { constructor: d, maxDepth: 256, cacheResult: function cacheResult(a, b) {
            this.copiedObjects.push([a, b]);
          }, getCachedResult: function getCachedResult(a) {
            for (var b = this.copiedObjects, c = b.length, d = 0; d < c; d++) {
              if (b[d][0] === a) return b[d][1];
            }
          }, deepCopy: function deepCopy(a) {
            if (null === a) return null;if ("object" != (typeof a === "undefined" ? "undefined" : (0, _typeof3.default)(a))) return a;var b = this.getCachedResult(a);if (b) return b;for (var c = 0; c < g.length; c++) {
              var d = g[c];if (d.canCopy(a)) return this.applyDeepCopier(d, a);
            }throw new Error("Unable to clone the following object " + a);
          }, applyDeepCopier: function applyDeepCopier(a, b) {
            var c = a.create(b);if (this.cacheResult(b, c), this.depth++, this.depth > this.maxDepth) throw new Error("Maximum recursion depth exceeded.");return a.populate(this.recursiveDeepCopy, b, c), this.depth--, c;
          } }, e.DeepCopier = c, e.deepCopiers = g, e.register = function (a) {
          a instanceof c || (a = new c(a)), g.unshift(a);
        }, e.register({ canCopy: function canCopy() {
            return !0;
          }, create: function create(a) {
            return a instanceof a.constructor ? b(a.constructor.prototype) : {};
          }, populate: function populate(a, b, c) {
            for (var d in b) {
              b.hasOwnProperty(d) && (c[d] = a(b[d]));
            }return c;
          } }), e.register({ canCopy: function canCopy(a) {
            return a instanceof Array;
          }, create: function create(a) {
            return new a.constructor();
          }, populate: function populate(a, b, c) {
            for (var d = 0; d < b.length; d++) {
              c.push(a(b[d]));
            }return c;
          } }), e.register({ canCopy: function canCopy(a) {
            return a instanceof Date;
          }, create: function create(a) {
            return new Date(a);
          } }), e.register({ canCopy: function canCopy(a) {
            return f(a);
          }, create: function create(a) {
            return "undefined" != typeof document && a === document ? document : a.cloneNode(!1);
          }, populate: function populate(a, b, c) {
            if ("undefined" != typeof document && b === document) return document;if (b.childNodes && b.childNodes.length) for (var d = 0; d < b.childNodes.length; d++) {
              var e = a(b.childNodes[d]);c.appendChild(e);
            }
          } }), { deepCopy: e };
      }();return b.deepCopy(a);
    };var c = c || {};c.getNamespace = function () {
      return a.ns_ || a;
    }, c.uid = function () {
      var a = 1;return function () {
        return +new Date() + "_" + a++;
      };
    }(), c.isEmpty = function (a) {
      return void 0 === a || null === a || "" === a || a instanceof Array && 0 === a.length;
    }, c.isNotEmpty = function (a) {
      return !this.isEmpty(a);
    }, c.safeGet = function (a, b) {
      return b = this.exists(b) ? b : "", this.exists(a) ? a : b;
    }, c.isTrue = function (a) {
      return "undefined" != typeof a && ("string" == typeof a ? (a = a.toLowerCase(), "true" === a || "1" === a || "on" === a) : !!a);
    }, c.regionMatches = function (a, b, c, d, e) {
      if (b < 0 || d < 0 || b + e > a.length || d + e > c.length) return !1;for (; --e >= 0;) {
        var f = a.charAt(b++),
            g = c.charAt(d++);if (f != g) return !1;
      }return !0;
    }, c.exists = function (a) {
      return "undefined" != typeof a && null != a;
    }, !function () {
      var a = [],
          b = !1,
          d = !0;c.onSystemClockJump = function (c) {
        a.push(c), b || (b = !0, d = +new Date(), setInterval(function () {
          var b = d + 1e3,
              c = +new Date();d = c;var e = c - b;if (Math.abs(e) > 1e3) for (var f = 0; f < a.length; ++f) {
            a[f](e > 0);
          }
        }, 1e3));
      };
    }();var c = c || {};c.hasPageVisibilityAPISupport = function () {
      if ("undefined" == typeof document) return !1;var a = !1;return "undefined" != typeof document.hidden ? a = !0 : "undefined" != typeof document.mozHidden ? a = !0 : "undefined" != typeof document.msHidden ? a = !0 : "undefined" != typeof document.webkitHidden && (a = !0), function () {
        return a;
      };
    }(), c.getPageVisibilityAPI = function () {
      if ("undefined" == typeof document) return null;var a, b, c;"undefined" != typeof document.hidden ? (a = "hidden", b = "visibilitychange", c = "visibilityState") : "undefined" != typeof document.mozHidden ? (a = "mozHidden", b = "mozvisibilitychange", c = "mozVisibilityState") : "undefined" != typeof document.msHidden ? (a = "msHidden", b = "msvisibilitychange", c = "msVisibilityState") : "undefined" != typeof document.webkitHidden && (a = "webkitHidden", b = "webkitvisibilitychange", c = "webkitVisibilityState");var d = { hidden: a, visibilityChange: b, state: c };return function () {
        return d;
      };
    }(), c.isTabInBackground = function () {
      if ("undefined" == typeof document) return null;var a = c.getPageVisibilityAPI();return function () {
        return document[a.hidden];
      };
    }(), c.getBrowserName = function () {
      if (!navigator) return "";var a,
          b,
          c = navigator.userAgent || "",
          d = navigator.appName || "";return (b = c.indexOf("Opera")) != -1 || (b = c.indexOf("OPR/")) != -1 ? d = "Opera" : (b = c.indexOf("Android")) != -1 ? d = "Android" : (b = c.indexOf("Chrome")) != -1 ? d = "Chrome" : (b = c.indexOf("Safari")) != -1 ? d = "Safari" : (b = c.indexOf("Firefox")) != -1 ? d = "Firefox" : (b = c.indexOf("IEMobile")) != -1 ? d = "Internet Explorer Mobile" : "Microsoft Internet Explorer" == d || "Netscape" == d ? d = "Internet Explorer" : (a = c.lastIndexOf(" ") + 1) < (b = c.lastIndexOf("/")) ? (d = c.substring(a, b), d.toLowerCase() == d.toUpperCase() && (d = navigator.appName)) : d = "unknown", d;
    }, c.getBrowserFullVersion = function () {
      if (!navigator) return "";var a,
          b,
          c,
          d,
          e = navigator.userAgent || "",
          f = navigator.appName || "",
          g = navigator.appVersion ? "" + parseFloat(navigator.appVersion) : "";return (b = e.indexOf("Opera")) != -1 ? (g = e.substring(b + 6), (b = e.indexOf("Version")) != -1 && (g = e.substring(b + 8))) : (b = e.indexOf("OPR/")) != -1 ? g = e.substring(b + 4) : (b = e.indexOf("Android")) != -1 ? g = e.substring(b + 11) : (b = e.indexOf("Chrome")) != -1 ? g = e.substring(b + 7) : (b = e.indexOf("Safari")) != -1 ? (g = e.substring(b + 7), (b = e.indexOf("Version")) != -1 && (g = e.substring(b + 8))) : (b = e.indexOf("Firefox")) != -1 ? g = e.substring(b + 8) : "Microsoft Internet Explorer" == f ? (d = new RegExp("MSIE ([0-9]{1,}[.0-9]{0,})"), null != d.exec(e) && (g = parseFloat(RegExp.$1))) : "Netscape" == f ? (d = new RegExp("Trident/.*rv:([0-9]{1,}[.0-9]{0,})"), null != d.exec(e) && (g = parseFloat(RegExp.$1))) : g = e.lastIndexOf(" ") + 1 < (b = e.lastIndexOf("/")) ? e.substring(b + 1) : "unknown", g = g.toString(), (c = g.indexOf(";")) != -1 && (g = g.substring(0, c)), (c = g.indexOf(" ")) != -1 && (g = g.substring(0, c)), (c = g.indexOf(")")) != -1 && (g = g.substring(0, c)), a = parseInt("" + g, 10), isNaN(a) && (g = "" + parseFloat(navigator.appVersion)), g;
    }, c.browserAcceptsLargeURLs = function () {
      return "undefined" == typeof window || (null !== window.ActiveXObject, !0);
    }, c.isBrowser = function () {
      return "undefined" != typeof window && "undefined" != typeof document;
    }, c.isWebSecure = function () {
      return "undefined" != typeof document && null != document && "s" === document.location.href.charAt(4);
    };var d = function () {
      var a = 1e4;return function (b, c) {
        function d(a) {
          a = a || [];var c = [h, +new Date()];return b && c.push(b), a = Array.prototype.slice.call(a), c = c.concat(a);
        }function e(a) {
          var b, d, e;if ("boolean" == typeof c || !c) return !!c;if (e = a.join(" "), c instanceof Array && c.length > 0) {
            for (b = 0; b < c.length; ++b) {
              if (d = c[b], d instanceof RegExp && d.test(e)) return !0;
            }return !1;
          }if ("object" == (typeof c === "undefined" ? "undefined" : (0, _typeof3.default)(c))) {
            var f = !1;if (c.hide instanceof Array) for (b = 0; b < c.hide.length; ++b) {
              if (d = c.hide[b], d instanceof RegExp && d.test(e)) {
                f = !0;break;
              }
            }if (c.show instanceof Array) for (b = 0; b < c.show.length; ++b) {
              if (d = c.show[b], d instanceof RegExp && d.test(e)) return !0;
            }return !f && !c.show;
          }return !0;
        }function f(b) {
          var d = i.length;(d > a || c && c.max && d > c.max) && (i = i.slice(-Math.floor(c.max / 2)), i.push("Previous logs: " + d)), i.push(b);
        }var g = this,
            h = "comScore",
            i = [];g.log = function () {
          var a = d(arguments);f(a), "undefined" != typeof console && "function" == typeof console.log && e(a) && console.log.apply(console, a);
        }, g.warn = function () {
          var a = d(arguments);f(a), "undefined" != typeof console && "function" == typeof console.warn && e(a) && console.warn.apply(console, a);
        }, g.error = function () {
          var a = d(arguments);f(a), "undefined" != typeof console && "function" == typeof console.error && e(a) && console.error.apply(console, a);
        }, g.apiCall = function (a) {
          for (var b = ["API call to:", a], c = 1; c < arguments.length; ++c) {
            b.push("arg" + c + ":", arguments[c]);
          }this.log.apply(this, b);
        }, g.infoLog = function () {
          var a = ["Trace log:"];a.push.apply(a, Array.prototype.slice.call(arguments)), this.log.apply(this, a);
        }, g.deprecation = function (a, b) {
          var c = ["Deprecated API:", a, "is deprecated and will be eventually removed."];b && c.push("Use", b, "instead."), this.warn.apply(this, c);
        }, g.getLogHistory = function () {
          return i;
        };
      };
    }(),
        e = function () {
      function b(b) {
        if ("undefined" != typeof document) {
          a.mym || (a.mym = { ml: function ml() {}, a: function a() {} });var c = document.createElement("script");c.onload = b, c.onerror = b, c.onreadystatechange = function () {
            "loaded" == this.readyState && (c.onreadystatechange = null, c.onload = null, c.onerror = null, b());
          }, c.type = "text/javascript", c.async = !1, c.src = h, d(c);
        }
      }function d(a) {
        var b = document.getElementsByTagName("script")[0];b && b.parentNode && b.parentNode.insertBefore(a, b);
      }var e = {},
          f = !1,
          g = !1,
          h = "http" + ("s" == document.URL.charAt(4) ? "s://sb" : "://b") + ".scorecardresearch.com/rs/vce_st.js";return e.tryAsyncLoad = function () {
        if (!g && !a.mvce) {
          var c = !1;b(function () {
            c || (c = !0, g = !1);
          });
        }
      }, e.fillViewability = function (b, d) {
        if (!a.mvce) return void e.tryAsyncLoad();if (a.mvce.v) {
          var g = {},
              h = a.mvce.v({ n: b, l: {}, win: "undefined" != typeof execScript ? b.ownerDocument.parentWindow : b.ownerDocument.defaultView }, g);d.ns_st_vi = Math.floor(100 * h) + "", f || (d.ns_st_vce = "qp0"), f = !0, c.extend(d, g);
        }
      }, e;
    }(),
        f = function () {
      function a(a, c) {
        for (var d = this, e = 0; e < b.length; ++e) {
          var f = b[e];d[f] = function (b) {
            return function () {
              return a[b].apply(a, Array.prototype.slice.call(arguments));
            };
          }(f);
        }d.setAsset = function () {
          c.apply(null, Array.prototype.slice.call(arguments));
        }, function (a) {
          var b = a;b.getClip = function () {
            return b.getAsset();
          };
        }(d);
      }var b = ["getAsset", "getLabels", "setLabels", "setLabel", "getLabel", "getPlaybackSessionID"];return a;
    }(),
        g = a.StreamingAnalytics.InternalStates,
        h = a.StreamingAnalytics.PlayerEvents;b.prototype = a.StreamingAnalytics.prototype, a.StreamingAnalytics.Plugin = b, b.extractParams = function (a, b, c) {
      var d,
          e,
          f,
          g = b.length,
          h = {},
          i = a.indexOf(b);if ("undefined" == typeof c && (c = "&"), i >= 0) for (f = a.substr(i + g).split(c), d = 0, e = f.length; d < e; d++) {
        var j = f[d].split("=");2 === j.length && (h[j[0]] = decodeURIComponent(j[1]));
      }return h;
    }, b.viewNotify = function (a, b) {
      var d, e;c.isBrowser() ? (d = window, e = document) : (d = {}, e = { location: { href: "" }, title: "", URL: "", referrer: "", cookie: "" });var f = b.getLiveEndpointURL(),
          g = "undefined",
          h = d.comScore || d.sitestat || function (a) {
        var f,
            h,
            i,
            j,
            k,
            l = "comScore=",
            m = e.cookie,
            n = "",
            o = "indexOf",
            p = "substring",
            q = "length",
            r = c.browserAcceptsLargeURLs() ? d.ns_.StreamingAnalytics.Constants.URL_LENGTH_LIMIT : d.ns_.StreamingAnalytics.Constants.RESTRICTED_URL_LENGTH_LIMIT,
            s = "&ns_",
            t = "&",
            u = d.encodeURIComponent || escape;if (m[o](l) + 1) for (j = 0, i = m.split(";"), k = i[q]; j < k; j++) {
          h = i[j][o](l), h + 1 && (n = t + unescape(i[j][p](h + l[q])));
        }a += s + "_t=" + +new Date() + s + "c=" + (e.characterSet || e.defaultCharset || "") + n, a.length > r && a.indexOf(t) > 0 && (f = a.substr(0, r - 8).lastIndexOf(t), a = (a.substring(0, f) + s + "cut=" + u(a.substring(f + 1))).substr(0, r)), b.getPlatformAPI().httpGet(a), (0, _typeof3.default)(d.ns_p) === g && (d.ns_p = { src: a }), d.ns_p.lastMeasurement = a;
      },
          i = decodeURIComponent || unescape,
          j = {},
          k = f.indexOf("?");if (k >= 0 && k < f.length - 1) {
        for (var l = f.substring(k + 1).split("&"), m = 0, n = l.length; m < n; m++) {
          var o = l[m],
              p = o.split("=");2 == p.length && (j[p[0]] = i(p[1]));
        }f = f.substring(0, k + 1);
      }var q = j;if ((typeof a === "undefined" ? "undefined" : (0, _typeof3.default)(a)) !== g) {
        for (var r in a) {
          a.hasOwnProperty(r) && (q[r] = a[r]);
        }var s = [],
            t = d.encodeURIComponent || escape;for (r in q) {
          s.push(t(r) + "=" + t(q[r]));
        }/[\?\&]$/.test(f) || (f += "&"), f += s.join("&");
      }return h(f);
    }, a.StreamSense.Plugin = b;
  }), function (a) {
    "use strict";
    return "undefined" != typeof ns_ && ns_.StreamSense && ns_.StreamingAnalytics.Plugin ? void a(ns_) : void ("undefined" != typeof console && console.error && console.error("The comScore Streaming Analytics library was not properly loaded."));
  }(function (a) {
    "use strict";
    var b = b || {};b.indexOf = function (a, b) {
      var c = -1;return this.forEach(b, function (b, d) {
        b == a && (c = d);
      }), c;
    }, b.forEach = function (a, b, c) {
      try {
        if ("function" == typeof b) if (c = "undefined" != typeof c ? c : null, "number" != typeof a.length || "undefined" == typeof a[0]) {
          var d = "undefined" != typeof a.__proto__;for (var e in a) {
            a.hasOwnProperty(e) && (!d || d && "undefined" == typeof a.__proto__[e]) && "function" != typeof a[e] && b.call(c, a[e], e);
          }
        } else for (var f = 0, g = a.length; f < g; f++) {
          b.call(c, a[f], f);
        }
      } catch (h) {}
    };var b = b || {};b.parseBoolean = function (a, b) {
      return b = b || !1, a ? "0" != a : b;
    }, b.parseInteger = function (a, b) {
      return null == a || isNaN(a) ? b || 0 : parseInt(a);
    }, b.parseLong = function (a, b) {
      var c = Number(a);return null == a || isNaN(c) ? b || 0 : c;
    }, b.toString = function (a) {
      if ("undefined" == typeof a) return "undefined";if ("string" == typeof a) return a;if (a instanceof Array) return a.join(",");var b = "";for (var c in a) {
        a.hasOwnProperty(c) && (b += c + ":" + a[c] + ";");
      }return b || a.toString();
    };var b = b || {};b.filter = function (a, b) {
      var c = {};for (var d in b) {
        b.hasOwnProperty(d) && a(b[d]) && (c[d] = b[d]);
      }return c;
    }, b.extend = function (a) {
      var b,
          c = arguments.length;a = a || {};for (var d = 1; d < c; d++) {
        if (b = arguments[d]) for (var e in b) {
          b.hasOwnProperty(e) && (a[e] = b[e]);
        }
      }return a;
    };var b = b || {};b.cloneObject = function (a) {
      if (null == a || "object" != (typeof a === "undefined" ? "undefined" : (0, _typeof3.default)(a))) return a;var b = function () {
        function a() {}function b(b) {
          return "object" == (typeof b === "undefined" ? "undefined" : (0, _typeof3.default)(b)) ? (a.prototype = b, new a()) : b;
        }function c(a) {
          for (var b in a) {
            a.hasOwnProperty(b) && (this[b] = a[b]);
          }
        }function d() {
          this.copiedObjects = [];var a = this;this.recursiveDeepCopy = function (b) {
            return a.deepCopy(b);
          }, this.depth = 0;
        }function e(a, b) {
          var c = new d();return b && (c.maxDepth = b), c.deepCopy(a);
        }function f(a) {
          return "undefined" != typeof window && window && window.Node ? a instanceof Node : "undefined" != typeof document && a === document || "number" == typeof a.nodeType && a.attributes && a.childNodes && a.cloneNode;
        }var g = [];return c.prototype = { constructor: c, canCopy: function canCopy() {
            return !1;
          }, create: function create(a) {}, populate: function populate(a, b, c) {} }, d.prototype = { constructor: d, maxDepth: 256, cacheResult: function cacheResult(a, b) {
            this.copiedObjects.push([a, b]);
          }, getCachedResult: function getCachedResult(a) {
            for (var b = this.copiedObjects, c = b.length, d = 0; d < c; d++) {
              if (b[d][0] === a) return b[d][1];
            }
          }, deepCopy: function deepCopy(a) {
            if (null === a) return null;if ("object" != (typeof a === "undefined" ? "undefined" : (0, _typeof3.default)(a))) return a;var b = this.getCachedResult(a);if (b) return b;for (var c = 0; c < g.length; c++) {
              var d = g[c];if (d.canCopy(a)) return this.applyDeepCopier(d, a);
            }throw new Error("Unable to clone the following object " + a);
          }, applyDeepCopier: function applyDeepCopier(a, b) {
            var c = a.create(b);if (this.cacheResult(b, c), this.depth++, this.depth > this.maxDepth) throw new Error("Maximum recursion depth exceeded.");return a.populate(this.recursiveDeepCopy, b, c), this.depth--, c;
          } }, e.DeepCopier = c, e.deepCopiers = g, e.register = function (a) {
          a instanceof c || (a = new c(a)), g.unshift(a);
        }, e.register({ canCopy: function canCopy() {
            return !0;
          }, create: function create(a) {
            return a instanceof a.constructor ? b(a.constructor.prototype) : {};
          }, populate: function populate(a, b, c) {
            for (var d in b) {
              b.hasOwnProperty(d) && (c[d] = a(b[d]));
            }return c;
          } }), e.register({ canCopy: function canCopy(a) {
            return a instanceof Array;
          }, create: function create(a) {
            return new a.constructor();
          }, populate: function populate(a, b, c) {
            for (var d = 0; d < b.length; d++) {
              c.push(a(b[d]));
            }return c;
          } }), e.register({ canCopy: function canCopy(a) {
            return a instanceof Date;
          }, create: function create(a) {
            return new Date(a);
          } }), e.register({ canCopy: function canCopy(a) {
            return f(a);
          }, create: function create(a) {
            return "undefined" != typeof document && a === document ? document : a.cloneNode(!1);
          }, populate: function populate(a, b, c) {
            if ("undefined" != typeof document && b === document) return document;if (b.childNodes && b.childNodes.length) for (var d = 0; d < b.childNodes.length; d++) {
              var e = a(b.childNodes[d]);c.appendChild(e);
            }
          } }), { deepCopy: e };
      }();return b.deepCopy(a);
    };var b = b || {};b.getNamespace = function () {
      return a.ns_ || a;
    }, b.uid = function () {
      var a = 1;return function () {
        return +new Date() + "_" + a++;
      };
    }(), b.isEmpty = function (a) {
      return void 0 === a || null === a || "" === a || a instanceof Array && 0 === a.length;
    }, b.isNotEmpty = function (a) {
      return !this.isEmpty(a);
    }, b.safeGet = function (a, b) {
      return b = this.exists(b) ? b : "", this.exists(a) ? a : b;
    }, b.isTrue = function (a) {
      return "undefined" != typeof a && ("string" == typeof a ? (a = a.toLowerCase(), "true" === a || "1" === a || "on" === a) : !!a);
    }, b.regionMatches = function (a, b, c, d, e) {
      if (b < 0 || d < 0 || b + e > a.length || d + e > c.length) return !1;for (; --e >= 0;) {
        var f = a.charAt(b++),
            g = c.charAt(d++);if (f != g) return !1;
      }return !0;
    }, b.exists = function (a) {
      return "undefined" != typeof a && null != a;
    }, !function () {
      var a = [],
          c = !1,
          d = !0;b.onSystemClockJump = function (b) {
        a.push(b), c || (c = !0, d = +new Date(), setInterval(function () {
          var b = d + 1e3,
              c = +new Date();d = c;var e = c - b;if (Math.abs(e) > 1e3) for (var f = 0; f < a.length; ++f) {
            a[f](e > 0);
          }
        }, 1e3));
      };
    }();var b = b || {};b.hasPageVisibilityAPISupport = function () {
      if ("undefined" == typeof document) return !1;var a = !1;return "undefined" != typeof document.hidden ? a = !0 : "undefined" != typeof document.mozHidden ? a = !0 : "undefined" != typeof document.msHidden ? a = !0 : "undefined" != typeof document.webkitHidden && (a = !0), function () {
        return a;
      };
    }(), b.getPageVisibilityAPI = function () {
      if ("undefined" == typeof document) return null;var a, b, c;"undefined" != typeof document.hidden ? (a = "hidden", b = "visibilitychange", c = "visibilityState") : "undefined" != typeof document.mozHidden ? (a = "mozHidden", b = "mozvisibilitychange", c = "mozVisibilityState") : "undefined" != typeof document.msHidden ? (a = "msHidden", b = "msvisibilitychange", c = "msVisibilityState") : "undefined" != typeof document.webkitHidden && (a = "webkitHidden", b = "webkitvisibilitychange", c = "webkitVisibilityState");var d = { hidden: a, visibilityChange: b, state: c };return function () {
        return d;
      };
    }(), b.isTabInBackground = function () {
      if ("undefined" == typeof document) return null;var a = b.getPageVisibilityAPI();return function () {
        return document[a.hidden];
      };
    }(), b.getBrowserName = function () {
      if (!navigator) return "";var a,
          b,
          c = navigator.userAgent || "",
          d = navigator.appName || "";return (b = c.indexOf("Opera")) != -1 || (b = c.indexOf("OPR/")) != -1 ? d = "Opera" : (b = c.indexOf("Android")) != -1 ? d = "Android" : (b = c.indexOf("Chrome")) != -1 ? d = "Chrome" : (b = c.indexOf("Safari")) != -1 ? d = "Safari" : (b = c.indexOf("Firefox")) != -1 ? d = "Firefox" : (b = c.indexOf("IEMobile")) != -1 ? d = "Internet Explorer Mobile" : "Microsoft Internet Explorer" == d || "Netscape" == d ? d = "Internet Explorer" : (a = c.lastIndexOf(" ") + 1) < (b = c.lastIndexOf("/")) ? (d = c.substring(a, b), d.toLowerCase() == d.toUpperCase() && (d = navigator.appName)) : d = "unknown", d;
    }, b.getBrowserFullVersion = function () {
      if (!navigator) return "";var a,
          b,
          c,
          d,
          e = navigator.userAgent || "",
          f = navigator.appName || "",
          g = navigator.appVersion ? "" + parseFloat(navigator.appVersion) : "";return (b = e.indexOf("Opera")) != -1 ? (g = e.substring(b + 6), (b = e.indexOf("Version")) != -1 && (g = e.substring(b + 8))) : (b = e.indexOf("OPR/")) != -1 ? g = e.substring(b + 4) : (b = e.indexOf("Android")) != -1 ? g = e.substring(b + 11) : (b = e.indexOf("Chrome")) != -1 ? g = e.substring(b + 7) : (b = e.indexOf("Safari")) != -1 ? (g = e.substring(b + 7), (b = e.indexOf("Version")) != -1 && (g = e.substring(b + 8))) : (b = e.indexOf("Firefox")) != -1 ? g = e.substring(b + 8) : "Microsoft Internet Explorer" == f ? (d = new RegExp("MSIE ([0-9]{1,}[.0-9]{0,})"), null != d.exec(e) && (g = parseFloat(RegExp.$1))) : "Netscape" == f ? (d = new RegExp("Trident/.*rv:([0-9]{1,}[.0-9]{0,})"), null != d.exec(e) && (g = parseFloat(RegExp.$1))) : g = e.lastIndexOf(" ") + 1 < (b = e.lastIndexOf("/")) ? e.substring(b + 1) : "unknown", g = g.toString(), (c = g.indexOf(";")) != -1 && (g = g.substring(0, c)), (c = g.indexOf(" ")) != -1 && (g = g.substring(0, c)), (c = g.indexOf(")")) != -1 && (g = g.substring(0, c)), a = parseInt("" + g, 10), isNaN(a) && (g = "" + parseFloat(navigator.appVersion)), g;
    }, b.browserAcceptsLargeURLs = function () {
      return "undefined" == typeof window || (null !== window.ActiveXObject, !0);
    }, b.isBrowser = function () {
      return "undefined" != typeof window && "undefined" != typeof document;
    }, b.isWebSecure = function () {
      return "undefined" != typeof document && null != document && "s" === document.location.href.charAt(4);
    };var b = b || {};b.hasPageVisibilityAPISupport = function () {
      if ("undefined" == typeof document) return !1;var a = !1;return "undefined" != typeof document.hidden ? a = !0 : "undefined" != typeof document.mozHidden ? a = !0 : "undefined" != typeof document.msHidden ? a = !0 : "undefined" != typeof document.webkitHidden && (a = !0), function () {
        return a;
      };
    }(), b.getPageVisibilityAPI = function () {
      if ("undefined" == typeof document) return null;var a, b, c;"undefined" != typeof document.hidden ? (a = "hidden", b = "visibilitychange", c = "visibilityState") : "undefined" != typeof document.mozHidden ? (a = "mozHidden", b = "mozvisibilitychange", c = "mozVisibilityState") : "undefined" != typeof document.msHidden ? (a = "msHidden", b = "msvisibilitychange", c = "msVisibilityState") : "undefined" != typeof document.webkitHidden && (a = "webkitHidden", b = "webkitvisibilitychange", c = "webkitVisibilityState");var d = { hidden: a, visibilityChange: b, state: c };return function () {
        return d;
      };
    }(), b.isTabInBackground = function () {
      if ("undefined" == typeof document) return null;var a = b.getPageVisibilityAPI();return function () {
        return document[a.hidden];
      };
    }(), b.getBrowserName = function () {
      if (!navigator) return "";var a,
          b,
          c = navigator.userAgent || "",
          d = navigator.appName || "";return (b = c.indexOf("Opera")) != -1 || (b = c.indexOf("OPR/")) != -1 ? d = "Opera" : (b = c.indexOf("Android")) != -1 ? d = "Android" : (b = c.indexOf("Chrome")) != -1 ? d = "Chrome" : (b = c.indexOf("Safari")) != -1 ? d = "Safari" : (b = c.indexOf("Firefox")) != -1 ? d = "Firefox" : (b = c.indexOf("IEMobile")) != -1 ? d = "Internet Explorer Mobile" : "Microsoft Internet Explorer" == d || "Netscape" == d ? d = "Internet Explorer" : (a = c.lastIndexOf(" ") + 1) < (b = c.lastIndexOf("/")) ? (d = c.substring(a, b), d.toLowerCase() == d.toUpperCase() && (d = navigator.appName)) : d = "unknown", d;
    }, b.getBrowserFullVersion = function () {
      if (!navigator) return "";var a,
          b,
          c,
          d,
          e = navigator.userAgent || "",
          f = navigator.appName || "",
          g = navigator.appVersion ? "" + parseFloat(navigator.appVersion) : "";return (b = e.indexOf("Opera")) != -1 ? (g = e.substring(b + 6), (b = e.indexOf("Version")) != -1 && (g = e.substring(b + 8))) : (b = e.indexOf("OPR/")) != -1 ? g = e.substring(b + 4) : (b = e.indexOf("Android")) != -1 ? g = e.substring(b + 11) : (b = e.indexOf("Chrome")) != -1 ? g = e.substring(b + 7) : (b = e.indexOf("Safari")) != -1 ? (g = e.substring(b + 7), (b = e.indexOf("Version")) != -1 && (g = e.substring(b + 8))) : (b = e.indexOf("Firefox")) != -1 ? g = e.substring(b + 8) : "Microsoft Internet Explorer" == f ? (d = new RegExp("MSIE ([0-9]{1,}[.0-9]{0,})"), null != d.exec(e) && (g = parseFloat(RegExp.$1))) : "Netscape" == f ? (d = new RegExp("Trident/.*rv:([0-9]{1,}[.0-9]{0,})"), null != d.exec(e) && (g = parseFloat(RegExp.$1))) : g = e.lastIndexOf(" ") + 1 < (b = e.lastIndexOf("/")) ? e.substring(b + 1) : "unknown", g = g.toString(), (c = g.indexOf(";")) != -1 && (g = g.substring(0, c)), (c = g.indexOf(" ")) != -1 && (g = g.substring(0, c)), (c = g.indexOf(")")) != -1 && (g = g.substring(0, c)), a = parseInt("" + g, 10), isNaN(a) && (g = "" + parseFloat(navigator.appVersion)), g;
    }, b.browserAcceptsLargeURLs = function () {
      return "undefined" == typeof window || (null !== window.ActiveXObject, !0);
    }, b.isBrowser = function () {
      return "undefined" != typeof window && "undefined" != typeof document;
    }, b.isWebSecure = function () {
      return "undefined" != typeof document && null != document && "s" === document.location.href.charAt(4);
    };var c = ["getPlaylist", "getClip", "setPlaylist", "setClip", "setLabel", "setLabels", "onGetLabels", "play", "pause", "end", "bufferStart", "bufferStop", "load", "start", "seekStart", "skipAd", "callToAction", "error", "transferPlayback", "drmFail", "drmApprove", "drmDeny", "changeBitrate", "changePlaybackRate", "changeVolume", "changeWindowState", "changeAudio", "changeVideo", "changeSubtitle", "changeCDN", "labelMapping", "getGenericPluginVersion", "setDuration", "setVideoSize"];a.StreamSense.Html5 = function (d, e) {
      function f() {
        J = new a.StreamingAnalytics.Plugin(e, G, H, I, { release: j, position: o, preMeasurement: g, postMeasurement: h }), J.log("init"), b.extend(F, { attachTo: i, detach: j }), i(d), E(), J.setLabel("ns_ap_pn", "js", !0), J.setLabel("ns_ap_pfm", "html", !0);
      }function g(b, c, d) {
        return J.log("OnPreMeasurement: " + b), J.setLabel("ns_st_br", Q, !0), J.setLabel("ns_st_vo", m(), !0), J.setLabel("ns_st_ws", r() ? "full" : "norm", !0), !(c === a.StreamSense.PlayerEvents.PLAY && !p());
      }function h(a) {
        J.log("OnPostMeasurement: " + a);
      }function i(a) {
        if (J.log("attachTo"), a) {
          W && j(), X = a;for (var b in V) {
            V.hasOwnProperty(b) && k(b, V[b], !1);
          }O || (J.setSmartStateDetection(!0), J.setDetectEnd(!0), J.setDetectPause(!0), J.setDetectPlay(!0), J.setDetectSeek(!0)), W = !0;
        }
      }function j() {
        J.log("detach");for (var a in V) {
          V.hasOwnProperty(a) && l(a, V[a], !1);
        }O || (J.setSmartStateDetection(!1), J.setDetectEnd(!1), J.setDetectPause(!1), J.setDetectPlay(!1), J.setDetectSeek(!1)), X = null, W = !1;
      }function k(a, b) {
        J.log("bind: " + a), X.addEventListener(a, b, !1);
      }function l(a, b) {
        J.log("unbind: " + a), X.removeEventListener(a, b, !1);
      }function m() {
        return X.muted ? 0 : 100 * X.volume;
      }function n() {
        return K ? isNaN(X.duration) ? 0 : Math.max(Math.floor(1e3 * X.duration), 0) : 0;
      }function o() {
        return !X || isNaN(X.currentTime) ? 0 : Math.max(Math.floor(1e3 * X.currentTime), 0);
      }function p() {
        return O ? !(X.paused || X.ended || X.seeking) : !(X.paused || X.ended || X.seeking || X.readyState < X.HAVE_FUTURE_DATA);
      }function q() {
        return X.ended;
      }function r() {
        return document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen;
      }function s() {
        J.log("loadStart"), K = !1, L = 0, R || (R = !0), J.setClipLabel("ns_st_ty", "video", !0), J.setClipLabel("ns_st_cs", [X.width, X.height].join("x"), !0), X.title && (J.setClipLabel("ns_st_ep", X.title, !0), J.setClipLabel("ns_st_pr", X.title, !0)), J.setClipLabel("ns_st_cu", X.currentSrc, !0);for (var a = {}, b = 0; b < X.attributes.length; ++b) {
          var c = X.attributes[b];a[c.name] = c.value;
        }for (var d in X) {
          X.hasOwnProperty(d) && ("webkitDisplayingFullscreen" === d || "webkitSupportsFullscreen" === d || "number" != typeof X[d] && "string" != typeof X[d] && "boolean" != typeof X[d] || (a[d] = X[d]));
        }var e = [{ prefix: "", map: a }],
            f = J.getClip().getLabels();J.setClip(f, !1, e, !0);
      }function t() {
        R = !1;
      }function u() {
        J.log("playing"), O ? p() && (S ? J.play({ ns_st_ui: "seek" }) : J.play(), S = !1) : 0 == o() && J.play(0);
      }function v() {
        J.log("waiting"), R || s(), A();
      }function w() {
        J.log("pause"), O && (q() || (N ? J.pause(M) : J.pause()));
      }function x() {
        J.log("ended"), q() && J.end();
      }function y() {
        J.log("timeUpdate");var a,
            b = o() - L;X.webkitVideoDecodedByteCount && (L && b && (a = X.webkitVideoDecodedByteCount, Q = Math.abs(Math.round(1e3 * (a - P) / b))), P = X.webkitVideoDecodedByteCount), 0 === b && A(), L = o(), L > 0 && (M = L);
      }function z() {
        if (J.log("seeking"), T = !1, O) {
          var a = N ? M : L;J.pause(a);
        }
      }function A() {
        T = !0, setTimeout(B, U);
      }function B() {
        T && J.bufferStart();
      }function C() {
        J.log("seeked"), S = !0;
      }function D() {
        K = !0, J.setClipLabel("ns_st_cl", n(), !0);
      }function E() {
        for (var a = 0; a < c.length; ++a) {
          J[c[a]] && (F[c[a]] = J[c[a]]);
        }
      }var F = this,
          G = "html5",
          H = "3.2.10",
          I = b.getBrowserName() + " " + b.getBrowserFullVersion(),
          J = null,
          K = !1,
          L = 0,
          M = -1,
          N = navigator.userAgent.indexOf("iPhone") > -1 || navigator.userAgent.indexOf("iPad") > -1 || navigator.userAgent.indexOf("iPod") > -1,
          O = "Internet Explorer Mobile" == b.getBrowserName() && b.getBrowserFullVersion() < 11,
          P = 0,
          Q = 0,
          R = !1,
          S = !1,
          T = !0,
          U = 250,
          V = { loadstart: s, emptied: t, playing: u, waiting: v, pause: w, ended: x, timeupdate: y, seeking: z, seeked: C, durationchange: D },
          W = !1,
          X = null;f();
    };
  });
}).call(window);

/***/ }),

/***/ "QcWB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__("Ds5P");
var newPromiseCapability = __webpack_require__("w6Dh");
var perform = __webpack_require__("SDXa");

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),

/***/ "Qh14":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("ReGu");
var enumBugKeys = __webpack_require__("QKXm");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ "R3AP":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("OzIq");
var hide = __webpack_require__("2p1q");
var has = __webpack_require__("WBcL");
var SRC = __webpack_require__("ulTY")('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__("7gX0").inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),

/***/ "ReGu":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("WBcL");
var toIObject = __webpack_require__("PHqh");
var arrayIndexOf = __webpack_require__("ot5s")(false);
var IE_PROTO = __webpack_require__("mZON")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "RhFG":
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__("kkCw")('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__("2p1q")(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "S+dD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _assign = __webpack_require__("woOf");

var _assign2 = _interopRequireDefault(_assign);

var _errorType = __webpack_require__("0PB5");

var _errorType2 = _interopRequireDefault(_errorType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Sizzle = __webpack_require__("zZaF");
var VideoConfig = __webpack_require__("Pqsl");
var Device = __webpack_require__("xOtj");
var Debug = __webpack_require__("BF+C")('android-fallback');
var VideoAttributes = __webpack_require__("tpcr");
var VideoDataBuilder = __webpack_require__("0t/H");
var Stats = __webpack_require__("ahyN");

var DEFAULT_CONFIG = {
    packageName: 'se.svt.android.svtplay',
    baseUrl: 'www.svtplay.se/app/android?play=',
    androidFallbackBaseUrl: 'http://api.svt.se/videoplayer-embed/android/',
    androidFallbackInstallUrl: 'http://api.svt.se/videoplayer-embed/android/install'
};

var BOLIBOMPA_CONFIG = {
    packageName: 'se.svt.bolibompa',
    baseUrl: 'www.svt.se/barnkanalen/bolibompa/android-update.html?play='
};

var BARN_CONFIG = {
    packageName: 'svt.se.barnkanalen',
    androidFallbackBaseUrl: 'https://www.svt.se/barnkanalen/barnplay/app-download/',
    androidFallbackInstallUrl: 'https://www.svt.se/barnkanalen/barnplay/app-download/'
};

module.exports = {
    create: function create(api) {
        function _sendEvent(eventType, data) {
            api.fire(eventType, data);
        }

        function _buildExternalDeviceUrlForAndroid(videoData) {
            var client = Stats.getClient();

            var config = void 0;
            if (VideoConfig.androidFallback) {
                config = (0, _assign2.default)({}, DEFAULT_CONFIG, VideoConfig.androidFallback);
            } else if (client === 'bolibompa') {
                config = (0, _assign2.default)({}, DEFAULT_CONFIG, BOLIBOMPA_CONFIG);
            } else if (client === 'barnplay' || client === 'barnkanalen') {
                config = (0, _assign2.default)({}, DEFAULT_CONFIG, BARN_CONFIG);
            } else {
                config = (0, _assign2.default)({}, DEFAULT_CONFIG);
            }

            var _config = config,
                packageName = _config.packageName,
                baseUrl = _config.baseUrl,
                androidFallbackBaseUrl = _config.androidFallbackBaseUrl,
                androidFallbackInstallUrl = _config.androidFallbackInstallUrl;


            var playVideoDataFallbackUrl = androidFallbackBaseUrl + 'videodata/?json=' + encodeURIComponent((0, _stringify2.default)(videoData));
            var url = baseUrl + encodeURIComponent(playVideoDataFallbackUrl);

            if (Device.isAndroidIntentCapable()) {
                url = 'intent://' + url + '#Intent;scheme=http;package=' + packageName + ';S.browser_fallback_url=' + encodeURIComponent(androidFallbackInstallUrl) + ';end';
            } else {
                url = (window.location.protocol || 'https:') + '//' + url;
            }
            Debug(['buildExternalDeviceUrlForAndroid', 'client: ' + client, 'packageName: ' + packageName, 'baseUrl: ' + baseUrl, 'androidFallbackBaseUrl: ' + androidFallbackBaseUrl, 'androidFallbackInstallUrl: ' + androidFallbackInstallUrl, 'fullUrl: ' + url].join('\n'));

            return url;
        }

        function _getMetadataForAndroidNativePlayer(videoId, onSuccess) {
            VideoConfig.metadataFetchFunction(videoId, function (metadata) {
                api.fire('metadata', metadata);
                if (api.data().inSweden !== undefined && !api.data().inSweden && metadata.rights && metadata.rights.geoBlockedSweden) {
                    api.fire('error', {
                        name: _errorType2.default.GEO_BLOCK_ERROR
                    });

                    return;
                }

                var videoElement = Sizzle('video', api.element())[0];

                api.data()._video = videoElement;

                var videoData = VideoDataBuilder.build(videoId, metadata, api);

                videoData.video.position = VideoAttributes.getStartPosition(videoElement);
                _sendEvent('ready', {
                    videoId: videoData.videoId,
                    externalUi: true
                });
                api.state().loading = false;
                api.state().ready = true;
                onSuccess(videoData);
            }, function (error, data) {
                if (data) {
                    api.fire('metadata', data);
                }
                api.fire('error', error);
            });
        }

        if (Device.forceAndroidFallbackMode()) {

            var videoData,
                filter = {
                load: function load() {
                    var videoId = Sizzle('video', api.element())[0].getAttribute('data-video-id');
                    api.element().on('click', function () {
                        api.play().catch(function () {
                            /*
                             * Wrapper API will throw a 'Interrupted by filters' error because
                             * play() of the play-filter below. The error is expected and can
                             * be ignored.
                             */
                        });
                    });

                    _getMetadataForAndroidNativePlayer(videoId, function (metadata) {
                        videoData = metadata;
                        api.state().ready = true;

                        _sendEvent('ready', {
                            videoId: videoId,
                            externalUi: true
                        });
                    });

                    return true;
                },
                play: function play() {
                    var videoId = Sizzle('video', api.element())[0].getAttribute('data-video-id'),
                        url;

                    if (videoId) {
                        url = _buildExternalDeviceUrlForAndroid(videoData);
                        //Debug('changeVideo android-url: ' + url);
                        window.location = url;

                        return true;
                    }

                    return false;
                }
            };

            api.filters.push(filter);
        }
    },

    destroy: function destroy(api) {
        // empty
    }
};

/***/ }),

/***/ "SCKt":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("gYYG");
__webpack_require__("1A13");
__webpack_require__("fx22");
__webpack_require__("y9m4");
__webpack_require__("+Mt+");
__webpack_require__("QcWB");
module.exports = __webpack_require__("7gX0").Promise;


/***/ }),

/***/ "SDXa":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),

/***/ "SHe9":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("wC1N");
var ITERATOR = __webpack_require__("kkCw")('iterator');
var Iterators = __webpack_require__("bN1p");
module.exports = __webpack_require__("7gX0").getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ "SWGL":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ "Sejc":
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__("rFzY");
var invoke = __webpack_require__("PHCx");
var html = __webpack_require__("d075");
var cel = __webpack_require__("jhxf");
var global = __webpack_require__("OzIq");
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__("ydD5")(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),

/***/ "St71":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("FKWp");
var get = __webpack_require__("1yV6");
module.exports = __webpack_require__("iANj").getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),

/***/ "THEY":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "TdxG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _typeof2 = __webpack_require__("pFYg");

var _typeof3 = _interopRequireDefault(_typeof2);

exports.createNode = createNode;
exports.getAttributes = getAttributes;
exports.fromString = fromString;
exports.getScript = getScript;
exports.toggleClass = toggleClass;
exports.addClass = addClass;
exports.removeClass = removeClass;
exports.hasClass = hasClass;
exports.hide = hide;
exports.show = show;
exports.forceRedraw = forceRedraw;
exports.addEvents = addEvents;
exports.removeEvents = removeEvents;
exports.getKeyFromKeyEvent = getKeyFromKeyEvent;
exports.setStoredData = setStoredData;
exports.getStoredData = getStoredData;
exports.isFullscreen = isFullscreen;
exports.toggleVideoFullscreen = toggleVideoFullscreen;
exports.exitVideoFullscreen = exitVideoFullscreen;
exports.enterVideoFullscreen = enterVideoFullscreen;

var _eventWrapperApi = __webpack_require__("YxlO");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Sizzle = __webpack_require__("zZaF");
var extend = __webpack_require__("5E+y");
var device = __webpack_require__("xOtj");
var Debug = __webpack_require__("BF+C")('svp-domutils');

var NAMESPACE = 'svp-domutils',
    STORAGE_NAMESPACE = 'svp_storage';

var scripts = {};

var keyCodeKeyMap = {
    9: 'tab',
    13: 'enter',
    17: 'controlleft',
    27: 'escape',
    32: 'space',
    35: 'end',
    36: 'home',
    37: 'arrowleft',
    38: 'arrowup',
    39: 'arrowright',
    40: 'arrowdown',
    48: 'digit0',
    49: 'digit1',
    50: 'digit2',
    51: 'digit3',
    52: 'digit4',
    53: 'digit5',
    54: 'digit6',
    55: 'digit7',
    56: 'digit8',
    57: 'digit9',
    67: 'keyc',
    70: 'keyf',
    77: 'keym',
    69: 'keye'
};

// Internet explorer and Firefox has their own vision of which key maps to which keyEvent.key ..
var ieKeyMap = {
    0: 'digit0',
    1: 'digit1',
    2: 'digit2',
    3: 'digit3',
    4: 'digit4',
    5: 'digit5',
    6: 'digit6',
    7: 'digit7',
    8: 'digit8',
    9: 'digit9',
    c: 'keyc',
    f: 'keyf',
    m: 'keym',
    e: 'keye',
    ' ': 'space',
    spacebar: 'space',
    escape: 'escape',
    up: 'arrowup',
    down: 'arrowdown',
    left: 'arrowleft',
    right: 'arrowright'
};

function _getBoundedRegExp(string) {
    return new RegExp('\\s?' + string, 'gi');
}

function _applyAll(el, fn) {
    var elements = Array.isArray(el) ? el : [el];
    elements.forEach(fn);
}

function _isFullscreen() {
    return document.fullscreen || document.mozFullScreen || document.webkitIsFullScreen || document.msFullscreenElement;
}

function createNode(type, attributes) {
    var node = document.createElement(type);

    if (attributes && (typeof attributes === 'undefined' ? 'undefined' : (0, _typeof3.default)(attributes)) === 'object') {
        for (var key in attributes) {
            if (Object.prototype.hasOwnProperty.call(attributes, key)) {
                node.setAttribute(key, attributes[key]);
            }
        }
    }

    return node;
}

function getAttributes(el) {
    var namedNodeMap = el.attributes;
    var res = {},
        currItem = void 0;

    for (var i = 0; i < namedNodeMap.length; i++) {
        currItem = namedNodeMap.item(i);
        res[currItem.name] = currItem.value;
    }

    return res;
}

function fromString(htmlString) {
    var el = document.createElement('div');
    el.innerHTML = htmlString;

    return el.childNodes[0];
}

function getScript(src) {
    // Exit early if script already loaded
    var loadedScript = scripts[src];
    if (loadedScript && loadedScript.pendingPromise) {
        return loadedScript.pendingPromise;
    } else if (loadedScript) {
        return _promise2.default.resolve();
    }

    var scriptNode = this.createNode('script', {
        type: 'text/javascript',
        src: src
    });

    var promise = new _promise2.default(function (resolve, reject) {
        scriptNode.onload = function () {
            scriptNode.onload = undefined;
            scripts[src].pendingPromise = false;
            resolve();
        };
        scriptNode.onerror = function (err) {
            scriptNode.onerror = undefined;
            scripts[src].pendingPromise = false;
            reject(err);
        };
        Sizzle('body')[0].appendChild(scriptNode);
    });

    scripts[src] = { pendingPromise: promise };

    return promise;
}

/**
 * Toggle the specified className on the given element or array of elements.
 *
 * If two arguments are given: Toggles the className for the given element or
 * elements. That is, if the class exists it will be removed, if not, it will
 * be added.
 * If three arguments are given: If force is true, the class will be added.
 * If force is false, the class will be removed.
 *
 * Aimed to be similar to HTML5 classList.toggle().
 *
 * @param {HTMLElement|HTMLElement[]} el - Element or array of elements that
 * will be affected.
 * @param {string} className - Class name to toggle or set.
 * @param {boolean} [force] - If specified and true, the class will be added.
 * If specified and false, the class will be removed.
 * @see https://dom.spec.whatwg.org/#dom-domtokenlist-toggle
 */
function toggleClass(el, className, force) {
    var regexp = _getBoundedRegExp(className);
    _applyAll(el, function (element) {
        if (regexp.test(element.className)) {
            if (force === undefined || force === false) {
                element.className = element.className.replace(regexp, '');
            }
        } else {
            if (force === undefined || force === true) {
                element.className += ' ' + className;
            }
        }
    });
}

function addClass(el, className) {
    var regexp = _getBoundedRegExp(className);
    _applyAll(el, function (element) {
        if (!regexp.test(element.className)) {
            element.className += ' ' + className;
        }
    });
}

function removeClass(el, className) {
    className = Array.isArray(className) ? className : [className];

    className.forEach(function (currClass) {
        var regexp = _getBoundedRegExp(currClass);
        _applyAll(el, function (element) {
            if (element && element.className) {
                element.className = element.className.replace(regexp, '');
            }
        });
    });
}

function hasClass(el, className) {
    var regexp = _getBoundedRegExp(className),
        element = Array.isArray(el) ? el[0] : el;

    return regexp.test(element.className);
}

function hide(el) {
    _applyAll(el, function (element) {
        element.style.display = 'none';
    });
}

function show(el) {
    _applyAll(el, function (element) {
        if (element.style.display) {
            element.style.display = '';
        } else {
            element.style.display = 'block';
        }
    });
}

function forceRedraw(element) {
    var displayStyle = element.style.display;
    element.style.display = 'none';

    element.style.display = displayStyle;
}

function addEvents(element, events, handler, namespace) {
    var eventsArray = events.split(/,\s*/);
    namespace = namespace || NAMESPACE;

    if (!element.addEventSVP) {
        extend(element, (0, _eventWrapperApi.createEventWrapper)());
    }

    for (var i = 0; i < eventsArray.length; i++) {
        element.addEventSVP(namespace + '.' + eventsArray[i], handler);
    }
}

function removeEvents(element, events, namespace) {
    namespace = namespace || NAMESPACE;
    var eventsArray = events.split(/,\s*/);

    if (!element.removeEventSVP) {
        Debug.error('Attempting to remove event from element without eventWrapperApi');

        return;
    }

    for (var i = 0; i < eventsArray.length; i++) {
        element.removeEventSVP(namespace + '.' + eventsArray[i]);
    }
}

function getKeyFromKeyEvent(e) {
    if (e.key) {
        return ieKeyMap[e.key.toLowerCase()] || e.key.toLowerCase();
    } else if (e.keyCode) {
        return keyCodeKeyMap[e.keyCode];
    }
}

function setStoredData(key, data) {
    if (!window.localStorage) {
        Debug('localStorage is not supported on this platform.');

        return;
    }

    var localKey = STORAGE_NAMESPACE + '.' + key;
    if (data !== undefined) {
        localStorage.setItem(localKey, data);
    } else {
        localStorage.removeItem(localKey);
    }
}

function getStoredData(key) {
    if (!window.localStorage) {
        Debug('localStorage is not supported on this platform.');

        return;
    }

    var localKey = STORAGE_NAMESPACE + '.' + key;

    return localStorage.getItem(localKey);
}

function isFullscreen() {
    return _isFullscreen();
}

function toggleVideoFullscreen(api) {
    this.enterVideoFullscreen(api) || this.exitVideoFullscreen(api);
}

function exitVideoFullscreen(api) {
    if (!_isFullscreen()) {
        return false;
    }

    if (document.exitFullscreen) {
        document.exitFullscreen();
    } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
    } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
    }

    api.fire('togglefullscreen', false);

    return true;
}

function enterVideoFullscreen(api) {
    if (_isFullscreen()) {
        return false;
    }

    var fullscreenElement = api.getFullscreenElement();

    if (device.isIOS()) {
        api.video().webkitEnterFullscreen();
    } else if (fullscreenElement.requestFullscreen) {
        fullscreenElement.requestFullscreen();
    } else if (fullscreenElement.msRequestFullscreen) {
        fullscreenElement.msRequestFullscreen();
    } else if (fullscreenElement.mozRequestFullScreen) {
        fullscreenElement.mozRequestFullScreen();
    } else if (fullscreenElement.webkitRequestFullscreen) {
        fullscreenElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
    }

    api.fire('togglefullscreen', true);

    return true;
}

/***/ }),

/***/ "TtgO":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("gCWN");
__webpack_require__("+3lO");
__webpack_require__("5Fj8");
__webpack_require__("1I8z");
__webpack_require__("EqE1");
module.exports = __webpack_require__("iANj").WeakMap;


/***/ }),

/***/ "UKM+":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "V3l/":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "V8zm":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("dK5q");
module.exports = __webpack_require__("iANj").Object.getPrototypeOf;


/***/ }),

/***/ "VD8v":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__("x//u");
var toObject = __webpack_require__("wXdB");
var IE_PROTO = __webpack_require__("+SdG")('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ "VT6N":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _errorType = __webpack_require__("0PB5");

var _errorType2 = _interopRequireDefault(_errorType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Device = __webpack_require__("xOtj");
var Debug = __webpack_require__("BF+C")('windows-phone-fallback');
var VideoAttributes = __webpack_require__("tpcr");
var VideoDataBuilder = __webpack_require__("0t/H");

var NAMESPACE = 'wpfallback';

module.exports = {
	create: function create(api) {
		function _sendEvent(eventType, data) {
			Debug('Send event: ' + eventType, data);
			api.fire(eventType, data);
		}

		function _buildExternalDeviceUrl(jsonurl, protocol) {
			var currProtocol = protocol || window.location.protocol || 'http:';
			var basepath = currProtocol + '//www.svtplay.se';
			var url = /^\//.test(jsonurl) ? basepath + jsonurl : jsonurl;

			return url.replace('http:', currProtocol);
		}

		var deviceFallbackController = {
			_metadata: null,
			_active: false,

			/* Public Methods */
			handleError: function handleError(e) {
				this._active = !!this._metadata;

				if (this._active) {
					// Hack to ensure that defaultPrevented gets set.
					Object.defineProperty(e, 'defaultPrevented', {
						get: function get() {
							return true;
						}
					});

					return false;
				}

				return true;
			},

			play: function play() {
				if (this._active) {
					var videoData = VideoDataBuilder.build(api.data().videoId, this._metadata, api);

					videoData.video.position = VideoAttributes.getStartPosition(api.video());
					videoData.video.subtitleReferences = videoData.video.subtitleReferences || [{ url: '' }];

					var jsonurl = 'http://api.svt.se/videoplayer-embed/android/videodata/?json=' + encodeURIComponent((0, _stringify2.default)(videoData)),
					    url;
					//WP app detection.
					if (Device.isWindowsPhone()) {
						this._notifyExternalPlaying(jsonurl);
						url = _buildExternalDeviceUrl(jsonurl, 'svtplay:');
						Debug('changeVideo windows_phone-url: ' + url);
						window.location = url;

						return true;
					}
					//W8 app detection.
					else if (Device.isWindows8App()) {
							this._notifyExternalPlaying(jsonurl);
							url = _buildExternalDeviceUrl(jsonurl);
							url = '//www.svtplay.se/app/windows8?play=' + encodeURIComponent(url);
							Debug('changeVideo windows_8-url: ' + url);
							window.location = url;

							return true;
						}
						//Default
						else {
								Debug.error('Could not find suitable fallback version');
							}
				}

				return false;
			},

			load: function load() {
				var _this = this;
				api.on(NAMESPACE + '.' + _errorType2.default.UNKNOW_VIDEO_TYPE_ERROR, this.handleError.bind(this));
				api.on(NAMESPACE + '.metadata', function (data) {
					_this._metadata = data ? data.detail : null;
				});
			},

			unload: function unload() {
				api.off(NAMESPACE + '.' + _errorType2.default.UNKNOW_VIDEO_TYPE_ERROR);
				api.off(NAMESPACE + '.metadata');
			},

			/**
    * Fire and forget!
    * Notify listeners that an external player
    * will be playing, do whatever necessary before changing app.
    * @param jsonurl
    * @private
    */
			_notifyExternalPlaying: function _notifyExternalPlaying(jsonurl) {
				// Fire and forget event for a external video start
				_sendEvent('playing', jsonurl);
				api.reset();
				_sendEvent('ready', {
					videoId: api.data().videoId,
					externalUi: true
				});
			}

		};

		if (Device.isWindowsPhone() || Device.isWindows8App()) {
			// Unload old deviceFallbackController if any
			if (api.deviceFallbackController) {
				api.deviceFallbackController.unload();
			}

			var filter = {
				load: function load() {
					this._metadata = false;
				},
				play: function play() {
					return !!deviceFallbackController.play();
				}
			};

			deviceFallbackController.load();
			api.filters.push(filter);

			api.deviceFallbackController = deviceFallbackController;
		}
	},

	destroy: function destroy(api) {
		var deviceFallbackController = api.deviceFallbackController;
		if (deviceFallbackController) {
			deviceFallbackController.unload();
		}
		api.deviceFallbackController = undefined;
	}
};

/***/ }),

/***/ "VWgF":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("OzIq");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),

/***/ "W1Zj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var PLAYING_STATE = exports.PLAYING_STATE = {
    error: 'error',
    loading: 'loading',
    paused: 'paused',
    playing: 'playing',
    stopped: 'stopped',
    unknown: 'unknown'
};

var STATE_CLASS = exports.STATE_CLASS = {
    active: 'svp_is--active',
    animatable: 'svp_is--animatable',
    error: 'svp_is--error',
    externalUi: 'svp_is--external-ui',
    fullscreen: 'svp_is--fullscreen',
    initialUi: 'svp_is--initial-ui',
    pipMode: 'svp_is--pip-mode',
    visible: 'svp_is--visible',
    hidden: 'svp_is--hidden'
};

var PROPERTY_CLASS = exports.PROPERTY_CLASS = {
    controlsHideInitially: 'svp_ui-controls--hide-initial',
    hideCursor: 'svp_video--hide-cursor',
    isLast: 'svp_ui-is--last'
};

var FOCUS_ELEMENT_CLASS = exports.FOCUS_ELEMENT_CLASS = 'svp_js-tabfocus';

/***/ }),

/***/ "W2nU":
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ "W6Rd":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ "WBcL":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "Wdy1":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("YjQv");
var core = __webpack_require__("iANj");
var ctx = __webpack_require__("3fMt");
var hide = __webpack_require__("aLzV");
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && key in exports) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ "WgSQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__("RhFG");
var step = __webpack_require__("KB1o");
var Iterators = __webpack_require__("bN1p");
var toIObject = __webpack_require__("PHqh");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__("uc2A")(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "Wlnq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _dom = __webpack_require__("TdxG");

var domUtils = _interopRequireWildcard(_dom);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var Sizzle = __webpack_require__("zZaF");

var Debug = __webpack_require__("BF+C")('thumbnails');

var NAMESPACE = 'thumbnails';

var CLASSNAMES = {
	progressHandle: 'svp_js-controls-timeline--progress-handle',
	progressMetadata: 'svp_js-controls-timeline--progress-metadata',
	thumbnail: 'svp_js-controls-timeline--progress-thumbnail',
	shadow: 'svp_js-controls-timeline--progress-thumbnail-shadow',
	timelineInner: 'svp_js-controls-timeline--inner',
	timeline: 'svp_js-controls-timeline'
};

module.exports = {
	create: function create(api) {
		if (!api.config.controls) {
			return;
		}

		var videoId, thumbnailUrl, cols, width, height, timegap;

		function dragEventFn(e) {
			var left = 0,
			    timeline = _getElement(CLASSNAMES.timeline),
			    thumbnail = _getElement(CLASSNAMES.thumbnail),
			    shadow = _getElement(CLASSNAMES.shadow),
			    rect = timeline.getBoundingClientRect(),
			    xPos = e.changedTouches ? e.changedTouches[0].clientX : e.clientX;
			if (xPos > rect.left) {
				if (xPos >= rect.left + timeline.clientWidth) {
					left = 100;
				} else {
					var position = xPos - (rect.left + window.pageXOffset);
					left = 100 * (position / timeline.clientWidth);
				}
			}
			var time = left / 100 * api.getDuration();

			var baseTime = time + timegap;
			var row = Math.floor(baseTime / (timegap * cols));
			var xpos = Math.floor(baseTime / timegap) * width - row * width * cols;
			var ypos = row * height;

			thumbnail.style.backgroundPosition = '-' + xpos + 'px -' + ypos + 'px';
			thumbnail.style.display = 'block';
			shadow.style.display = 'block';
		}

		function mouseupFn() {
			var thumbnail = _getElement(CLASSNAMES.thumbnail),
			    shadow = _getElement(CLASSNAMES.shadow);
			document.removeEventListener('mousemove', dragEventFn);
			document.removeEventListener('touchmove', dragEventFn);
			document.removeEventListener('mouseup', mouseupFn);
			document.removeEventListener('touchend', mouseupFn);

			thumbnail.style.display = 'none';
			shadow.style.display = 'none';
		}
		function dragStartFn() {
			document.addEventListener('mousemove', dragEventFn);
			document.addEventListener('touchmove', dragEventFn);
			document.addEventListener('mouseup', mouseupFn);
			document.addEventListener('touchend', mouseupFn);
		}

		function _getElement(className) {
			return Sizzle('.' + className, api.element())[0];
		}

		function _resetUi() {
			var progressMetadataElement = _getElement(CLASSNAMES.progressMetadata),
			    thumbnailElement = _getElement(CLASSNAMES.thumbnail),
			    shadowElement = _getElement(CLASSNAMES.shadow);

			if (progressMetadataElement) {
				if (thumbnailElement) {
					progressMetadataElement.removeChild(thumbnailElement);
				}

				if (shadowElement) {
					progressMetadataElement.removeChild(shadowElement);
				}
			}
		}

		function _resetEvents() {
			var progressHandle = _getElement(CLASSNAMES.progressHandle);

			if (progressHandle) {
				domUtils.removeEvents(progressHandle, 'mousedown', NAMESPACE);
				domUtils.removeEvents(progressHandle, 'touchstart', NAMESPACE);
				domUtils.removeEvents(_getElement(CLASSNAMES.timelineInner), 'mouseout, mousemove, touchstart', NAMESPACE);
			}

			document.removeEventListener('mousemove', dragEventFn);
			document.removeEventListener('touchmove', dragEventFn);
			document.removeEventListener('mouseup', mouseupFn);
			document.removeEventListener('touchend', mouseupFn);
		}

		function _buildUi() {
			var progressHandleElement = _getElement(CLASSNAMES.progressMetadata);
			var thumbnailElement = domUtils.fromString('<span aria-hidden="true" class="svp_js-controls-timeline--progress-thumbnail svp_ui-controls-timeline--progress-thumbnail svp_ui-controls--hide-initial"></span>');
			var shadowElement = domUtils.fromString('<span aria-hidden="true" class="svp_js-controls-timeline--progress-thumbnail-shadow svp_ui-controls-timeline--progress-thumbnail-shadow svp_ui-controls--hide-initial"></span>');

			thumbnailElement.style.backgroundImage = 'url(' + thumbnailUrl + ')';

			progressHandleElement.appendChild(thumbnailElement);
			progressHandleElement.appendChild(shadowElement);
		}

		function _bindUiInteractionEvents() {
			var progressHandle = _getElement(CLASSNAMES.progressHandle);

			domUtils.addEvents(progressHandle, 'mousedown', dragStartFn, NAMESPACE);
			domUtils.addEvents(progressHandle, 'touchstart', dragStartFn, NAMESPACE);

			domUtils.addEvents(_getElement(CLASSNAMES.timelineInner), 'mouseout', mouseupFn, NAMESPACE);
			domUtils.addEvents(_getElement(CLASSNAMES.timelineInner), 'mousemove', dragEventFn, NAMESPACE);
			domUtils.addEvents(_getElement(CLASSNAMES.timelineInner), 'touchstart', function () {
				domUtils.removeEvents(_getElement(CLASSNAMES.timelineInner), 'mouseout, mousemove, touchstart', NAMESPACE);
			}, NAMESPACE);
		}

		api.on(NAMESPACE + '.metadata', function (metadata) {
			videoId = metadata.detail.programVersionId;
			if (metadata.detail.thumbnailMap) {
				thumbnailUrl = metadata.detail.thumbnailMap.url;
				cols = metadata.detail.thumbnailMap.columns;
				width = metadata.detail.thumbnailMap.thumbnailwidth;
				height = metadata.detail.thumbnailMap.thumbnailheight;
				timegap = metadata.detail.thumbnailMap.timeBetweenPicturesInMillis / 1000;
				_buildUi();
				_bindUiInteractionEvents();
			} else {
				Debug('no thumbnails found for ' + videoId);
			}
		});

		api.filters.push({
			load: function load() {
				_resetEvents();
				_resetUi();
			}
		});
	},

	destroy: function destroy(api) {
		var progressHandle = Sizzle('.' + CLASSNAMES.progressMetadata, api.element())[0];

		if (progressHandle) {
			domUtils.removeEvents(progressHandle, 'mousedown', NAMESPACE);
			domUtils.removeEvents(progressHandle, 'touchstart', NAMESPACE);
		}
		api.off(NAMESPACE + '.metadata');
	}

};

/***/ }),

/***/ "Wzv4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {

	/**
  * registers a global functionhandler with callback mapped to UID.  Flash always callbacks to the global scope.
  * @param UID String        the UID for the flash.
  * @param eventType String  the eventType to listen for
  * @param scope Object      scope of the callback
  * @param method Function   callback function.
  */
	function addExternalListener(UID, eventType, scope, method) {
		if (!window.__svtplayerCallback__) {
			window.__svtplayerCallback__ = function (UID, a_eventType, data) {
				var callback;

				if (window.__svtplayerEventListeners__[a_eventType]) {
					callback = window.__svtplayerEventListeners__[a_eventType][UID];
					if (callback !== null) {
						callback.method.apply(callback.scope, [a_eventType, data]);
					}
				}
			};
		}

		if (!window.__svtplayerEventListeners__) {
			window.__svtplayerEventListeners__ = {};
		}

		if (window.__svtplayerEventListeners__[eventType] === undefined) {
			window.__svtplayerEventListeners__[eventType] = {};
		}

		window.__svtplayerEventListeners__[eventType][UID] = {
			scope: scope,
			method: method
		};
	}

	/**
  * remove an external listener. currently cares only about eventType
  * and scope. might be we need more granularity in the future so we
  * can remove listeners for particular functions, but there's no need
  * right now as the only use for this function is when deleting a
  * video object.
  *
  * @param UID String        the UID for the flash.*
  * @param eventType String  event to listen for
  */
	function removeExternalListener(UID, eventType) {
		if (window.__svtplayerEventListeners__ && window.__svtplayerEventListeners__[eventType] && window.__svtplayerEventListeners__[eventType][UID]) {
			window.__svtplayerEventListeners__[eventType][UID] = undefined;
		}
	}

	return {
		addExternalListener: addExternalListener,
		removeExternalListener: removeExternalListener
	};
}();

/***/ }),

/***/ "XFB5":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("TtgO"), __esModule: true };

/***/ }),

/***/ "XSOZ":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ "XteP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Notes about browser support and related issues:
 *
 * Works on:
 * - macOS, Google Chrome
 * - Galaxy S6 Edge, Google Chrome, Samsung Internet, Oculus Home (GearVR),
 *   and Samsung Internet for GearVR
 * - Windows 10, Google Chrome and Microsoft Edge
 *
 * There are two issues that prevent support for Safari and Firefox. There
 * is a CORS issue on Safari, preventing video to load correctly from
 * other origins than the host. There is also a WebGL issue that occur on
 * both macOS Safari and Firefox.
 *
 * There are also problems for iOS because of the way it handle videos, with
 * automatic fullscreen etc.
 *
 * CORS issue:
 * - https://bugs.webkit.org/show_bug.cgi?id=135379
 * - https://github.com/mrdoob/three.js/issues/8110
 *
 * WebGL issue:
 * - https://github.com/mrdoob/three.js/issues/9716
 * - https://bugs.webkit.org/show_bug.cgi?id=171054
 * - https://bugzilla.mozilla.org/show_bug.cgi?id=1246410
 * - https://bugzilla.mozilla.org/show_bug.cgi?id=1322746
 *
 *
 * Does not work on IE11 because HTMLVideoElement is not a supported data
 * source in the WebGL texImage2D method. This could probably be resolved
 * with a custom fix for IE11, by rendering the video to a canvas and then
 * use the canvas as data source for texImage2D. More info at:
 * - https://msdn.microsoft.com/en-us/library/dn302435(v=vs.85).aspx
 * - https://github.com/mrdoob/three.js/issues/7560O
 *
 */

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _sizzle = __webpack_require__("zZaF");

var _sizzle2 = _interopRequireDefault(_sizzle);

var _dom = __webpack_require__("TdxG");

var domUtils = _interopRequireWildcard(_dom);

var _videoAttributes = __webpack_require__("tpcr");

var _videoAttributes2 = _interopRequireDefault(_videoAttributes);

var _debug = __webpack_require__("BF+C");

var _debug2 = _interopRequireDefault(_debug);

var _types = __webpack_require__("/W6e");

var _hasImmersiveSupport = __webpack_require__("q3q5");

var _hasImmersiveSupport2 = _interopRequireDefault(_hasImmersiveSupport);

var _errorType = __webpack_require__("0PB5");

var _errorType2 = _interopRequireDefault(_errorType);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FULLSCREEN_CHANGE_EVENTS = 'fullscreenchange, mozfullscreenchange,' + 'MSFullscreenChange, webkitfullscreenchange';
var NAMESPACE = 'immersive';

var Debug = (0, _debug2.default)('immersive');

function parseVideoFormatOrDefault(videoFormatString) {
    switch (videoFormatString) {
        case 'stereo':
        case 'stereo_tb':
            return _types.VIDEO_FORMAT.Stereo_TB;
        case 'stereo_lr':
            return _types.VIDEO_FORMAT.Stereo_LR;
        default:
            return _types.VIDEO_FORMAT.Mono;
    }
}

function createVRButton(api, immersiveManager) {
    var button = document.createElement('div');
    button.className = 'svp_immersive-vr_button';

    domUtils.addEvents(button, 'click, touchend', function (e) {
        e.preventDefault();

        /**
         * We would like to start the video when the VRDisplay is presenting
         * the video. An issue is that play() must be called in response to a
         * user gesture. As such, api.play() is first called here, directly
         * in the event handler. The second api.play() call is when the
         * VRDisplay is ready and presenting, which is were we actually would
         * like to start playing.
         */

        api.play();
        immersiveManager.enterVR().then(function () {
            api.play();
        });
    });

    return button;
}

function getDashInstance(api, videoElement) {
    var uid = _videoAttributes2.default.getUID(videoElement);
    if (!uid) {
        return;
    }
    var videoObject = api.video();
    if (!videoObject || typeof videoObject.getDashInstances !== 'function') {
        return;
    }
    var dashInstances = videoObject.getDashInstances();
    if (!dashInstances) {
        return;
    }

    return dashInstances[uid];
}

function updateDashInstance(dashInstance) {
    if (!dashInstance) {
        return;
    }

    // Turn off limit bitrate by portal. A 360 video does not
    // render the entire video to the video element viewport.
    // Instead, it will render a part of the video source. As such,
    // the video element size and video resolution does not match.
    dashInstance.mediaPlayer.setLimitBitrateByPortal(false);
}

var SizzleSingle = function SizzleSingle(selector, context) {
    var result = (0, _sizzle2.default)(selector, context);

    return result.length > 0 ? result[0] : null;
};

var queryVideoElement = function queryVideoElement(api) {
    return SizzleSingle('video', api.element());
};

var ImmersivePlugin = function () {
    function ImmersivePlugin(namespace, api) {
        var _this = this;

        (0, _classCallCheck3.default)(this, ImmersivePlugin);

        this.namespace = namespace;
        this.api = api;
        this.videoElement = queryVideoElement(api);
        this.dashInstance = null;
        this.immersiveManager = null;

        this.api.on(this.namespace + '.metadata', function (metadata) {
            var isImmersiveVideo = _videoAttributes2.default.isImmersiveVideo(_this.videoElement);

            if (isImmersiveVideo) {
                _this.setupImmersive();
            } else {
                _this.teardownImmersive();
            }
        });
    }

    (0, _createClass3.default)(ImmersivePlugin, [{
        key: 'handleImmersiveNotSupported',
        value: function handleImmersiveNotSupported() {
            // The unknownVideoTypeError can occur after the immersiveNotSupported
            // is fired. For example, the stream might be dash only and the user
            // is using Safari. We prevent this error so that it does not replace
            // the immersive error message.
            this.api.once(this.namespace + '.' + _errorType2.default.UNKNOW_VIDEO_TYPE_ERROR, function (e) {
                e.preventDefault();
            });

            this.api.fire('error', {
                name: _errorType2.default.IMMERSIVE_NOT_SUPPORTED_ERROR
            });
        }
    }, {
        key: 'setupImmersive',
        value: function setupImmersive() {
            var _this2 = this;

            if (!(0, _hasImmersiveSupport2.default)()) {
                this.handleImmersiveNotSupported();

                return;
            }

            domUtils.addClass(this.api.element(), 'svp_immersive');
            this.videoElement.crossOrigin = 'anonymous';

            this.addEventListeners();

            // Dynamically import ImmersiveManager, which will also load its
            // heavy dependencies (three and webvr-polyfill).
            //
            // TODO: Use import() instead of require.ensure(), because it is
            // specific to webpack and is superseeded by ES syntax import().
            __webpack_require__.e/* require.ensure */(2).then((function (require) {
                var ImmersiveManager = __webpack_require__("sjhj");

                var videoFormatString = _videoAttributes2.default.getImmersiveVideoFormat(_this2.videoElement);
                var videoFormat = parseVideoFormatOrDefault(videoFormatString);

                Debug.log('Video Format: ' + videoFormatString + ' (' + videoFormat + ')');

                _this2.immersiveManager = new ImmersiveManager(_this2.videoElement, videoFormat);

                // Return immediately if any error occured.
                if (_this2.immersiveManager.isInErrorState()) {
                    _this2.api.fire('error');

                    return;
                }

                _this2.immersiveManager.initialize().then(function () {
                    // Insert VR button if VR mode is allowed.
                    if (_this2.immersiveManager.canEnterVR()) {
                        _this2.api.insertButton(createVRButton(_this2.api, _this2.immersiveManager));
                    }

                    _this2.immersiveManager.run();

                    // Append to DOM
                    _this2.api.element().appendChild(_this2.immersiveManager.container);

                    Debug.log('Immersive plugin is enabled and running.');
                });
            }).bind(null, __webpack_require__)).catch(function (err) {
                Debug.error('Failed to load immersive plugin because:', err);
                _this2.api.fire('error', {
                    name: _errorType2.default.IMMERSIVE_FAILED_TO_LOAD
                });
            });
        }
    }, {
        key: 'teardownImmersive',
        value: function teardownImmersive() {
            if (this.immersiveManager && this.immersiveManager.container) {
                this.api.element().removeChild(this.immersiveManager.container);
            }

            domUtils.removeClass(this.api.element(), 'svp_immersive');

            if (this.immersiveManager) {
                this.immersiveManager = null;
            }
        }
    }, {
        key: 'addEventListeners',
        value: function addEventListeners() {
            var _this3 = this;

            this.api.on(this.namespace + '.ready', function () {
                _this3.dashInstance = getDashInstance(_this3.api, _this3.videoElement);
                updateDashInstance(_this3.dashInstance);
            });

            this.api.on(this.namespace + '.dashmanifestloaded', function () {
                updateDashInstance(_this3.dashInstance);
            });

            // Prevent automatic pause when the user enter VR mode, which occur
            // on Samsung Browser (the default Internet app).
            this.api.on(this.namespace + '.pause', function (event) {
                if (_this3.immersiveManager && _this3.immersiveManager.inVRMode()) {
                    Debug.log('Applying do not pause fix');
                    window.setTimeout(function () {
                        return _this3.api.play();
                    }, 50);
                }
            });

            var handleResize = function handleResize() {
                if (_this3.immersiveManager && !_this3.immersiveManager.isInErrorState()) {
                    _this3.immersiveManager.updateSize();
                }
            };
            this.api.on(this.namespace + '.resize', handleResize);
            domUtils.addEvents(window, 'resize', handleResize, this.namespace);
            domUtils.addEvents(document, FULLSCREEN_CHANGE_EVENTS, handleResize, this.namespace);

            // Add mouse events on window to add dragging class on the player
            // container element. This allows the CSS to change cursor when
            // dragging occurs.
            domUtils.addEvents(window, 'mousedown', function () {
                domUtils.addClass(_this3.api.element(), 'svp_immersive--dragging');
            }, this.namespace);
            domUtils.addEvents(window, 'mouseup', function () {
                domUtils.removeClass(_this3.api.element(), 'svp_immersive--dragging');
            }, this.namespace);
        }
    }, {
        key: 'removeEventListeners',
        value: function removeEventListeners() {
            this.api.off(this.namespace + '.metadata');
            this.api.off(this.namespace + '.ready');
            this.api.off(this.namespace + '.dashmanifestloaded');
            this.api.off(this.namespace + '.resize');
            this.api.off(this.namespace + '.' + _errorType2.default.UNKNOW_VIDEO_TYPE_ERROR);

            domUtils.removeEvents(window, 'resize', this.namespace);
            domUtils.removeEvents(document, FULLSCREEN_CHANGE_EVENTS, this.namespace);
            domUtils.removeEvents(window, 'mousedown', this.namespace);
            domUtils.removeEvents(window, 'mouseup', this.namespace);
        }
    }, {
        key: 'destroy',
        value: function destroy() {
            this.removeEventListeners();
            this.teardownImmersive();
        }
    }]);
    return ImmersivePlugin;
}();

module.exports = {
    namespace: NAMESPACE,
    _pluginInstance: null,

    create: function create(api) {
        this._pluginInstance = new ImmersivePlugin(this.namespace, api);
    },

    destroy: function destroy(api) {
        if (this._pluginInstance) {
            this._pluginInstance.destroy();
        }
    }
};

/***/ }),

/***/ "XvUs":
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__("DIVP");
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),

/***/ "Y00i":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _dom = __webpack_require__("TdxG");

var domUtils = _interopRequireWildcard(_dom);

var _audioTrack = __webpack_require__("0Gsn");

var _audioTrack2 = _interopRequireDefault(_audioTrack);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Sizzle = __webpack_require__("zZaF");

var NAMESPACE = 'ui-language-dialog';
var CAPTIONS_STORAGE_KEY = "captionsOn";

var CLASSNAMES = {
    textTrackLabel: 'svp_js-controls__text-track-label-text'
};

var LanguageDialog = function () {
    function LanguageDialog(api, languageButton) {
        (0, _classCallCheck3.default)(this, LanguageDialog);

        this.api = api;
        this.languageButton = languageButton;
    }

    (0, _createClass3.default)(LanguageDialog, [{
        key: '_createElement',
        value: function _createElement() {
            var _this = this;

            var form = domUtils.fromString('<form class="svp_ui-controls__language-dialog"></form>');
            var audioTracks = this.api.getAudioTracks();
            var spokenTextTrack = LanguageDialog._getSpokenTextTrack(audioTracks);

            if (spokenTextTrack) {
                var audioTrackSettings = domUtils.fromString('<fieldset class="svp_ui-controls__language-dialog-content">\n                    <legend class="svp_ui-controls__language-dialog-title">HJ\xC4LPMEDEL</legend>\n                    <label class="svp_ui-controls__label svp_ui-controls__language-dialog-label">\n                        Av\n                        <input name="audio_track" type="radio" value="off" ' + (!spokenTextTrack.active ? 'checked' : '') + ' class="svp_ui-controls__language-dialog-checkbox">\n                        <span class="svp_ui-controls__language-dialog-checkmark"></span>\n                    </label>\n                    <label class="svp_ui-controls__label svp_ui-controls__language-dialog-label">\n                        Uppl\xE4st text\n                        <input name="audio_track" type="radio" value="spoken_text_on" ' + (spokenTextTrack.active ? 'checked' : '') + ' class="svp_ui-controls__language-dialog-checkbox">\n                        <span class="svp_ui-controls__language-dialog-checkmark"></span>\n                    </label>\n                </fieldset>');
                form.appendChild(audioTrackSettings);
            }

            var textTracks = this.api.getTextTracks();

            if (textTracks.length > 0) {
                var textTrackActive = domUtils.getStoredData(CAPTIONS_STORAGE_KEY) === 'true';

                var textTrackSettings = domUtils.fromString('<fieldset class="svp_ui-controls__language-dialog-content">\n                    <legend class="svp_ui-controls__language-dialog-title">UNDERTEXT</legend>\n                    <div class="svp_ui-controls__slider">\n                        <label class="svp_ui-controls__label" tabindex="-1" for="svp_ui-controls__text_track_selector">\n                            <span class="svp_visually-hidden">Visa undertext</span>\n                            <span class="' + CLASSNAMES.textTrackLabel + '" aria-hidden="true">' + (textTrackActive ? 'På' : 'Av') + '</span>\n                            <input type="checkbox" value="None" id="svp_ui-controls__text_track_selector" name="text_track" ' + (textTrackActive ? 'checked' : '') + ' class="svp_ui-controls__slider-input"/>\n                            <span class="svp_ui-controls__slider-background"><span class="svp_ui-controls__slider-dot"></span></span>\n                        </label>\n                    </div>\n                </fieldset>');
                form.appendChild(textTrackSettings);
            }

            var closeButton = domUtils.fromString('<button class="svp_ui-controls__language-dialog-close-button">Stäng</button>');

            domUtils.addEvents(closeButton, 'click', function (e) {
                e.stopPropagation();
                e.preventDefault();
                _this.destroy();
            });

            form.appendChild(closeButton);

            var container = domUtils.fromString('<div class="svp_js-controls__language-dialog-container svp_ui-controls__language-dialog-container"></div>');
            container.appendChild(form);

            return container;
        }
    }, {
        key: '_handleTextTrackSelection',
        value: function _handleTextTrackSelection(event) {
            var labels = Sizzle('.' + CLASSNAMES.textTrackLabel);

            if (event.target.checked) {
                this._showCaptions(true);

                labels.forEach(function (element) {
                    element.innerHTML = 'På';
                });
            } else {
                this._showCaptions(false);

                labels.forEach(function (element) {
                    element.innerHTML = 'Av';
                });
            }
        }
    }, {
        key: '_setAudioTrack',
        value: function _setAudioTrack(track) {
            this.api.setAudioTrack(track);
        }
    }, {
        key: '_showCaptions',
        value: function _showCaptions(shouldShow) {
            domUtils.setStoredData(CAPTIONS_STORAGE_KEY, shouldShow);
            this.api.showCaptions(shouldShow);
        }
    }, {
        key: '_handleHelpersSelection',
        value: function _handleHelpersSelection(event) {
            if (event.target.value === 'off' && event.target.checked) {
                this._setAudioTrack(_audioTrack2.default.DEFAULT_AUDIO);
            } else if (event.target.value === 'spoken_text_on' && event.target.checked) {
                this._setAudioTrack(_audioTrack2.default.SPOKEN_TEXT);
            }
        }
    }, {
        key: '_getElement',
        value: function _getElement(className) {
            return Sizzle('.' + className, this.api.element())[0];
        }
    }, {
        key: '_addChangeListeners',
        value: function _addChangeListeners() {
            var _this2 = this;

            Sizzle('input[name="text_track"]', this.element).forEach(function (element) {
                domUtils.addEvents(element, 'change', function (e) {
                    _this2._handleTextTrackSelection(e);
                }, NAMESPACE);

                domUtils.addEvents(element, 'keyup, keydown', function (e) {
                    if (domUtils.getKeyFromKeyEvent(e) === 'space') {
                        e.stopPropagation();
                    }
                }, NAMESPACE);
            });

            Sizzle('input[name="audio_track"]', this.element).forEach(function (element) {
                domUtils.addEvents(element, 'change', function (e) {
                    _this2._handleHelpersSelection(e);
                }, NAMESPACE);
            });

            Sizzle('input[name="audio_track"]', this.element).forEach(function (element) {
                // empty
            });
        }
    }, {
        key: '_stopPropagation',
        value: function _stopPropagation() {
            // Do not let clicks propagate to player
            domUtils.addEvents(this.element, 'click, touchend', function (e) {
                e.stopPropagation();
            }, NAMESPACE);
        }
    }, {
        key: 'create',
        value: function create() {
            this.element = this._createElement();
            this._stopPropagation();
            this._addChangeListeners();

            return this.element;
        }
    }, {
        key: 'destroy',
        value: function destroy() {
            this.languageButton.destroyDialog();
        }
    }], [{
        key: '_getSpokenTextTrack',
        value: function _getSpokenTextTrack(audioTracks) {
            for (var i = 0; i < audioTracks.length; i++) {
                if (audioTracks[i].id === _audioTrack2.default.SPOKEN_TEXT) {
                    return audioTracks[i];
                }
            }

            return undefined;
        }
    }]);
    return LanguageDialog;
}();

exports.default = LanguageDialog;
module.exports = exports['default'];

/***/ }),

/***/ "YTz9":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "YjQv":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "YxlO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createEventWrapper = undefined;

var _weakMap = __webpack_require__("XFB5");

var _weakMap2 = _interopRequireDefault(_weakMap);

var _extend = __webpack_require__("5E+y");

var _extend2 = _interopRequireDefault(_extend);

var _ravenJs = __webpack_require__("/Hyb");

var _ravenJs2 = _interopRequireDefault(_ravenJs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Used to keep references to wrapped handlers from original handlers.
var wrappedHandlerMap = new _weakMap2.default();

var parseNamespacedEventName = function parseNamespacedEventName(eventName) {
    var parts = eventName.split('.');

    if (parts.length === 1) {
        return {
            namespace: 'all',
            eventName: eventName
        };
    }

    if (parts.length === 2) {
        return {
            namespace: parts[0],
            eventName: parts[1]
        };
    }

    throw new Error('Bad event name');
};

/**
 * We wrap event handlers with a try-catch so that we are able to report any
 * uncaught exceptions.
 */
var wrapWithErrorHandler = function wrapWithErrorHandler(fn) {
    return function () {
        try {
            fn.apply(undefined, arguments);
        } catch (err) {
            _ravenJs2.default.captureException(err);

            /*
             * Opinionated: we do not re-throw the error here, instead we consider
             * it reported and thus handled. By doing this we prevent the error to
             * bubble up to the client site, so that the error is not reported
             * again by site's own error handler/reporter.
             *
             * However, for debugging purposes it is useful if the error is shown
             * in the console. We do report the error with Debug.error because
             * this is not really a caught error.
             */
            if (console) {
                console.error(err); // eslint-disable-line no-console
            }
        }
    };
};

var createEventWrapper = exports.createEventWrapper = function createEventWrapper() {
    return {
        events: {},
        addEventSVP: function addEventSVP(namespacedEventName, handler) {
            if (!this.addEventListener) {
                return;
            }

            var _parseNamespacedEvent = parseNamespacedEventName(namespacedEventName),
                namespace = _parseNamespacedEvent.namespace,
                eventName = _parseNamespacedEvent.eventName;

            var wrappedHandler = wrapWithErrorHandler(handler);

            wrappedHandlerMap.set(handler, wrappedHandler);

            this.events[namespace] = this.events[namespace] || {};
            this.events[namespace][eventName] = this.events[namespace][eventName] || { handlers: [] };
            this.events[namespace][eventName].handlers.push(wrappedHandler);

            this.addEventListener(eventName, wrappedHandler);
        },
        removeEventSVP: function removeEventSVP(namespacedEventName, handler) {
            var _this = this;

            if (!this.removeEventListener) {
                return;
            }

            var _parseNamespacedEvent2 = parseNamespacedEventName(namespacedEventName),
                namespace = _parseNamespacedEvent2.namespace,
                eventName = _parseNamespacedEvent2.eventName;

            if (!this.events[namespace]) {
                return;
            }

            if (handler) {
                var wrappedHandler = wrappedHandlerMap.get(handler);
                if (wrappedHandler) {
                    this.removeEventListener(eventName, wrappedHandler);
                }

                this.removeEventListener(eventName, handler);
            } else if (this.events[namespace][eventName]) {
                this.events[namespace][eventName].handlers.forEach(function (handler) {
                    _this.removeEventListener(eventName, handler);
                });
            }

            delete this.events[namespace][eventName];
        },
        destroy: function destroy() {
            if (this.removeEventListener) {
                for (var namespace in this.events) {
                    if (Object.prototype.hasOwnProperty.call(this.events, namespace)) {
                        for (var event in this.events[namespace]) {
                            if (Object.prototype.hasOwnProperty.call(this.events[namespace], event) && this.events[namespace][event]) {
                                this.events[namespace][event].handlers.forEach(this.removeEventListener.bind(this, event));
                            }
                        }
                    }
                }
            }
            this.addEventSVP = undefined;
            this.removeEventSVP = undefined;
            this.events = undefined;
        }
    };
};

/***/ }),

/***/ "Zbun":
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__("iANj");
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),

/***/ "ZhOs":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("rZAI");
module.exports = __webpack_require__("iANj").Object.keys;


/***/ }),

/***/ "Zrlr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),

/***/ "Zx67":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("V8zm"), __esModule: true };

/***/ }),

/***/ "Zzip":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("BQO6"), __esModule: true };

/***/ }),

/***/ "a/OS":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("YjQv");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),

/***/ "aFK5":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("vwWJ"), __esModule: true };

/***/ }),

/***/ "aLzV":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("GCs6");
var createDesc = __webpack_require__("YTz9");
module.exports = __webpack_require__("qs+f") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "abPz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__("Aq0r");
var step = __webpack_require__("beh1");
var Iterators = __webpack_require__("yYxz");
var toIObject = __webpack_require__("ksFB");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__("4dmN")(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "ahyN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {

	getClient: function getClient() {
		var currentHost = document.location.host,
		    currentPath = document.location.pathname,
		    client;

		if (currentHost.indexOf('svtplay.se') > -1) {
			client = 'svt-play';
		} else if (currentHost.indexOf('svt.se') > -1) {
			if (currentPath.indexOf('/barnkanalen/barnplay/') > -1 || currentPath.match(/\/barnkanalen\/$/) !== null) {
				//same as String.endsWith('/barnkanalen/')
				client = 'barnplay';
			} else if (currentPath.indexOf('/barnkanalen/bolibompa/') > -1) {
				client = 'bolibompa';
			} else if (currentPath.indexOf('/barnkanalen/') > -1 || currentPath.indexOf('/mixat/') > -1) {
				client = 'barnkanalen';
			} else if (currentPath.indexOf('/nyheter/') > -1 || currentPath.indexOf('/kultur/') > -1 || currentPath.indexOf('/vader/') > -1 || currentPath.indexOf('/opinion/') > -1) {
				client = 'svtse-nyheter';
			} else if (currentPath.indexOf('/sport/') > -1) {
				client = 'svtse-sport';
			} else if (currentPath.indexOf('/videoplayer-embed/') > -1) {
				client = 'external';
			} else {
				client = 'svtse';
			}
		} else if (currentHost.indexOf('oppetarkiv.se') > -1) {
			client = 'oppet-arkiv';
		} else {
			client = 'external';
		}

		return client;
	},

	getComscoreBaseUrl: function getComscoreBaseUrl() {
		var currentHost = document.location.host,
		    account;

		if (currentHost.indexOf('www.svtplay.se') > -1 || currentHost.indexOf('www.svt.se') > -1 || currentHost.indexOf('www.oppetarkiv.se') > -1) {
			account = 'svt';
		} else {
			account = 'test';
		}

		return 'http' + (document.location.href.charAt(4) === 's' ? 's://' : '://') + 'ld.svt.se/svt/' + account + '/s?';
	},

	getScorecardResearchUrl: function getScorecardResearchUrl() {
		return 'http' + (document.location.href.charAt(4) === 's' ? 's://sb' : '://b') + '.scorecardresearch.com/b?c1=2';
	},

	getComscoreSite: function getComscoreSite() {
		var currentHost = document.location.host,
		    account;

		if (currentHost.indexOf('www.svtplay.se') > -1 || currentHost.indexOf('www.svt.se') > -1 || currentHost.indexOf('www.oppetarkiv.se') > -1) {
			account = 'svt';
		} else {
			account = 'test';
		}

		return account;
	},

	getComscoreC2Value: function getComscoreC2Value() {
		return '21885884';
	},

	getMmsClientNr: function getMmsClientNr() {
		return '1001001';
	}

};

/***/ }),

/***/ "b98B":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var utils = __webpack_require__("xKeu");

/*
 TraceKit - Cross brower stack traces

 This was originally forked from github.com/occ/TraceKit, but has since been
 largely re-written and is now maintained as part of raven-js.  Tests for
 this are in test/vendor.

 MIT license
*/

var TraceKit = {
  collectWindowErrors: true,
  debug: false
};

// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
var _window =
  typeof window !== 'undefined'
    ? window
    : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

// global reference to slice
var _slice = [].slice;
var UNKNOWN_FUNCTION = '?';

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/;

function getLocationHref() {
  if (typeof document === 'undefined' || document.location == null) return '';

  return document.location.href;
}

/**
 * TraceKit.report: cross-browser processing of unhandled exceptions
 *
 * Syntax:
 *   TraceKit.report.subscribe(function(stackInfo) { ... })
 *   TraceKit.report.unsubscribe(function(stackInfo) { ... })
 *   TraceKit.report(exception)
 *   try { ...code... } catch(ex) { TraceKit.report(ex); }
 *
 * Supports:
 *   - Firefox: full stack trace with line numbers, plus column number
 *              on top frame; column number is not guaranteed
 *   - Opera:   full stack trace with line and column numbers
 *   - Chrome:  full stack trace with line and column numbers
 *   - Safari:  line and column number for the top frame only; some frames
 *              may be missing, and column number is not guaranteed
 *   - IE:      line and column number for the top frame only; some frames
 *              may be missing, and column number is not guaranteed
 *
 * In theory, TraceKit should work on all of the following versions:
 *   - IE5.5+ (only 8.0 tested)
 *   - Firefox 0.9+ (only 3.5+ tested)
 *   - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
 *     Exceptions Have Stacktrace to be enabled in opera:config)
 *   - Safari 3+ (only 4+ tested)
 *   - Chrome 1+ (only 5+ tested)
 *   - Konqueror 3.5+ (untested)
 *
 * Requires TraceKit.computeStackTrace.
 *
 * Tries to catch all unhandled exceptions and report them to the
 * subscribed handlers. Please note that TraceKit.report will rethrow the
 * exception. This is REQUIRED in order to get a useful stack trace in IE.
 * If the exception does not reach the top of the browser, you will only
 * get a stack trace from the point where TraceKit.report was called.
 *
 * Handlers receive a stackInfo object as described in the
 * TraceKit.computeStackTrace docs.
 */
TraceKit.report = (function reportModuleWrapper() {
  var handlers = [],
    lastArgs = null,
    lastException = null,
    lastExceptionStack = null;

  /**
     * Add a crash handler.
     * @param {Function} handler
     */
  function subscribe(handler) {
    installGlobalHandler();
    handlers.push(handler);
  }

  /**
     * Remove a crash handler.
     * @param {Function} handler
     */
  function unsubscribe(handler) {
    for (var i = handlers.length - 1; i >= 0; --i) {
      if (handlers[i] === handler) {
        handlers.splice(i, 1);
      }
    }
  }

  /**
     * Remove all crash handlers.
     */
  function unsubscribeAll() {
    uninstallGlobalHandler();
    handlers = [];
  }

  /**
     * Dispatch stack information to all handlers.
     * @param {Object.<string, *>} stack
     */
  function notifyHandlers(stack, isWindowError) {
    var exception = null;
    if (isWindowError && !TraceKit.collectWindowErrors) {
      return;
    }
    for (var i in handlers) {
      if (handlers.hasOwnProperty(i)) {
        try {
          handlers[i].apply(null, [stack].concat(_slice.call(arguments, 2)));
        } catch (inner) {
          exception = inner;
        }
      }
    }

    if (exception) {
      throw exception;
    }
  }

  var _oldOnerrorHandler, _onErrorHandlerInstalled;

  /**
     * Ensures all global unhandled exceptions are recorded.
     * Supported by Gecko and IE.
     * @param {string} message Error message.
     * @param {string} url URL of script that generated the exception.
     * @param {(number|string)} lineNo The line number at which the error
     * occurred.
     * @param {?(number|string)} colNo The column number at which the error
     * occurred.
     * @param {?Error} ex The actual Error object.
     */
  function traceKitWindowOnError(message, url, lineNo, colNo, ex) {
    var stack = null;

    if (lastExceptionStack) {
      TraceKit.computeStackTrace.augmentStackTraceWithInitialElement(
        lastExceptionStack,
        url,
        lineNo,
        message
      );
      processLastException();
    } else if (ex && utils.isError(ex)) {
      // non-string `ex` arg; attempt to extract stack trace

      // New chrome and blink send along a real error object
      // Let's just report that like a normal error.
      // See: https://mikewest.org/2013/08/debugging-runtime-errors-with-window-onerror
      stack = TraceKit.computeStackTrace(ex);
      notifyHandlers(stack, true);
    } else {
      var location = {
        url: url,
        line: lineNo,
        column: colNo
      };

      var name = undefined;
      var msg = message; // must be new var or will modify original `arguments`
      var groups;
      if ({}.toString.call(message) === '[object String]') {
        var groups = message.match(ERROR_TYPES_RE);
        if (groups) {
          name = groups[1];
          msg = groups[2];
        }
      }

      location.func = UNKNOWN_FUNCTION;

      stack = {
        name: name,
        message: msg,
        url: getLocationHref(),
        stack: [location]
      };
      notifyHandlers(stack, true);
    }

    if (_oldOnerrorHandler) {
      return _oldOnerrorHandler.apply(this, arguments);
    }

    return false;
  }

  function installGlobalHandler() {
    if (_onErrorHandlerInstalled) {
      return;
    }
    _oldOnerrorHandler = _window.onerror;
    _window.onerror = traceKitWindowOnError;
    _onErrorHandlerInstalled = true;
  }

  function uninstallGlobalHandler() {
    if (!_onErrorHandlerInstalled) {
      return;
    }
    _window.onerror = _oldOnerrorHandler;
    _onErrorHandlerInstalled = false;
    _oldOnerrorHandler = undefined;
  }

  function processLastException() {
    var _lastExceptionStack = lastExceptionStack,
      _lastArgs = lastArgs;
    lastArgs = null;
    lastExceptionStack = null;
    lastException = null;
    notifyHandlers.apply(null, [_lastExceptionStack, false].concat(_lastArgs));
  }

  /**
     * Reports an unhandled Error to TraceKit.
     * @param {Error} ex
     * @param {?boolean} rethrow If false, do not re-throw the exception.
     * Only used for window.onerror to not cause an infinite loop of
     * rethrowing.
     */
  function report(ex, rethrow) {
    var args = _slice.call(arguments, 1);
    if (lastExceptionStack) {
      if (lastException === ex) {
        return; // already caught by an inner catch block, ignore
      } else {
        processLastException();
      }
    }

    var stack = TraceKit.computeStackTrace(ex);
    lastExceptionStack = stack;
    lastException = ex;
    lastArgs = args;

    // If the stack trace is incomplete, wait for 2 seconds for
    // slow slow IE to see if onerror occurs or not before reporting
    // this exception; otherwise, we will end up with an incomplete
    // stack trace
    setTimeout(function() {
      if (lastException === ex) {
        processLastException();
      }
    }, stack.incomplete ? 2000 : 0);

    if (rethrow !== false) {
      throw ex; // re-throw to propagate to the top level (and cause window.onerror)
    }
  }

  report.subscribe = subscribe;
  report.unsubscribe = unsubscribe;
  report.uninstall = unsubscribeAll;
  return report;
})();

/**
 * TraceKit.computeStackTrace: cross-browser stack traces in JavaScript
 *
 * Syntax:
 *   s = TraceKit.computeStackTrace(exception) // consider using TraceKit.report instead (see below)
 * Returns:
 *   s.name              - exception name
 *   s.message           - exception message
 *   s.stack[i].url      - JavaScript or HTML file URL
 *   s.stack[i].func     - function name, or empty for anonymous functions (if guessing did not work)
 *   s.stack[i].args     - arguments passed to the function, if known
 *   s.stack[i].line     - line number, if known
 *   s.stack[i].column   - column number, if known
 *
 * Supports:
 *   - Firefox:  full stack trace with line numbers and unreliable column
 *               number on top frame
 *   - Opera 10: full stack trace with line and column numbers
 *   - Opera 9-: full stack trace with line numbers
 *   - Chrome:   full stack trace with line and column numbers
 *   - Safari:   line and column number for the topmost stacktrace element
 *               only
 *   - IE:       no line numbers whatsoever
 *
 * Tries to guess names of anonymous functions by looking for assignments
 * in the source code. In IE and Safari, we have to guess source file names
 * by searching for function bodies inside all page scripts. This will not
 * work for scripts that are loaded cross-domain.
 * Here be dragons: some function names may be guessed incorrectly, and
 * duplicate functions may be mismatched.
 *
 * TraceKit.computeStackTrace should only be used for tracing purposes.
 * Logging of unhandled exceptions should be done with TraceKit.report,
 * which builds on top of TraceKit.computeStackTrace and provides better
 * IE support by utilizing the window.onerror event to retrieve information
 * about the top of the stack.
 *
 * Note: In IE and Safari, no stack trace is recorded on the Error object,
 * so computeStackTrace instead walks its *own* chain of callers.
 * This means that:
 *  * in Safari, some methods may be missing from the stack trace;
 *  * in IE, the topmost function in the stack trace will always be the
 *    caller of computeStackTrace.
 *
 * This is okay for tracing (because you are likely to be calling
 * computeStackTrace from the function you want to be the topmost element
 * of the stack trace anyway), but not okay for logging unhandled
 * exceptions (because your catch block will likely be far away from the
 * inner function that actually caused the exception).
 *
 */
TraceKit.computeStackTrace = (function computeStackTraceWrapper() {
  // Contents of Exception in various browsers.
  //
  // SAFARI:
  // ex.message = Can't find variable: qq
  // ex.line = 59
  // ex.sourceId = 580238192
  // ex.sourceURL = http://...
  // ex.expressionBeginOffset = 96
  // ex.expressionCaretOffset = 98
  // ex.expressionEndOffset = 98
  // ex.name = ReferenceError
  //
  // FIREFOX:
  // ex.message = qq is not defined
  // ex.fileName = http://...
  // ex.lineNumber = 59
  // ex.columnNumber = 69
  // ex.stack = ...stack trace... (see the example below)
  // ex.name = ReferenceError
  //
  // CHROME:
  // ex.message = qq is not defined
  // ex.name = ReferenceError
  // ex.type = not_defined
  // ex.arguments = ['aa']
  // ex.stack = ...stack trace...
  //
  // INTERNET EXPLORER:
  // ex.message = ...
  // ex.name = ReferenceError
  //
  // OPERA:
  // ex.message = ...message... (see the example below)
  // ex.name = ReferenceError
  // ex.opera#sourceloc = 11  (pretty much useless, duplicates the info in ex.message)
  // ex.stacktrace = n/a; see 'opera:config#UserPrefs|Exceptions Have Stacktrace'

  /**
     * Computes stack trace information from the stack property.
     * Chrome and Gecko use this property.
     * @param {Error} ex
     * @return {?Object.<string, *>} Stack trace information.
     */
  function computeStackTraceFromStackProp(ex) {
    if (typeof ex.stack === 'undefined' || !ex.stack) return;

    var chrome = /^\s*at (.*?) ?\(((?:file|https?|blob|chrome-extension|native|eval|webpack|<anonymous>|[a-z]:|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i,
      gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|\[native).*?|[^@]*bundle)(?::(\d+))?(?::(\d+))?\s*$/i,
      winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i,
      // Used to additionally parse URL/line/column from eval frames
      geckoEval = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i,
      chromeEval = /\((\S*)(?::(\d+))(?::(\d+))\)/,
      lines = ex.stack.split('\n'),
      stack = [],
      submatch,
      parts,
      element,
      reference = /^(.*) is undefined$/.exec(ex.message);

    for (var i = 0, j = lines.length; i < j; ++i) {
      if ((parts = chrome.exec(lines[i]))) {
        var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
        var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval && (submatch = chromeEval.exec(parts[2]))) {
          // throw out eval line/column and use top-most line/column number
          parts[2] = submatch[1]; // url
          parts[3] = submatch[2]; // line
          parts[4] = submatch[3]; // column
        }
        element = {
          url: !isNative ? parts[2] : null,
          func: parts[1] || UNKNOWN_FUNCTION,
          args: isNative ? [parts[2]] : [],
          line: parts[3] ? +parts[3] : null,
          column: parts[4] ? +parts[4] : null
        };
      } else if ((parts = winjs.exec(lines[i]))) {
        element = {
          url: parts[2],
          func: parts[1] || UNKNOWN_FUNCTION,
          args: [],
          line: +parts[3],
          column: parts[4] ? +parts[4] : null
        };
      } else if ((parts = gecko.exec(lines[i]))) {
        var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval && (submatch = geckoEval.exec(parts[3]))) {
          // throw out eval line/column and use top-most line number
          parts[3] = submatch[1];
          parts[4] = submatch[2];
          parts[5] = null; // no column when eval
        } else if (i === 0 && !parts[5] && typeof ex.columnNumber !== 'undefined') {
          // FireFox uses this awesome columnNumber property for its top frame
          // Also note, Firefox's column number is 0-based and everything else expects 1-based,
          // so adding 1
          // NOTE: this hack doesn't work if top-most frame is eval
          stack[0].column = ex.columnNumber + 1;
        }
        element = {
          url: parts[3],
          func: parts[1] || UNKNOWN_FUNCTION,
          args: parts[2] ? parts[2].split(',') : [],
          line: parts[4] ? +parts[4] : null,
          column: parts[5] ? +parts[5] : null
        };
      } else {
        continue;
      }

      if (!element.func && element.line) {
        element.func = UNKNOWN_FUNCTION;
      }

      stack.push(element);
    }

    if (!stack.length) {
      return null;
    }

    return {
      name: ex.name,
      message: ex.message,
      url: getLocationHref(),
      stack: stack
    };
  }

  /**
     * Adds information about the first frame to incomplete stack traces.
     * Safari and IE require this to get complete data on the first frame.
     * @param {Object.<string, *>} stackInfo Stack trace information from
     * one of the compute* methods.
     * @param {string} url The URL of the script that caused an error.
     * @param {(number|string)} lineNo The line number of the script that
     * caused an error.
     * @param {string=} message The error generated by the browser, which
     * hopefully contains the name of the object that caused the error.
     * @return {boolean} Whether or not the stack information was
     * augmented.
     */
  function augmentStackTraceWithInitialElement(stackInfo, url, lineNo, message) {
    var initial = {
      url: url,
      line: lineNo
    };

    if (initial.url && initial.line) {
      stackInfo.incomplete = false;

      if (!initial.func) {
        initial.func = UNKNOWN_FUNCTION;
      }

      if (stackInfo.stack.length > 0) {
        if (stackInfo.stack[0].url === initial.url) {
          if (stackInfo.stack[0].line === initial.line) {
            return false; // already in stack trace
          } else if (
            !stackInfo.stack[0].line &&
            stackInfo.stack[0].func === initial.func
          ) {
            stackInfo.stack[0].line = initial.line;
            return false;
          }
        }
      }

      stackInfo.stack.unshift(initial);
      stackInfo.partial = true;
      return true;
    } else {
      stackInfo.incomplete = true;
    }

    return false;
  }

  /**
     * Computes stack trace information by walking the arguments.caller
     * chain at the time the exception occurred. This will cause earlier
     * frames to be missed but is the only way to get any stack trace in
     * Safari and IE. The top frame is restored by
     * {@link augmentStackTraceWithInitialElement}.
     * @param {Error} ex
     * @return {?Object.<string, *>} Stack trace information.
     */
  function computeStackTraceByWalkingCallerChain(ex, depth) {
    var functionName = /function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i,
      stack = [],
      funcs = {},
      recursion = false,
      parts,
      item,
      source;

    for (
      var curr = computeStackTraceByWalkingCallerChain.caller;
      curr && !recursion;
      curr = curr.caller
    ) {
      if (curr === computeStackTrace || curr === TraceKit.report) {
        // console.log('skipping internal function');
        continue;
      }

      item = {
        url: null,
        func: UNKNOWN_FUNCTION,
        line: null,
        column: null
      };

      if (curr.name) {
        item.func = curr.name;
      } else if ((parts = functionName.exec(curr.toString()))) {
        item.func = parts[1];
      }

      if (typeof item.func === 'undefined') {
        try {
          item.func = parts.input.substring(0, parts.input.indexOf('{'));
        } catch (e) {}
      }

      if (funcs['' + curr]) {
        recursion = true;
      } else {
        funcs['' + curr] = true;
      }

      stack.push(item);
    }

    if (depth) {
      // console.log('depth is ' + depth);
      // console.log('stack is ' + stack.length);
      stack.splice(0, depth);
    }

    var result = {
      name: ex.name,
      message: ex.message,
      url: getLocationHref(),
      stack: stack
    };
    augmentStackTraceWithInitialElement(
      result,
      ex.sourceURL || ex.fileName,
      ex.line || ex.lineNumber,
      ex.message || ex.description
    );
    return result;
  }

  /**
     * Computes a stack trace for an exception.
     * @param {Error} ex
     * @param {(string|number)=} depth
     */
  function computeStackTrace(ex, depth) {
    var stack = null;
    depth = depth == null ? 0 : +depth;

    try {
      stack = computeStackTraceFromStackProp(ex);
      if (stack) {
        return stack;
      }
    } catch (e) {
      if (TraceKit.debug) {
        throw e;
      }
    }

    try {
      stack = computeStackTraceByWalkingCallerChain(ex, depth + 1);
      if (stack) {
        return stack;
      }
    } catch (e) {
      if (TraceKit.debug) {
        throw e;
      }
    }
    return {
      name: ex.name,
      message: ex.message,
      url: getLocationHref()
    };
  }

  computeStackTrace.augmentStackTraceWithInitialElement = augmentStackTraceWithInitialElement;
  computeStackTrace.computeStackTraceFromStackProp = computeStackTraceFromStackProp;

  return computeStackTrace;
})();

module.exports = TraceKit;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "bN1p":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "bSeU":
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ "bUqO":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("zgIt")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "beh1":
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),

/***/ "c2wH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _assign = __webpack_require__("woOf");

var _assign2 = _interopRequireDefault(_assign);

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _getOwnPropertyNames = __webpack_require__("aFK5");

var _getOwnPropertyNames2 = _interopRequireDefault(_getOwnPropertyNames);

var _getIterator2 = __webpack_require__("BO1k");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _pluginManager = __webpack_require__("Nhvj");

var _pluginManager2 = _interopRequireDefault(_pluginManager);

var _sizzle = __webpack_require__("zZaF");

var _sizzle2 = _interopRequireDefault(_sizzle);

var _device = __webpack_require__("xOtj");

var _device2 = _interopRequireDefault(_device);

var _dom = __webpack_require__("TdxG");

var domUtils = _interopRequireWildcard(_dom);

var _debug = __webpack_require__("BF+C");

var _debug2 = _interopRequireDefault(_debug);

var _extend = __webpack_require__("5E+y");

var _extend2 = _interopRequireDefault(_extend);

var _breakpoints = __webpack_require__("+JT+");

var _breakpoints2 = _interopRequireDefault(_breakpoints);

var _config = __webpack_require__("Pqsl");

var _config2 = _interopRequireDefault(_config);

var _wrapperApi = __webpack_require__("cB3I");

var _wrapperApi2 = _interopRequireDefault(_wrapperApi);

var _eventWrapperApi = __webpack_require__("YxlO");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Debug = (0, _debug2.default)('video');

var videoElementConfigAttributes = ['autoplay', 'data-video-controls', 'preload'];

var defaultVideoConfig = {
	autoplay: false,
	limitBitrateByPortal: true,
	preload: 'auto'
};

var instances = [];
var _configured = false;

var pluginManager = new _pluginManager2.default();

// Array to hold plugins that should be added when the video module is
// configured. It is used to allow addPlugin to be called before initVideo.
var pluginsToAdd = [];

var asArray = function asArray(obj) {
	if (Array.isArray(obj)) {
		return obj;
	}

	if (obj) {
		return [obj];
	}

	return [];
};

function initConfig() {
	// Add plugins listed in the config.
	asArray(_config2.default.plugins).filter(function (plugin) {
		return plugin;
	}).forEach(function (plugin) {
		return addPlugin(plugin);
	});

	_configured = true;
}

function _createApiProxy(api, element) {
	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;

	try {
		for (var _iterator = (0, _getIterator3.default)((0, _getOwnPropertyNames2.default)((0, _getPrototypeOf2.default)(api))), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
			var name = _step.value;

			if (typeof api[name] === 'function' && name !== 'constructor') {
				if (name === 'destroy') {
					(function () {
						var oldDestroy = element.destroy;
						element.destroy = function () {
							oldDestroy.call(element);
							api.destroy();
						};
					})();
				} else {
					element[name] = api[name].bind(api);
				}
			}
		}
	} catch (err) {
		_didIteratorError = true;
		_iteratorError = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion && _iterator.return) {
				_iterator.return();
			}
		} finally {
			if (_didIteratorError) {
				throw _iteratorError;
			}
		}
	}
}

function _attributeFilter(attrName) {
	var isVideoConfigAttr = videoElementConfigAttributes.some(function (x) {
		return x === attrName;
	});

	return isVideoConfigAttr || attrName.match(/data-/);
}

function resetAttributes(element, originalAttributes) {
	for (var i = 0; i < element.attributes.length; i++) {
		var currAttr = element.attributes[i];
		if (!_attributeFilter(currAttr.name) && originalAttributes[currAttr.name] === undefined) {
			element.removeAttribute(currAttr.name);
		}
	}

	(0, _keys2.default)(originalAttributes).forEach(function (attribute) {
		element.setAttribute(attribute, originalAttributes[attribute]);
	});
}

function getAttributesFromElement(element) {
	var attrObj = [];
	for (var i = 0; i < element.attributes.length; i++) {
		if (!_attributeFilter(element.attributes[i].name)) {
			attrObj[element.attributes[i].name] = element.attributes[i].value;
		}
	}

	return attrObj;
}

function pullConfigFromVideoElement(videoElement) {
	var config = {};
	videoElementConfigAttributes.forEach(function (attrName) {
		if (videoElement.hasAttribute(attrName)) {
			var attrValue = videoElement.getAttribute(attrName);

			if (attrName.match(/data-video/)) {
				attrName = attrName.replace(/data-video-/, '');
			} else {
				videoElement.removeAttribute(attrName);
				videoElement.setAttribute('data-video-' + attrName, attrValue);
			}

			config[attrName] = attrValue !== '' ? attrValue : true;
		}
	});

	return config;
}

function initVideo(rootElement, autoplay) {

	var videoElement = (0, _sizzle2.default)('video', rootElement);
	var matchBreakpointCallback = function matchBreakpointCallback(name, isMatch) {
		Debug('matchBreakpointCallback', name, isMatch);
		if (isMatch) {
			domUtils.addClass(rootElement, name);
		} else {
			domUtils.removeClass(rootElement, name);
		}
	};

	if (!videoElement.length) {
		Debug.error('No video element found');

		return;
	}

	videoElement = videoElement[0];
	rootElement.originalAttributes = {
		root: getAttributesFromElement(rootElement),
		video: getAttributesFromElement(videoElement)
	};

	if (!_configured) {
		initConfig();
	}

	pluginsToAdd.forEach(function (_ref) {
		var plugin = _ref.plugin,
		    prepend = _ref.prepend;

		addPlugin(plugin, prepend);
	});
	pluginsToAdd.length = 0;

	var videoId = videoElement.getAttribute('data-video-id');

	if (!videoId) {
		Debug.error('No videoId given');

		return;
	}

	videoElement.setAttribute('data-rt', 'video-player');

	(0, _extend2.default)(videoElement, (0, _eventWrapperApi.createEventWrapper)());
	domUtils.addClass(rootElement, 'svp_container');
	domUtils.addClass(rootElement, 'svp_css-container--font');
	domUtils.addClass(videoElement, 'svp_video');

	if (_config2.default.theme && _config2.default.theme !== 'standard') {
		_config2.default.theme.split(/,/).forEach(function (themeName) {
			domUtils.addClass(rootElement, 'svp_theme__' + themeName.trim());
		});
	}

	//Fix for iOS 7 bug that defaults video height to 150px
	if (_device2.default.isIOSLte7()) {
		var canvasNode = domUtils.fromString('<canvas class="svp_video">');
		rootElement.insertBefore(canvasNode, videoElement);
		videoElement.className += ' svp_video_ios7';
	}

	if (_device2.default.isWindowsPhone()) {
		rootElement.className += ' svp_container_wp';
	}

	// Build video config
	var videoConfig = (0, _assign2.default)({}, defaultVideoConfig, pullConfigFromVideoElement(videoElement));

	(0, _extend2.default)(rootElement, (0, _eventWrapperApi.createEventWrapper)());
	var api = new _wrapperApi2.default(videoId, rootElement, videoConfig);
	_createApiProxy(api, rootElement);

	pluginManager.createAll(api);

	instances.push({ id: videoId, api: api, rootElement: rootElement });

	//register breakpoint listeners
	if (_config2.default.breakPoints) {
		_config2.default.breakPoints.forEach(function (bp) {
			(0, _keys2.default)(bp).forEach(function (className) {
				_breakpoints2.default.addListener(videoElement, className, bp[className], matchBreakpointCallback);
			});
		});
	}

	if (!api.config.preload || api.config.preload !== 'none' || api.config.autoplay) {
		rootElement.load(videoId, autoplay);
	}
}

function initVideoNoJs(videoContainerEl) {
	var videoEl = (0, _sizzle2.default)('video', videoContainerEl)[0];
	var posterImage = videoEl.getAttribute('poster');
	var videoId = videoEl.getAttribute('data-video-id');
	var url = _config2.default.nojsPlayerBaseUrl + videoId;

	videoContainerEl.className += ' svp_container svp_is--error';

	var linkEl = domUtils.fromString('<div class="svp_video-container">\
			<img class="svp_ui-error__poster svp_video" src="' + posterImage + '"/>\
			<div class="svp_ui-error svp_ui-error__is--visible svp_ui-error__is--nojs"> \
				<div class="svp_ui-error__inner">\
					<span class="svp_ui-error__icon svp_ui-error__icon--blocked svp_is--visible"></span>\
					<div class="svp_ui-error__message-container">\
						<span class="svp_ui-error__message" aria-live="assertive" role="alert">Vi rekommenderar att du uppdaterar din webbläsare</span>\
						<div class="svp_ui-error__message-link--container">\
							<span class="svp_ui-error__message-icon--arrow"></span>\
							<a href="' + url + '" target="_blank">Inte nu, försök spela ändå</a>\
						</div>\
					</div>\
				</div>\
			</div>\
		</div>');

	videoContainerEl.replaceChild(linkEl, videoEl);
}

function destroyElement(element) {
	if (element.destroy) {
		element.destroy();
	}
	if (element.children) {
		for (var i = 0; i < element.children.length; i++) {
			destroyElement(element.children[i]);
		}
	}
}

function destroy(rootElement) {
	// Lookup and remove instance
	var instance = void 0;
	for (var i = 0; i < instances.length; i++) {
		if (instances[i].rootElement === rootElement) {
			instance = instances[i];
			instances.splice(i, 1);
			break;
		}
	}

	if (!instance) {
		Debug.error('Destroy failed because an instance with the specified video id was not found');

		return;
	}

	var _instance = instance,
	    api = _instance.api;


	pluginManager.destroyAll(api);

	destroyElement(rootElement);

	var videoElement = (0, _sizzle2.default)('video', rootElement)[0];
	var originalAttributes = rootElement.originalAttributes;

	if (_device2.default.isIOSLte7()) {
		var canvasNode = (0, _sizzle2.default)('canvas', rootElement)[0];
		rootElement.removeChild(canvasNode);
	}

	domUtils.removeClass(rootElement, 'svp_container');
	domUtils.removeClass(videoElement, 'svp_video');

	if (originalAttributes) {
		resetAttributes(rootElement, originalAttributes.root);
		resetAttributes(videoElement, originalAttributes.video);
	}

	_breakpoints2.default.destroy(videoElement);
}

function addPlugin(plugin) {
	var prepend = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

	if (_configured) {
		pluginManager.addPlugin(plugin, prepend);
	} else {
		pluginsToAdd.push({ plugin: plugin, prepend: prepend });
	}
}

function noop() {
	//
}

var forceNoJs = window.location.search.match(/nojs=true/);
var noJsMode = !document.addEventListener || forceNoJs;

module.exports = {
	destroy: destroy,
	initialize: noJsMode ? initVideoNoJs : initVideo,
	addPlugin: noJsMode ? noop : addPlugin
};

/***/ }),

/***/ "c5AH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__("Wdy1");

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),

/***/ "c8Kh":
/***/ (function(module, exports) {

module.exports = true;


/***/ }),

/***/ "cB3I":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*global SVP*/


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _assign = __webpack_require__("woOf");

var _assign2 = _interopRequireDefault(_assign);

var _typeof2 = __webpack_require__("pFYg");

var _typeof3 = _interopRequireDefault(_typeof2);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _getIterator2 = __webpack_require__("BO1k");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _sizzle = __webpack_require__("zZaF");

var _sizzle2 = _interopRequireDefault(_sizzle);

var _config = __webpack_require__("Pqsl");

var _config2 = _interopRequireDefault(_config);

var _resolveStreamingConfig = __webpack_require__("Gm6T");

var _resolveStreamingConfig2 = _interopRequireDefault(_resolveStreamingConfig);

var _metadataFetchFromSource = __webpack_require__("hSV+");

var _metadataFetchFromSource2 = _interopRequireDefault(_metadataFetchFromSource);

var _device = __webpack_require__("xOtj");

var _device2 = _interopRequireDefault(_device);

var _dom = __webpack_require__("TdxG");

var domUtils = _interopRequireWildcard(_dom);

var _customEvent = __webpack_require__("L+TV");

var _customEvent2 = _interopRequireDefault(_customEvent);

var _debug = __webpack_require__("BF+C");

var _debug2 = _interopRequireDefault(_debug);

var _videoType = __webpack_require__("vlJ+");

var _videoType2 = _interopRequireDefault(_videoType);

var _errorType = __webpack_require__("0PB5");

var _errorType2 = _interopRequireDefault(_errorType);

var _dashVideo = __webpack_require__("JeYD");

var _dashVideo2 = _interopRequireDefault(_dashVideo);

var _hlsVideo = __webpack_require__("i0zA");

var _hlsVideo2 = _interopRequireDefault(_hlsVideo);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Debug = (0, _debug2.default)('wrapperApi');

var NAMESPACE = 'wrapper';
var READY_NAMESPACE = 'wrapper-ready';

var STATE_CLASS = {
	forceHide: 'svp_is--force-hide'
};

function applyFunctionToFilters(filters, fnName, args) {
	if (!filters) {
		return true;
	}

	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;

	try {
		for (var _iterator = (0, _getIterator3.default)(filters), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
			var filter = _step.value;

			if (hasFunction(filter, fnName)) {
				var retValue = filter[fnName].apply(filter, args);

				if (isValidReturnValue(retValue, fnName)) {
					return retValue;
				}
			}
		}
	} catch (err) {
		_didIteratorError = true;
		_iteratorError = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion && _iterator.return) {
				_iterator.return();
			}
		} finally {
			if (_didIteratorError) {
				throw _iteratorError;
			}
		}
	}

	return null;
}

function hasFunction(filter, fnName) {
	return filter && typeof filter[fnName] === 'function';
}

function isValidReturnValue(retValue, fnName) {
	return (fnName.match(/^is/) || retValue !== false) && retValue !== null && retValue !== undefined;
}

function hasSourceElementChild(element) {
	return (0, _sizzle2.default)('source', element).length > 0;
}

function getEvents(videoObject) {
	// TODO: Which of these do we need/want to support?
	var events = ['abort', 'bufferEmpty', 'canplay', 'canplaythrough', 'durationchange', 'emptied', 'ended', 'error', 'loadeddata', 'loadedmetadata', 'loadstart', 'pause', 'play', 'playing', 'progress', 'ratechange', 'resize', 'seeked', 'seeking', 'stalled', 'suspend', 'timeupdate', 'volumechange', 'waiting'];

	if (videoObject.customEvents) {
		events = events.concat(videoObject.customEvents);
	}

	return events;
}

function cleanEvents(videoObject) {
	if (videoObject.removeEventSVP) {
		getEvents(videoObject).forEach(function (eventName) {
			videoObject.removeEventSVP(NAMESPACE + '.' + eventName);
		});
	}
}

function attachEvents(rootElement, videoObject) {
	if (videoObject.addEventSVP) {
		getEvents(videoObject).forEach(function (eventName) {
			videoObject.addEventSVP(NAMESPACE + '.' + eventName, function (event) {
				if (event.preventDefault) {
					event.preventDefault();
				}

				if (eventName !== 'timeupdate') {
					Debug('received event: ' + eventName);
				}

				rootElement.dispatchEvent(new _customEvent2.default(event.type, { detail: event }));

				return false;
			});
		});
	}
}

function handleError(wrapperApi) {
	wrapperApi.on(_errorType2.default.UNKNOW_VIDEO_TYPE_ERROR, function (e) {
		// If no plugin has handled this, send an error
		if (!e.defaultPrevented) {
			wrapperApi.fire('error', {
				name: _errorType2.default.UNKNOW_VIDEO_TYPE_ERROR
			});
		}

		wrapperApi.off(_errorType2.default.UNKNOW_VIDEO_TYPE_ERROR);
	});

	wrapperApi.fire(_errorType2.default.UNKNOW_VIDEO_TYPE_ERROR, null, {
		cancelable: true
	});
}

function _videoObjectReadyFn(wrapperApi, videoObject, isExternalUi) {
	if (!wrapperApi.state()) {
		return;
	}
	wrapperApi.state().loading = false;
	wrapperApi.state().ready = true;
	wrapperApi._data._video = videoObject;

	domUtils.removeEvents(videoObject, 'loadstart', READY_NAMESPACE);

	wrapperApi.fire('ready', {
		videoId: wrapperApi.data() && wrapperApi.data().videoId,
		externalUi: isExternalUi
	});

	if (_config2.default.resetOnEnd) {
		wrapperApi.on('reset.ended', function () {
			var videoId = wrapperApi.data() && wrapperApi.data().videoId;
			wrapperApi.off('reset.ended');

			if (videoId) {
				wrapperApi.on('reset.seeked', function () {
					wrapperApi.off('reset.seeked');
					wrapperApi.pause();
				});

				setTimeout(function () {
					wrapperApi.reset();
					wrapperApi.fire('ready', {
						videoId: videoId,
						externalUi: isExternalUi
					});
				}, 100);
			}
		});
	}
}

function _setup(wrapperApi, videoId, metadata, videoUrls, textUrls) {
	if (!wrapperApi.state()) {
		return;
	}
	wrapperApi._data.videoId = videoId;
	wrapperApi.fire('metadata', metadata);

	var videoObject = void 0;
	var videoElement = (0, _sizzle2.default)('video', wrapperApi.element())[0];
	var streamingConfig = (0, _resolveStreamingConfig2.default)(videoUrls, textUrls, metadata, videoElement);

	if (window.SVP._inSweden !== undefined) {
		if (!window.SVP._inSweden && (metadata.geoBlockedSweden || metadata.rights && metadata.rights.geoBlockedSweden)) {
			//TODO rewrite this once we decide how to handle rights in the api
			wrapperApi.fire('error', { name: _errorType2.default.GEO_BLOCK_ERROR });

			return;
		}
	}

	var isNewType = wrapperApi.data().videoConfig.videoType !== streamingConfig.videoType;
	if (wrapperApi.video().unload && isNewType) {
		Debug('Switching video format: ' + wrapperApi.data().videoConfig.videoType + ' --> ' + streamingConfig.videoType);
		cleanEvents(wrapperApi.video());
		wrapperApi.video().unload();
		videoElement = (0, _sizzle2.default)('video', wrapperApi.element())[0];
	}

	var autoplay = wrapperApi.isAutoplay();
	if (autoplay) {
		videoElement.setAttribute('autoplay', '');
		videoElement.autoplay = true;
	} else {
		videoElement.removeAttribute('autoplay');
		videoElement.autoplay = false;
	}

	switch (streamingConfig.videoType) {
		case _videoType2.default.DASH:
			{
				__webpack_require__.e/* require.ensure */(0).then((function (require) {
					var dashjs = __webpack_require__("2u2m")['default'];
					videoObject = _dashVideo2.default.load(videoId, videoElement, streamingConfig.videoUrl, metadata, wrapperApi.config, wrapperApi, dashjs);

					domUtils.addEvents(videoObject, 'loadstart', function () {
						_videoObjectReadyFn(wrapperApi, videoObject, false);
					}, READY_NAMESPACE);

					if (isNewType) {
						attachEvents(wrapperApi.element(), videoObject);
					}
				}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
				break;
			}
		case _videoType2.default.HLS:
			{
				videoObject = _hlsVideo2.default.load(videoElement, streamingConfig.videoUrl, metadata, wrapperApi.config, wrapperApi);

				domUtils.addEvents(videoObject, 'loadstart', function () {
					_videoObjectReadyFn(wrapperApi, videoObject, false);
				}, READY_NAMESPACE);

				if (isNewType) {
					// On Android 4.4.2 and below, the poster image sometimes isn't removed properly. Seeking fixes this.
					if (_device2.default.isBrokenAndroidChrome()) {
						domUtils.addEvents(wrapperApi.element(), 'timeupdate', function () {
							if (wrapperApi.getCurrentTime() > 0) {
								domUtils.removeEvents(wrapperApi.element(), 'timeupdate', 'androidWrapper');
								wrapperApi.seek(Math.floor(wrapperApi.getCurrentTime()));
							}
						}, 'androidWrapper');
					}
					attachEvents(wrapperApi.element(), videoObject);
				}
				break;
			}
		case _videoType2.default.HDS:
		case _videoType2.default.FLASHLS:
			{
				var oldVideoObject = wrapperApi._data._video;
				videoObject = _config2.default.flashEngine.load(videoElement, streamingConfig.videoUrl, streamingConfig.textUrl, metadata, autoplay);

				if (oldVideoObject) {
					cleanEvents(oldVideoObject); //clear events on old obj
				}
				attachEvents(wrapperApi.element(), videoObject);

				_videoObjectReadyFn(wrapperApi, videoObject, false);
				if (wrapperApi.isAutoplay()) {
					wrapperApi.play();
				}
				break;
			}
		default:
			{
				handleError(wrapperApi);
				_videoObjectReadyFn(wrapperApi, videoElement, true);
				if (isNewType) {
					attachEvents(wrapperApi.element(), videoElement);
				}
				break;
			}
	}
	wrapperApi._data.videoConfig = streamingConfig;
}

var Props = function Props(videoId, rootElement) {
	this.videoId = videoId;
	this.allowNoUi = true;
	this.isRemote = false;
	this._video = {};
	this._root = rootElement;

	this.videoConfig = {
		videoType: _videoType2.default.UNKNOWN
	};
};

Props.prototype.destroy = function () {
	//Set all references to undefined
	var key;
	for (key in this) {
		if (Object.prototype.hasOwnProperty.call(this, key)) {
			this[key] = undefined;
		}
	}
};

var State = function State() {
	this.ready = false;
	this.loading = false;
	this.hidden = false;
};

var WrapperAPI = function () {
	function WrapperAPI(videoId, rootElement, config) {
		(0, _classCallCheck3.default)(this, WrapperAPI);

		this._data = new Props(videoId, rootElement);
		this._state = new State();
		this.filters = [];
		this.device = _device2.default;
		this.config = config;
		this.fullscreenElement = null;
		this.autoplay = this.config.autoplay;
	}

	(0, _createClass3.default)(WrapperAPI, [{
		key: 'data',
		value: function data() {
			return this._data;
		}
	}, {
		key: 'state',
		value: function state() {
			return this._state;
		}
	}, {
		key: 'element',
		value: function element() {
			return this._data && this._data._root;
		}
	}, {
		key: 'video',
		value: function video() {
			return this._data && this._data._video;
		}
	}, {
		key: 'isAutoplay',
		value: function isAutoplay() {
			return this.autoplay;
		}
	}, {
		key: 'load',
		value: function load(videoId, autoplay) {
			var _this2 = this;

			if (videoId) {
				this._data.videoId = videoId;
			}

			Debug('load(videoId, autoplay)', this._data.videoId, autoplay);

			this._state.ready = false;
			this._state.loading = true;

			this.autoplay = autoplay !== undefined ? autoplay : this.config.autoplay;

			if (applyFunctionToFilters(this.filters, 'load', arguments)) {
				// eslint-disable-line prefer-rest-params
				return;
			}

			var callback = _setup.bind(this, this, this._data.videoId);
			var errorHandler = function errorHandler(error, data) {
				// TODO: this should/could be made more fine-grained (errType is http/timeout/error)
				if (data) {
					_this2.fire('metadata', data);
				}
				_this2.fire('error', error);
			};

			var rootElement = this.element();

			if (hasSourceElementChild(rootElement)) {
				(0, _metadataFetchFromSource2.default)(rootElement, callback);
			} else {
				_config2.default.metadataFetchFunction(this._data.videoId, callback, errorHandler);
			}
		}

		/**
   * Attempts to start the playback of the video.
   *
   * @return {Promise} Returns a Promise that is fulfilled when the video is
   * started or rejected if any error occured.
   */

	}, {
		key: 'play',
		value: function play() {
			var _this3 = this;

			if (this.state().ready) {
				if (applyFunctionToFilters(this.filters, 'play', arguments)) {
					// eslint-disable-line prefer-rest-params
					return _promise2.default.reject(new Error('Interrupted by filters.'));
				}

				// The return value of play() varies between browsers. If a
				// promise is returned we pass that as our return value, otherwise
				// we make a guess and resolve a promise directly.
				var result = this.video().play();
				if ((typeof result === 'undefined' ? 'undefined' : (0, _typeof3.default)(result)) === 'object' && typeof result.then === 'function') {
					return result;
				} else {
					return _promise2.default.resolve();
				}
			} else if (this.state().loading) {
				// The video is not yet ready to be played. We wait for a loadstart
				// (which occurs when the video is being loaded) before we execute
				// play. Note that we create a wrapping promise that resolves with
				// the inner play promise.
				return new _promise2.default(function (resolve) {
					var onLoadStart = function onLoadStart() {
						_this3.element().removeEventSVP('loadstart', onLoadStart);
						resolve(_this3.play());
					};
					_this3.element().addEventSVP('loadstart', onLoadStart);
				});
			}
		}
	}, {
		key: 'destroy',
		value: function destroy() {
			if (this.video().unload) {
				this.video().unload();
			}
			cleanEvents(this.video());

			this._data.destroy();
			this._data = undefined;
			this._state = undefined;
			this.filters = undefined;
			this.config = undefined;
			this.device = undefined;

			var noop = function noop() {
				// empty
			};
			this.load = noop;
			this.play = noop;
			this.destroy = noop;
			this.on = noop;
			this.off = noop;
			this.fire = noop;
		}

		/**
   * Dispatch an event on the wrapper element
   *
   * @param {string} eventName - The name of the event.
   * @param {object} [data] - The detail data for the CustomEvent.
   * @param {object} [customEventData] - EventInit dictionary to pass to the
   *      CustomEvent. It can specify "bubbles", "cancelable" and "compsed"
   *      fields on the event.
   */

	}, {
		key: 'fire',
		value: function fire(eventName, data, customEventInit) {
			var el = this.element();
			if (!el) {
				return;
			}

			var ev = new _customEvent2.default(eventName, (0, _assign2.default)({ detail: data }, customEventInit));

			var cancelled = el.dispatchEvent(ev);

			return cancelled;
		}
	}, {
		key: 'on',
		value: function on() {
			return this.element() && this.element().addEventSVP && this.element().addEventSVP.apply(this.data()._root, arguments); // eslint-disable-line prefer-rest-params
		}
	}, {
		key: 'off',
		value: function off() {
			return this.element() && this.element().removeEventSVP && this.element().removeEventSVP.apply(this.data()._root, arguments); // eslint-disable-line prefer-rest-params
		}
	}, {
		key: 'once',
		value: function once(event, callback) {
			var _this = this;
			event = event.match(/\./) ? event : NAMESPACE + '.' + event;

			return this.on(event, function () {
				callback.apply(_this, arguments); // eslint-disable-line prefer-rest-params
				_this.off(event);
			});
		}
	}, {
		key: 'show',
		value: function show() {
			domUtils.removeClass(this.element(), STATE_CLASS.forceHide);
			this.state().hidden = false;
		}
	}, {
		key: 'hide',
		value: function hide() {
			domUtils.addClass(this.element(), STATE_CLASS.forceHide);
			this.state().hidden = true;
		}
	}, {
		key: 'setFullscreenElement',
		value: function setFullscreenElement(element) {
			// Fullscreen API in iOS is not supported for other node types than video
			if (_device2.default.isIOS() && element.tagName.toLocaleLowerCase() !== 'video') {
				return false;
			}

			this.fullscreenElement = element;

			return true;
		}
	}, {
		key: 'getFullscreenElement',
		value: function getFullscreenElement() {
			return this.fullscreenElement || this.element();
		}
	}, {
		key: 'enterFullscreen',
		value: function enterFullscreen() {
			domUtils.enterVideoFullscreen(this);
		}
	}, {
		key: 'exitFullscreen',
		value: function exitFullscreen() {
			domUtils.exitVideoFullscreen(this);
		}
	}]);
	return WrapperAPI;
}();

exports.default = WrapperAPI;


function applyFunctionToFiltersOrVideoObject(api, fnName, args) {
	var ret = applyFunctionToFilters(api.filters, fnName, args);
	if (ret === null || ret === undefined) {
		var videoObject = api.video();
		if (videoObject[fnName]) {
			ret = videoObject[fnName].apply(videoObject, args);
		}
	}

	return ret;
}

['pause', 'seek', 'insertButton', 'showCaptions', 'reset', 'setVolume', 'mute', 'setAudioTrack'].forEach(function (fnName) {
	WrapperAPI.prototype[fnName] = function () {
		applyFunctionToFiltersOrVideoObject(this, fnName, arguments); // eslint-disable-line prefer-rest-params

		return this;
	};
});

['getCurrentTime', 'getDuration', 'getVolume', 'getMaxSeekable', 'isMuted', 'getMetrics', 'getSrc', 'isPaused', 'isSeeking', 'getTextTracks', 'getAudioTracks'].forEach(function (fnName) {
	WrapperAPI.prototype[fnName] = function () {
		return applyFunctionToFiltersOrVideoObject(this, fnName, arguments); // eslint-disable-line prefer-rest-params
	};
});
module.exports = exports['default'];

/***/ }),

/***/ "d075":
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__("OzIq").document;
module.exports = document && document.documentElement;


/***/ }),

/***/ "dK5q":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__("wXdB");
var $getPrototypeOf = __webpack_require__("VD8v");

__webpack_require__("30vf")('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),

/***/ "dudK":
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__("3fMt");
var call = __webpack_require__("tn1D");
var isArrayIter = __webpack_require__("yuYM");
var anObject = __webpack_require__("FKWp");
var toLength = __webpack_require__("GhAV");
var getIterFn = __webpack_require__("1yV6");
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),

/***/ "eAa1":
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__("3fMt");
var IObject = __webpack_require__("wiaE");
var toObject = __webpack_require__("wXdB");
var toLength = __webpack_require__("GhAV");
var asc = __webpack_require__("s2sY");
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),

/***/ "eENa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _map = __webpack_require__("ifoU");

var _map2 = _interopRequireDefault(_map);

exports.create = create;
exports.destroy = destroy;

var _dom = __webpack_require__("TdxG");

var domUtils = _interopRequireWildcard(_dom);

var _device = __webpack_require__("xOtj");

var _device2 = _interopRequireDefault(_device);

var _sizzle = __webpack_require__("zZaF");

var _sizzle2 = _interopRequireDefault(_sizzle);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Debug = __webpack_require__("BF+C")('airplay');

var EVENT_NAMESPACE = 'airplay';

var instances = new _map2.default();

var AirPlay = function () {
    function AirPlay(api) {
        var _this = this;

        (0, _classCallCheck3.default)(this, AirPlay);

        this.api = api;

        this.api.once(EVENT_NAMESPACE + '.ready', function () {
            return _this._setupEventListeners();
        });
    }

    (0, _createClass3.default)(AirPlay, [{
        key: '_setupEventListeners',
        value: function _setupEventListeners() {
            var _this2 = this;

            if (!window.WebKitPlaybackTargetAvailabilityEvent) {
                return;
            }

            Debug('Airplay init');

            if (_device2.default.isAirplayCapable()) {
                domUtils.addEvents(this.api.video(), 'webkitplaybacktargetavailabilitychanged', function (e) {
                    return _this2._onAvailabilityChange(e);
                }, EVENT_NAMESPACE);
            }

            domUtils.addEvents(this.api.video(), 'webkitcurrentplaybacktargetiswirelesschanged', function (e) {
                return _this2._onWirelessChanged(e);
            }, EVENT_NAMESPACE);
        }
    }, {
        key: '_onAvailabilityChange',
        value: function _onAvailabilityChange(event) {
            Debug(event, event.availability);

            if (event.availability === 'available') {
                domUtils.show(this._createButton());
            }
        }
    }, {
        key: '_onWirelessChanged',
        value: function _onWirelessChanged(event) {
            var _this3 = this;

            Debug('webkitcurrentplaybacktargetiswireless', this.api.video().webkitCurrentPlaybackTargetIsWireless, event);

            if (this.api.video().webkitCurrentPlaybackTargetIsWireless) {
                this.api.once(EVENT_NAMESPACE + '.canplay', function () {
                    return _this3.api.play();
                }); //fixes a bug with airplay stuck in pause state
                this.api.data().allowNoUi = false;
            } else {
                this.api.data().allowNoUi = true;
            }
        }
    }, {
        key: '_createButton',
        value: function _createButton() {
            var _this4 = this;

            var button = (0, _sizzle2.default)('.svp_airplay-button', this.api.element())[0];
            if (button) {
                return button;
            }

            button = domUtils.fromString('<div class="svp_airplay-button"></div>');

            button.addEventListener('click', function (e) {
                e.stopPropagation();
                _this4.api.video().webkitShowPlaybackTargetPicker();
            });

            button.addEventListener('touchend', function (e) {
                e.stopPropagation();
                _this4.api.video().webkitShowPlaybackTargetPicker();
            });

            this.api.insertButton(button);

            return button;
        }
    }, {
        key: 'destroy',
        value: function destroy() {
            if (!window.WebKitPlaybackTargetAvailabilityEvent) {
                return;
            }

            var button = (0, _sizzle2.default)('.svp_airplay-button', this.api.element())[0];
            if (button) {
                button.parentElement.removeChild(button);
            }

            if (_device2.default.isAirplayCapable()) {
                domUtils.removeEvents(this.api.video(), 'webkitplaybacktargetavailabilitychanged', EVENT_NAMESPACE);
            }
            domUtils.removeEvents(this.api.video(), 'webkitcurrentplaybacktargetiswirelesschanged', EVENT_NAMESPACE);

            this.api.off(EVENT_NAMESPACE + '.ready');
        }
    }]);
    return AirPlay;
}();

function create(api) {
    instances.set(api, new AirPlay(api));
}

function destroy(api) {
    var instance = instances.get(api);

    if (instance) {
        instance.destroy();
        instances.delete(api);
    }
}

/***/ }),

/***/ "eaCm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__("GCs6").f;
var create = __webpack_require__("NZ8V");
var redefineAll = __webpack_require__("nJ75");
var ctx = __webpack_require__("3fMt");
var anInstance = __webpack_require__("4S0F");
var forOf = __webpack_require__("dudK");
var $iterDefine = __webpack_require__("4dmN");
var step = __webpack_require__("beh1");
var setSpecies = __webpack_require__("EFoD");
var DESCRIPTORS = __webpack_require__("qs+f");
var fastKey = __webpack_require__("+zJ9").fastKey;
var validate = __webpack_require__("fTPD");
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),

/***/ "eg8w":
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),

/***/ "euHq":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("gCWN");
__webpack_require__("tz60");
__webpack_require__("+3lO");
__webpack_require__("2kY9");
__webpack_require__("oUpx");
__webpack_require__("txMS");
__webpack_require__("Mnw5");
module.exports = __webpack_require__("iANj").Map;


/***/ }),

/***/ "fTPD":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("8ANE");
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),

/***/ "fU25":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "fYB6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

exports.getManifest = getManifest;
exports.setupMaxBitrate = setupMaxBitrate;

var _bitrateutil = __webpack_require__("htwy");

var BitrateUtil = _interopRequireWildcard(_bitrateutil);

var _url = __webpack_require__("QKfw");

var UrlUtil = _interopRequireWildcard(_url);

var _videoAttributes = __webpack_require__("tpcr");

var VideoUtil = _interopRequireWildcard(_videoAttributes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var request = __webpack_require__("ft8J");


// This code originates from https://github.com/videojs/videojs-contrib-hls
function parseRepresentation(m3u8) {
    var attributeSeparator = function () {
        var key = '[^=]*';
        var value = '"[^"]*"|[^,]*';
        var keyvalue = '(?:' + key + ')=(?:' + value + ')';

        return new RegExp('(?:^|,)(' + keyvalue + ')');
    }();

    var parseAttributes = function parseAttributes(attributes) {
        var attrs = attributes.split(attributeSeparator);
        var i = attrs.length;
        var result = {};
        var attr;
        while (i--) {
            if (attrs[i] === '') {
                continue;
            }
            attr = /([^=]*)=(.*)/.exec(attrs[i]).slice(1);
            attr[0] = attr[0].replace(/^\s+|\s+$/g, '');
            attr[1] = attr[1].replace(/^\s+|\s+$/g, '');
            attr[1] = attr[1].replace(/^['"](.*)['"]$/g, '$1');
            result[attr[0]] = attr[1];
        }

        return result;
    };

    var parseLine = function parseLine(line) {
        var match;
        var properties;

        line = line.replace(/^\s+|\s+$/g, '');
        line = line.replace('\r', '');

        match = /^#EXT-X-STREAM-INF:?(.*)$/.exec(line);
        if (match) {
            properties = parseAttributes(match[1]);
            if (properties.RESOLUTION) {
                var split = properties.RESOLUTION.split('x');
                if (split[0]) {
                    properties.width = parseInt(split[0], 10);
                }
                if (split[1]) {
                    properties.height = parseInt(split[1], 10);
                }
            }
            if (properties.BANDWIDTH) {
                properties.bandwidth = parseInt(properties.BANDWIDTH, 10);
            }
        }

        return properties;
    };

    var representation = [];
    var lines = m3u8.split('\n');
    for (var i = 0; i < lines.length; i++) {
        var result = parseLine(lines[i]);
        if (result !== undefined) {
            representation.push(result);
        }
    }

    return representation;
}

function limitVariantStreams(variants, videoElement, videoConfig) {
    var limitByMaxBitrateRule = function limitByMaxBitrateRule(variants) {
        var maxBitrate = VideoUtil.getMaxBitrate(videoElement);
        if (!maxBitrate) {
            return variants;
        }

        return BitrateUtil.limitVariantStreamsByMaxConstant(variants, maxBitrate * 1000);
    };

    var limitByPortalRule = function limitByPortalRule(variants) {
        return BitrateUtil.limitVariantStreamsByPortal(variants, videoElement, true);
    };

    // Used as a nop
    var identity = function identity(variants) {
        return variants;
    };

    // Define rules that will limit the variants.
    var rules = [limitByMaxBitrateRule, videoConfig.limitBitrateByPortal ? limitByPortalRule : identity];

    // Reduce by each rule.
    return rules.reduce(function (variants, rule) {
        return rule(variants);
    }, variants);
}

function isValidResponseURL(responseURL) {
    return responseURL && responseURL.startsWith('http');
}

/**
 * Get manifest from URL. The manifest will also include the response URL from redirects.
 *
 * @param {String} url
 * @returns {Promise}
 */
function getManifest(url) {
    return new _promise2.default(function (resolve, reject) {
        request.getText(url, function (response, xhr) {
            return resolve({
                url: isValidResponseURL(xhr.responseURL) ? xhr.responseURL : url,
                representation: parseRepresentation(response)
            });
        }, function (error) {
            reject(error);
        });
    });
}

function setupMaxBitrate(manifest, videoElement, videoConfig) {
    // Assume preferred starting bitrate is the first variant stream.
    var preferredStartBitrate = Math.ceil(manifest.representation[0].bandwidth / 1000);

    // Filter the variants by defined rules.
    var allowedVariants = limitVariantStreams(manifest.representation, videoElement, videoConfig);

    var maxAllowedBitrate = Math.ceil(Math.max.apply(null, allowedVariants.map(function (item) {
        return item.bandwidth;
    })) / 1000);

    var startBitrate = Math.min(preferredStartBitrate, maxAllowedBitrate);

    return UrlUtil.setQueryParameters({
        __b__: startBitrate,
        b: '0-' + maxAllowedBitrate
    }, manifest.url);
}

/***/ }),

/***/ "fZjL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("ZhOs"), __esModule: true };

/***/ }),

/***/ "ft8J":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = function () {
	function _isCrossDomain(url) {
		return !url.match(document.domain);
	}

	function _get(url, successFn, errFn, parseJson) {
		var req;

		if (_isCrossDomain(url) && window.XDomainRequest) {
			req = new XDomainRequest();

			if (!errFn) {
				errFn = function errFn() {
					// empty
				};
			}

			req.timeout = 10000;

			req.onprogress = function () {
				// empty
			};

			req.ontimeout = errFn.bind(this, 'timeout');

			req.onerror = errFn.bind(this, 'error');

			req.onload = function () {
				successFn(parseJson ? JSON.parse(req.responseText) : req.responseText);
			};
		} else {
			req = new XMLHttpRequest();
			req.onreadystatechange = function () {
				if (req.readyState === 4) {
					if (req.status === 200) {
						successFn(parseJson ? JSON.parse(req.responseText) : req.responseText, req);
					} else if (errFn) {
						errFn('http', req);
					}
				}
			};

			if (errFn) {
				req.onerror = errFn.bind(this, 'error');
				req.ontimeout = errFn.bind(this, 'timeout');
			}
		}

		req.open('GET', url, true);
		req.send(null);
	}

	return {
		getText: function getText(url, successFn, errFn) {
			_get(url, successFn, errFn, false);
		},

		getJson: function getJson(url, successFn, errFn) {
			_get(url, successFn, errFn, true);
		},

		ping: function ping(url, successFn, errFn) {

			var req;

			if (_isCrossDomain(url) && window.XDomainRequest) {
				req = new XDomainRequest();
				req.onload = function () {
					successFn();
				};
			} else {
				req = new XMLHttpRequest();
				req.onreadystatechange = function () {
					if (req.readyState === 4) {
						if (req.status === 200) {
							successFn();
						} else {
							errFn();
						}
					}
				};
			}

			req.onerror = errFn;
			req.ontimeout = errFn;
			req.open('GET', url, true);
			req.send(null);
		},

		postJSON: function postJSON(url, data, successFn, errFn) {

			var req;

			if (_isCrossDomain(url) && window.XDomainRequest) {
				req = new XDomainRequest();
				req.onload = function () {
					successFn();
				};
			} else {
				req = new XMLHttpRequest();
				req.onreadystatechange = function () {
					if (req.readyState === 4) {
						if (req.status === 200) {
							successFn();
						}
					}
				};
			}

			req.onerror = errFn;
			req.ontimeout = errFn;
			req.open('POST', url, true);
			req.setRequestHeader('Content-type', 'application/json');
			req.send((0, _stringify2.default)(data));
		}

	};
}();

/***/ }),

/***/ "fx22":
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__("WgSQ");
var getKeys = __webpack_require__("Qh14");
var redefine = __webpack_require__("R3AP");
var global = __webpack_require__("OzIq");
var hide = __webpack_require__("2p1q");
var Iterators = __webpack_require__("bN1p");
var wks = __webpack_require__("kkCw");
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),

/***/ "g36u":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("OzIq");
var macrotask = __webpack_require__("Sejc").set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__("ydD5")(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver
  } else if (Observer) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    var promise = Promise.resolve();
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),

/***/ "gCWN":
/***/ (function(module, exports) {



/***/ }),

/***/ "gOoy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (!Array.isArray) {
    Array.isArray = function (arg) {
        return Object.prototype.toString.call(arg) === '[object Array]';
    };
}

/***/ }),

/***/ "gYYG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__("wC1N");
var test = {};
test[__webpack_require__("kkCw")('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__("R3AP")(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),

/***/ "hEWt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _dom = __webpack_require__("TdxG");

var domUtils = _interopRequireWildcard(_dom);

var _videoAttributes = __webpack_require__("tpcr");

var _videoAttributes2 = _interopRequireDefault(_videoAttributes);

var _uiConstants = __webpack_require__("W1Zj");

var Constants = _interopRequireWildcard(_uiConstants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var Sizzle = __webpack_require__("zZaF");


var PROPERTY_CLASS = Constants.PROPERTY_CLASS;
var STATE_CLASS = Constants.STATE_CLASS;

var NAMESPACE = 'ui-fullscreen-button';

var CLASSNAMES = {
	fullscreen: 'svp_js-controls-btn--fullscreen',
	fullscreenLabel: 'svp_ui-controls__fullscreen-label'
};

var BUTTON_ICONS = {
	fullscreen: 'svp_ui-controls__button-fullscreen',
	fullscreenEnd: 'svp_ui-controls__button-fullscreen-end'
};

function getCurrentInstanceNamespace(api) {
	// Note that it is not possible to use api.video() here because that is not
	// available before video-load.
	var videoElement = Sizzle('video', api.element())[0];
	var uid = _videoAttributes2.default.getUID(videoElement) || _videoAttributes2.default.generateAndSetUID(videoElement);

	return NAMESPACE + '-' + uid;
}

var createFn = function createFn(api) {

	function _getElement(className) {
		return api && Sizzle('.' + className, api.element())[0];
	}

	function _getFullscreenButton() {
		return _getElement(CLASSNAMES.fullscreen);
	}

	return {

		createElement: function createElement() {
			return domUtils.fromString('<div class=" ' + PROPERTY_CLASS.controlsHideInitially + ' svp_ui-controls--hide-on-error">\
					<button class="' + CLASSNAMES.fullscreen + ' svp_ui-controls__button-fullscreen"\
						aria-live="assertive"\
						title="Aktivera helskärm (F)"\
						tabindex="0">\
						<span class="svp_ui-controls__hidden ' + CLASSNAMES.fullscreenLabel + '">Aktivera helskärm</span>\
					</button>\
				</div>');
		},

		reset: function reset() {
			var fullscreenButton = _getFullscreenButton();

			if (fullscreenButton) {
				domUtils.removeClass(fullscreenButton, BUTTON_ICONS.fullscreenEnd);
				domUtils.addClass(fullscreenButton, BUTTON_ICONS.fullscreen);
			}
		},

		bindEvents: function bindEvents(api) {
			domUtils.addEvents(_getFullscreenButton(), 'mousedown, touchstart', function (e) {
				e.stopPropagation();
				e.preventDefault();
			});
			domUtils.addEvents(_getFullscreenButton(), 'click, touchend', function (e) {
				e.stopPropagation();
				e.preventDefault();
				domUtils.toggleVideoFullscreen(api);
			});
			domUtils.addEvents(api.element(), 'dblclick', function (e) {
				e.stopPropagation();
				e.preventDefault();
				domUtils.toggleVideoFullscreen(api);
			});
			domUtils.addEvents(document, 'fullscreenchange, mozfullscreenchange, MSFullscreenChange, webkitfullscreenchange', function () {
				var fullscreenButton = _getFullscreenButton(),
				    fullscreenLabel = _getElement(CLASSNAMES.fullscreenLabel),
				    isFullscreen = domUtils.isFullscreen(),
				    _focusElement = Sizzle('.' + Constants.FOCUS_ELEMENT_CLASS)[0],
				    label = isFullscreen ? 'Avsluta helskärm' : 'Aktivera helskärm';
				if (isFullscreen) {
					domUtils.removeClass(fullscreenButton, BUTTON_ICONS.fullscreen);
					domUtils.addClass(fullscreenButton, BUTTON_ICONS.fullscreenEnd);
					if (document.activeElement !== fullscreenButton) {
						api.element().setAttribute('tabindex', '0');
						_focusElement.removeAttribute('tabindex');
						api.element().focus();
					}
					domUtils.addClass(api.element(), STATE_CLASS.fullscreen);
				} else {
					domUtils.removeClass(fullscreenButton, BUTTON_ICONS.fullscreenEnd);
					domUtils.addClass(fullscreenButton, BUTTON_ICONS.fullscreen);
					domUtils.removeClass(api.element(), STATE_CLASS.fullscreen);
				}
				fullscreenButton.setAttribute('title', label + ' (F)');
				fullscreenLabel.innerHTML = label;
			}, getCurrentInstanceNamespace(api));

			domUtils.addEvents(_getFullscreenButton(), 'keyup', function (e) {
				var keyName = domUtils.getKeyFromKeyEvent(e);

				if (keyName === 'enter') {
					e.preventDefault();
					e.stopPropagation();

					return true;
				}

				return false;
			});
		}
	};
};

module.exports = {
	create: createFn,
	destroy: function destroy(api) {
		var currentInstanceNamespace = getCurrentInstanceNamespace(api);
		var fullscreenButton = Sizzle('.' + CLASSNAMES.fullscreen, api.element())[0];
		if (fullscreenButton) {
			domUtils.removeEvents(fullscreenButton, 'click, touchend');
			fullscreenButton.parentElement.removeChild(fullscreenButton);
		}
		domUtils.removeEvents(api.element(), 'dblclick');
		domUtils.removeEvents(document, 'fullscreenchange, mozfullscreenchange, MSFullscreenChange, webkitfullscreenchange', currentInstanceNamespace);
	}
};

/***/ }),

/***/ "hSV+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (videoElement, callback) {
    // Read video urls from source elements
    var videoData = {};
    var sourceElements = (0, _sizzle2.default)('source', videoElement);

    sourceElements.forEach(function (item) {
        var dataType = item.getAttribute('data-type');

        if (dataType) {
            videoData[dataType] = item.getAttribute('src');
        }
    });

    callback({}, videoData, {});
};

var _sizzle = __webpack_require__("zZaF");

var _sizzle2 = _interopRequireDefault(_sizzle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];

/***/ }),

/***/ "hgbu":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("a/OS")('wks');
var uid = __webpack_require__("GmwO");
var Symbol = __webpack_require__("YjQv").Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ "htwy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Debug = __webpack_require__("BF+C")('bitrate-util');

module.exports = function () {
    var aspectRatio = 16 / 9;

    function _doesTheVideoFit(video, width, height) {
        return width / height > aspectRatio ? width >= video.width : height >= video.height;
    }

    /**
     * Find the maximum bandwidth in an array of variant streams that can fit
     * inside the specified width and height.
     *
     * @param {Object[]} variants The variant streams to search in.
     * @param {Number} width Limiting width.
     * @param {Number} height Limiting height.
     * @return {Number} Returns the highest bitrate that the portal can fully
     *   utilize.
     */
    function findMaxFittingBandwidth(variants, width, height) {
        // Sort by bandwidth
        variants = variants.sort(function (a, b) {
            return a.bandwidth - b.bandwidth;
        });

        var i = 0;
        var match = variants[variants.length - 1];

        for (; i < variants.length; i++) {
            if (variants[i].height && !_doesTheVideoFit(variants[i], width, height)) {
                match = variants[i];
                break;
            }
        }
        while (i + 1 < variants.length) {
            if (variants[i + 1].height && match.height !== variants[i + 1].height) {
                match = variants[i];
                break;
            }
            i++;
        }

        Debug.log('findMaxFittingBandwidth -\n            stream: ' + match.bandwidth + ' ' + match.width + 'x' + match.height + '\n            element: ' + width + 'x' + height);

        return match.bandwidth;
    }

    /**
     * Limit the given variant streams (representation) to only contain items
     * that fit the videoElement or screen. The algorithm perfers to scale
     * down before scaling up.
     *
     * @param {HTMLVideoElement} videoElement Video element to test for.
     * @param {Object[]} variants Array of available bitrates with
     *   corresponding width and height.
     * @param {boolean} useScreenAsMax Whether or not to use the screen size
     *   or video element size as limiting portal.
     * @return {Object[]} Returns a filtered array of variant streams.
     */
    function limitVariantStreamsByPortal(variants, videoElement, useScreenAsMax) {
        if (variants === undefined || variants.length === 0) {
            return variants;
        }

        var height = useScreenAsMax ? screen.height : parseInt(window.getComputedStyle(videoElement).height, 10);
        var width = useScreenAsMax ? screen.width : parseInt(window.getComputedStyle(videoElement).width, 10);

        var bitrateLimit = findMaxFittingBandwidth(variants, width, height);

        return limitVariantStreamsByMaxConstant(variants, bitrateLimit);
    }

    /**
     * Limit given variant streams by a specified constant.
     *
     * @param {Object[]} variants Array of variant streams.
     * @param {Number} bitrateLimit The max bitrate constant.
     * @return {Object[]} Returns a filtered array of variant streams.
     */
    function limitVariantStreamsByMaxConstant(variants, bitrateLimit) {
        return variants.filter(function (item) {
            return item.bandwidth <= bitrateLimit;
        });
    }

    return {
        limitVariantStreamsByPortal: limitVariantStreamsByPortal,
        limitVariantStreamsByMaxConstant: limitVariantStreamsByMaxConstant
    };
}();

/***/ }),

/***/ "i0zA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _assign = __webpack_require__("woOf");

var _assign2 = _interopRequireDefault(_assign);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _m3u8util = __webpack_require__("fYB6");

var M3U8 = _interopRequireWildcard(_m3u8util);

var _url = __webpack_require__("QKfw");

var UrlUtil = _interopRequireWildcard(_url);

var _dom = __webpack_require__("TdxG");

var domUtil = _interopRequireWildcard(_dom);

var _device = __webpack_require__("xOtj");

var _device2 = _interopRequireDefault(_device);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var extend = __webpack_require__("5E+y");
var SVPCustomEvent = __webpack_require__("L+TV");

var config = __webpack_require__("Pqsl");
var VideoUtil = __webpack_require__("tpcr");
var Debug = __webpack_require__("BF+C")('hls-video');
var AudioTrack = __webpack_require__("0Gsn");

var NAMESPACE = 'hls-video';

module.exports = function () {

    var instances = {};
    var AUDIO_STORAGE_KEY = "audioTrack";

    function _extend(videoElement, uid) {
        extend(videoElement, {
            getCurrentTime: function getCurrentTime() {
                return videoElement.currentTime;
            },
            getSrc: function getSrc() {
                // HLS.js sets a temporary URL (blob) as src attribute so we'll need to fetch the "real" URL form the HLS.js object
                var hlsObject = instances[uid];
                if (hlsObject) {
                    return hlsObject.url;
                }

                return videoElement.src;
            },

            getDuration: function getDuration() {
                return videoElement.liveDuration ? Math.max(videoElement.liveDuration, videoElement.currentTime) : videoElement.duration;
            },
            getVolume: function getVolume() {
                return videoElement.volume;
            },
            isMuted: function isMuted() {
                return videoElement.muted;
            },
            mute: function mute(shouldMute) {
                videoElement.muted = shouldMute;
            },
            getMetrics: function getMetrics() {
                var isSVTCdn = this.getSrc().indexOf('cdn.svt') > 0;

                var metrics = {};
                if (videoElement.getVideoPlaybackQuality) {
                    metrics.droppedFrames = videoElement.getVideoPlaybackQuality().droppedVideoFrames;
                }
                metrics.bufferLevel = Math.round(videoElement.buffered.end(0) - videoElement.currentTime);
                metrics.dimensions = Math.round(videoElement.offsetWidth) + ' x ' + Math.round(videoElement.offsetHeight);
                metrics.resolution = videoElement.videoWidth + ' x ' + videoElement.videoHeight;
                metrics.cdn = isSVTCdn ? 1 : 2;
                metrics.dash = false;

                return metrics;
            },
            seek: function seek(position) {
                if (videoElement.seekable.length > 0 && !videoElement.seeking) {
                    // Make seekTo-position sane before seeking
                    var seekTo = Math.min(Math.max(videoElement.seekable.start(0), position), videoElement.seekable.end(0));

                    // Due to bug in safari making video halt when scrubbing to
                    // the very end we extract a minimal amount from total duration
                    if (_device2.default.supportsHls() && seekTo >= videoElement.seekable.end(0)) {
                        seekTo -= 0.01;
                    }

                    // hls.js don't like seeking to close to live edge
                    if (videoElement.liveDuration && !_device2.default.supportsHls() && seekTo >= videoElement.seekable.end(0)) {
                        seekTo -= 8;
                    }

                    if (seekTo !== Number.POSITIVE_INFINITY) {
                        videoElement.currentTime = seekTo;
                    }
                }
            },
            getMaxSeekable: function getMaxSeekable() {
                return videoElement.seekable.length > 0 ? videoElement.seekable.end(0) : 0;
            },
            setVolume: function setVolume(volume) {
                videoElement.volume = volume;
                videoElement.muted = volume === 0;
            },
            showCaptions: function showCaptions(shouldShow) {
                videoElement.parentNode.dispatchEvent(new SVPCustomEvent('captionsvisible', { detail: { shouldShow: shouldShow } }));
            },
            getTextTracks: function getTextTracks() {
                var hlsObject = instances[uid];

                return _getTextTracks(videoElement, hlsObject);
            },
            getAudioTracks: function getAudioTracks() {
                var hlsObject = instances[uid];

                return _getAudioTacks(videoElement, hlsObject);
            },
            setAudioTrack: function setAudioTrack(audioTrackId) {
                var hlsObject = instances[uid];
                _setAudioTrack(audioTrackId, videoElement, hlsObject);
                domUtil.setStoredData(AUDIO_STORAGE_KEY, audioTrackId);
            },
            reset: function reset() {
                if (videoElement.currentTime) {
                    videoElement.currentTime = 0;
                }
            },
            unload: function unload() {
                while (videoElement.lastChild) {
                    videoElement.removeChild(videoElement.lastChild);
                }
                videoElement.pause();
                videoElement.removeAttribute('src');
                if (instances[uid]) {
                    instances[uid].detachMedia();
                    instances[uid].destroy();
                }
            }
        });
    }

    function _setAudioTrack(audioTrackId, videoElement, hlsObject) {
        if (videoElement.audioTracks) {
            for (var i = 0; i < videoElement.audioTracks.length; i++) {
                if (videoElement.audioTracks[i].language === audioTrackId) {
                    videoElement.audioTracks[i].enabled = true;
                }
            }
        }

        if (hlsObject) {
            for (var _i = 0; _i < hlsObject.audioTracks.length; _i++) {
                if (hlsObject.audioTracks[_i].lang === audioTrackId) {
                    hlsObject.audioTrack = hlsObject.audioTracks[_i].id;
                }
            }
        }
    }

    function _setupHlsJs(videoUrl, videoElement, uid, api) {
        Debug.log('Using HLS.js', videoUrl);

        // Destroy previous hlsjs object
        if (instances[uid]) {
            instances[uid].detachMedia();
            instances[uid].destroy();
        }

        var hlsjsConfig = {
            //TODO: Channel this to normal debug-logger.
            debug: false,

            // Start to load HLS playlist and fragments
            // automatically after manifest is parsed.
            // Not to be confused with autoplay.
            autoStartLoad: true
        };

        __webpack_require__.e/* require.ensure */(1).then((function (require) {
            var Hls = __webpack_require__("YT+p");
            var hlsjsObject = new Hls(hlsjsConfig);
            hlsjsObject.attachMedia(videoElement);
            hlsjsObject.on(Hls.Events.MEDIA_ATTACHED, function () {
                // Disable attributes in order to remove audio codec specs in playlist
                videoUrl = UrlUtil.setQueryParameters({ attributes: 'off' }, videoUrl);
                Debug.log('HLSJS using url ' + videoUrl);
                hlsjsObject.loadSource(videoUrl);
            });

            hlsjsObject.on(Hls.Events.LEVEL_SWITCHING, function (event, data) {
                api.fire('bitrateswitch', { mediaType: 'unknown', bitrate: data.bitrate });
            });

            hlsjsObject.on(Hls.Events.ERROR, function (event, data) {
                var url = data.frag && data.frag.url || data.context && data.context.url || null;

                if (data.details === Hls.ErrorDetails.BUFFER_STALLED_ERROR) {
                    api.fire('bufferEmpty');
                } else {
                    api.fire('error', {
                        player: 'hlsjs',
                        name: data.type,
                        id: data.details,
                        url: url
                    });
                }
            });

            instances[uid] = hlsjsObject;
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }

    function _setupNativeHls(videoUrl, videoElement) {
        Debug.log('Using native HLS', videoUrl);

        videoElement.setAttribute('src', videoUrl);

        if (_device2.default.isIOSNotSafari()) {
            // This is a hack for ensuring playability in Firefox and Chrome on
            // iOS 10. Hopefully it'll be fixed on their end once they've recompiled for iOS 10.
            // TODO: Remove once fixed.
            videoElement.dispatchEvent(new SVPCustomEvent('loadstart', { detail: {} }));
        }
    }

    function _getTextTracks(videoElement, hlsObject) {
        var tracks = [];

        if (videoElement.textTracks) {
            for (var i = 0; i < videoElement.textTracks.length; i++) {
                if (videoElement.textTracks[i].language === 'sv') {
                    tracks.push({
                        id: videoElement.textTracks[i].language
                    });
                }
            }
        } else if (hlsObject && hlsObject.textTracks) {
            for (var _i2 = 0; _i2 < hlsObject.textTracks.length; _i2++) {
                if (hlsObject.textTracks[_i2].lang === 'sv') {
                    tracks.push({
                        id: hlsObject.textTracks[_i2].lang
                    });
                }
            }
        }

        return tracks;
    }

    function _hasSpokenAudio(audioTracks) {
        if (audioTracks.length > 1) {
            for (var i = 0; i < audioTracks.length; i++) {
                if (audioTracks[i].id === AudioTrack.SPOKEN_TEXT) {
                    return true;
                }
            }
        }

        return false;
    }

    function _getAudioTacks(videoElement, hlsObject) {
        var activeAudioTrack = domUtil.getStoredData(AUDIO_STORAGE_KEY) || AudioTrack.DEFAULT_AUDIO;
        var tracks = [];

        if (videoElement.audioTracks) {
            for (var i = 0; i < videoElement.audioTracks.length; i++) {
                if (videoElement.audioTracks[i].language) {
                    tracks.push({
                        id: videoElement.audioTracks[i].language,
                        active: videoElement.audioTracks[i].language === activeAudioTrack
                    });
                }
            }
        }

        if (hlsObject && hlsObject.audioTracks) {
            for (var _i3 = 0; _i3 < hlsObject.audioTracks.length; _i3++) {
                tracks.push({
                    id: hlsObject.audioTracks[_i3].lang,
                    active: hlsObject.audioTracks[_i3].lang === activeAudioTrack
                });
            }
        }

        return tracks;
    }

    return {
        load: function load(videoElement, videoUrl, metadata, videoConfig, api) {
            var uid = VideoUtil.getUID(videoElement) || VideoUtil.generateAndSetUID(videoElement);

            while (videoElement.lastChild) {
                videoElement.removeChild(videoElement.lastChild);
            }

            // Fetch available bitrates from the primary manifest URL (probably Akamai)
            M3U8.getManifest(videoUrl).then(function (manifest) {

                // Setup a new manifest URL with bitrate limit parameters
                var modifiedVideoUrl = M3U8.setupMaxBitrate(manifest, videoElement, videoConfig);

                // Check if there is an alternative manifest URL (probably SVT-CDN switcher)
                var altUrl = UrlUtil.getQueryParameter('alt', modifiedVideoUrl);
                if (config.useAltHlsUrl && altUrl && _device2.default.isRedirectCapable()) {
                    var startBitrate = UrlUtil.getQueryParameter('__b__', modifiedVideoUrl);
                    var maxBitrate = UrlUtil.getQueryParameter('b', modifiedVideoUrl);

                    // Attach the bitrate limit parameters on the alt URL
                    modifiedVideoUrl = UrlUtil.setQueryParameters({
                        __b__: startBitrate,
                        b: maxBitrate
                    }, decodeURIComponent(altUrl));

                    // Get the manifest from the resolved URL
                    return M3U8.getManifest(modifiedVideoUrl).catch(function (e) {
                        // If we fail to fetch it, let the video element try
                        // https://stackoverflow.com/questions/33044293/safari-xhr-ajax-requests-w-cross-domain-redirect-fails
                        return _promise2.default.resolve((0, _assign2.default)({}, manifest, { url: modifiedVideoUrl }));
                    });
                } else {
                    return _promise2.default.resolve((0, _assign2.default)({}, manifest, { url: modifiedVideoUrl }));
                }
            }).then(function (manifest) {
                if (_device2.default.supportsHls()) {
                    _setupNativeHls(manifest.url, videoElement);
                } else {
                    _setupHlsJs(manifest.url, videoElement, uid, api);
                }
            });

            var setInitialStartPosition = function setInitialStartPosition() {
                var currentTime = VideoUtil.getStartPosition(videoElement);

                if (currentTime && videoElement.currentTime !== currentTime) {
                    videoElement.currentTime = currentTime;
                }
            };

            var setPreferredAudioTrack = function setPreferredAudioTrack() {
                var audioTrackId = domUtil.getStoredData(AUDIO_STORAGE_KEY) || AudioTrack.DEFAULT_AUDIO;
                if (audioTrackId === AudioTrack.DEFAULT_AUDIO) {
                    return;
                }

                var hlsObject = instances[uid];
                _setAudioTrack(audioTrackId, videoElement, hlsObject);
            };

            var metadataLoadedListener = function metadataLoadedListener() {
                setInitialStartPosition();
                setPreferredAudioTrack();
                videoElement.liveDuration = metadata && metadata.timeshiftEnabled ? metadata.contentDuration : undefined;

                var hlsObject = instances[uid];

                if (_hasSpokenAudio(_getAudioTacks(videoElement, hlsObject))) {
                    api.fire('audiotracksloaded');
                } else if (videoElement.audioTracks) {
                    domUtil.addEvents(videoElement.audioTracks, 'addtrack', function () {
                        if (_hasSpokenAudio(_getAudioTacks(videoElement, hlsObject))) {
                            api.fire('audiotracksloaded');
                            domUtil.removeEvents(videoElement.audioTracks, 'addtrack', NAMESPACE);
                        }
                    }, NAMESPACE);
                }

                domUtil.removeEvents(videoElement, 'loadedmetadata, loadeddata', NAMESPACE);
            };

            domUtil.addEvents(videoElement, 'loadedmetadata, loadeddata', metadataLoadedListener, NAMESPACE);

            _extend(videoElement, uid);

            return videoElement;
        }
    };
}();

/***/ }),

/***/ "iANj":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.1' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ "ifoU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("euHq"), __esModule: true };

/***/ }),

/***/ "jATa":
/***/ (function(module, exports) {

/*
 json-stringify-safe
 Like JSON.stringify, but doesn't throw on circular references.

 Originally forked from https://github.com/isaacs/json-stringify-safe
 version 5.0.1 on 3/8/2017 and modified to handle Errors serialization
 and IE8 compatibility. Tests for this are in test/vendor.

 ISC license: https://github.com/isaacs/json-stringify-safe/blob/master/LICENSE
*/

exports = module.exports = stringify;
exports.getSerialize = serializer;

function indexOf(haystack, needle) {
  for (var i = 0; i < haystack.length; ++i) {
    if (haystack[i] === needle) return i;
  }
  return -1;
}

function stringify(obj, replacer, spaces, cycleReplacer) {
  return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces);
}

// https://github.com/ftlabs/js-abbreviate/blob/fa709e5f139e7770a71827b1893f22418097fbda/index.js#L95-L106
function stringifyError(value) {
  var err = {
    // These properties are implemented as magical getters and don't show up in for in
    stack: value.stack,
    message: value.message,
    name: value.name
  };

  for (var i in value) {
    if (Object.prototype.hasOwnProperty.call(value, i)) {
      err[i] = value[i];
    }
  }

  return err;
}

function serializer(replacer, cycleReplacer) {
  var stack = [];
  var keys = [];

  if (cycleReplacer == null) {
    cycleReplacer = function(key, value) {
      if (stack[0] === value) {
        return '[Circular ~]';
      }
      return '[Circular ~.' + keys.slice(0, indexOf(stack, value)).join('.') + ']';
    };
  }

  return function(key, value) {
    if (stack.length > 0) {
      var thisPos = indexOf(stack, this);
      ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
      ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);

      if (~indexOf(stack, value)) {
        value = cycleReplacer.call(this, key, value);
      }
    } else {
      stack.push(value);
    }

    return replacer == null
      ? value instanceof Error ? stringifyError(value) : value
      : replacer.call(this, key, value);
  };
}


/***/ }),

/***/ "jgO3":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("8ANE");
var isArray = __webpack_require__("NU0k");
var SPECIES = __webpack_require__("hgbu")('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),

/***/ "jhxf":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("UKM+");
var document = __webpack_require__("OzIq").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ "kkCw":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("VWgF")('wks');
var uid = __webpack_require__("ulTY");
var Symbol = __webpack_require__("OzIq").Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ "kkvn":
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__("3fMt");
var invoke = __webpack_require__("eg8w");
var html = __webpack_require__("+iDZ");
var cel = __webpack_require__("PY1i");
var global = __webpack_require__("YjQv");
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__("NZra")(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),

/***/ "ksFB":
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("wiaE");
var defined = __webpack_require__("+MZ2");
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ "l+LE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _dom = __webpack_require__("TdxG");

var domUtils = _interopRequireWildcard(_dom);

var _uiConstants = __webpack_require__("W1Zj");

var Constants = _interopRequireWildcard(_uiConstants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var timeUtils = __webpack_require__("74ZT");
var Debug = __webpack_require__("BF+C")('play-button');
var Sizzle = __webpack_require__("zZaF");

var PLAYING_STATE = Constants.PLAYING_STATE;
var PROPERTY_CLASS = Constants.PROPERTY_CLASS;

var NAMESPACE = 'ui-play-button';

var CLASSNAMES = {
	buttonContainer: 'svp_ui-controls__playButton-container',
	buttonLabel: 'svp_ui-controls__playButton-label',
	errorMarker: 'svp_js-controls-btn--play__error-marker',
	play: 'svp_js-controls-btn--play'
};

var BUTTON_ICONS = {
	general_error: 'svp_ui-controls__button-general-error',
	geoblock_error: 'svp_ui-controls__button-geoblock-error',
	liveNotStarted_error: 'svp_ui-controls__button-live-not-started-error',
	play: 'svp_ui-controls__button-play',
	pause: 'svp_ui-controls__button-pause',
	stop: 'svp_ui-controls__button-stop'
};

var createFn = function createFn(api) {
	var _currentState = PLAYING_STATE.unknown,
	    _prevState = null,
	    _isLiveVideo = false,
	    _isTimeshiftEnabled = false,
	    _isVideoError = false,
	    _liveStartTimeUTC = 0;

	function _getElement(className) {
		return api && Sizzle('.' + className, api.element())[0];
	}

	function _getPlayButton() {
		return _getElement(CLASSNAMES.play);
	}

	function _setPlayingState(state) {
		Debug('Setting state to ' + state);
		var playButton = _getPlayButton(),
		    playButtonLabel = _getElement(CLASSNAMES.buttonLabel),
		    spaceEnabled = false,
		    assertive = false,
		    label;

		if (state !== PLAYING_STATE.loading) {
			domUtils.removeClass(playButton, [BUTTON_ICONS.play, BUTTON_ICONS.general_error, BUTTON_ICONS.geoblock_error, BUTTON_ICONS.pause, BUTTON_ICONS.stop, BUTTON_ICONS.liveNotStarted_error]);
		}

		switch (state) {
			case PLAYING_STATE.playing:
				if (_isLiveVideo && !_isTimeshiftEnabled) {
					domUtils.addClass(playButton, BUTTON_ICONS.stop);
					label = 'Stoppa video';
				} else {
					domUtils.addClass(playButton, BUTTON_ICONS.pause);
					label = 'Pausa video';
				}
				spaceEnabled = true;
				_isVideoError = false;
				break;
			case PLAYING_STATE.paused:
				domUtils.addClass(playButton, BUTTON_ICONS.play);
				label = 'Spela video';
				spaceEnabled = true;
				break;
			case PLAYING_STATE.loading:
				label = 'Laddar video';
				assertive = true;
				_isVideoError = false;
				break;
			case PLAYING_STATE.error:
				var errorClass = BUTTON_ICONS.general_error;
				domUtils.addClass(playButton, errorClass);
				label = 'Fel';
				_isVideoError = true;
				break;
		}

		playButton.setAttribute('tabindex', _isVideoError ? '-1' : '0');
		playButton.setAttribute('aria-live', assertive ? 'assertive' : 'off');
		playButtonLabel.innerHTML = label + (state === PLAYING_STATE.loading ? ' ' + timeUtils.getFormattedTime(api.getCurrentTime()) : '');

		domUtils.forceRedraw(playButton);

		_currentState = state;
		if (state !== PLAYING_STATE.loading) {
			_prevState = state;
		}
	}

	api.on(NAMESPACE + '.metadata', function (data) {
		_isLiveVideo = data && (data.detail.live || data.detail.simulcast);
		_isTimeshiftEnabled = data && data.detail.timeshiftEnabled;
		_liveStartTimeUTC = data && data.detail.liveStartTimeUTC;
	});

	var togglePlayFn = function togglePlayFn(e) {
		if (e) {
			e.preventDefault();
			e.stopPropagation();
		}
		switch (_currentState) {
			case PLAYING_STATE.paused:
				if (_isLiveVideo && !_isTimeshiftEnabled) {
					api.seek(Number.POSITIVE_INFINITY);
				}
				api.play();
				break;
			case PLAYING_STATE.playing:
				api.pause();
				break;
			default:
				// Do nothing
				break;
		}
	};

	return {

		createElement: function createElement() {
			return domUtils.fromString('<div class=" ' + PROPERTY_CLASS.controlsHideInitially + ' ' + CLASSNAMES.buttonContainer + '">\
					<button class="' + CLASSNAMES.play + ' ' + BUTTON_ICONS.play + '"\
						aria-live="off"\
						tabindex="0"\
						data-rt="video-player-play">\
						<span class="svp_ui-controls__hidden ' + CLASSNAMES.buttonLabel + '">Laddar video</span>\
					</button>\
				</div>');
		},

		bindEvents: function bindEvents(api) {
			var setLoading = _setPlayingState.bind(this, PLAYING_STATE.loading);

			api.on(NAMESPACE + '.play', function () {
				domUtils.removeClass(_getElement(CLASSNAMES.buttonContainer), 'svp_ui-controls--hide-initial');
				setLoading();
			});

			api.on(NAMESPACE + '.buffering', setLoading);
			api.on(NAMESPACE + '.seeking', setLoading);
			api.on(NAMESPACE + '.loadstart', setLoading);

			api.on(NAMESPACE + '.seeked', function () {
				_setPlayingState(_prevState);
			});

			api.on(NAMESPACE + '.canplay', function () {
				_setPlayingState(PLAYING_STATE.paused);
			});

			api.on(NAMESPACE + '.playing', function () {
				_setPlayingState(PLAYING_STATE.playing);
			});

			api.on(NAMESPACE + '.pause', function () {
				_setPlayingState(PLAYING_STATE.paused);
			});

			api.on(NAMESPACE + '.ui-error', function (errorEvent) {
				var retry = errorEvent && errorEvent.detail ? errorEvent.detail.retry : false;
				_setPlayingState(retry ? PLAYING_STATE.PAUSED : PLAYING_STATE.ERROR);
			});

			domUtils.addEvents(_getPlayButton(), 'mousedown', function (e) {
				e.preventDefault();
			});
			domUtils.addEvents(_getPlayButton(), 'click, touchend', togglePlayFn);
			domUtils.addEvents(_getPlayButton(), 'keyup', function (e) {
				if (domUtils.getKeyFromKeyEvent(e) === 'enter') {
					e.stopPropagation();
				}
			}, NAMESPACE);
		},
		setState: function setState(state, what) {
			if (state === 'error') {
				_setPlayingState(PLAYING_STATE.error, what);
			}
		},
		togglePlay: togglePlayFn,
		reset: function reset() {
			_currentState = PLAYING_STATE.unknown;
			var playButton = _getPlayButton(),
			    errorElements = Sizzle('.' + CLASSNAMES.errorMarker, playButton);

			errorElements.forEach(function (el) {
				playButton.removeChild(el);
			});
		}
	};
};

module.exports = {
	create: createFn,

	destroy: function destroy(api) {
		api.off(NAMESPACE + '.pause');
		api.off(NAMESPACE + '.play');
		api.off(NAMESPACE + '.playing');
		api.off(NAMESPACE + '.seeking');
		api.off(NAMESPACE + '.seeked');
		api.off(NAMESPACE + '.buffering');
		api.off(NAMESPACE + '.canplay');
		api.off(NAMESPACE + '.metadata');
		api.off(NAMESPACE + '.ui-error');

		var playButton = Sizzle('.' + CLASSNAMES.play, api.element())[0];
		if (playButton) {
			domUtils.removeEvents(playButton, 'click, touchend, keyup', NAMESPACE);
			playButton.parentElement.removeChild(playButton);
		}
	}
};

/***/ }),

/***/ "l/Ll":
/***/ (function(module, exports) {

function RavenConfigError(message) {
  this.name = 'RavenConfigError';
  this.message = message;
}
RavenConfigError.prototype = new Error();
RavenConfigError.prototype.constructor = RavenConfigError;

module.exports = RavenConfigError;


/***/ }),

/***/ "l1Xx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _getIterator2 = __webpack_require__("BO1k");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _map = __webpack_require__("ifoU");

var _map2 = _interopRequireDefault(_map);

exports.create = create;
exports.destroy = destroy;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Debug = __webpack_require__("BF+C")('media-player-statistics');

var STATISTICS_API_ENDPOINT = 'https://message.cdn.svt.se';
var NAMESPACE = 'mediaplayerstatistics.';

var instances = new _map2.default();

function s4() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
}

function uuid() {
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

var MediaPlayerStatistics = function () {
    function MediaPlayerStatistics(fraction, api) {
        (0, _classCallCheck3.default)(this, MediaPlayerStatistics);

        this.active = false;
        if (fraction < Math.random()) {
            return;
        }
        this.api = api;
        this.state = 'stop';
        this.stateChange = new Date().getTime();
        this.currentRate = {};

        this.session = uuid();
        this.initStatistics(api.getDuration(), api.getSrc());
        this.send = this.sendFkn.bind(this);
        this.callbacks();
    }

    (0, _createClass3.default)(MediaPlayerStatistics, [{
        key: 'initStatistics',
        value: function initStatistics() {
            this.active = false;
            this.statistics = {
                type: 'player',
                application: {
                    name: 'svtvideoplayer',
                    location: window.location.href
                },
                player: {
                    session: this.session,
                    time: new Date().toISOString(),
                    event: 'report',
                    duration: undefined,
                    location: undefined,
                    report: {
                        counters: { stop: 0, start: 0, play: 0, pause: 0, seek: 0, buffer: 0 },
                        timers: { stop: 0, start: 0, play: 0, pause: 0, seek: 0, buffer: 0 },
                        rates: {},
                        errors: []
                    }
                }
            };
        }
    }, {
        key: 'callbacks',
        value: function callbacks() {
            var _this = this;

            this.api.filters.push({
                load: function load() {
                    _this.send();
                    _this.initStatistics(_this.api.getDuration(), _this.api.getSrc());
                }
            });
            this.api.on(NAMESPACE + 'metadata', function (e) {
                _this.statistics.player.duration = e.detail.contentDuration;
            });
            this.api.on(NAMESPACE + 'ready', function (e) {
                _this.active = true;
            });
            window.addEventListener('unload', this.send);

            this.api.on(NAMESPACE + 'play', function () {
                _this.statistics.player.location = _this.api.getSrc();
                _this.transition('start');
            });
            this.api.on(NAMESPACE + 'playing', function () {
                return _this.transition('play');
            });
            this.api.on(NAMESPACE + 'pause', function () {
                return _this.transition('pause');
            });
            this.api.on(NAMESPACE + 'seeking', function () {
                return _this.transition('seek');
            });
            this.api.on(NAMESPACE + 'seeked', function () {
                if (_this.api.isPaused()) {
                    _this.transition('stop');
                    _this.statistics.player.report.counters.stop--;
                } else {
                    _this.statistics.player.report.counters.play--;
                }
            });
            this.api.on(NAMESPACE + 'ended', function () {
                return _this.transition('stop');
            });
            this.api.on(NAMESPACE + 'error', function (e) {
                _this.statistics.player.report.counters.error++;
                if (e.detail) {
                    _this.statistics.player.report.errors.push({
                        player: e.detail.player,
                        error: e.detail.name,
                        id: e.detail.id,
                        url: e.detail.url
                    });
                } else {
                    _this.statistics.player.report.errors.push({
                        error: 'unknown'
                    });
                }
            });
            this.api.on(NAMESPACE + 'bufferEmpty', function () {
                if (!_this.api.isSeeking()) {
                    _this.transition('buffer');
                }
            });
            this.api.on(NAMESPACE + 'bitrateswitch', function (ev) {
                _this.currentRate[ev.detail.mediaType] = ev.detail.bitrate;
            });
        }
    }, {
        key: 'transition',
        value: function transition(to) {
            var t = new Date().getTime();
            var d = (t - this.stateChange) / 1000;
            if (this.state === 'play') {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = (0, _getIterator3.default)((0, _keys2.default)(this.currentRate)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var mediaType = _step.value;

                        if (!(mediaType in this.statistics.player.report.rates)) {
                            this.statistics.player.report.rates[mediaType] = {};
                        }
                        if (!(this.currentRate[mediaType] in this.statistics.player.report.rates[mediaType])) {
                            this.statistics.player.report.rates[mediaType][this.currentRate[mediaType]] = 0;
                        }
                        this.statistics.player.report.rates[mediaType][this.currentRate[mediaType]] += d;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
            this.statistics.player.report.timers[this.state] += d;
            this.stateChange = t;
            this.state = to;
            this.statistics.player.report.counters[this.state]++;
        }
    }, {
        key: 'sendFkn',
        value: function sendFkn() {
            if (!this.active) {
                return;
            }
            if (this.state !== 'stop') {
                this.transition('stop');
            }
            navigator.sendBeacon(STATISTICS_API_ENDPOINT, (0, _stringify2.default)(this.statistics));
        }
    }]);
    return MediaPlayerStatistics;
}();

function create(api) {
    if (instances.has(api)) {
        Debug.warn('Akamai statistics plugin was already created for this api instance and has\n            not been destroyed. The previous instance may leak memory and listeners.');
    }

    if ('navigator' in window && 'sendBeacon' in window.navigator) {
        instances.set(api, new MediaPlayerStatistics(1, api));
    }
}

function destroy(api) {
    var mediaPlayerStatistics = instances.get(api);
    if (mediaPlayerStatistics) {
        api.off(NAMESPACE + 'ready');
        api.off(NAMESPACE + 'metadata');
        window.removeEventListener('unload', mediaPlayerStatistics.send);
        api.off(NAMESPACE + 'play');
        api.off(NAMESPACE + 'playing');
        api.off(NAMESPACE + 'pause');
        api.off(NAMESPACE + 'seeking');
        api.off(NAMESPACE + 'seeked');
        api.off(NAMESPACE + 'ended');
        api.off(NAMESPACE + 'error');
        api.off(NAMESPACE + 'waiting');
        api.off(NAMESPACE + 'bitrateswitch');
        api.off(NAMESPACE + 'bufferEmpty');
        // TODO: Remove the filter on load

        mediaPlayerStatistics.send();
        instances.delete(api);
    }
}

/***/ }),

/***/ "lDLk":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("DIVP");
var IE8_DOM_DEFINE = __webpack_require__("xZa+");
var toPrimitive = __webpack_require__("s4j0");
var dP = Object.defineProperty;

exports.f = __webpack_require__("bUqO") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "m7oa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _map = __webpack_require__("ifoU");

var _map2 = _interopRequireDefault(_map);

var _dom = __webpack_require__("TdxG");

var domUtils = _interopRequireWildcard(_dom);

var _videoAttributes = __webpack_require__("tpcr");

var _videoAttributes2 = _interopRequireDefault(_videoAttributes);

var _sizzle = __webpack_require__("zZaF");

var _sizzle2 = _interopRequireDefault(_sizzle);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NAMESPACE = 'metrics';
var UPDATE_METRICS_INTERVAL = 1000; //ms
var HIDE_CONTEXT_MENU_AFTER = 7000; //ms

var instances = new _map2.default();

var Metrics = function () {
    function Metrics(api, uid) {
        (0, _classCallCheck3.default)(this, Metrics);

        this.api = api;
        this.enable = false;
        this.interval = null;
        this.id = 'svp-metrics-' + uid;
        this.menuId = 'svp-metrics-menu-' + uid;
        this.contextMenuVisible = false;
        this.markupAdded = false;
        this.enableContextMenu = false;
        this.hideContextMenuTimer = null;

        this._addListeners();
    }

    (0, _createClass3.default)(Metrics, [{
        key: '_createMarkup',
        value: function _createMarkup() {
            return domUtils.fromString('<div class="svp_metrics svp_css-container--font" id="' + this.id + '">\
                <p class="svp_metrics__row">\
                    <span id="' + this.id + '-abs">&nbsp;</span>\
                </p>\
                <p class="svp_metrics__row">Dropped frames: \
                    <span id="' + this.id + '-dropped"></span>\
                </p>\
                <p class="svp_metrics__row">Buffer level: \
                    <span id="' + this.id + '-buffer"></span>\
                </p>\
                <p class="svp_metrics__row">CDN: \
                    <span id="' + this.id + '-cdn"></span>\
                </p>\
                <p class="svp_metrics__row">Dimensions: \
                    <span id="' + this.id + '-dimensions"></span>\
                </p>\
                <p class="svp_metrics__row">Resolution: \
                    <span id="' + this.id + '-resolution"></span>\
                </p>\
            </div>');
        }
    }, {
        key: '_createMenuMarkup',
        value: function _createMenuMarkup(x, y) {
            var showOrHide = this.enable ? 'Dölj' : 'Visa';

            return domUtils.fromString('<div class="svp_metrics-menu" id="' + this.menuId + '" style="left: ' + x + 'px; top: ' + y + 'px;">\
                <ul class="svp_metrics-menu-list">\
                    <li class="svp-metrics-menu__item">\
                        <a class="svp-metrics-menu__item-button svp_js-show-debug-info" role="button">' + showOrHide + ' mer videoinformation</a>\
                    </li>\
                </ul>\
            </ul>');
        }
    }, {
        key: '_keyDownListener',
        value: function _keyDownListener(e) {
            if (e.key === 'd') {
                this.enable = !this.enable;

                if (this.enable) {
                    this.start();
                } else {
                    this.stop(true);
                }
            }
        }
    }, {
        key: '_cumulativeOffset',
        value: function _cumulativeOffset(element) {
            var top = 0;
            var left = 0;

            do {
                top += element.offsetTop || 0;
                left += element.offsetLeft || 0;
                element = element.offsetParent;
            } while (element);

            return {
                top: top,
                left: left
            };
        }
    }, {
        key: '_showContextMenu',
        value: function _showContextMenu(e) {
            var _this = this;

            if (this.contextMenuVisible) {
                return this._hideContextMenu();
            }
            if (!this.enableContextMenu) {
                return;
            }

            e.preventDefault();

            var offset = this._cumulativeOffset(e.target);

            this.api.element().appendChild(this._createMenuMarkup(e.pageX - offset.left, e.pageY - offset.top));

            var debugButton = (0, _sizzle2.default)('.svp_js-show-debug-info', this.api.element())[0];

            debugButton.addEventListener('click', this._showDebugButtonClick.bind(this));

            this.contextMenuVisible = true;

            this.hideContextMenuTimer = setTimeout(function () {
                _this._hideContextMenu();
            }, HIDE_CONTEXT_MENU_AFTER);
        }
    }, {
        key: '_showDebugButtonClick',
        value: function _showDebugButtonClick(e) {
            e.preventDefault();

            var debugButton = (0, _sizzle2.default)('.svp_js-show-debug-info', this.api.element())[0];

            if (debugButton) {
                debugButton.removeEventListener('click', this._showDebugButtonClick.bind(this));
            }

            this.enable = !this.enable;

            if (this.enable) {
                this.start();
            } else {
                this.stop(true);
            }

            this._hideContextMenu();
        }
    }, {
        key: '_hideContextMenu',
        value: function _hideContextMenu() {
            var markuptoRemove = document.getElementById(this.menuId);

            if (markuptoRemove) {
                this.api.element().removeChild(markuptoRemove);
            }

            if (this.hideContextMenuTimer) {
                clearTimeout(this.hideContextMenuTimer);
                this.hideContextMenuTimer = null;
            }

            this.contextMenuVisible = false;
        }
    }, {
        key: '_addListeners',
        value: function _addListeners() {
            var _this2 = this;

            var element = this.api.element();
            domUtils.addEvents(element, 'keydown', this._keyDownListener.bind(this), NAMESPACE);
            domUtils.addEvents(element, 'contextmenu', this._showContextMenu.bind(this), NAMESPACE);
            domUtils.addEvents(element, 'click', this._hideContextMenu.bind(this), NAMESPACE);

            this.api.on(NAMESPACE + '.playing', function () {
                _this2.enableContextMenu = true;

                if (_this2.enable && !_this2.playing) {
                    _this2.start();
                }

                _this2.playing = true;
            });

            this.api.on(NAMESPACE + '.pause', function () {
                _this2.playing = false;

                if (_this2.enable) {
                    _this2.stop();
                }
            });

            this.api.on(NAMESPACE + '.resize', function () {
                _this2._hideContextMenu();
            });
        }
    }, {
        key: '_removeListerners',
        value: function _removeListerners() {
            domUtils.removeEvents(this.api.element(), 'keydown, contextmenu, click', NAMESPACE);
            this.api.off(NAMESPACE + '.playing');
            this.api.off(NAMESPACE + '.pause');
        }
    }, {
        key: 'start',
        value: function start() {
            if (!this.markupAdded) {
                this.api.element().appendChild(this._createMarkup());
                this.markupAdded = true;
            }

            this._startMetricsInterval();
        }
    }, {
        key: 'stop',
        value: function stop(removeMarkup) {
            this._clearMetricsInterval();

            if (removeMarkup) {
                var markuptoRemove = document.getElementById(this.id);

                if (markuptoRemove) {
                    this.api.element().removeChild(markuptoRemove);
                    this.markupAdded = false;
                }
            }
        }
    }, {
        key: '_startMetricsInterval',
        value: function _startMetricsInterval() {
            var _this3 = this;

            this.interval = setInterval(function () {
                var metrics = _this3.api.getMetrics();

                document.getElementById(_this3.id + '-abs').innerHTML = metrics.dash ? 'MPEG-DASH' : 'HLS';
                document.getElementById(_this3.id + '-dropped').innerHTML = metrics.droppedFrames;
                document.getElementById(_this3.id + '-buffer').innerHTML = Math.floor(metrics.bufferLevel) + 's';
                document.getElementById(_this3.id + '-cdn').innerHTML = metrics.cdn || 'N/A';
                document.getElementById(_this3.id + '-dimensions').innerHTML = metrics.dimensions;
                document.getElementById(_this3.id + '-resolution').innerHTML = metrics.resolution;
            }, UPDATE_METRICS_INTERVAL);
        }
    }, {
        key: '_clearMetricsInterval',
        value: function _clearMetricsInterval() {
            if (this.interval) {
                clearInterval(this.interval);
                this.interval = null;
            }
        }
    }, {
        key: 'destroy',
        value: function destroy() {
            this.stop(true);
            this._removeListerners();
        }
    }]);
    return Metrics;
}();

module.exports = {
    create: function create(api) {
        api.once(NAMESPACE + '.ready', function () {
            var videoElement = api.video();
            var uid = _videoAttributes2.default.getUID(videoElement) || _videoAttributes2.default.generateAndSetUID(videoElement);

            var metrics = new Metrics(api, uid);
            instances.set(api, metrics);
        });
    },
    destroy: function destroy(api) {
        if (instances.has(api)) {
            instances.get(api).destroy();
            instances.delete(api);
        }
    }
};

/***/ }),

/***/ "mZON":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("VWgF")('keys');
var uid = __webpack_require__("ulTY");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ "mgCp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("c8Kh");
var global = __webpack_require__("YjQv");
var ctx = __webpack_require__("3fMt");
var classof = __webpack_require__("FHqv");
var $export = __webpack_require__("Wdy1");
var isObject = __webpack_require__("8ANE");
var aFunction = __webpack_require__("SWGL");
var anInstance = __webpack_require__("4S0F");
var forOf = __webpack_require__("dudK");
var speciesConstructor = __webpack_require__("BfX3");
var task = __webpack_require__("kkvn").set;
var microtask = __webpack_require__("LKnP")();
var newPromiseCapabilityModule = __webpack_require__("3HN9");
var perform = __webpack_require__("AgWD");
var promiseResolve = __webpack_require__("qC2Z");
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__("hgbu")('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value);
            if (domain) domain.exit();
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  if (promise._h == 1) return false;
  var chain = promise._a || promise._c;
  var i = 0;
  var reaction;
  while (chain.length > i) {
    reaction = chain[i++];
    if (reaction.fail || !isUnhandled(reaction.promise)) return false;
  } return true;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__("nJ75")($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__("LhDF")($Promise, PROMISE);
__webpack_require__("EFoD")(PROMISE);
Wrapper = __webpack_require__("iANj")[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__("wWcv")(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),

/***/ "mhbO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*global SVP */


var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _dom = __webpack_require__("TdxG");

var domUtils = _interopRequireWildcard(_dom);

var _errorType = __webpack_require__("0PB5");

var _errorType2 = _interopRequireDefault(_errorType);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Sizzle = __webpack_require__("zZaF");
var config = __webpack_require__("Pqsl");
var time = __webpack_require__("74ZT");

var NAMESPACE = 'ui-timeline-controls';

var ERROR_ATTRIBUTE = 'svp_is--error';
var VISIBLE_ATTRIBUTE = 'svp_is--visible';

var CLASSNAMES = {
	errorContainer: 'svp_js-error',
	errorIcon: 'svp_js-error--icon',
	errorMessage: 'svp_js-error--message',
	errorLinkContainer: 'svp_js-error--link-container',
	errorLink: 'svp_js-error--link',
	errorLiveClock: 'svp_js-error--live-clock',
	errorRetry: 'svp_js-error--retry'
};

var ICONS = {
	general: 'svp_ui-error__icon--blocked',
	geoblock: 'svp_ui-error__icon--geoblock'
};

var LIVE_PING_INTERVAL_MS = 10000;
var liveInterval;

var createFn = function createFn(api) {

	function _createElement() {
		var errorNode = domUtils.fromString('<div class="svp_ui-error ' + CLASSNAMES.errorContainer + '">\
				<div class="svp_ui-error__inner">\
					<span class="svp_ui-error__icon ' + CLASSNAMES.errorIcon + '"></span>\
					<div class="svp_ui-error__message-container">\
						<span class="svp_ui-error__message ' + CLASSNAMES.errorMessage + '" aria-live="assertive" role="alert"></span>\
						<button class="svp_ui-error__retry ' + CLASSNAMES.errorRetry + '">Försök igen</button>\
						<div class="svp_ui-error__message-link--container ' + CLASSNAMES.errorLinkContainer + '">\
							<span class="svp_ui-error__message-icon--arrow"></span>\
							<a target="_blank" class="' + CLASSNAMES.errorLink + '" href=""></a>\
						</div>\
					</div>\
				</div>\
			</div>');

		if (SVP._cssNotLoadedClass) {
			domUtils.addClass(errorNode, SVP._cssNotLoadedClass);
			errorNode.style.visibility = 'hidden';
		}

		return errorNode;
	}

	function _getElement(className) {
		return api && Sizzle('.' + className, api.element())[0];
	}

	function _createClockFace(startTime) {
		var time = new Date(startTime * 1000),
		    hours = time.getHours(),
		    minutes = time.getMinutes(),
		    hoursElement = domUtils.fromString('<div class="svp_ui-error__live-clock-hours"></div>'),
		    minutesElement = domUtils.fromString('<div class="svp_ui-error__live-clock-minutes"></div>'),
		    containerDiv = domUtils.fromString('<div class="svp_ui-error__live-clock ' + CLASSNAMES.errorLiveClock + '"></div>');

		hoursElement.style.transform = 'rotate(' + (hours + minutes / 60) / 12 * 360 + 'deg)';
		minutesElement.style.transform = 'rotate(' + minutes / 60 * 360 + 'deg)';
		containerDiv.appendChild(hoursElement);
		containerDiv.appendChild(minutesElement);
		containerDiv.appendChild(domUtils.fromString('<div class="svp_ui-error__live-clock-knot"></div>'));

		return containerDiv;
	}

	function _displayError(errorObject, iconClass, liveStartTime) {
		if (errorObject && api.state()) {
			api.hide(); //hide all ui components except error

			api.pause(); // TODO: should we do something smarter here?
			var errorMessage = _getElement(CLASSNAMES.errorMessage),
			    errorIcon = _getElement(CLASSNAMES.errorIcon),
			    errorLink = _getElement(CLASSNAMES.errorLink),
			    errorLinkContainer = _getElement(CLASSNAMES.errorLinkContainer),
			    errorLiveClock = _getElement(CLASSNAMES.errorLiveClock),
			    errorRetry = _getElement(CLASSNAMES.errorRetry);

			errorMessage.innerHTML = errorObject.text;
			if (errorLiveClock) {
				errorLiveClock.parentElement.removeChild(errorLiveClock);
			}

			domUtils.removeClass(errorIcon, (0, _keys2.default)(ICONS));

			if (liveStartTime) {
				errorIcon.parentElement.insertBefore(_createClockFace(liveStartTime), errorIcon);
				liveInterval = setInterval(function () {
					config.metadataFetchFunction(api.data().videoId, function (metadata) {
						if (metadata.live) {
							clearInterval(liveInterval);
							api.load();
						}
					}, function () {
						// empty
					});
				}, LIVE_PING_INTERVAL_MS);
			} else if (iconClass) {
				domUtils.addClass(errorIcon, iconClass);
			}

			if (errorObject.link) {
				errorLink.setAttribute('href', errorObject.link.url);
				errorLink.innerHTML = errorObject.link.text;
				domUtils.show(errorLinkContainer);
			} else {
				domUtils.hide(errorLinkContainer);
			}

			if (errorObject.retry) {
				domUtils.addClass(errorRetry, VISIBLE_ATTRIBUTE);
			} else {
				domUtils.removeClass(errorRetry, VISIBLE_ATTRIBUTE);
			}

			domUtils.addClass(api.element(), ERROR_ATTRIBUTE);
		}
	}

	function _reset() {
		var errorMessage = _getElement(CLASSNAMES.errorMessage);
		errorMessage.innerHTML = '';
		domUtils.removeClass(api.element(), ERROR_ATTRIBUTE);
		api.show(); //show all ui components
		clearInterval(liveInterval);
	}

	function _errorHandler(errorEvent) {
		var detail = errorEvent && errorEvent.detail ? errorEvent.detail : {},
		    key,
		    errorObject,
		    liveStartTime = 0,
		    iconClass = ICONS.general;

		if (detail.target && detail.target.error) {
			//standard video error
			switch (detail.target.error.code) {
				case detail.target.error.MEDIA_ERR_ABORTED:
					key = _errorType2.default.MEDIA_ERROR_ABORTED;
					break;
				case detail.target.error.MEDIA_ERR_NETWORK:
					key = _errorType2.default.MEDIA_ERROR_NETWORK;
					break;
				case detail.target.error.MEDIA_ERR_DECODE:
					key = _errorType2.default.MEDIA_ERROR_DECODE;
					break;
				case detail.target.error.MEDIA_ERR_SRC_NOT_SUPPORTED:
					key = _errorType2.default.MEDIA_ERROR_SRC_NOT_SUPPORTED;
					break;
				default:
					key = _errorType2.default.DEFAULT_ERROR;
					break;
			}
			errorObject = config.messages.error[key];
		} else if (detail.name) {
			//our own error
			key = detail.name;
			errorObject = config.messages.error[key];
			switch (key) {
				case _errorType2.default.LIVE_NOT_STARTED_ERROR:
					errorObject.text = 'Sändningen startar ' + time.formatPrettyVideoDate(new Date(detail.timestamp * 1000));
					liveStartTime = detail.timestamp;
					break;
				case _errorType2.default.GEO_BLOCK_ERROR:
					iconClass = ICONS.geoblock;
					break;
			}
		} else {
			errorObject = config.messages.error.defaultError;
		}

		if (api.state()) {
			_displayError(errorObject, iconClass, liveStartTime);
		}
	}

	api.element().appendChild(_createElement());
	api.on(NAMESPACE + '.error', _errorHandler.bind(this));
	api.on(NAMESPACE + '.play', _reset.bind(this));

	_getElement(CLASSNAMES.errorRetry).addEventListener('click', function () {
		api.play();
	});

	api.filters.push({
		load: function load() {
			_reset();
		},
		reset: function reset() {
			_reset();
		}
	});
};

module.exports = {
	create: createFn,
	destroy: function destroy(api) {
		if (api) {
			var element = api.element(),
			    errorContainer = Sizzle('.' + CLASSNAMES.errorContainer, element)[0];

			api.off(NAMESPACE + '.error');
			api.off(NAMESPACE + '.play');

			domUtils.removeClass(api.element(), ERROR_ATTRIBUTE);

			if (errorContainer) {
				errorContainer.parentElement.removeChild(errorContainer);
			}

			clearInterval(liveInterval);
		}
	}
};

/***/ }),

/***/ "mvHQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("Zbun"), __esModule: true };

/***/ }),

/***/ "n4Q7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _dom = __webpack_require__("TdxG");

var domUtils = _interopRequireWildcard(_dom);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var device = __webpack_require__("xOtj");
var Sizzle = __webpack_require__("zZaF");

var NAMESPACE = 'ui-volume-controls';

var CLASSNAMES = {
	volumeContainer: 'svp_js-controls-volume-container',
	volumeButton: 'svp_js-controls-btn--volume',
	volumeLabel: 'svp_ui-controls__volume-label',
	volumeSeekbarContainer: 'svp_js-controls-volume-seekbar-container',
	volumeSeekbar: 'svp_js-controls-volume-seekbar',
	volumeSeekbarProgress: 'svp_js-controls-volume-seekbar--progress',
	volumeSeekbarHandle: 'svp_js-controls-volume-seekbar--progress-handle'
};

var OVERRIDE_CLASSNAMES = {
	volumeSeekbar: 'svp_css-volume--seekbar',
	volumeSeekbarProgress: 'svp_css-volume--seekbar-progress',
	volumeSeekbarHandle: 'svp_css-volume--seekbar-handle'
};

var BUTTON_ICONS = {
	volumeHigher: 'svp_ui-controls__button-volume-high',
	volumeLower: 'svp_ui-controls__button-volume-lower',
	volumeLowest: 'svp_ui-controls__button-volume-lowest',
	muted: 'svp_ui-controls__button-muted'
};

var STATES = {
	focus: 'svp_is--focus'
};

var STORAGE_KEY = 'storedVolume';

var createFn = function createFn(api) {

	function _getElement(className) {
		return api && Sizzle('.' + className, api.element())[0];
	}

	function _adjustVolumeControls() {
		var wantedVolume = api.getVolume(),
		    isMuted = api.isMuted(),
		    button = _getElement(CLASSNAMES.volumeButton),
		    volumeSeekbarProgress = _getElement(CLASSNAMES.volumeSeekbarProgress),
		    volumeSeekbar = _getElement(CLASSNAMES.volumeSeekbar),
		    volumeSeekbarHandle = _getElement(CLASSNAMES.volumeSeekbarHandle),
		    volumeSeekbarContainer = _getElement(CLASSNAMES.volumeSeekbarContainer),
		    label = isMuted || wantedVolume === 0 ? 'Ljud på' : 'Ljud av',
		    volumeSeekbarHandleOffset,
		    wantedClass;

		if (isMuted || wantedVolume === 0) {
			wantedClass = BUTTON_ICONS.muted;
		} else if (wantedVolume < 0.15) {
			wantedClass = BUTTON_ICONS.volumeLowest;
		} else if (wantedVolume < 0.6) {
			wantedClass = BUTTON_ICONS.volumeLower;
		} else {
			wantedClass = BUTTON_ICONS.volumeHigher;
		}

		if (!domUtils.hasClass(button, wantedClass)) {
			domUtils.removeClass(button, [BUTTON_ICONS.volumeLowest, BUTTON_ICONS.volumeLower, BUTTON_ICONS.volumeHigher, BUTTON_ICONS.muted]);
			domUtils.addClass(button, wantedClass);
		}

		//Calculate handler offset, consider radius of the handler and the margin to the container.
		if (volumeSeekbarHandleOffset === undefined) {
			volumeSeekbarHandleOffset = volumeSeekbarContainer.getBoundingClientRect().bottom - volumeSeekbar.getBoundingClientRect().bottom - volumeSeekbarHandle.getBoundingClientRect().height / 2;
		}
		var volume = isMuted ? 0 : volumeSeekbar.getBoundingClientRect().height * wantedVolume,
		    volumePercent = String(wantedVolume.toFixed(1) * 100);
		volumeSeekbarProgress.style.height = volume + "px";
		volumeSeekbarHandle.style.bottom = volume + volumeSeekbarHandleOffset + "px";

		button.setAttribute('title', label + ' (M)');
		button.setAttribute('aria-valuetext', isMuted ? 0 : volumePercent + '% volym');
		button.setAttribute('aria-valuenow', isMuted ? 0 : volumePercent);
	}

	function _mute(shouldMute) {
		api.mute(shouldMute);

		var storedValue = shouldMute ? 0 : api.getVolume();
		domUtils.setStoredData(STORAGE_KEY, storedValue);
	}

	function _bindVolumeUiInteractionEvents() {
		var volumeButton = _getElement(CLASSNAMES.volumeButton),
		    enableVolumeSeekbar = true,
		    adjustingSeekbar = false;

		var adjustVolume = function adjustVolume(e) {
			var seekbarRect = _getElement(CLASSNAMES.volumeSeekbar).getBoundingClientRect(),
			    volumeSeekbarContainer = _getElement(CLASSNAMES.volumeSeekbarContainer),
			    seekbarContainerRect = volumeSeekbarContainer.getBoundingClientRect(),
			    seekbarMargin = seekbarContainerRect.bottom - seekbarRect.bottom,
			    position = seekbarContainerRect.bottom - e.clientY;

			//adjust position to seekbar; remove margins
			if (position < seekbarMargin) {
				position = seekbarMargin;
			} else if (position > seekbarMargin + seekbarRect.height) {
				position = seekbarMargin + seekbarRect.height;
			}

			var fraction = (position - seekbarMargin) / seekbarRect.height;

			api.setVolume(fraction);
			domUtils.setStoredData(STORAGE_KEY, fraction);

			_adjustVolumeControls();
		};

		var dragEventFn = function dragEventFn(e) {
			adjustVolume(e);
		};

		var dragStartFn = function dragStartFn(e) {
			adjustingSeekbar = true;
			var namespace = NAMESPACE + '-drag',
			    mouseupFn = function mouseupFn(e) {
				adjustingSeekbar = false;
				domUtils.removeEvents(document, 'mousemove, mouseup', namespace);
			};

			domUtils.addEvents(document, 'mousemove', dragEventFn, namespace);
			domUtils.addEvents(document, 'mouseup', mouseupFn, namespace);
			e.preventDefault();
			e.stopPropagation();
		};

		var volumeKeyUpHandler = function volumeKeyUpHandler(e) {
			var keyEvent = domUtils.getKeyFromKeyEvent(e),
			    handled = false;

			if (keyEvent === 'enter') {
				_mute(!api.isMuted());
				_adjustVolumeControls();
				handled = true;
			}

			if (handled || keyEvent === 'arrowup' || keyEvent === 'arrowdown') {
				api.fire('showControls', { shouldShow: true });
				e.preventDefault();
				e.stopPropagation();
			}
		};

		var volumeKeyDownHandler = function volumeKeyDownHandler(e) {
			var keyEvent = domUtils.getKeyFromKeyEvent(e);
			var handled = false;
			var step;
			var newVolume;

			if (keyEvent === 'arrowup' || keyEvent === 'arrowdown') {
				step = keyEvent === 'arrowup' ? 0.1 : -0.1;
				newVolume = Math.max(0, Math.min(1, api.getVolume() + step));
				api.setVolume(newVolume);
				handled = true;
			}

			if (handled || keyEvent === 'enter') {
				e.preventDefault();
				e.stopPropagation();
			}
		};

		var hideVolumeContainer = function hideVolumeContainer() {
			var volumeSeekbarContainer = _getElement(CLASSNAMES.volumeSeekbarContainer);
			if (!adjustingSeekbar && enableVolumeSeekbar) {
				volumeSeekbarContainer.style.visibility = 'hidden';
			}
		};

		var showVolumeContainer = function showVolumeContainer() {
			var volumeSeekbarContainer = _getElement(CLASSNAMES.volumeSeekbarContainer);
			if (enableVolumeSeekbar) {
				_adjustVolumeControls();
				volumeSeekbarContainer.style.visibility = 'visible';
			}
		};

		var setFocus = function setFocus() {
			var volumeContainer = _getElement(CLASSNAMES.volumeContainer);
			domUtils.addClass(volumeContainer, STATES.focus);
			showVolumeContainer();
		};

		var removeFocus = function removeFocus() {
			var volumeContainer = _getElement(CLASSNAMES.volumeContainer);
			domUtils.removeClass(volumeContainer, STATES.focus);
			hideVolumeContainer();
		};

		domUtils.addEvents(_getElement(CLASSNAMES.volumeSeekbarHandle), 'mousedown', dragStartFn, NAMESPACE);

		domUtils.addEvents(volumeButton, 'mousedown', function (e) {
			e.preventDefault();
		});

		domUtils.addEvents(volumeButton, 'click, touchend', function (e) {
			e.stopPropagation();
			e.preventDefault();
			_mute(!api.isMuted());
			_adjustVolumeControls();
		}, NAMESPACE);

		domUtils.addEvents(volumeButton, 'touchstart', function () {
			enableVolumeSeekbar = false;
			domUtils.hide(_getElement(CLASSNAMES.volumeSeekbarContainer));
		}, NAMESPACE);

		if (!device.isTouch()) {
			domUtils.addEvents(volumeButton, 'mouseenter', showVolumeContainer, NAMESPACE);
		}

		domUtils.addEvents(_getElement(CLASSNAMES.volumeButton), 'focus', setFocus, NAMESPACE);
		domUtils.addEvents(_getElement(CLASSNAMES.volumeButton), 'blur', removeFocus, NAMESPACE);
		domUtils.addEvents(_getElement(CLASSNAMES.volumeContainer), 'mouseleave', hideVolumeContainer, NAMESPACE);
		domUtils.addEvents(_getElement(CLASSNAMES.volumeContainer), 'keyup', volumeKeyUpHandler, NAMESPACE);
		domUtils.addEvents(_getElement(CLASSNAMES.volumeContainer), 'keydown', volumeKeyDownHandler, NAMESPACE);

		// The container listens to click
		domUtils.addEvents(_getElement(CLASSNAMES.volumeSeekbarContainer), 'click', function (e) {
			e.preventDefault();
			e.stopPropagation();
			adjustVolume(e);
		}, NAMESPACE);

		domUtils.addEvents(_getElement(CLASSNAMES.volumeSeekbarContainer), 'mousedown', function (e) {
			e.preventDefault();
			e.stopPropagation();
		}, NAMESPACE);
	}

	return {

		createElement: function createElement() {
			return domUtils.fromString('<div class="svp_ui-controls__volume-container ' + CLASSNAMES.volumeContainer + ' svp_ui-controls--hide-on-error svp_ui-controls--hide-initial">\
					<div class="svp_ui-controls__volume-seekbar-container ' + CLASSNAMES.volumeSeekbarContainer + '">\
						<div class="svp_ui-controls__volume-seekbar ' + CLASSNAMES.volumeSeekbar + ' ' + OVERRIDE_CLASSNAMES.volumeSeekbar + '">\
							<div class="svp_ui-controls__volume-seekbar-progress ' + CLASSNAMES.volumeSeekbarProgress + ' ' + OVERRIDE_CLASSNAMES.volumeSeekbarProgress + '"></div>\
						</div>\
						<div class="svp_ui-controls__volume-seekbar-handle ' + CLASSNAMES.volumeSeekbarHandle + ' ' + OVERRIDE_CLASSNAMES.volumeSeekbarHandle + '"></div>\
					</div>\
					<button class="svp_ui-controls__button-volume-high ' + CLASSNAMES.volumeButton + '" tabindex="0" \
						aria-live="assertive"\
						role="slider"\
						aria-valuemin="0"\
						aria-valuemax="100"\
						aria-valuenow="0"\
						aria-valuetext="0% volym"\
						title="Ljud av">\
						<span class="svp_ui-controls__hidden ' + CLASSNAMES.volumeLabel + '">Volym</span>\
					</button>\
				</div>');
		},

		reset: function reset() {
			var volumeContainer = _getElement(CLASSNAMES.volumeContainer);

			if (volumeContainer) {
				domUtils.removeClass(volumeContainer, BUTTON_ICONS.fullscreenEnd);
				domUtils.addClass(volumeContainer, BUTTON_ICONS.fullscreen);
			}
		},

		bindEvents: function bindEvents(api) {
			api.on(NAMESPACE + '.loadedmetadata', function () {
				_adjustVolumeControls();
				api.off(NAMESPACE + '.loadedmetadata');
			});

			api.on(NAMESPACE + '.volumechange', _adjustVolumeControls.bind(this));

			_bindVolumeUiInteractionEvents();

			var storedVolume = domUtils.getStoredData(STORAGE_KEY);
			if (storedVolume !== null && storedVolume !== undefined) {
				if (api.state().ready) {
					if (storedVolume > 0) {
						api.setVolume(storedVolume);
					} else {
						api.mute(true);
					}
				} else {
					api.on(NAMESPACE + '.ready', function () {
						api.off(NAMESPACE + '.ready');
						if (storedVolume > 0) {
							api.setVolume(storedVolume);
						} else {
							api.mute(true);
						}
					});
				}
			}
		}
	};
};

module.exports = {
	create: createFn,
	destroy: function destroy(api) {
		if (api) {
			var element = api.element(),
			    volumeContainer = Sizzle('.' + CLASSNAMES.volumeContainer, element)[0],
			    currItem;
			if (volumeContainer) {
				for (var className in CLASSNAMES) {
					if (Object.prototype.hasOwnProperty.call(CLASSNAMES, className)) {
						currItem = Sizzle('.' + CLASSNAMES[className], element)[0];
						if (currItem.destroy) {
							currItem.destroy();
						}
					}
				}
				volumeContainer.parentElement.removeChild(volumeContainer);
			}

			api.off(NAMESPACE + '.volumechange');
		}
	}
};

/***/ }),

/***/ "nJ75":
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__("aLzV");
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),

/***/ "nphH":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("DIVP");
var isObject = __webpack_require__("UKM+");
var newPromiseCapability = __webpack_require__("w6Dh");

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),

/***/ "oUpx":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__("Wdy1");

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__("9h1I")('Map') });


/***/ }),

/***/ "oY0/":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("+3lO");
__webpack_require__("tz60");
module.exports = __webpack_require__("St71");


/***/ }),

/***/ "oeih":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ "ot5s":
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("PHqh");
var toLength = __webpack_require__("BbyF");
var toAbsoluteIndex = __webpack_require__("zo/l");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ "pEGt":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("DvwR");
var enumBugKeys = __webpack_require__("B5V0");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ "pFYg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__("Zzip");

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__("5QVw");

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),

/***/ "q3q5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    return hasFeatures() && isBrowserEnabled();
};

var disabledUserAgents = [
// Safari
/^((?!chrome|android).)*safari/i,

// iOS
/(ipad|iphone|ipod)/i];

function isBrowserEnabled() {
    return disabledUserAgents.every(function (x) {
        return !x.test(navigator.userAgent);
    });
}

function hasWebGLFeatures() {
    try {
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
        var exts = ctx.getSupportedExtensions();

        return Boolean(canvas && ctx && exts);
    } catch (e) {
        return false;
    }
}

function hasFeatures() {
    return hasWebGLFeatures();
}

module.exports = exports['default'];

/***/ }),

/***/ "q6TJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.windowsPhoneFallback = exports.ui = exports.thumbnails = exports.splash = exports.pictureinpicture = exports.mmsStats = exports.metrics = exports.mediaPlayerStatistics = exports.keyboardNavigation = exports.iosNative = exports.iosNativeCC = exports.immersive = exports.fallbackOldDevice = exports.errorHandler = exports.embed = exports.chromecast = exports.captions = exports.androidNative = exports.androidFallback = exports.akamaiStats = exports.airplay = undefined;

var _airplay = __webpack_require__("eENa");

var airplay = _interopRequireWildcard(_airplay);

var _akamaiStats = __webpack_require__("J9Y8");

var akamaiStats = _interopRequireWildcard(_akamaiStats);

var _androidFallback = __webpack_require__("S+dD");

var androidFallback = _interopRequireWildcard(_androidFallback);

var _androidNative = __webpack_require__("8AVD");

var androidNative = _interopRequireWildcard(_androidNative);

var _captions = __webpack_require__("xwWq");

var captions = _interopRequireWildcard(_captions);

var _chromecast = __webpack_require__("6n1X");

var chromecast = _interopRequireWildcard(_chromecast);

var _embed = __webpack_require__("2KM4");

var embed = _interopRequireWildcard(_embed);

var _errorHandler = __webpack_require__("mhbO");

var errorHandler = _interopRequireWildcard(_errorHandler);

var _fallbackOldDevice = __webpack_require__("NH+Q");

var fallbackOldDevice = _interopRequireWildcard(_fallbackOldDevice);

var _immersive = __webpack_require__("XteP");

var immersive = _interopRequireWildcard(_immersive);

var _iosNativeCc = __webpack_require__("4uUc");

var iosNativeCC = _interopRequireWildcard(_iosNativeCc);

var _iosNative = __webpack_require__("+3SP");

var iosNative = _interopRequireWildcard(_iosNative);

var _keyboardNavigation = __webpack_require__("qn43");

var keyboardNavigation = _interopRequireWildcard(_keyboardNavigation);

var _mediaPlayerStatistics = __webpack_require__("l1Xx");

var mediaPlayerStatistics = _interopRequireWildcard(_mediaPlayerStatistics);

var _mmsStats = __webpack_require__("GshV");

var mmsStats = _interopRequireWildcard(_mmsStats);

var _pictureinpicture = __webpack_require__("/JIA");

var pictureinpicture = _interopRequireWildcard(_pictureinpicture);

var _splash = __webpack_require__("59mL");

var splash = _interopRequireWildcard(_splash);

var _thumbnails = __webpack_require__("Wlnq");

var thumbnails = _interopRequireWildcard(_thumbnails);

var _ui = __webpack_require__("2ghV");

var ui = _interopRequireWildcard(_ui);

var _windowsPhoneFallback = __webpack_require__("VT6N");

var windowsPhoneFallback = _interopRequireWildcard(_windowsPhoneFallback);

var _metrics = __webpack_require__("m7oa");

var metrics = _interopRequireWildcard(_metrics);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.airplay = airplay;
exports.akamaiStats = akamaiStats;
exports.androidFallback = androidFallback;
exports.androidNative = androidNative;
exports.captions = captions;
exports.chromecast = chromecast;
exports.embed = embed;
exports.errorHandler = errorHandler;
exports.fallbackOldDevice = fallbackOldDevice;
exports.immersive = immersive;
exports.iosNativeCC = iosNativeCC;
exports.iosNative = iosNative;
exports.keyboardNavigation = keyboardNavigation;
exports.mediaPlayerStatistics = mediaPlayerStatistics;
exports.metrics = metrics;
exports.mmsStats = mmsStats;
exports.pictureinpicture = pictureinpicture;
exports.splash = splash;
exports.thumbnails = thumbnails;
exports.ui = ui;
exports.windowsPhoneFallback = windowsPhoneFallback;

/***/ }),

/***/ "qC2Z":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("FKWp");
var isObject = __webpack_require__("8ANE");
var newPromiseCapability = __webpack_require__("3HN9");

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),

/***/ "qkyc":
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__("kkCw")('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),

/***/ "qn43":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _dom = __webpack_require__("TdxG");

var domUtils = _interopRequireWildcard(_dom);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var Debug = __webpack_require__("BF+C")('keyboardNav');

var NAMESPACE = 'keyboard-nav';

module.exports = {
	namespace: NAMESPACE,
	create: function create(api) {
		var _isPlaying = false,
		    _captionsVisible = false;

		function _handleKeyUp(event) {
			var keyName = domUtils.getKeyFromKeyEvent(event),
			    _eventHandled = true;
			Debug('event: ' + keyName + ' (isPlaying: ' + _isPlaying + ')');
			switch (keyName) {
				case 'enter':
				case 'space':
					if (_isPlaying) {
						api.pause();
					} else {
						api.play();
					}
					break;
				case 'digit1':
				case 'digit2':
				case 'digit3':
				case 'digit4':
				case 'digit5':
				case 'digit6':
				case 'digit7':
				case 'digit8':
				case 'digit9':
					var duration = api.getDuration();
					if (duration) {
						var seekTo = duration * parseInt(keyName.replace(/digit/, ''), 10) / 10;
						api.seek(seekTo);
					}
					break;
				case 'digit0':
				case 'home':
					api.seek(1);
					break;
				case 'end':
					api.seek(api.getDuration() - 2);
					break;
				case 'keym':
					api.mute(!api.isMuted());
					break;
				case 'keyc':
					_captionsVisible = !_captionsVisible;
					api.showCaptions(_captionsVisible, true);
					break;
				case 'keyf':
					domUtils.toggleVideoFullscreen(api);
					break;
				case 'tab':
					break;
				default:
					_eventHandled = false;
					break;
			}

			if (_eventHandled) {
				api.fire('showControls', { shouldShow: true });
				event.preventDefault();
				event.stopPropagation();
			}

			return !_eventHandled;
		}

		function _handleKeyDown(e) {
			var keyName = domUtils.getKeyFromKeyEvent(e);

			if (keyName === 'space') {
				e.preventDefault();
				e.stopPropagation();

				return true;
			}

			return false;
		}

		domUtils.addEvents(api.element(), 'keyup', _handleKeyUp, NAMESPACE);
		domUtils.addEvents(api.element(), 'keydown', _handleKeyDown, NAMESPACE);
		api.on(NAMESPACE + '.playing', function () {
			_isPlaying = true;
		});
		var notPlaying = function notPlaying() {
			_isPlaying = false;
		};
		api.on(NAMESPACE + '.pause', notPlaying);
		api.on(NAMESPACE + '.error', notPlaying);
		api.on(NAMESPACE + '.buffering', notPlaying);

		api.on(NAMESPACE + '.captionsvisible', function (event) {
			Debug('setting captionsvisible to ' + event.detail.shouldShow);
			_captionsVisible = event.detail.shouldShow;
		});
	},
	destroy: function destroy(api) {
		var element = api.element();

		if (element) {
			element.removeAttribute('tabindex');
			domUtils.removeEvents(api.element(), 'keyup', NAMESPACE);
			domUtils.removeEvents(api.element(), 'keydown', NAMESPACE);
		}
		api.off(NAMESPACE + '.playing');
		api.off(NAMESPACE + '.pause');
		api.off(NAMESPACE + '.error');
		api.off(NAMESPACE + '.buffering');
		api.off(NAMESPACE + '.seeking');
		api.off(NAMESPACE + '.captionsvisible');
	}
};

/***/ }),

/***/ "qs+f":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("zyKz")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "r3+g":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("GCs6");
var anObject = __webpack_require__("FKWp");
var getKeys = __webpack_require__("pEGt");

module.exports = __webpack_require__("qs+f") ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ "r5ma":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (videoId, callback, errorCallback) {
    var apiUrl = url.getQueryParameter('svtIsStage') === 'true' ? API_STAGE : API_PROD;
    apiUrl = url.getQueryParameter('apiPath') || apiUrl;

    _request2.default.getJson(apiUrl + videoId, function (jsonData) {
        var videoUrls = {};
        var textUrls = {};
        var videoRefs = jsonData.videoReferences || [];
        var textRefs = jsonData.subtitleReferences || [];

        videoRefs.forEach(function (item) {
            videoUrls[item.format] = item.url;
        });

        textRefs.forEach(function (item) {
            textUrls[item.format] = item.url;
        });

        var error = _validator2.default.validate(jsonData, videoUrls);
        if (error) {
            errorCallback(error, jsonData);
        } else {
            callback(jsonData, videoUrls, textUrls);
        }
    }, function () {
        errorCallback({ name: _errorType2.default.LOAD_ERROR });
    });
};

var _url = __webpack_require__("QKfw");

var url = _interopRequireWildcard(_url);

var _request = __webpack_require__("ft8J");

var _request2 = _interopRequireDefault(_request);

var _validator = __webpack_require__("ufNG");

var _validator2 = _interopRequireDefault(_validator);

var _errorType = __webpack_require__("0PB5");

var _errorType2 = _interopRequireDefault(_errorType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var API_STAGE = '//api.stage.svt.se/videoplayer-api/video/';
var API_PROD = '//api.svt.se/videoplayer-api/video/';

module.exports = exports['default'];

/***/ }),

/***/ "rFzY":
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__("XSOZ");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "rKx+":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("4ajQ");
var $Object = __webpack_require__("iANj").Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),

/***/ "rZAI":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__("wXdB");
var $keys = __webpack_require__("pEGt");

__webpack_require__("30vf")('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),

/***/ "rjjF":
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__("bSeU");
var createDesc = __webpack_require__("YTz9");
var toIObject = __webpack_require__("ksFB");
var toPrimitive = __webpack_require__("9MbE");
var has = __webpack_require__("x//u");
var IE8_DOM_DEFINE = __webpack_require__("LocR");
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__("qs+f") ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),

/***/ "ruEN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _dom = __webpack_require__("TdxG");

var domUtils = _interopRequireWildcard(_dom);

var _errorType = __webpack_require__("0PB5");

var _errorType2 = _interopRequireDefault(_errorType);

var _url = __webpack_require__("QKfw");

var url = _interopRequireWildcard(_url);

var _eventWrapperApi = __webpack_require__("YxlO");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var device = __webpack_require__("xOtj");
var extend = __webpack_require__("5E+y");
var statsUtil = __webpack_require__("ahyN");

var SVPCustomEvent = __webpack_require__("L+TV");
var Sizzle = __webpack_require__("zZaF");

var VideoUtil = __webpack_require__("tpcr");

var Debug = __webpack_require__("BF+C")('flash-video');

var CLASSNAMES = {
    flashPosterImage: 'svp_js-flash-poster-image'
};

module.exports = function () {

    // Structure is {objectNode: <DOMObject>, initialized: <Boolean>}
    var instances = {};

    function _attachEventListeners() {
        if (window.__svtplayerCallback__ === undefined) {
            window.__svtplayerCallback__ = function (UID, eventName, data) {
                if (eventName !== 'timeupdate') {
                    Debug('flash event (' + UID + '): ' + eventName + (!!data ? ' with data ' + data : ''));
                }

                var instance = instances[UID],
                    objectNode;
                if (instance) {
                    objectNode = instance.objectNode;

                    //Map our custom flash events to standard html5 events
                    switch (eventName) {
                        case 'initialized':
                            instance.initialized = true;
                            objectNode.dispatchEvent(new SVPCustomEvent(eventName, { detail: data }));
                            objectNode.dispatchEvent(new SVPCustomEvent('play')); //Kind of hacky, but needed for the splash to disappear at the right time
                            break;
                        case 'paused':
                            objectNode.dispatchEvent(new SVPCustomEvent('pause'));
                            break;
                        default:
                            objectNode.dispatchEvent(new SVPCustomEvent(eventName, { detail: data }));
                            break;
                    }
                }
            };
        }
    }

    function _internalLoad(videoElement, UID) {
        var instance = instances[UID];
        if (instance) {
            if (instance.initialized) {
                instance.objectNode.dispatchEvent(new SVPCustomEvent('play'));

                return;
            }

            var parentNode = videoElement.parentNode,
                imgPath = videoElement.poster || 'https://www.svtplay.se/public/images/default/play_default_998x561.jpg',
                existingObjectNode = Sizzle('object', parentNode)[0],
                imgNode = Sizzle('.svp_image', parentNode)[0];

            if (existingObjectNode) {
                parentNode.replaceChild(instance.objectNode, existingObjectNode);
            } else {
                parentNode.insertBefore(instance.objectNode, videoElement);
                domUtils.hide(videoElement);
            }

            if (!imgNode) {
                parentNode.insertBefore(domUtils.fromString('<img class="svp_image ' + CLASSNAMES.flashPosterImage + '" src=' + imgPath + '>'), instance.objectNode);
            } else {
                imgNode.setAttribute('src', imgPath);
            }

            var interval = setInterval(function () {
                var item = Sizzle('.svp_js-flash-error', parentNode)[0];

                if (!item) {
                    clearInterval(interval);
                    parentNode.off('flash.initialized');
                } else if (item.offsetParent !== null) {
                    clearInterval(interval);
                    parentNode.off('flash.initialized');
                    parentNode.fire('error', {
                        name: _errorType2.default.FLASH_NOT_SUPPORTED
                    });
                }
            }, 100);

            parentNode.on('flash.initialized', function () {
                clearInterval(interval);
                parentNode.off('flash.initialized');
            });

            _attachEventListeners();
        }
    }

    return {
        load: function load(videoElement, videoUrl, captionUrl, metadata) {
            var _this = this,
                _arguments = arguments;

            var swfPath = url.absolutePath('svtplayer-2017.03.swf'),
                client = statsUtil.getClient(),
                programTitle = metadata.mmsStatistics && metadata.mmsStatistics.ns_st_pr || 'unknown_program',
                episodeTitle = metadata.mmsStatistics && metadata.mmsStatistics.ns_st_ep || 'unknown_episode',
                categoryTitle = metadata.mmsStatistics && metadata.mmsStatistics.ns_st_pl || 'unknown_category';

            var uid = VideoUtil.getUID(videoElement) || VideoUtil.generateAndSetUID(videoElement);

            var settings = {
                video: {
                    videoReferences: [{ 'url': videoUrl, playerType: 'flash' }],
                    subtitleReferences: [{ 'url': captionUrl }],
                    position: VideoUtil.getStartPosition(videoElement)
                },
                statistics: {
                    client: client,
                    mmsClientNr: statsUtil.getMmsClientNr(),
                    programId: metadata.programVersionId,
                    statisticsUrl: statsUtil.getComscoreBaseUrl() + client + '.' + programTitle + '.' + episodeTitle,
                    title: episodeTitle,
                    folderStructure: programTitle,
                    category: categoryTitle
                },
                context: {
                    UID: uid
                }
            };

            if (metadata.live) {
                settings.video.live = true;
                if (metadata.timeshiftEnabled) {
                    settings.video.dvr = true;
                    settings.materialLength = metadata.contentDuration;
                    settings.video.livestartUTC = metadata.liveStartTimeUTC;
                }
            }

            if (metadata.simulcast) {
                settings.video.live = true;
                settings.video.dvr = false;
                settings.disabled = 'live';
            }

            if (!VideoUtil.isControlsEnabled(videoElement)) {
                settings.disabled = 'controlbar';
            }

            var instance = instances[uid],
                parentNode = videoElement.parentNode,
                _readyFn,
                objectNode;

            if (!(instance && instance.initialized)) {
                if (device.isIE() || !device.supportsFlash) {
                    objectNode = domUtils.fromString('<object id="' + uid + '" class="svp_video svp_flashvideo" classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000"> \
							<param name="movie" value="' + swfPath + '" /> \
							<param name="flashvars" value="json=' + encodeURIComponent((0, _stringify2.default)(settings)) + '" /> \
							<param name="allowscriptaccess" value="always" /> \
							<param name="allowfullscreen" value="true" /> \
							<param name="bgcolor" value="#000000" /> \
							<param name="wmode" value="direct" /> \
							<div class="svp_js-flash-error"></div>\
						</object>');
                } else {
                    objectNode = domUtils.fromString('<object id="' + uid + '" class="svp_video svp_flashvideo" type="application/x-shockwave-flash" \
							data="' + swfPath + '"> \
							<param name="flashvars" value="json=' + encodeURIComponent((0, _stringify2.default)(settings)) + '" /> \
							<param name="allowscriptaccess" value="always" /> \
							<param name="allowfullscreen" value="true" /> \
							<param name="bgcolor" value="#000000" /> \
							<param name="wmode" value="direct" /> \
							<div class="svp_js-flash-error"></div>\
						</object>');
                }

                var origSeek = objectNode.seek;
                var flashSetVolume = objectNode.setVolume;
                var flashGetVolume = objectNode.getVolume;
                var extension = {
                    customEvents: ['initialized'],
                    getDuration: function getDuration() {
                        return metadata.contentDuration;
                    },
                    getCurrentTime: function getCurrentTime() {
                        return this.getPosition ? this.getPosition(true) : 0;
                    },
                    getVolume: function getVolume() {
                        if (flashGetVolume) {
                            return flashGetVolume();
                        }

                        return null;
                    },
                    play: _internalLoad.bind(this, videoElement, uid),
                    pause: function pause() {
                        if (this.svtPause) {
                            this.svtPause();
                        }
                    },
                    getTextTracks: function getTextTracks() {
                        return [];
                    },
                    seek: function seek(position) {
                        if (origSeek) {
                            origSeek(position, true, false);
                        }
                    },
                    setVolume: function setVolume(volume) {
                        if (flashSetVolume) {
                            flashSetVolume(volume, false);
                        }
                    },
                    reset: function reset() {
                        try {
                            if (this.seek) {
                                this.seek(0);
                            }
                        } catch (err) {}
                    },
                    getMetrics: function getMetrics() {
                        return {
                            flash: true,
                            dash: false,
                            droppedFrames: -1,
                            dimensions: -1,
                            resolution: -1,
                            bufferLevel: -1
                        };
                    },
                    unload: function unload() {
                        var uid = this.getAttribute('id'),
                            instance = instances[uid];

                        if (instance) {
                            var posterImage = Sizzle('.' + CLASSNAMES.flashPosterImage, this.parentElement)[0];

                            if (posterImage) {
                                this.parentElement.removeChild(posterImage);
                            }
                            this.parentElement.removeEventListener('ready', _readyFn);
                            this.parentElement.removeChild(this);
                            domUtils.show(videoElement);
                            delete instances[uid];
                        }
                    }
                };

                extend(objectNode, (0, _eventWrapperApi.createEventWrapper)());
                extend(objectNode, extension);
                instances[uid] = { objectNode: objectNode, initialized: false };
            } else {
                var retryFn = function retryFn() {
                    Debug.error('Error re-using Flash-object, retrying.');
                    objectNode.unload();
                    objectNode = _this.load.apply(_this, _arguments); // eslint-disable-line prefer-rest-params
                };

                objectNode = instance.objectNode;
                if (objectNode && objectNode.setJSONItem) {
                    var jsonString = (0, _stringify2.default)(settings),
                        flashvars = 'json=' + encodeURIComponent(jsonString);

                    Sizzle('param[name="flashvars"]', objectNode)[0].setAttribute('value', flashvars);
                    try {
                        // If the Flash-object is in a bad state, this will fail -- hence try/catch
                        objectNode.setJSONItem(jsonString);
                    } catch (e) {
                        retryFn();
                    }
                } else {
                    //if objectNode don't have flash registered functions we re-initalized it
                    retryFn();
                }
            }

            _readyFn = function readyFn() {
                parentNode.removeEventListener('ready', _readyFn);

                // Let the world know we're ready to play
                objectNode.dispatchEvent(new SVPCustomEvent('loadstart'));
                objectNode.dispatchEvent(new SVPCustomEvent('loadedmetadata'));
                objectNode.dispatchEvent(new SVPCustomEvent('canplay'));
            };
            parentNode.addEventListener('ready', _readyFn);

            return objectNode;
        }

    };
}();

/***/ }),

/***/ "s2sY":
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__("jgO3");

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),

/***/ "s4j0":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("UKM+");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "tYO1":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("0/jl");
__webpack_require__("gCWN");
__webpack_require__("3ggi");
__webpack_require__("OoWg");
module.exports = __webpack_require__("iANj").Symbol;


/***/ }),

/***/ "tn1D":
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__("FKWp");
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),

/***/ "tpcr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var timeUtils = __webpack_require__("74ZT");

var REDUCED_MAX_BANDWIDTH_KBPS = 750;

module.exports = function () {
    return {
        getStartPosition: function getStartPosition(videoElement) {
            return Number(videoElement.getAttribute('data-video-startposition')) || 0;
        },
        setStartPosition: function setStartPosition(videoElement, startPosition) {
            videoElement.setAttribute('data-video-startposition', startPosition);
        },
        getSplashText: function getSplashText(videoElement) {
            var text = void 0;
            if (videoElement.getAttribute('data-video-splash-text')) {
                text = videoElement.getAttribute('data-video-splash-text');
            } else if (videoElement.getAttribute('data-video-length')) {
                text = String(timeUtils.getFormattedVideoLength(Number(videoElement.getAttribute('data-video-length'))));
            }

            return text;
        },
        getUID: function getUID(videoElement) {
            return videoElement.getAttribute('data-video-uid');
        },
        generateAndSetUID: function generateAndSetUID(videoElement) {
            var uid = String(Math.round(Math.random() * 1000000));
            videoElement.setAttribute('data-video-uid', uid);

            return uid;
        },
        getMaxBitrate: function getMaxBitrate(videoElement) {
            return videoElement.getAttribute('data-video-reduced-bandwidth') === 'true' ? REDUCED_MAX_BANDWIDTH_KBPS : undefined;
        },
        isControlsEnabled: function isControlsEnabled(videoElement) {
            return videoElement.hasAttribute('data-video-controls');
        },
        isImmersiveVideo: function isImmersiveVideo(videoElement) {
            return videoElement.hasAttribute('data-video-immersive') && videoElement.getAttribute('data-video-immersive') !== 'false';
        },
        getImmersiveVideoFormat: function getImmersiveVideoFormat(videoElement) {
            return videoElement.getAttribute('data-video-immersive-format');
        }
    };
}();

/***/ }),

/***/ "twxM":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("lDLk");
var anObject = __webpack_require__("DIVP");
var getKeys = __webpack_require__("Qh14");

module.exports = __webpack_require__("bUqO") ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ "txMS":
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__("c5AH")('Map');


/***/ }),

/***/ "tz60":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__("0Lvz")(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__("4dmN")(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "uc2A":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("V3l/");
var $export = __webpack_require__("Ds5P");
var redefine = __webpack_require__("R3AP");
var hide = __webpack_require__("2p1q");
var has = __webpack_require__("WBcL");
var Iterators = __webpack_require__("bN1p");
var $iterCreate = __webpack_require__("IRJ3");
var setToStringTag = __webpack_require__("yYvK");
var getPrototypeOf = __webpack_require__("KOrd");
var ITERATOR = __webpack_require__("kkCw")('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ "ufNG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _errorType = __webpack_require__("0PB5");

var _errorType2 = _interopRequireDefault(_errorType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var device = __webpack_require__("xOtj");

module.exports = function () {

	function validate(metadata, videoUrls) {
		var error;
		if (metadata.liveStartTimeUTC && !metadata.rights) {
			error = {
				name: _errorType2.default.LIVE_NOT_STARTED_ERROR,
				timestamp: metadata.liveStartTimeUTC
			};
		} else if (!metadata.rights) {
			error = {
				name: _errorType2.default.RIGHTS_EXPIRED_ERROR
			};
		} else if (metadata.rights.drmCopyProtection && !device.isFlashCapable() && _onlyHds(videoUrls)) {
			error = {
				name: _errorType2.default.DRM_PROTECTION_ERROR
			};
		}

		return error;
	}

	function _onlyHds(videoUrls) {
		return !(videoUrls.dash264 || videoUrls.hls) && videoUrls.hds !== undefined;
	}

	return {
		validate: validate
	};
}();

/***/ }),

/***/ "ulTY":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ "vlJ+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    UNKNOWN: 0,
    DASH: 1,
    HLS: 2,
    HDS: 3,
    FLASHLS: 4
};
module.exports = exports["default"];

/***/ }),

/***/ "vmSO":
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__("rFzY");
var call = __webpack_require__("XvUs");
var isArrayIter = __webpack_require__("9vb1");
var anObject = __webpack_require__("DIVP");
var toLength = __webpack_require__("BbyF");
var getIterFn = __webpack_require__("SHe9");
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),

/***/ "vmzn":
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__("0fkz");

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0, i;

  for (i in namespace) {
    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  return debug;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),

/***/ "vwWJ":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("LfR4");
var $Object = __webpack_require__("iANj").Object;
module.exports = function getOwnPropertyNames(it) {
  return $Object.getOwnPropertyNames(it);
};


/***/ }),

/***/ "w6Dh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__("XSOZ");

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),

/***/ "wC1N":
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__("ydD5");
var TAG = __webpack_require__("kkCw")('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),

/***/ "wWcv":
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__("hgbu")('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),

/***/ "wXdB":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__("+MZ2");
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ "wiaE":
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("NZra");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ "woOf":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("Eif7"), __esModule: true };

/***/ }),

/***/ "wxAW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__("C4MV");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),

/***/ "x//u":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "x/31":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("gCWN");
__webpack_require__("tz60");
__webpack_require__("+3lO");
__webpack_require__("mgCp");
__webpack_require__("+GuK");
__webpack_require__("Nrqz");
module.exports = __webpack_require__("iANj").Promise;


/***/ }),

/***/ "xKeu":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var _window =
  typeof window !== 'undefined'
    ? window
    : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function isObject(what) {
  return typeof what === 'object' && what !== null;
}

// Yanked from https://git.io/vS8DV re-used under CC0
// with some tiny modifications
function isError(value) {
  switch ({}.toString.call(value)) {
    case '[object Error]':
      return true;
    case '[object Exception]':
      return true;
    case '[object DOMException]':
      return true;
    default:
      return value instanceof Error;
  }
}

function isErrorEvent(value) {
  return supportsErrorEvent() && {}.toString.call(value) === '[object ErrorEvent]';
}

function isUndefined(what) {
  return what === void 0;
}

function isFunction(what) {
  return typeof what === 'function';
}

function isString(what) {
  return Object.prototype.toString.call(what) === '[object String]';
}

function isEmptyObject(what) {
  for (var _ in what) return false; // eslint-disable-line guard-for-in, no-unused-vars
  return true;
}

function supportsErrorEvent() {
  try {
    new ErrorEvent(''); // eslint-disable-line no-new
    return true;
  } catch (e) {
    return false;
  }
}

function wrappedCallback(callback) {
  function dataCallback(data, original) {
    var normalizedData = callback(data) || data;
    if (original) {
      return original(normalizedData) || normalizedData;
    }
    return normalizedData;
  }

  return dataCallback;
}

function each(obj, callback) {
  var i, j;

  if (isUndefined(obj.length)) {
    for (i in obj) {
      if (hasKey(obj, i)) {
        callback.call(null, i, obj[i]);
      }
    }
  } else {
    j = obj.length;
    if (j) {
      for (i = 0; i < j; i++) {
        callback.call(null, i, obj[i]);
      }
    }
  }
}

function objectMerge(obj1, obj2) {
  if (!obj2) {
    return obj1;
  }
  each(obj2, function(key, value) {
    obj1[key] = value;
  });
  return obj1;
}

/**
 * This function is only used for react-native.
 * react-native freezes object that have already been sent over the
 * js bridge. We need this function in order to check if the object is frozen.
 * So it's ok that objectFrozen returns false if Object.isFrozen is not
 * supported because it's not relevant for other "platforms". See related issue:
 * https://github.com/getsentry/react-native-sentry/issues/57
 */
function objectFrozen(obj) {
  if (!Object.isFrozen) {
    return false;
  }
  return Object.isFrozen(obj);
}

function truncate(str, max) {
  return !max || str.length <= max ? str : str.substr(0, max) + '\u2026';
}

/**
 * hasKey, a better form of hasOwnProperty
 * Example: hasKey(MainHostObject, property) === true/false
 *
 * @param {Object} host object to check property
 * @param {string} key to check
 */
function hasKey(object, key) {
  return Object.prototype.hasOwnProperty.call(object, key);
}

function joinRegExp(patterns) {
  // Combine an array of regular expressions and strings into one large regexp
  // Be mad.
  var sources = [],
    i = 0,
    len = patterns.length,
    pattern;

  for (; i < len; i++) {
    pattern = patterns[i];
    if (isString(pattern)) {
      // If it's a string, we need to escape it
      // Taken from: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
      sources.push(pattern.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1'));
    } else if (pattern && pattern.source) {
      // If it's a regexp already, we want to extract the source
      sources.push(pattern.source);
    }
    // Intentionally skip other cases
  }
  return new RegExp(sources.join('|'), 'i');
}

function urlencode(o) {
  var pairs = [];
  each(o, function(key, value) {
    pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
  });
  return pairs.join('&');
}

// borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
// intentionally using regex and not <a/> href parsing trick because React Native and other
// environments where DOM might not be available
function parseUrl(url) {
  var match = url.match(/^(([^:\/?#]+):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
  if (!match) return {};

  // coerce to undefined values to empty string so we don't get 'undefined'
  var query = match[6] || '';
  var fragment = match[8] || '';
  return {
    protocol: match[2],
    host: match[4],
    path: match[5],
    relative: match[5] + query + fragment // everything minus origin
  };
}
function uuid4() {
  var crypto = _window.crypto || _window.msCrypto;

  if (!isUndefined(crypto) && crypto.getRandomValues) {
    // Use window.crypto API if available
    // eslint-disable-next-line no-undef
    var arr = new Uint16Array(8);
    crypto.getRandomValues(arr);

    // set 4 in byte 7
    arr[3] = (arr[3] & 0xfff) | 0x4000;
    // set 2 most significant bits of byte 9 to '10'
    arr[4] = (arr[4] & 0x3fff) | 0x8000;

    var pad = function(num) {
      var v = num.toString(16);
      while (v.length < 4) {
        v = '0' + v;
      }
      return v;
    };

    return (
      pad(arr[0]) +
      pad(arr[1]) +
      pad(arr[2]) +
      pad(arr[3]) +
      pad(arr[4]) +
      pad(arr[5]) +
      pad(arr[6]) +
      pad(arr[7])
    );
  } else {
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = (Math.random() * 16) | 0,
        v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
}

/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @param elem
 * @returns {string}
 */
function htmlTreeAsString(elem) {
  /* eslint no-extra-parens:0*/
  var MAX_TRAVERSE_HEIGHT = 5,
    MAX_OUTPUT_LEN = 80,
    out = [],
    height = 0,
    len = 0,
    separator = ' > ',
    sepLength = separator.length,
    nextStr;

  while (elem && height++ < MAX_TRAVERSE_HEIGHT) {
    nextStr = htmlElementAsString(elem);
    // bail out if
    // - nextStr is the 'html' element
    // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
    //   (ignore this limit if we are on the first iteration)
    if (
      nextStr === 'html' ||
      (height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN)
    ) {
      break;
    }

    out.push(nextStr);

    len += nextStr.length;
    elem = elem.parentNode;
  }

  return out.reverse().join(separator);
}

/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @param HTMLElement
 * @returns {string}
 */
function htmlElementAsString(elem) {
  var out = [],
    className,
    classes,
    key,
    attr,
    i;

  if (!elem || !elem.tagName) {
    return '';
  }

  out.push(elem.tagName.toLowerCase());
  if (elem.id) {
    out.push('#' + elem.id);
  }

  className = elem.className;
  if (className && isString(className)) {
    classes = className.split(/\s+/);
    for (i = 0; i < classes.length; i++) {
      out.push('.' + classes[i]);
    }
  }
  var attrWhitelist = ['type', 'name', 'title', 'alt'];
  for (i = 0; i < attrWhitelist.length; i++) {
    key = attrWhitelist[i];
    attr = elem.getAttribute(key);
    if (attr) {
      out.push('[' + key + '="' + attr + '"]');
    }
  }
  return out.join('');
}

/**
 * Returns true if either a OR b is truthy, but not both
 */
function isOnlyOneTruthy(a, b) {
  return !!(!!a ^ !!b);
}

/**
 * Returns true if the two input exception interfaces have the same content
 */
function isSameException(ex1, ex2) {
  if (isOnlyOneTruthy(ex1, ex2)) return false;

  ex1 = ex1.values[0];
  ex2 = ex2.values[0];

  if (ex1.type !== ex2.type || ex1.value !== ex2.value) return false;

  return isSameStacktrace(ex1.stacktrace, ex2.stacktrace);
}

/**
 * Returns true if the two input stack trace interfaces have the same content
 */
function isSameStacktrace(stack1, stack2) {
  if (isOnlyOneTruthy(stack1, stack2)) return false;

  var frames1 = stack1.frames;
  var frames2 = stack2.frames;

  // Exit early if frame count differs
  if (frames1.length !== frames2.length) return false;

  // Iterate through every frame; bail out if anything differs
  var a, b;
  for (var i = 0; i < frames1.length; i++) {
    a = frames1[i];
    b = frames2[i];
    if (
      a.filename !== b.filename ||
      a.lineno !== b.lineno ||
      a.colno !== b.colno ||
      a['function'] !== b['function']
    )
      return false;
  }
  return true;
}

/**
 * Polyfill a method
 * @param obj object e.g. `document`
 * @param name method name present on object e.g. `addEventListener`
 * @param replacement replacement function
 * @param track {optional} record instrumentation to an array
 */
function fill(obj, name, replacement, track) {
  var orig = obj[name];
  obj[name] = replacement(orig);
  if (track) {
    track.push([obj, name, orig]);
  }
}

module.exports = {
  isObject: isObject,
  isError: isError,
  isErrorEvent: isErrorEvent,
  isUndefined: isUndefined,
  isFunction: isFunction,
  isString: isString,
  isEmptyObject: isEmptyObject,
  supportsErrorEvent: supportsErrorEvent,
  wrappedCallback: wrappedCallback,
  each: each,
  objectMerge: objectMerge,
  truncate: truncate,
  objectFrozen: objectFrozen,
  hasKey: hasKey,
  joinRegExp: joinRegExp,
  urlencode: urlencode,
  uuid4: uuid4,
  htmlTreeAsString: htmlTreeAsString,
  htmlElementAsString: htmlElementAsString,
  isSameException: isSameException,
  isSameStacktrace: isSameStacktrace,
  parseUrl: parseUrl,
  fill: fill
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "xOtj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* global ActiveXObject */


var _url = __webpack_require__("QKfw");

var UrlUtil = _interopRequireWildcard(_url);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var UA = {
	CANALDIGITAL: 'adb',
	ANDROID: 'android',
	ANDROID4: 'android 4',
	ANDROID5: 'android 5',
	CHROME: 'chrome',
	FIREFOX: 'firefox',
	IE: 'msie',
	IE11: 'trident/7.0',
	EDGE: 'edge',
	INETTV: 'inettvbrowser', // Sony
	IPHONE: 'iphone',
	IPAD: 'ipad',
	IPOD: 'ipod',
	IOS5: 'os 5',
	IOS6: 'os 6',
	IOS7: 'os 7',
	IOS9: 'os 9',
	LG: 'lg browser',
	MAC: 'mac',
	MAC_OS_HIGH_SIERRA: 'mac os x 10_13',
	NETCAST: 'netcast',
	PANASONIC: 'viera',
	PHILIPS: 'philips',
	PS4: 'playstation 4',
	SAFARI: 'safari',
	SAMSUNG: 'samsung',
	SONYCE: 'sonycebrowser',
	VERSION: 'version', // use with iOS to find mobile safari
	WEBOS: 'webos',
	WIIU: 'nintendo wiiu',
	WIN8: 'msapphost/2.0',
	WP: 'windows phone',
	WP_DESKTOP: 'wpdesktop',
	XP: 'windows nt 5.1'
};

var UA_SETTINGS = {
	fullScreen: [UA.PS4, UA.SONYCE, UA.INETTV, UA.PHILIPS],
	hlsCapable: [UA.PS4, UA.LG, UA.WIIU, UA.WEBOS, UA.NETCAST],
	hlsOnly: [UA.CANALDIGITAL, UA.PHILIPS, UA.SONYCE, UA.INETTV, UA.PANASONIC],
	iOS: [UA.IPAD, UA.IPHONE, UA.IPOD],
	iOSMobile: [UA.IPHONE, UA.IPOD],
	maxQuality: [UA.PS4, UA.LG, UA.WIIU, UA.SONYCE, UA.INETTV, UA.PANASONIC, UA.PHILIPS, UA.CANALDIGITAL],
	windowsPhone: [UA.WP, UA.WP_DESKTOP]
};

var CURR_UA = navigator.userAgent.toLowerCase(),
    SUPPORTS_FLASH;

module.exports = function () {

	function _matchUserAgent(ua) {
		return CURR_UA.indexOf(ua) !== -1;
	}

	function _matchUserAgentList(uaList) {

		for (var i = 0; i < uaList.length; i++) {
			if (_matchUserAgent(uaList[i])) {
				return true;
			}
		}

		return false;
	}

	function _getAndroidVersion() {
		if (!isAndroid()) {
			return {};
		}

		var androidMajorMinor = CURR_UA.replace(/.*android (\d\.\d).*/, '$1').split('.');
		var major = Number(androidMajorMinor[0]);
		var minor = Number(androidMajorMinor[1]);

		return {
			major: major,
			minor: minor
		};
	}

	function _getChromeVersion() {
		if (!_matchUserAgent(UA.CHROME)) {
			return {
				major: 0,
				minor: 0
			};
		}

		var chromeMajorMinor = CURR_UA.replace(/.*chrome\/(\d+\.\d+).*/, '$1').split('.');
		var major = Number(chromeMajorMinor[0]);
		var minor = Number(chromeMajorMinor[1]);

		return {
			major: major,
			minor: minor
		};
	}

	function isIE() {
		return _matchUserAgent(UA.IE);
	}

	function isIEEdge() {
		return _matchUserAgent(UA.EDGE);
	}

	function isIOS() {
		return _matchUserAgentList(UA_SETTINGS.iOS) && !_matchUserAgent(UA.WP);
	}

	function isIOS5() {
		return isIOS() && _matchUserAgent(UA.IOS5);
	}

	function isIOSLte7() {
		return isIOS() && (_matchUserAgent(UA.IOS7) || _matchUserAgent(UA.IOS6) || _matchUserAgent(UA.IOS5));
	}

	function isIOSApp() {
		return window.localStorage && localStorage.getItem('svtapp') === 'ios-app' || UrlUtil.getQueryParameter('svtapp') === 'play-ios-app';
	}

	function isIOSNotSafari() {
		return isIOS() && !_matchUserAgent(UA.VERSION);
	}

	function isBrokenAndroidChrome() {
		return isAndroid() && _getChromeVersion().major <= 30;
	}

	function isWindowsXpFirefox() {
		return _matchUserAgent(UA.FIREFOX) && _matchUserAgent(UA.XP);
	}

	function isMacDesktopSafari() {
		return _matchUserAgent(UA.SAFARI) && _matchUserAgent(UA.MAC) && !_matchUserAgent(UA.CHROME) && !_matchUserAgent(UA.WP) && !isIOS();
	}

	function isDesktopChrome() {
		return _matchUserAgent(UA.CHROME) && window.chrome && !(isIOS() || isAndroid() || isIEEdge());
	}

	function isDesktopFirefox() {
		return _matchUserAgent(UA.FIREFOX) && !(isIOS() || isAndroid() || isIEEdge());
	}

	function isHlsOnlyDevice() {
		return _matchUserAgentList(UA_SETTINGS.hlsOnly);
	}

	function isDashIncapableAndroid() {
		if (isAndroid()) {
			var version = _getAndroidVersion();

			return version.major <= 5 && _matchUserAgent(UA.SAMSUNG);
		}

		return false;
	}

	function isHttpLiveStreamingCapable(videoElement) {
		return isIOS() || isMacDesktopSafari() || _getAndroidVersion().major >= 5 || _matchUserAgentList(UA_SETTINGS.hlsCapable) || isHlsOnlyDevice() || videoElement && videoElement.canPlayType && !!videoElement.canPlayType('application/vnd.apple.mpegurl;codecs="avc1.77.30, mp4a.40.2"');
	}

	function isAndroid() {
		return _matchUserAgent(UA.ANDROID) && !_matchUserAgent(UA.WP);
	}

	function isAndroidApp() {
		return !!window.SvtPlayAndroid;
	}

	function isWindowsPhone() {
		return _matchUserAgentList(UA_SETTINGS.windowsPhone);
	}

	function isWindows8App() {
		return _matchUserAgent(UA.WIN8);
	}

	function isMacOS() {
		return _matchUserAgent(UA.MAC);
	}

	function isFlashCapable() {
		return !isAndroid() && !isIOS() && !isWindowsPhone() && !isWindows8App();
	}

	function isDashCapable() {
		return !!window.MediaSource && !isMacDesktopSafari() && !isWindowsXpFirefox() && !isDashIncapableAndroid();
	}

	function isDashLiveCapable() {
		return isDashCapable() && isDesktopChrome();
	}

	function isHlsJsCapable() {
		return !!window.MediaSource && !!window.MediaSource.isTypeSupported('video/mp4; codecs="avc1.42E01E, mp4a.40.5"');
	}

	function isRedirectCapable() {
		return isDesktopChrome() && _getChromeVersion().major > 37 && _getChromeVersion().major !== 55 || isMacDesktopSafari() || isDesktopFirefox() || isIOS() && !isIOSLte7();
	}

	function isAirplayCapable() {
		return isMacDesktopSafari() || _matchUserAgent(UA.IOS9) && _matchUserAgent(UA.IPAD);
	}

	function isPictureInPictureCapable(videoElement) {
		return typeof videoElement.webkitSupportsPresentationMode === 'function' && videoElement.webkitSupportsPresentationMode('picture-in-picture');
	}

	function isTouch() {
		return 'ontouchstart' in window || navigator.MaxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
	}

	function isAndroidIntentCapable() {
		if (isAndroid()) {
			var chromeVersion = _getChromeVersion();

			return chromeVersion.major > 40;
		}

		return false;
	}

	function forceAndroidFallbackMode() {
		if (isAndroid()) {
			var version = _getAndroidVersion();
			var chromeVersion = _getChromeVersion();

			return chromeVersion.major < 40 || version.major < 4 || version.major < 5 && version.minor < 4;
		}

		return false;
	}

	function supportsShockwaveFlash() {
		if (SUPPORTS_FLASH === undefined) {
			var hasFlash = false;
			try {
				if (new ActiveXObject('ShockwaveFlash.ShockwaveFlash')) {
					hasFlash = true;
				}
			} catch (e) {
				if (navigator.mimeTypes && navigator.mimeTypes['application/x-shockwave-flash'] !== undefined && navigator.mimeTypes['application/x-shockwave-flash'].enabledPlugin) {
					hasFlash = true;
				}
			}
			SUPPORTS_FLASH = hasFlash;
		}

		return SUPPORTS_FLASH;
	}

	function toString() {
		return 'Device info: \n' + 'User agent = ' + CURR_UA + '\n' + 'isDashCapable = ' + isDashCapable() + '\n' + 'supportsShockwaveFlash = ' + supportsShockwaveFlash() + '\n' + 'isFlashCapable = ' + isFlashCapable() + '\n' + 'isHlsOnlyDevice = ' + isHlsOnlyDevice() + '\n' + 'isHlsJsCapable = ' + isHlsJsCapable() + '\n' + 'forceAndroidFallbackMode = ' + forceAndroidFallbackMode() + '\n' + 'isRedirectCapable = ' + isRedirectCapable() + '\n' + 'isTouch = ' + isTouch();
	}

	return {
		forceAndroidFallbackMode: forceAndroidFallbackMode,
		isBrokenAndroidChrome: isBrokenAndroidChrome,
		isDesktopChrome: isDesktopChrome,
		isMacDesktopSafari: isMacDesktopSafari,
		isIE: isIE,
		isIOS: isIOS,
		isIOS5: isIOS5,
		isIOSLte7: isIOSLte7,
		isIOSApp: isIOSApp,
		isIOSNotSafari: isIOSNotSafari,
		isAndroid: isAndroid,
		isAndroidApp: isAndroidApp,
		isMacOS: isMacOS,
		isTouch: isTouch,
		isWindowsPhone: isWindowsPhone,
		isWindows8App: isWindows8App,
		isFlashCapable: isFlashCapable,
		isRedirectCapable: isRedirectCapable,
		isAndroidIntentCapable: isAndroidIntentCapable,
		isAirplayCapable: isAirplayCapable,
		isPictureInPictureCapable: isPictureInPictureCapable,
		supportsDash: isDashCapable,
		supportsDashLive: isDashLiveCapable,
		supportsHls: isHttpLiveStreamingCapable,
		supportsHlsJs: isHlsJsCapable,
		supportsFlash: supportsShockwaveFlash,
		toString: toString
	};
}();

/***/ }),

/***/ "xVc6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__("pEGt");
var gOPS = __webpack_require__("THEY");
var pIE = __webpack_require__("bSeU");
var toObject = __webpack_require__("wXdB");
var IObject = __webpack_require__("wiaE");
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__("zyKz")(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),

/***/ "xZa+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("bUqO") && !__webpack_require__("zgIt")(function () {
  return Object.defineProperty(__webpack_require__("jhxf")('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "xwWq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__("woOf");

var _assign2 = _interopRequireDefault(_assign);

exports.create = create;
exports.destroy = destroy;

var _dom = __webpack_require__("TdxG");

var domUtils = _interopRequireWildcard(_dom);

var _videoAttributes = __webpack_require__("tpcr");

var _videoAttributes2 = _interopRequireDefault(_videoAttributes);

var _request = __webpack_require__("ft8J");

var _request2 = _interopRequireDefault(_request);

var _device = __webpack_require__("xOtj");

var _device2 = _interopRequireDefault(_device);

var _sizzle = __webpack_require__("zZaF");

var _sizzle2 = _interopRequireDefault(_sizzle);

var _debug = __webpack_require__("BF+C");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Debug = (0, _debug2.default)('captions');
var EVENT_NAMESPACE = 'captions';

var fullscreenEvents = 'fullscreenchange, mozfullscreenchange, MSFullscreenChange, webkitfullscreenchange';

var CLASSNAMES = {
    captionsText: 'svp_js-captions-text',
    captionsContainer: 'svp_js-captions-container'
};

var STYLE_CLASSES = {
    captionsText: 'svp_captions-text',
    captionsContainer: 'svp_captions-container',
    captionsLine: 'svp_captions-line',
    elevated: 'svp_captions--elevated',
    visible: 'svp_captions-container--visible',
    align: {
        start: 'svp_captions-text--align-start',
        middle: 'svp_captions-text--align-middle',
        end: 'svp_captions-text--align-end'
    },
    position: 'svp_captions-text--position-config',
    vttline: 'svp_captions-text--line-config',
    bold: 'svp_captions-text--bold',
    italic: 'svp_captions-text--italic',
    underline: 'svp_captions-text--underline'
};

function getCurrentInstanceNamespace(api) {
    // Note that it is not possible to use api.video() here because that is not
    // available before video-load.
    var videoElement = (0, _sizzle2.default)('video', api.element())[0];
    var uid = _videoAttributes2.default.getUID(videoElement) || _videoAttributes2.default.generateAndSetUID(videoElement);

    return EVENT_NAMESPACE + '-' + uid;
}

function createCaptionsContainerElement() {
    var captionsContainer = document.createElement('div');
    captionsContainer.className = CLASSNAMES.captionsContainer + ' ' + STYLE_CLASSES.captionsContainer;

    return captionsContainer;
}

function createCaptionsTextElement() {
    var captionsText = document.createElement('div');
    captionsText.className = CLASSNAMES.captionsText + ' ' + STYLE_CLASSES.captionsText;

    return captionsText;
}

function _getWebVttUrl(metadataObject) {
    var textRefs = metadataObject.subtitleReferences || [];
    var textUrl = false;

    textRefs.forEach(function (item) {
        if (item.format === 'webvtt') {
            textUrl = item.url;
        }
    });

    return textUrl;
}

function complexTimeToSeconds(timeString /* hh:mm:ss.sss */) {
    return timeString.split(':').map(parseFloat).reduce(function (prev, current, index) {
        return prev + current * [3600, 60, 1][index];
    }, 0);
}

function formatText(line) {
    var innerHTML = line.replace(/(\r|\n)$/g, ' $&').replace(/<b>/g, '<span class="' + STYLE_CLASSES.bold + '">').replace(/<i>/g, '<span class="' + STYLE_CLASSES.italic + '">').replace(/<u>/g, '<span class="' + STYLE_CLASSES.underline + '">').replace(/<c\.(.*?)>/g, '<span class="svp_captions-text--color-$1">').replace(/<\/b>|<\/i>|<\/u>|<\/c>/g, '</span>');

    return '<span class="' + STYLE_CLASSES.captionsLine + '">' + innerHTML + '</span>';
}

function getSegmentConfiguration(configTuples) {
    var config = {};

    configTuples.forEach(function (item) {
        var keyVal = item.split(/:/);

        config[keyVal[0]] = keyVal[1];
    });

    return config;
}

function parseVttFile(data) {
    // remove first three lines of meta data
    var lines = data.trim().split("\n").slice(2);

    // Initialise with empty caption
    var captions = [];

    var segment = { id: '', innerHTML: '' };
    var inSegment = void 0;

    lines.forEach(function (line) {
        if (/^\d+$/.test(line)) {
            segment.id = line;
        } else if (line.trim().length === 0 && inSegment) {
            captions.push(segment);
            segment = { start: 0, end: 0, innerHTML: '' };
            inSegment = false;
        } else {
            if (/-->/.test(line)) {
                // Format is of style 00:03:28.560 --> 00:03:31.160 align:end
                var time = line.split(/\s/);
                segment.start = complexTimeToSeconds(time[0]);
                segment.end = complexTimeToSeconds(time[2]);
                segment.config = time.length > 3 ? getSegmentConfiguration(time.slice(3)) : {};
                inSegment = true;
            } else if (inSegment) {
                if (segment.innerHTML !== '') {
                    segment.innerHTML += '<br>';
                }
                segment.innerHTML += formatText(line);
            }
        }
    });

    captions.push(segment);
    Debug('Parsed VTT-file');

    return captions;
}

function _getConfigHtmlStyle(config) {
    var classes = [];
    var style = {};

    if (config.align && STYLE_CLASSES.align[config.align]) {
        classes.push(STYLE_CLASSES.align[config.align]);
    }

    if (config.position && config.position.match(/\d+%/)) {
        classes.push(STYLE_CLASSES.position);
        style.left = config.position;
    }

    if (config.line !== undefined && config.line.match(/%/)) {
        // TODO: support non-percentage values?
        classes.push(STYLE_CLASSES.vttline);
        style.top = config.line;
    }

    return { classes: classes, style: style };
}

function isCaptionActive(caption, currentTime) {
    return currentTime >= caption.start && currentTime <= caption.end;
}

function _createCustomTrackElement(api, responseText) {
    if (!api.element()) {
        return; //happens if we try to play dash after flash and gets loadPlayerError and destroy SVP
    }

    var element = api.element();
    var captions = parseVttFile(responseText);
    var captionsContainerElement = createCaptionsContainerElement();

    var currCaptionsIndex = 0;
    var activeCaptionIndices = [];
    var enabled = false;
    var elevated = false;
    var fontSize = 15;
    var marginLeftRight = 10;

    var updateSizes = function updateSizes() {
        fontSize = Math.max(element.offsetWidth * 0.0375, 15);
        marginLeftRight = element.offsetWidth * 0.175;
    };

    var renderCaption = function renderCaption(captionIndex, caption) {
        // Is this caption already rendered?
        for (var i = 0; i < captionsContainerElement.children.length; i++) {
            var child = captionsContainerElement.children[i];
            if (child.getAttribute('data-caption-index') === captionIndex.toString()) {
                // Font size and margin might have changed because of window resize.
                child.style.fontSize = fontSize + 'px';
                child.style.marginLeft = marginLeftRight + 'px';
                child.style.marginRight = marginLeftRight + 'px';

                return;
            }
        }

        var captionsTextElement = createCaptionsTextElement();
        captionsTextElement.setAttribute('data-caption-index', captionIndex);
        captionsTextElement.innerHTML = caption.innerHTML;

        var _getConfigHtmlStyle2 = _getConfigHtmlStyle(caption.config),
            style = _getConfigHtmlStyle2.style,
            classes = _getConfigHtmlStyle2.classes;

        (0, _assign2.default)(captionsTextElement.style, style);
        captionsTextElement.className += ' ' + classes.join(' ');
        captionsTextElement.style.fontSize = fontSize + 'px';
        captionsTextElement.style.marginLeft = marginLeftRight + 'px';
        captionsTextElement.style.marginRight = marginLeftRight + 'px';

        captionsContainerElement.appendChild(captionsTextElement);
    };

    var render = function render() {
        if (enabled) {
            domUtils.toggleClass(captionsContainerElement, STYLE_CLASSES.elevated, elevated);
            domUtils.addClass(captionsContainerElement, STYLE_CLASSES.visible);
            activeCaptionIndices.forEach(function (index) {
                return renderCaption(index, captions[index]);
            });
        } else {
            domUtils.removeClass(captionsContainerElement, STYLE_CLASSES.visible);
        }
    };

    api.on(EVENT_NAMESPACE + '.timeupdate', function () {
        if (api.data().isRemote) {
            return;
        }

        if (enabled) {
            var currentTime = api.getCurrentTime();

            while (currentTime > captions[currCaptionsIndex].end) {
                currCaptionsIndex++;
            }

            activeCaptionIndices.length = 0;
            for (var i = currCaptionsIndex; isCaptionActive(captions[i], currentTime); i++) {
                activeCaptionIndices.push(i);
            }

            // Remove old caption texts
            for (var _i = 0; _i < captionsContainerElement.children.length; _i++) {
                var child = captionsContainerElement.children[_i];
                var captionIndex = parseInt(child.getAttribute('data-caption-index'), 10);

                if (activeCaptionIndices.indexOf(captionIndex) === -1) {
                    captionsContainerElement.removeChild(child);
                    _i--;
                }
            }

            render();
        }
    });

    api.on(EVENT_NAMESPACE + '.seeked', function () {
        var currTime = api.getCurrentTime();
        for (var i = 0; i < captions.length; i++) {
            if (captions[i].end >= currTime) {
                currCaptionsIndex = i;
                break;
            }
        }

        render();
    });

    api.on(EVENT_NAMESPACE + '.captionsvisible', function (event) {
        enabled = event.detail.shouldShow;
        render();
    });

    api.on(EVENT_NAMESPACE + '.controls', function (event) {
        elevated = event.detail.visible;
        render();
    });

    var onResize = function onResize() {
        updateSizes();
        render();
    };

    var currentInstanceNamespace = getCurrentInstanceNamespace(api);
    domUtils.addEvents(window, 'resize', onResize, currentInstanceNamespace);
    domUtils.addEvents(document, fullscreenEvents, onResize, currentInstanceNamespace);
    updateSizes();

    // TODO: Filters can not be removed. This will return the wrong value if we change
    // to a video without captions!
    api.filters.push({
        getTextTracks: function getTextTracks() {
            // console.log('Returning from filter');
            return [{ id: 'sv' }];
        }
    });

    api.element().appendChild(captionsContainerElement);
    api.fire('captionsloaded');
}

function _createTrackElement(api, textTrackUrl) {
    var videoElement = (0, _sizzle2.default)('video', api.element())[0];

    api.off(EVENT_NAMESPACE + '.loadedmetadata');

    if (videoElement) {
        videoElement.setAttribute('crossorigin', 'anonymous');

        var track = document.createElement('track');
        track.kind = 'captions';
        track.label = 'Svenska';
        track.srclang = 'sv';
        track.src = textTrackUrl;
        track['default'] = true;

        videoElement.appendChild(track);

        api.on(EVENT_NAMESPACE + '.captionsvisible', function (event) {
            var shouldShow = event.detail.shouldShow;

            videoElement.textTracks[0].mode = shouldShow ? 'showing' : 'hidden';
        });

        api.fire('captionsloaded');
    }
}

function _reset(api) {
    api.off(EVENT_NAMESPACE + '.captionsvisible');
    api.off(EVENT_NAMESPACE + '.timeupdate');
    api.off(EVENT_NAMESPACE + '.seeked');
    api.off(EVENT_NAMESPACE + '.playing');
    api.off(EVENT_NAMESPACE + '.controls');
    api.off('track.controls');

    var currentInstanceNamespace = getCurrentInstanceNamespace(api);
    domUtils.removeEvents(window, 'resize', currentInstanceNamespace);
    domUtils.removeEvents(document, fullscreenEvents, currentInstanceNamespace);

    var element = (0, _sizzle2.default)('.' + CLASSNAMES.captionsContainer, api.element())[0];
    if (element) {
        element.parentElement.removeChild(element);
    }
}

function create(api) {
    api.on(EVENT_NAMESPACE + '.metadata', function (metdataEvent) {
        Debug('metadata received');
        var trackUrl = _getWebVttUrl(metdataEvent.detail);
        if (trackUrl) {
            if (_device2.default.isIOS()) {
                api.on(EVENT_NAMESPACE + '.loadedmetadata', _createTrackElement.bind(this, api, trackUrl));
            } else {
                _request2.default.getText(trackUrl, _createCustomTrackElement.bind(this, api));
            }
        }
    });

    api.filters.push({
        load: function load() {
            _reset(api);
        }
    });
}

function destroy(api) {
    _reset(api);
    api.off(EVENT_NAMESPACE + '.metadata');
}

/***/ }),

/***/ "y9m4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("V3l/");
var global = __webpack_require__("OzIq");
var ctx = __webpack_require__("rFzY");
var classof = __webpack_require__("wC1N");
var $export = __webpack_require__("Ds5P");
var isObject = __webpack_require__("UKM+");
var aFunction = __webpack_require__("XSOZ");
var anInstance = __webpack_require__("9GpA");
var forOf = __webpack_require__("vmSO");
var speciesConstructor = __webpack_require__("7O1s");
var task = __webpack_require__("Sejc").set;
var microtask = __webpack_require__("g36u")();
var newPromiseCapabilityModule = __webpack_require__("w6Dh");
var perform = __webpack_require__("SDXa");
var promiseResolve = __webpack_require__("nphH");
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__("kkCw")('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value);
            if (domain) domain.exit();
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  if (promise._h == 1) return false;
  var chain = promise._a || promise._c;
  var i = 0;
  var reaction;
  while (chain.length > i) {
    reaction = chain[i++];
    if (reaction.fail || !isUnhandled(reaction.promise)) return false;
  } return true;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__("A16L")($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__("yYvK")($Promise, PROMISE);
__webpack_require__("CEne")(PROMISE);
Wrapper = __webpack_require__("7gX0")[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__("qkyc")(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),

/***/ "yYvK":
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__("lDLk").f;
var has = __webpack_require__("WBcL");
var TAG = __webpack_require__("kkCw")('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ "yYxz":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "ydD5":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "yuYM":
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__("yYxz");
var ITERATOR = __webpack_require__("hgbu")('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),

/***/ "zZaF":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Sizzle CSS Selector Engine v2.3.3
 * https://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2016-08-08
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	disabledAncestor = addCombinator(
		function( elem ) {
			return elem.disabled === true && ("form" in elem || "label" in elem);
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!compilerCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {

				if ( nodeType !== 1 ) {
					newContext = context;
					newSelector = selector;

				// qSA looks outside Element context, which is not what we want
				// Thanks to Andrew Dupont for this workaround technique
				// Support: IE <=8
				// Exclude object elements
				} else if ( context.nodeName.toLowerCase() !== "object" ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rcssescape, fcssescape );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[i] = "#" + nid + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				if ( newSelector ) {
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement("fieldset");

	try {
		return !!fn( el );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}
		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
						disabledAncestor( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	// documentElement is verified for cases where it doesn't yet exist
	// (such as loading iframes in IE - #4833)
	var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	return documentElement ? documentElement.nodeName !== "HTML" : false;
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( preferredDoc !== document &&
		(subWindow = document.defaultView) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( el ) {
		el.className = "i";
		return !el.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( el ) {
		el.appendChild( document.createComment("") );
		return !el.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID filter and find
	if ( support.getById ) {
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode("id");
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( (elem = elems[i++]) ) {
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( el ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll(":enabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll(":disabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( el ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	// Make sure that attribute selectors are quoted
	expr = expr.replace( rattributeQuotes, "='$1']" );

	if ( support.matchesSelector && documentIsHTML &&
		!compilerCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return (sel + "").replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( (oldCache = uniqueCache[ key ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( el ) {
	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( el ) {
	return el.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

// EXPOSE
var _sizzle = window.Sizzle;

Sizzle.noConflict = function() {
	if ( window.Sizzle === Sizzle ) {
		window.Sizzle = _sizzle;
	}

	return Sizzle;
};

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function() { return Sizzle; }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
// Sizzle requires that there be a global window in Common-JS like environments
} else if ( typeof module !== "undefined" && module.exports ) {
	module.exports = Sizzle;
} else {
	window.Sizzle = Sizzle;
}
// EXPOSE

})( window );


/***/ }),

/***/ "zgIt":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ "zo/l":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("oeih");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ "zyKz":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ })

/******/ });


// WEBPACK FOOTER //
// js/svtvideoplayer-2.1.0.js